(function() {
  'use strict';

  angular
    .module('ocoExternalSite', [
      'angular-bind-html-compile',
      'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'restangular',
      'ui.router',
      'ui.router.title',
      'permission',
      'permission.ui',
      'ui.bootstrap',
      'toastr',
      'environment',
      'ui.select',
      'ya.nouislider'
    ])
    .directive('ngCx', function() {
        return function(scope, elem, attrs) {
            attrs.$observe('ngCx', function(x) {
                elem.attr('cx', x);
            });
        };
    })
    .directive('ngCy', function() {
        return function(scope, elem, attrs) {
            attrs.$observe('ngCy', function(y) {
                elem.attr('cy', y);
            });
        };
    });
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .filter('selectedSector', SelectedSectorFilter);

  /** @ngInject */
  function SelectedSectorFilter(CompanyFilterService, LookupService) {
    return function(input) {
      return isSelectedSectors() ? limitResultsReturnedTo12(subSectorsMatchingSelectedSector(input)) : limitResultsReturnedTo12(input);
    };

    function limitResultsReturnedTo12(input) {
      if (input.length <= 12) {
        return input;
      }
      return input.slice(0, 12);
    }

    function isSelectedSectors() {
      return CompanyFilterService.selectedSectors.length > 0;
    }

    function subSectorsMatchingSelectedSector(input) {
      return input.filter(hasMatchingSectorId);
    }

    function hasMatchingSectorId(subSector) {
      var matchingSectors = CompanyFilterService.selectedSectors.find(function (selectedSectorName) {
        return subSector.sectorId === getSector(selectedSectorName).id
      });
      return angular.isDefined(matchingSectors);
    }

    function getSector(sectorName) {
      return LookupService.sectors.find(function (sector) {
        return sector.name === sectorName
      })
    }
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .filter('nonSelectedUsState', SelectedUsStateFilter);

  /** @ngInject */
  function SelectedUsStateFilter(CompanyFilterService) {
    return function(input) {
      return input.filter(function (usState) {
        return !isAlreadySelected(usState);
      });
    };

    function isAlreadySelected(usState) {
      return CompanyFilterService.selectedUsStates.find(function (selectedUsState) {
        return selectedUsState === usState.state
      });
    }
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .filter('nonSelectedSubSector', NonSelectedSubSectorFilter);

  /** @ngInject */
  function NonSelectedSubSectorFilter(CompanyFilterService) {
    return function(input) {
      return input.filter(function (subSector) {
        return !isAlreadySelected(subSector);
      });
    };

    function isAlreadySelected(subSector) {
      return CompanyFilterService.selectedSubSectors.find(function (selectedSubSector) {
        return selectedSubSector === subSector.name
      });
    }
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .filter('nonSelectedSector', NonSelectedSectorFilter);

  /** @ngInject */
  function NonSelectedSectorFilter(CompanyFilterService) {
    return function(input) {
      return input.filter(function (sector) {
        return !isAlreadySelected(sector);
      });
    };

    function isAlreadySelected(sector) {
      return CompanyFilterService.selectedSectors.find(function (sectorName) {
        return sectorName === sector.name
      });
    }
  }
})();

/**
 * Copyright 2023 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .filter('nonSelectedSectorTag', NonSelectedSectorTagFilter);

  /** @ngInject */
  function NonSelectedSectorTagFilter(CompanyFilterService) {
    return function(input) {
      return input.filter(function (sectorTags) {
        return !isAlreadySelected(sectorTags);
      });
    };

    function isAlreadySelected(sectorTags) {
      return CompanyFilterService.selectedSectorTags.find(function (selectedSectorTag) {
        return selectedSectorTag === sectorTags.tag
      });
    }
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .filter('nonSelectedScale', NonSelectedScaleFilter);

  /** @ngInject */
  function NonSelectedScaleFilter(CompanyFilterService) {
    return function(input) {
      return input.filter(function (scale) {
        return !isAlreadySelected(scale);
      });
    };

    function isAlreadySelected(scale) {
      return CompanyFilterService.selectedScale.find(function (selectedScale) {
        return selectedScale.key === scale.key;
      });
    }
  }
})();

/**
 * Copyright 2019 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .filter('nonSelectedRegion', SelectedRegionFilter);

  /** @ngInject */
  function SelectedRegionFilter(CompanyFilterService) {
    return function(input) {
      if (!input) return false;
      return input.filter(function (region) {
        return !isAlreadySelected(region);
      });
    };

    function isAlreadySelected(region) {
      return CompanyFilterService.selectedRegions.find(function (selectedRegion) {
        return selectedRegion === region.name
      });
    }
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .filter('nonSelectedExhibition', NonSelectedExhibitionFilter);

  /** @ngInject */
  function NonSelectedExhibitionFilter(CompanyFilterService) {
    return function(input) {
      return input.filter(function (exhibition) {
        return !isAlreadySelected(exhibition);
      });
    };

    function isAlreadySelected(exhibition) {
      return CompanyFilterService.selectedExhibitions.find(function (exhibitionObject) {
        return exhibitionObject.name === exhibition.name
      });
    }
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .filter('nonSelectedCountry', SelectedCountryFilter);

  /** @ngInject */
  function SelectedCountryFilter(CompanyFilterService) {
    return function(input) {
      return input.filter(function (country) {
        return !isAlreadySelected(country);
      });
    };

    function isAlreadySelected(country) {
      return CompanyFilterService.selectedCountries.find(function (selectedCountry) {
        return selectedCountry === country.name
      });
    }
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function() {
  'use strict';

  angular
    .module('ocoExternalSite')
    .service('StringUtils', StringUtils);

  /** @ngInject */
  function StringUtils() {
    var service = {};

    service.isEmpty = function (str) {
      return (!str || 0 === str.length);
    };

    service.isAllSpaces = function (str) {
      return !!str.match(/^\s+$/)
    };

    // Remove trailing commas or spaces from string
    service.cleanseStringEndings = function (str) {
      if (str != null) {
        while (endsWithSpaceOrComma(str)) {
          str = str.substring(0, str.length - 1);
        }
      }
      return str
    };

    function endsWithSpaceOrComma(str) {
      return !!str.match(/([, ])$/m);
    }

    return service;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function() {
  'use strict';

  angular
    .module('ocoExternalSite')
    .service('MessageHelper', MessageHelper);

  /** @ngInject */
  function MessageHelper($timeout) {
    var service = {};
    var _timer = null;

    function scheduleAutoClear(controller, duration) {
      if (_timer) {
        $timeout.cancel(_timer);
      }
      _timer = $timeout(function() {
        controller.alert = null;
        _timer = null;
      }, duration || 10000);
    }

    service.getSuccessAlert = function(message, controller, duration) {
      var alert = {
        type: 'success',
        message: message
      };
      if (controller) {
        controller.alert = alert;
        scheduleAutoClear(controller, duration);
      }
      return alert;
    };

    service.getErrorAlert = function(message, controller, duration) {
      var alert = {
        type: 'error',
        message: message
      };
      if (controller) {
        controller.alert = alert;
        scheduleAutoClear(controller, duration);
      }
      return alert;
    };

    return service;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
    'use strict';

    angular
        .module('ocoExternalSite')
        .service('HttpUtils', HttpUtils);

    /** @ngInject */
    function HttpUtils($http, $timeout) {
        var service = {};

        service.waitForHttpRequestsToFinish = function (intervalTime, finished) {
            service.intervalTime = intervalTime;
            service.finished = finished;
            $timeout(wait);
        }

        var wait = function() {
            if ($http.pendingRequests.length > 0) {
                $timeout(wait, service.intervalTime, false);
            } else {
                service.finished();
            }
        }

        return service;
    }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function() {
  'use strict';

  angular
    .module('ocoExternalSite')
    .service('DateUtils', DateUtils);

  /** @ngInject */
  function DateUtils() {
    var service = {};

    service.convertDate = function(dateTime) {
      return new Date(dateTime.year, dateTime.monthValue - 1, dateTime.dayOfMonth,
        dateTime.hour, dateTime.minute, dateTime.second, dateTime.nano);
    };

    service.createDateRange = function(startDate, endDate) {
      if (startDate.isSame(endDate, 'year')) {
        if (startDate.isSame(endDate, 'month')) {
          if (startDate.isSame(endDate, 'day')) {
            return endDate.format("Do MMMM YYYY")
          } else {
            return fullDateExcludingStartMonthAndYear(startDate, endDate)
          }
        } else {
          return fullDateExcludingStartYear(startDate, endDate)
        }
      } else {
        return fullDate(startDate, endDate)
      }
    };

    function fullDateExcludingStartMonthAndYear(startDate, endDate) {
      return startDate.format("Do") + " - " + endDate.format("Do MMMM YYYY");
    }

    function fullDateExcludingStartYear(startDate, endDate) {
      return startDate.format("Do MMMM") + " - " + endDate.format("Do MMMM YYYY");
    }

    function fullDate(startDate, endDate) {
      return startDate.format("Do MMMM YYYY") + " - " + endDate.format("Do MMMM YYYY");
    }

    return service;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .filter('subSector', SubSectorFilter);

  /** @ngInject */
  function SubSectorFilter(LookupService) {
    return function(input) {
       if (input === null) {
        return "";
      }
      var subSector = _.find(LookupService.subSectors, function(subSector) {
        return subSector.id === input;
      });
      return subSector ? subSector.name : "";
    }
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .filter('scale', ScaleFilter);

  /** @ngInject */
  function ScaleFilter(LookupService) {
    return function(input) {
      if (input === null) {
        return "";
      }
      var scale = LookupService.scales.find(function(scale) {
        return scale.key.toLowerCase() === input.toLowerCase();
      });
      return scale ? scale.value : "";
    }
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .filter('rating', RatingFilter);

  /** @ngInject */
  function RatingFilter(AlgorithmRatingService) {
    return function(input) {
       if (input === null) {
        return "";
      }
      var rating = AlgorithmRatingService.ratings.find(function(rating) {
        return rating.sortOrder == input;
      });
      return rating ? rating.rating : "";
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .filter('kmbFormat', kmbFormat);

  function kmbFormat() {
    return function (num) {
      if (isNaN(num)) return num;

      if (num >= 1000000) {
        return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
      }
      if (num >= 1000) {
        return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
      }
      return num;
    };
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .filter('dateSuffix', DateSuffix);

  /** @ngInject */
  function DateSuffix() {
    return function(input) {
      var suffix = ["th","st","nd","rd"], v = input % 100;
      return input + (suffix[(v - 20) % 10] || suffix[v] || suffix[0]);
    };
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .filter('countryTitle', CountryTitleFilter);

  /** @ngInject */
  function CountryTitleFilter(LookupService) {
    return function(input) {
      var country = _.find(LookupService.countryList, function(country) {
        return country.id === input;
      });
      return country ? country.name : "";
    }
  }
})();

(function() {
  'use strict';

  /**
    * This allows you to match create form field matching validations.
    * See updatePassword.html for example of usage.
    */
  angular
    .module('ocoExternalSite')
    .directive('valueMatch', match);

  function match() {
    return {
      require: 'ngModel',
      restrict: 'A',
      scope: {
        match: "=valueMatch"
      },
      link: function(scope, elm, attrs, ctrl) {
        if(!ctrl) {
          return;
        }

        ctrl.$validators.match = function(modelValue) {
          var matchValue = scope.match;
          return matchValue === modelValue;
        };
      }
    };
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function() {
  'use strict';

  /** @ngInject */
  function VelocitiListTitleController(
    NavigationService,
    DownloadReportsResource,
    MyListsSummaryService,
    ModalService,
    LoadingService,
    CompanyFilterService) {
    var vm = this;
    vm.isDownloading = false;
    vm.alertHide = false;
    vm.responseMessage ="";

    vm.goToVelocitiListTab = function(isGoingToListTab) {
      if (vm.isDownloading) {
        return;
      }
      if (vm.isOnList && !isGoingToListTab) {
        NavigationService.goToVelocitiListSearchCompanies(vm.listId, vm.listName);
      }
      if (!vm.isOnList && isGoingToListTab) {
        NavigationService.goToVelocitiList(vm.listId, vm.listName);
      }
    };

    vm.downloadListAsReportMail = function() {
      LoadingService.isLoading(true);
      vm.isDownloading = true;
      MyListsSummaryService.getListSummaryById(
        vm.listId,
        onListSummaryRetrievedByMail,
        function() {
          vm.alert = "There was an error downloading your list."
          setFinishedDownloadingFlags();
        }
      );
    }
    vm.downloadListAsReport= function() {
      LoadingService.isLoading(true);
      vm.isDownloading = true;
      MyListsSummaryService.getListSummaryById(
        vm.listId,
        onListSummaryRetrieved,
        function() {
          vm.alert = "There was an error downloading your list."
          setFinishedDownloadingFlags();
        }
      );
    }

    function onListSummaryRetrievedByMail(listSummary) {
      if (listSummary.numberOfCompaniesInList === 0) {
        showCannotDownloadMessage();
      }/* else if (listSummary.numberOfCompaniesInList > 500) {
        showMessage('Downloads capped to the first 500 companies and contact information capped to the first 100 companies. Please contact VELOCITI support for further information.')
          .then(function() { downloadList(); });
      } else if (listSummary.numberOfCompaniesInList > 1) {
        showMessage('Contact information downloads capped to the first 100 companies. Please contact VELOCITI support for further information.')
          .then(function() { downloadList(); });
      } */
      else {
        downloadListByMail();
      }
    }

    function onListSummaryRetrieved(listSummary) {
      if (listSummary.numberOfCompaniesInList === 0) {
        showCannotDownloadMessage();
      } /*else if (listSummary.numberOfCompaniesInList > 500) {
        showMessage('Downloads capped to the first 500 companies and contact information capped to the first 100 companies. Please contact VELOCITI support for further information.')
          .then(function() { downloadList(); });
      } else if (listSummary.numberOfCompaniesInList > 1) {
        showMessage('Contact information downloads capped to the first 100 companies. Please contact VELOCITI support for further information.')
          .then(function() { downloadList(); });
      }*/
      else {
        downloadList();
      }
    }

    function showCannotDownloadMessage() {
      var modalInstance = ModalService.showOkModal("You cannot download an empty list. Get started by adding some companies.")
      modalInstance.result.then(
        function () {
          setFinishedDownloadingFlags();
        }
      );
    }

    function showMessage(message) {
      return ModalService.showOkModal(message).result;
    }

    function downloadList() {
      vm.alert = "";
      DownloadReportsResource.downloadVelocitiListReport(
        vm.listId,
        vm.listName,
        CompanyFilterService.getTradeDestinationCountryId(),
        function(success) {
          setFinishedDownloadingFlags();
          /*startAlert("Download started ..");*/
        },
        function() {
          vm.alert = "There was an error downloading your list.";
          setFinishedDownloadingFlags();
        }
      );
    }

    function downloadListByMail() {
      vm.alert = "";
      DownloadReportsResource.downloadVelocitiListReportByMail(
        vm.listId,
        vm.listName,
        CompanyFilterService.getTradeDestinationCountryId(),
        function(success) {
          setFinishedDownloadingFlags();
          startAlert(success);
        },
        function() {
          vm.alert = "There was an error downloading your list.";
          setFinishedDownloadingFlags();
        }
      );
    }

    function setFinishedDownloadingFlags() {
      LoadingService.isLoading(false);
      vm.isDownloading = false;
    }

    function startAlert(alertMessage){
      vm.responseMessage =alertMessage[0];
      vm.alertHide =true;
      setTimeout(function() {
          vm.alertHide = false
          vm.responseMessage = "";
        }, 4000); // Hide after 4 seconds
    }

    vm.closeAlert = function(){
      vm.alertHide = false
      vm.responseMessage = "";
    }
  }


  /** @ngInject */
  angular
    .module('ocoExternalSite')
    .component('velocitiListTitle', {
      bindings: {
        isOnList: '<',
        listName: '@',
        listId: '@'
      },
      templateUrl: 'app/components/velocitiListTitle/velocitiListTitle.html',
      controller: [
        'NavigationService',
        'DownloadReportsResource',
        'MyListsSummaryService',
        'ModalService',
        'LoadingService',
        'CompanyFilterService',
        VelocitiListTitleController],
      controllerAs: 'vltController'
    });
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  /** @ngInject */
  function VelocitiListEditCompanyButtonController(ModalService, VelocitiListCompanyService, LoadingService) {
    var vm = this;

    vm.toggleCompanyInList = function () {
      vm.alert = "";
      if (vm.isInList) {
        removeFromList();
      } else {
        addToList();
      }
    };

    function addToList() {
      LoadingService.isLoading(true);
      VelocitiListCompanyService.addCompanyToList(vm.listId, vm.companyId,
        function () {
          LoadingService.isLoading(false);
          vm.isInList = true;
        },
        function () {
          LoadingService.isLoading(false);
          vm.alert = "There was an error adding " + vm.companyName + " to list. Please try again later.";
        }
      );
    }

    function removeFromList() {
      var modalInstance = ModalService.showOkCancelModal("Are you sure you want to delete the " + vm.companyName + " company from this list?")
      modalInstance.result.then(
        function () {
          LoadingService.isLoading(true);
          VelocitiListCompanyService.deleteCompanyFromList(vm.listId, vm.companyId,
            function () {
              LoadingService.isLoading(false);
              vm.isInList = false;
            },
            function () {
              LoadingService.isLoading(false);
              vm.alert = "There was an error deleting " + vm.companyName + ". Please try again later.";
            }
          );
        },
        function () {
          // Cancel dialog action
        }
      );
    }
  }


  /** @ngInject */
  angular
    .module('ocoExternalSite')
    .component('velocitiListEditCompanyButton', {
      bindings: {
        companyId: '@',
        listId: '@',
        companyName: "@",
        isInList: "<",
        alert: '='
      },
      templateUrl: 'app/components/velocitiListEditCompanyButton/velocitiListEditCompanyButton.html',
      controller: ['ModalService', 'VelocitiListCompanyService', 'LoadingService', VelocitiListEditCompanyButtonController],
      controllerAs: 'vlecbController'
    });
})();

/**
 * Copyright 2017 OCO Global.
 */

(function() {
  'use strict';

  /** @ngInject */
  function TradeDestinationController(CompanyFilterService, LookupService, $scope) {
    var vm = this;
    var countryList;

    vm.$onInit = function() {
      vm.isTradeDestinationDefined = CompanyFilterService.getTradeDestinationCountryId() !== "";
      buildCountryListAndSetupTradeDestination();
    };

    // Need this to update values when user clears box as this is not caught by the typeahead select method
    function watchForChangesInSelectedTradeDestination() {
      $scope.$watch(
        angular.bind(vm, function() {
          return vm.selectedTradeDestinationName;
        }),
        vm.onChangeInSelectedTradeDestination,
        true
      );
    }

    vm.onChangeInSelectedTradeDestination = function() {
      if (vm.selectedTradeDestinationName === "") {
        vm.isTradeDestinationDefined = false;
        CompanyFilterService.setTradeDestinationCountryId("");
      }
    }

    function setSelectedTradeDestination() {
      if (vm.isTradeDestinationDefined) {
        var selectedTradeDestination = _.filter(countryList, { id: CompanyFilterService.getTradeDestinationCountryId() })[0];
        vm.selectedTradeDestinationName = selectedTradeDestination.name;
      }
    }

    function buildCountryListAndSetupTradeDestination() {
      LookupService.getCountries(function() {
        countryList = getCopyOfCountryList();
        removeUsersCurrentLocationFromCountryList();
        vm.countries = _.map(countryList, function(country) {
          return country.name
        });
        setSelectedTradeDestination();
        watchForChangesInSelectedTradeDestination();
      });
    }

    function getCopyOfCountryList() {
      return angular.fromJson(
        angular.toJson(LookupService.countryList)
      )
    }

    function removeUsersCurrentLocationFromCountryList() {
      if (angular.isDefined(vm.userLocationId) && vm.userLocationId !== null) {
        var indexOfLocation = _.findIndex(countryList, function(country) {
          return country.id === vm.userLocationId;
        });
        if (indexOfLocation != -1) {
          countryList.splice(indexOfLocation, 1);
        }
      }
    }

    vm.changeSelectedTradeDestination = function(countryName) {
      vm.isTradeDestinationDefined = true;
      var tradeDestination = _.find(
        countryList,
        function(destination) {
          return destination.name === countryName;
        });

      CompanyFilterService.setTradeDestinationCountryId(tradeDestination.id);
    }

    vm.keyPressed = function(event) {
      if (isEscapeKey(event)) {
        vm.selectedTradeDestinationName = "";
      }
    };

    function isEscapeKey(event) {
      return event.keyCode === 27;
    }
  }

  /** @ngInject */
  angular
    .module('ocoExternalSite')
    .component('tradeDestination', {
      bindings: {
        userLocationId: '<'
      },
      templateUrl: 'app/components/tradeDestination/tradeDestination.html',
      controller: TradeDestinationController,
      controllerAs: 'tdController'
    });
})();

/**
 * Copyright 2017 OCO Global.
 */

/*
 * To use this component add the following markup to your page:
 *
 * <single-message-summary alert=myController.alert></single-message-summary>
 *
 * The alert box will be displayed when you set your error message and hidden when the object is equal to ''.
 * This box takes html input so if you wish to break your lines use the <br> tag.
 */
(function () {
  'use strict';

  /** @ngInject */
  function SingleMessageSummaryController(StringUtils) {
    var vm = this;

    vm.isDisplayingErrorMessage = false;

    vm.$onChanges = function(changes) {
      vm.isDisplayingErrorMessage = isErrorMessageSet(changes.alert.currentValue);
    };

    function isErrorMessageSet(message) {
      return !StringUtils.isEmpty(message);
    }
  }

  /** @ngInject */
  angular
    .module('ocoExternalSite')
    .component('singleMessageSummary', {
      bindings: {
        alert: '<'
      },
      templateUrl: 'app/components/singleMessageSummary/singleMessageSummary.html',
      controller: ['StringUtils', SingleMessageSummaryController],
      controllerAs: 'smController'

    });
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .directive('sidebar', SidebarDirective);

  /** @ngInject */
  function SidebarDirective() {
    return {
      restrict: 'E',
      scope: {},
      templateUrl: 'app/components/sidebar/sidebar.html',
      controller: SidebarDirectiveController,
      controllerAs: 'controller'
    };
  }

  /** @ngInject */
  function SidebarDirectiveController($state) {
    var vm = this;

    var activePage = $state.current.name;
    var activePageSelect = $state.current.name;

    $('aside#sidebar').hover(function(){
    $(this).parents("main").next().toggleClass("footer_blk");
    });

    $('aside#sidebar nav ul li a').click(function(){
       $(this).parents("main").next().removeClass("footer_blk");
    });

    vm.isActive = function(elementId) {
    if(activePage=='companies'){
    	$('footer').addClass("search-footer");
    }else{
    	$('footer').removeClass("search-footer");
	}
      return elementId === activePage ? 'active' : '';
    };
    vm.isSelect = function(elementId) {
      return elementId === activePageSelect ? 'active-item' : '';
    };
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

/*
 * To use this on an element which supports scrollTop (such as Textbox) add the attributesToWatch
 * with a boolean flag to trigger scrolling.
 * e.g. <textarea scroll-to-top="mycontroller.shouldScrollToTop"></textarea>
 */
(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .directive('scrollToTop', scrollToTopDirective);

  /** @ngInject */
  function scrollToTopDirective() {
    return {
      restrict: 'A',
      scope: {
        scrollToTop: '='
      },
      link: scrollToTopLink
    };
  }

  /** @ngInject */
  function scrollToTopLink(scope, element) {
    scope.$watch('scrollToTop', function(shouldScrollToTop) {
      if (shouldScrollToTop) {
        element[0].scrollTop = 0;
      }
    })
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  /** @ngInject */
  function ResultsScaleController() {
    var vm = this;

    vm.$onInit = function () {
      if (angular.isUndefined(vm.searchResults) || vm.searchResults === null) {
        setDefaultCompanyTotals();
      } else {
        setCompanyTotals(vm.searchResults);
      }
    }

    function setDefaultCompanyTotals() {
      vm.matchingPercent = '0%';
      vm.notMatchingPercent = '0%';
    }

    function setCompanyTotals(searchResults) {
      var matchingPercent = Math.round(searchResults.matching / searchResults.total * 100);
      vm.matchingPercent = matchingPercent + '%';
      vm.notMatchingPercent = (100 - matchingPercent) + '%';
    }

    vm.$onChanges = function(changesObject) {
      if(isValueEmpty(changesObject.searchResults.currentValue)) {
        setDefaultCompanyTotals();
      } else {
        setCompanyTotals(changesObject.searchResults.currentValue);
      }
      if (isValueEmpty(vm.scaleData)) {
        setDefaultScaleData()
      } else {
        setScaleData();
      }
    }

    function isValueEmpty(value) {
      return angular.isUndefined(value) || value === null;
    }

    function setDefaultScaleData() {
      vm.scaleSME = '0%';
      vm.scaleMid = '0%';
      vm.scaleLarge = '0%';
    }

    function setScaleData() {
      var SMECount = findCountById("SME");
      var MIDCount = findCountById("MID_CAP");
      var LARGECount = findCountById("LARGE_CORPORATE");

      var totalCount = SMECount + MIDCount + LARGECount;

      vm.scaleSME = Math.round(SMECount / totalCount * 100) + '%';
      vm.scaleMid = Math.round(MIDCount / totalCount * 100) + '%';
      vm.scaleLarge = Math.round(LARGECount / totalCount * 100) + '%';
    }

    function findCountById(id) {
      var keyCount = _.find(vm.scaleData, {scale: id});
      return keyCount ? keyCount.count : 0;
    }

  }

  /** @ngInject */
  angular
    .module('ocoExternalSite')
    .component('resultsScale', {
      bindings: {
        searchResults: '<',
        scaleData: '<'
      },
      templateUrl: 'app/components/resultsScale/resultsScale.html',
      controller: [ResultsScaleController],
      controllerAs: 'resultsScaleController'
    });
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  /** @ngInject */
  function OkModalController($document) {
    var vm = this;

    vm.message = function() {
      return $document[0].getElementById("alertModalBody").innerHTML = vm.resolve.message;
    };

    vm.ok = function () {
      vm.close();
    };
  }

  /** @ngInject */
  angular
    .module('ocoExternalSite')
    .component('okModal', {
      bindings: {
        close: '&',
        dismiss: '&',
        resolve: '<'
      },
      templateUrl: 'app/components/modals/okModal.html',
      controller: OkModalController,
      controllerAs: 'okModalController'
    });
})();

/**
 * Copyright 2017 OCO Global.
 */

(function() {
  'use strict';

  /** @ngInject */
  function NewListModalController() {
    var vm = this;
    vm.hasListTitle = false;
    vm.title = "";

    vm.ok = function() {
      vm.close({ $value: vm.title });
    };

    vm.onTitleChange = function() {
      if (vm.title.trim().length > 0) {
        vm.hasListTitle = true;
      }
    };

    vm.cancel = function() {
      vm.dismiss();
    };
  }

  /** @ngInject */
  angular
    .module('ocoExternalSite')
    .component('newListModal', {
      bindings: {
        close: '&',
        dismiss: '&'
      },
      templateUrl: 'app/components/modals/newListModal.html',
      controller: NewListModalController,
      controllerAs: 'nlmController'
    });
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  /** @ngInject */
  function ModalAlertController($document) {
    var vm = this;

    vm.message = function() {
      return $document[0].getElementById("alertModalBody").innerHTML = vm.resolve.message;
    };

    vm.ok = function () {
      vm.close();
    };

    vm.cancel = function () {
      vm.dismiss();
    };

  }

  /** @ngInject */
  angular
    .module('ocoExternalSite')
    .component('modalAlert', {
      bindings: {
        close: '&',
        dismiss: '&',
        resolve: '<'
      },
      templateUrl: 'app/components/modals/modalAlert.html',
      controller: ModalAlertController,
      controllerAs: 'modalAlertController'
    });
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  /** @ngInject */
  function AddToListModalController(MyListsSummaryService, VelocitiListService, UserService, SectorImageMapperService) {
    var vm = this;

    vm.isEditing = false;
    vm.newListName = null;
    vm.newListSubmitting = false;

    init();
    function init() {
      getMyListSummaries();
      getListIdsThatCompanyIsIn();
    }

    function getMyListSummaries() {
      MyListsSummaryService.getMyListsSummarySortedByName(
        function (myLists) {
          vm.myLists = myLists;
          getImageForList(myLists);
        }, function () {
          errorWithMessage("Unable to get company lists. Please try again later.")
        }
      )
    }

    function getImageForList(myLists) {
      for (var i = 0; i < myLists.length; i++) {
        myLists[i].imageUrl = SectorImageMapperService.getSectorImageUrl(myLists[i].sectorWhichDescribesList);
      }
    }

    function getListIdsThatCompanyIsIn() {
      MyListsSummaryService.getMyListIdsForCompany(vm.resolve.companyId,
        function (myListIdsForCompany) {
          vm.myListIdsForCompany = myListIdsForCompany;
        }, function () {
          errorWithMessage("Unable to get companies for lists. Please try again later.")
        }
      )
    }

    function errorWithMessage(errorMessage) {
      vm.close({$value: errorMessage});
    }

    vm.editNewListName = function () {
      if (!vm.isEditing) {
        vm.isEditing = true
      }
    };

    vm.keyPressed = function(event) {
      if (isEnterKey(event)) {
        vm.newListSubmitting = true;
        if (!vm.newListName) {
          resetNewList();
          vm.isEditing = false;
        } else if (!listWithSameName()) {
          saveNewList();
          vm.isEditing = false;
        }
      }
    };

    function resetNewList() {
      vm.newListName = null;
      vm.newListSubmitting = false;
    }

    function saveNewList() {
      VelocitiListService.addList(
        getNewList(),
        addCompanyToNewList,
        function (error) {
          if (isDuplicateListError(error)) {
            errorWithMessage("You already have a list called " + vm.newListName + ". You cannot create duplicate lists.")
          } else {
            errorWithMessage("An error occurred while trying to add company to list. Please try again later.")
          }
        }
      );
    }

    function isDuplicateListError(error) {
      return error.status === 409;
    }

    function getNewList() {
      return {
        name: vm.newListName,
        ownerAppUserId: UserService.getUser().id
      }
    }

    function addCompanyToNewList(list) {
      addCompanyToList(list);
    }

    function isEnterKey(event) {
      return event.keyCode === 13;
    }

    vm.isInList = function (list) {
      if (vm.myListIdsForCompany) {
        return vm.myListIdsForCompany.indexOf(list.listId) > -1;
      } else {
        return false
      }
    };

    vm.addCompanyToList = function (list) {
      if (!vm.isInList(list)) {
        addCompanyToList(list);
      }
    };

    function addCompanyToList(list) {
      MyListsSummaryService.addCompanyToList(
        getCompanyList(list),
        vm.close,
        function () {
          errorWithMessage("An error occurred while trying to add company to list. Please try again later.")
        }
      );
    }

    function getCompanyList(list) {
      return {
        //An existing list ID is stored as 'listId' whereas a new list returns ID as 'id'
        listId: list.listId ? list.listId : list.id,
        companyId: vm.resolve.companyId
      };
    }

    vm.nameAlreadyExists = function () {
      return vm.isEditing ? angular.isDefined(listWithSameName()) : false;
    };

    function listWithSameName() {
      return vm.myLists.find(function (list) {
        return list.name == vm.newListName
      });
    }

    return vm
  }

  /** @ngInject */
  angular
    .module('ocoExternalSite')
    .component('addToListModal', {
      bindings: {
        close: '&',
        dismiss: '&',
        resolve: '<'
      },
      templateUrl: 'app/components/modals/addToListModal.html',
      controller: AddToListModalController,
      controllerAs: 'atlmController'
    });
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  /** @ngInject */
  function InvestSignalListController(LookupService, InvestSignalService, CompanyService, SortOrder, InvestSignalFilterService, LoadingService) {
    var vm = this;
    vm.search = {
      hq: { name: '' },
      name: '',
      sector: { name: ''},
      targetMarkets: { name: ''},
      publishDate: ''
    };

    var sortUpIcon = "&#xf0de;";
    var sortDownIcon = "&#xf0dd;";
    var sortIcon = "&#xf0dc;";
    vm.currentPage = 1;
    vm.itemsPerPage = 10;
    vm.sortByColumn;
    vm.sortOrder; // ASCENDING or DESCENDING
    vm.dateMonths = {
       "Jan": "01",
       "Feb": "02",
       "Mar": "03",
       "Apr": "04",
       "May": "05",
       "Jun": "06",
       "Jul": "07",
       "Aug": "08",
       "Sep": "09",
       "Oct": "10",
       "Nov": "11",
       "Dec": "12"
    };

    InvestSignalService.getAllPublishedSignals(function(signalList){
      vm.signalList = signalList;
      vm.signalList.forEach( function(element) {
        // format and store the publish date as yyyy-mm-dd
        var d = new Date(element.publishDate),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;
        element.publishDateFilter = [year, month, day].join('-');

        switch((element.publishDate.getMonth() + 1).toString()){
          case '1': element.publishDate = "Jan " + element.publishDate.getFullYear().toString(); break;
          case '2': element.publishDate = "Feb " + element.publishDate.getFullYear().toString(); break;
          case '3': element.publishDate = "Mar " + element.publishDate.getFullYear().toString(); break;
          case '4': element.publishDate = "Apr " + element.publishDate.getFullYear().toString(); break;
          case '5': element.publishDate = "May " + element.publishDate.getFullYear().toString(); break;
          case '6': element.publishDate = "Jun " + element.publishDate.getFullYear().toString(); break;
          case '7': element.publishDate = "Jul " + element.publishDate.getFullYear().toString(); break;
          case '8': element.publishDate = "Aug " + element.publishDate.getFullYear().toString(); break;
          case '9': element.publishDate = "Sep " + element.publishDate.getFullYear().toString(); break;
          case '10': element.publishDate = "Oct " + element.publishDate.getFullYear().toString(); break;
          case '11': element.publishDate = "Nov " + element.publishDate.getFullYear().toString(); break;
          case '12': element.publishDate = "Dec " + element.publishDate.getFullYear().toString(); break;
        }
      });

      if(signalList.length > 0){
        vm.hasSearchResults = true;
      }
      LoadingService.isLoading(false);
    }, function(){});

    vm.filter = function () {
      vm.setPage(1);
    }

    vm.filterList = function (row) {
        var hq = vm.search.hq.name,
            name = vm.search.name.toLowerCase(),
            sector = vm.search.sector.name,
            targetMarkets = vm.search.targetMarkets.name,
            publishDate = vm.search.publishDate;

        if (publishDate != null && publishDate != '') {
           var dateParts = publishDate.split(" ");
           var dateM = vm.dateMonths[ dateParts[0] ];
           publishDate = [ dateParts[1], dateM, "01" ].join("-");
        }

        function matchesTargetMarkets() {
          if (!targetMarkets) return true;
          if (!row) return false;
          if (!row['targetMarkets']) return false;
          return row['targetMarkets'].indexOf(targetMarkets) > -1;
        }

	return ((hq == null || hq == '' || hq == row['hq']) &&
            (name == null || name == '' || row['companyName'].toLowerCase().indexOf(name)!=-1 ) &&
            (sector == null || sector == '' || sector == row['sector']) &&
            matchesTargetMarkets() &&
            (publishDate == null || publishDate == '' || publishDate <= row['publishDateFilter']));
    }

    vm.$onInit = function() {
      LoadingService.isLoading(true);
      getCountries();
      getSectors();
      getTargetMarkets();
      resetNumberOfSelectedSignals();
      resetSort();
      getPublishSince();
    };

    vm.setPage = function (pageNo) {
      vm.currentPage = pageNo;
    };

    vm.setItemsPerPage = function(num) {
      vm.itemsPerPage = num;
      vm.currentPage = 1;
    }

    function getCountries() {
      LookupService.getCountries(function() {
        vm.countries = LookupService.countryList;
      });
    }

    function getSectors() {
//      vm.sectors = angular.copy(LookupService.sectors);
      LookupService.populateSectors(function() {
        vm.sectors = LookupService.sectors;
      });
    }

    function getPublishSince() {
      vm.publishSince = new Array();
      var currentDate = new Date();
      vm.publishSince.push(new Date(currentDate.getFullYear().toString(),currentDate.getMonth().toString(),1));
      var previousMonth =  currentDate.getMonth();
      var previousYear =  currentDate.getFullYear();
      for(var i = 0; i < 23; i++){
        if(previousMonth !== 0){
          previousMonth -= 1;
          vm.publishSince.push(new Date(previousYear.toString(),previousMonth.toString(),1));
        }
        else if (previousMonth === 0){
          previousMonth += 11;
          previousYear -= 1;
          vm.publishSince.push(new Date(previousYear.toString(),previousMonth.toString(),1));
        }
      }
    }

    function getTargetMarkets() {
      LookupService.getRegions(function() {
        vm.regions = LookupService.regions;
      });
    }

    function resetSort() {
      vm.sortByColumn = vm.companyNameColumn;
      vm.sortOrder = SortOrder.ASCENDING;
    }

    vm.signalSelectedChanged = function() {
      vm.numOfSignalsSelected = getNumberOfSelectedSignals();
    };

    vm.$onChanges = function(changesObject) {
      resetNumberOfSelectedSignals();
      if (angular.isDefined(changesObject.searchResults) && changesObject.searchResults.currentValue !== null) {
        vm.signalList = changesObject.searchResults.currentValue.companies;
        vm.hasSearchResults = changesObject.searchResults.currentValue.matching !== 0;
      }
    };

    vm.changeSortByColumn = function(columnName) {
      if (isSortByColumn(columnName)) {
        toggleSortOrder();
      } else {
        vm.sortByColumn = columnName;
        vm.sortOrder = SortOrder.ASCENDING;
        InvestSignalFilterService.changeSortByColumn(vm.sortByColumn, vm.sortOrder);
      }
    };

    vm.getSortIcon = function(columnName) {
      if (isSortByColumn(columnName)) {
        return isSortingInAscendingOrder() ? sortDownIcon : sortUpIcon;
      }
      return sortIcon;
    };

    function isSortByColumn(columnName) {
      return columnName === vm.sortByColumn;
    }

    function isSortingInAscendingOrder() {
      return vm.sortOrder === SortOrder.ASCENDING;
    }

    function toggleSortOrder() {
      vm.sortOrder = vm.sortOrder === SortOrder.ASCENDING ? SortOrder.DESCENDING : SortOrder.ASCENDING;
      InvestSignalFilterService.setSortOrder(vm.sortOrder);
    }

    function getNumberOfSelectedSignals() {
      var totalSelected = 0;
      for (var i = 0; i < vm.signalList.length; i++) {
        if (vm.signalList[i].selected) {
          totalSelected++;
        }
      }
      return totalSelected;
    }

    function resetNumberOfSelectedSignals() {
      vm.numOfSignalsSelected = 0;
    }

    vm.showCompanyDetails = function(signal) {
      CompanyService.getCompanyDetails(signal.companyId, function (response) {
        var company = response;
        vm.companyDetails = {
          id: signal.companyId,
          name: signal.companyName,
          website: company.website,
          catSector: company.catSector,
          rating: company.grade
        }
      }, function () {});
    };
  }

  /** @ngInject */
  angular
    .module('ocoExternalSite')
    .component('investSignalList', {
      bindings: {
        listId: '@',
        searchResults: '<',
        actionButton: '@',
        alert: '='
      },
      templateUrl: 'app/components/investSignalList/investSignalList.html',
      controller: InvestSignalListController,
      controllerAs: 'islController'
    });
})();
angular.module('ocoExternalSite').filter('start', function() {
  return function(input, start) {
      if(input) {
          start = +start; //parse to int
          return input.slice(start);
      }
      return [];
  }
});

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  /** @ngInject */
  function CompanySearchTitleController(ModalService, VelocitiListService, MessageHelper, VelocitiListCompanyService,
    CompanyFilterService, LoadingService, NavigationService, TrendsReportService) {
    var vm = this;

    vm.trendsReportService = TrendsReportService;
    vm.notFilteringCountryOrSector = true;
    vm.tooltipMessage = '';

    vm.saveAsList = function () {
      var modalInstance = ModalService.showNewListModal();
      modalInstance.result.then(addListWithSpecifiedName);
    };

    vm.requestTrendsReport = function () {
      TrendsReportService.requestTrendsReport();
    }

    vm.$onChanges = function () {
      var currentFilter = CompanyFilterService.getCurrentFilter();
      if (angular.isUndefined(currentFilter) || currentFilter == null)
      {
      }
      else{
      vm.notFilteringCountryOrSector = currentFilter.countries.length === 0 || currentFilter.sectors.length === 0;
            if (vm.searchResults) {
             if(vm.searchResults.companies == null){
                  vm.numberOfFilteredCompanies = 0;
             }
			      else{
                  vm.numberOfFilteredCompanies = vm.searchResults.companies.length;
             }
            }
            setTooltipMessage();
      }
    };

    function setTooltipMessage() {
      if (vm.notFilteringCountryOrSector) {
        vm.tooltipMessage = "Please select both country and sector search criteria";
      } else if (vm.numberOfFilteredCompanies === 0) {
        vm.tooltipMessage = "Please adjust your search criteria so that matches are found"
      } else {
        vm.tooltipMessage = '';
      }
    }

    function addListWithSpecifiedName(listName) {
      LoadingService.isLoading(true);
      VelocitiListService.addList(getListToAdd(listName),
        addSearchResultsToList,
        function (error) {
          errorCreatingList(error, listName)
        }
      );
    }

    function getListToAdd(listName) {
      return {
        name: listName
      };
    }

    function addSearchResultsToList(addedList) {
      VelocitiListCompanyService.addCompaniesToList(addedList.id, getRequestForAddingCompaniesToList(),
        function () {
          LoadingService.isLoading(false);
          NavigationService.goToVelocitiList(addedList.id, addedList.name);
        },
        errorAddingCompaniesToList
      );
    }

    function getRequestForAddingCompaniesToList() {
      var request = angular.copy(CompanyFilterService.getCurrentFilter());
      request.count = vm.searchResults.matching;
      request.page = 1;
      return request
    }

    function errorAddingCompaniesToList() {
      LoadingService.isLoading(false);
      vm.alert = MessageHelper.getErrorAlert("We had trouble adding to your list. Please try again later.");
    }

    function errorCreatingList(error, listName) {
      LoadingService.isLoading(false);
      if (isDuplicateListError(error)) {
        vm.alert = MessageHelper.getErrorAlert("You already have a list called " + listName + ". You cannot create duplicate lists.");
      } else {
        vm.alert = MessageHelper.getErrorAlert("We had trouble creating your list. Please try again later.");
      }
    }

    function isDuplicateListError(error) {
      return error.status === 409;
    }

    return vm;
  }

  /** @ngInject */
  angular
    .module('ocoExternalSite')
    .component('companySearchTitle', {
      bindings: {
        searchResults: '<',
        alert: '='
      },
      templateUrl: 'app/components/companySearchTitle/companySearchTitle.html',
      controller: ['ModalService', 'VelocitiListService', 'MessageHelper', 'VelocitiListCompanyService', 'CompanyFilterService', 'LoadingService', 'NavigationService', 'TrendsReportService', CompanySearchTitleController],
      controllerAs: 'cstController'
    });
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  /** @ngInject */
  function CompanyListResultsTotalsController() {
    var vm = this;

    vm.$onInit = function() {
      if (angular.isUndefined(vm.searchResults) || vm.searchResults === null) {
        setDefaultCompanyTotals();
      } else {
        setCompanyTotals(vm.searchResults);
      }
    }

    vm.$onChanges = function(changesObject) {
      if (changesObject.searchResults.currentValue === null) {
        setDefaultCompanyTotals();
      } else {
        setCompanyTotals(changesObject.searchResults.currentValue);
      }
    }

    function setCompanyTotals(searchResults) {
      vm.numOfCompaniesFound = searchResults.matching;
      if(searchResults.companies != null)
      {
        vm.numOfCompaniesShowing = searchResults.companies.length;
      }else
      {
        vm.numOfCompaniesShowing = 0;
      }

    }

    function setDefaultCompanyTotals() {
      vm.numOfCompaniesFound = 0;
      vm.numOfCompaniesShowing = 0;
    }

    vm.getCompaniesWithUnits = function(companies) {
          var unit = '';
          if (companies > 999 && companies < 1000000) {
            unit = 'K';
            companies = parseFloat(companies / 1000).toFixed(1);
          }
          else
          if (companies > 999999 && companies < 1000000000) {
             unit = 'M';
             companies = parseFloat(companies / 1000000).toFixed(1);
          }
          else
          if (companies > 999999999) {
             unit = 'B';
             companies = parseFloat(companies / 1000000000).toFixed(1);
          }
          return companies + unit;
        }
  }

  /** @ngInject */
  angular
    .module('ocoExternalSite')
    .component('companyListResultsTotals', {
      bindings: {
        searchResults: '<'
      },
      templateUrl: 'app/components/companyListResultsTotals/companyListResultsTotals.html',
      controller: [CompanyListResultsTotalsController],
      controllerAs: 'clrtController'
    });
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  /** @ngInject */
  function CompanyProfileListPagingController(CompanyProfileService) {
    var vm = this;
    vm.currentPage = 1;
    vm.totalNumberOfResults = 100;
    vm.itemsPerPage = CompanyProfileService.pageSize;

    vm.$onInit = function() {
      if (angular.isUndefined(vm.searchResults) || vm.searchResults === null) {
        // Handle no search results here
      } else {
        setValuesFromSearchResults(vm.searchResults);
      }
    };

    function setValuesFromSearchResults(searchResults) {
      vm.currentPage = searchResults.page;
      vm.totalNumberOfResults = searchResults.matching;
    }

    vm.$onChanges = function(changesObject) {
      if (angular.isDefined(changesObject.searchResults.currentValue) && changesObject.searchResults.currentValue !== null) {
        setValuesFromSearchResults(changesObject.searchResults.currentValue);
      }
    };

    vm.setPageSize = function(pageSize) {
      CompanyProfileService.setPageSize(pageSize);
      vm.itemsPerPage = CompanyProfileService.pageSize;
    };

    vm.pageNumberChanged = function() {
      CompanyProfileService.setPageNumber(vm.currentPage);
    }
  }

  /** @ngInject */
  angular
    .module('ocoExternalSite')
    .component('companyProfileListPaging', {
      bindings: {
        searchResults: '<'
      },
      templateUrl: 'app/components/companyListPaging/companyListPaging.html',
      controller: CompanyProfileListPagingController,
      controllerAs: 'clpController'
    });
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  /** @ngInject */
  function CompanyListPagingController(CompanyFilterService) {
    var vm = this;
    vm.currentPage = 1;
    vm.totalNumberOfResults = 0;
    vm.itemsPerPage = CompanyFilterService.getPageSize();

    vm.$onInit = function() {
      if (angular.isUndefined(vm.searchResults) || vm.searchResults === null) {
        // Handle no search results here
      } else {
        setValuesFromSearchResults(vm.searchResults);
      }
    };

    function setValuesFromSearchResults(searchResults) {
    if(CompanyFilterService.checkDefaultFiltersWithoutSort())
    {
      vm.currentPage = searchResults.page;
      vm.totalNumberOfResults = searchResults.matching;
      }
      else{
      vm.currentPage = 1;
      vm.totalNumberOfResults = 0;
      }
    }

    vm.$onChanges = function(changesObject) {
      if (angular.isDefined(changesObject.searchResults.currentValue) && changesObject.searchResults.currentValue !== null) {
        setValuesFromSearchResults(changesObject.searchResults.currentValue);
      }
    };

    vm.setPageSize = function(pageSize) {
      CompanyFilterService.setPageSize(pageSize);
      vm.itemsPerPage = CompanyFilterService.getPageSize();
    };

    vm.pageNumberChanged = function() {
      CompanyFilterService.setPageNumber(vm.currentPage);
    }
  }

  /** @ngInject */
  angular
    .module('ocoExternalSite')
    .component('companyListPaging', {
      bindings: {
        searchResults: '<'
      },
      templateUrl: 'app/components/companyListPaging/companyListPaging.html',
      controller: CompanyListPagingController,
      controllerAs: 'clpController'
    });
})();

/**
 * Copyright 2017 OCO Global.
 */

(function() {
  'use strict';

  /** @ngInject */
  function CompanyListFiltersController(CompanyFilterService, LookupService, $rootScope,
    $scope, VelocitiEvents, AlgorithmRatingService, $q, ExhibitionService, $stateParams, TopTargetListService) {
    var vm = this;
    vm.isFundingModalShow = false;
    vm.isHiringModalShow = false;
    vm.subCategoryShow = null;
    vm.companyFilterService = CompanyFilterService;
    vm.isDateRangeShow = false;
    vm.isHiringDateRangeShow = false;
    vm.dealMinAmount = null;
    vm.dealMaxAmount = null;
    vm.isFundingTypeRequireShow = false;
    vm.isSectorFilter = true;
    vm.companyName = "";
    vm.domainName = "";
    vm.showAdvancedFeatures = false;
    vm.selectedCountry = "";
    vm.selectedSector = "";
    vm.selectedSubSector = "";
    vm.selectedCompanyType = "";
    vm.selectedNAICS = "";
    vm.selectedSIC = "";
    vm.selectedISIC = "";
    vm.selectedNewCompaniesOption = null;
    vm.selectedCity = "";
    vm.selectedRegion = "";
    vm.selectedOverseasOperation = "";
    vm.ratingSteps = [];
    vm.sectors = LookupService.sectors;
    vm.selectedExhibition = "";
    vm.selectedNoPresence = "";
    vm.exhibitions = [];
    vm.filteredSubSector = [];
    vm.industries = [];
    vm.selectedTopTargetList = null;
    vm.selectedTopTargetYear = null;
    vm.signalTypes = [];
    vm.countryRegionList = [];
    vm.signalDataFilterRange = {
        signalTypes: [],
        targetMarkets: [],
        sourceMarkets: [],
        createdFrom: "",
        createdTo: ""
    };

    updateUSACountryFilterSelected();
    Object.defineProperty(vm, 'selectedTopTargetListName', {
      get: function () {
        if (!vm.selectedTopTargetList) { return null; }
        return vm.selectedTopTargetList.name;
      },
    });
    vm.selectedFundingSeriesIds = [];
    vm.selectedFundingStartDate = null;
    vm.selectedFundingEndDate = null;
    vm.selectedHiringStartDate = null;
    vm.selectedHiringEndDate = null;
    vm.showRequiredRange = false;
    vm.fundingModalShow = function(response) {
          vm.isFundingModalShow = response;
          vm.resetDateRange();
          vm.selectedFundingIds = [];
          vm.selectedFundingSeriesIds = [];
          vm.isFundingTypeRequireShow = false;
          vm.dealMinAmount = null;
          vm.dealMinAmount = null;
        };
        vm.hiringModalShow = function(response) {
          vm.isHiringModalShow = response;
          vm.resetHiringDateRange();
          vm.jobTitle = null;
          vm.department = [];
          vm.country = [];
          vm.state = null;
        };

    vm.isDateRangeSectionShow = function(response) {
          vm.isDateRangeShow = response;
          vm.resetDateRange();
    };
    vm.isHiringDateRangeSectionShow = function(response) {
          vm.isHiringDateRangeShow = response;
          vm.resetHiringDateRange();
    };


     vm.fundingModalSave = function() {

    if(vm.selectedFundingStartDate != null && vm.selectedFundingEndDate != null)
         {

             vm.showRequiredRange = false;
             var fundingDataDateRange = { fromDate : vm.selectedFundingStartDate,
             toDate : vm.selectedFundingEndDate,
             };
             var fundingDealAmount = { min : vm.dealMinAmount,
             max : vm.dealMaxAmount,
             };
             vm.fundingData = { fundingSeries: vm.selectedFundingSeriesIds,
             funding_types: vm.selectedFundingIds,
             fundingDateRange: fundingDataDateRange,
             fundingDealAmount: fundingDealAmount
             };
             CompanyFilterService.fundingDataFiltering(vm.fundingData);
             vm.isFundingModalShow = false;
         }
      else
      if(vm.selectedFundingStartDate == null || vm.selectedFundingEndDate == null)
      {
          vm.showRequiredRange = true;
      }
     };
   vm.hiringDepartmentsList =  [       {name: "Administration"},
                                       {name: "Customer"},
                                       {name: "Finance"},
                                       {name: "HR"},
                                       {name: "IT"},
                                       {name: "Legal"},
                                       {name: "Marketing"},
                                       {name: "Operations"},
                                       {name: "R&D"},
                                       {name: "Sales"}
                                   ];
   vm.hiringModalSave = function() {
    if(vm.selectedHiringStartDate != null && vm.selectedHiringEndDate != null)
         {
           if(vm.jobTitle){
            var jobTitle = [];
            jobTitle.push(vm.jobTitle);
           }

           if(vm.state){
            var state = [];
            state.push(vm.state);
           }
            vm.showRequiredRange = false;
            vm.hiringData = {
             jobTitle: jobTitle ? jobTitle : null,
             department: vm.department.length > 0 ? vm.department : null,
             country: vm.country.length > 0 ? vm.country : null,
             state: state ? state : null,
             fromDate : vm.selectedHiringStartDate,
             toDate : vm.selectedHiringEndDate
           };
           CompanyFilterService.hiringDataFiltering(vm.hiringData);
           vm.isHiringModalShow = false;
         }
      else
        if(vm.selectedHiringStartDate == null || vm.selectedHiringEndDate == null)
        {
            vm.showRequiredRange = true;
        }
    };

     vm.subMenuShow = function(res){
     if(res == vm.subCategoryShow)
     {
     vm.subCategoryShow = null;
     }
     else{
     vm.subCategoryShow = res;
     }
     };

    var MAX_TURNOVER = 1000000; // stored in millions
    var MAX_EMPLOYEES = 1000000;

    var MIN_EMPLOYEE_GROWTH_RATE = 0;
    var MAX_EMPLOYEE_GROWTH_RATE = 100;

    vm.onChangeInCompanyNameFilter = function() {
      CompanyFilterService.changeCompanyName(vm.companyName);
    };

    vm.onChangeInDomainNameFilter = function() {
      CompanyFilterService.changeDomainName(vm.domainName);
    };


    vm.toggleShowAdvancedFeatures = function() {
      vm.showAdvancedFeatures = !vm.showAdvancedFeatures;
    };

    function getRatingsSliderOptions() {
      return {
        start: [0, vm.ratingSteps.length - 1],
        step: 1,
        connect: true,
        range: { 'min': 0, 'max': vm.ratingSteps.length - 1 },
        tooltips: true,
        format: {
          from: function(value) {
            return value;
          },
          to: function(value) {
            return '<span>' + vm.ratingSteps[parseInt(value)].rating + '</span>';
          }
        }
      };
    }

    // Reverse and increment max & min index values to represent rating sort order
    vm.onChangeInRatingFilter = function() {
      if (isDefaultRatingValues()) {
        CompanyFilterService.clearRatingFilter();
      } else {
        CompanyFilterService.setRatingFilter(
          (vm.ratingSliderOptions.range.max + 1) - vm.ratingSliderOptions.start[1],
          (vm.ratingSliderOptions.range.max + 1) - vm.ratingSliderOptions.start[0], 1);
      }
    };

    vm.ratingSliderEvents = {
      change: vm.onChangeInRatingFilter.bind(undefined)
    };

    function isDefaultRatingValues() {
      var ratingRange = vm.ratingSliderOptions.range;
      return (ratingRange.max) - vm.ratingSliderOptions.start[1] == ratingRange.min &&
        (ratingRange.max) - vm.ratingSliderOptions.start[0] == ratingRange.max
    }

    var ratingFilterResetListener = $rootScope.$on(VelocitiEvents.RATING_FILTER_RESET, resetRating);

    function resetRating() {
      vm.ratingSliderOptions.start = [0, vm.ratingSteps.length - 1];
    }

    $scope.$on('$destroy', ratingFilterResetListener);

    vm.turnoverSliderOptions = {
      start: [0, MAX_TURNOVER],
      step: MAX_TURNOVER / 1000,
      connect: true,
      range: { 'min': 0, 'max': MAX_TURNOVER },
      tooltips: true,
      format: {
        from: function(value) {
          return value;
        },
        to: turnoverScaleValue
      }
    };

    function turnoverScaleValue(value) {
      var unit = 'M';
      var turnover = getTurnover(value);
      if (turnover > 999) {
        unit = 'B';
        turnover = parseInt(turnover / 1000);
      }
      return '<span>' + turnover + unit + '</span>';
    }

    // Logarithmic value minus 1 to allow bottom value of 0 (1-1000000 -> 0-999999)
    function getTurnover(value) {
      return parseInt(convertLinearScaleToLogarithmic(value, MAX_TURNOVER) - 1)
    }

    vm.onChangeInTurnoverFilter = function() {
      if (isDefaultTurnoverValues()) {
        CompanyFilterService.clearTurnoverFilter();
      } else {
        CompanyFilterService.setTurnoverFilter(
          getTurnover(vm.turnoverSliderOptions.start[0]),
          getTurnover(vm.turnoverSliderOptions.start[1]), 1);
      }
    };

    function isDefaultTurnoverValues() {
      return vm.turnoverSliderOptions.start[0] == vm.turnoverSliderOptions.range.min &&
        vm.turnoverSliderOptions.start[1] == vm.turnoverSliderOptions.range.max
    }

    vm.turnoverSliderEvents = {
      change: vm.onChangeInTurnoverFilter.bind(undefined)
    };

    var turnoverFilterResetListener = $rootScope.$on(VelocitiEvents.TURNOVER_FILTER_RESET, resetTurnover);

    function resetTurnover() {
      vm.turnoverSliderOptions.start = [0, MAX_TURNOVER];
    }

    $scope.$on('$destroy', turnoverFilterResetListener);

    vm.employeesSliderOptions = {
      start: [null, null],
      step: MAX_EMPLOYEES / 1000,
      connect: true,
      range: { 'min': 0, 'max': MAX_EMPLOYEES },
      tooltips: true,
      format: {
        from: function(value) {
          return value;
        },
        to: employeeScaleValue
      }
    };

    vm.companyEmployeeGrowthRateSliderOptions = {
      start: [MIN_EMPLOYEE_GROWTH_RATE, MAX_EMPLOYEE_GROWTH_RATE],
      step: MAX_EMPLOYEE_GROWTH_RATE / 10,
      connect: true,
      range: { 'min': MIN_EMPLOYEE_GROWTH_RATE, 'max': MAX_EMPLOYEE_GROWTH_RATE },
      tooltips: true,
      format: {
        from: function(value) {
          return value;
        },
        to: companyEmployeeGrowthRateScaleValue
      }
    };

    function employeeScaleValue(value) {
      var unit = '';
      var employees = getEmployees(value);
      if (employees > 999) {
        unit = 'K';
        employees = parseInt(employees / 1000);
      }
      return '<span>' + employees + unit + '</span>';
    }

    function companyEmployeeGrowthRateScaleValue(value) {
      return '<span>' + (value >= 100 ? 'Any' : Math.round(value) + '%') + '</span>';
    }

    // Logarithmic value minus 1 to allow bottom value of 0 (1-1000000 -> 0-999999)
    function getEmployees(value) {
      return parseInt(convertLinearScaleToLogarithmic(value, MAX_EMPLOYEES) - 1)
    }

    // Convert a value on a linear scale of 0 - MAX, to a logarithmic value
    function convertLinearScaleToLogarithmic(value, max) {
      return Math.pow(10, (value / max) * Math.log10(max))
    }
      vm.onChangeInEmployeesFilter = function() {
       if(vm.employeesSliderOptions.start[0] == ''){
                  vm.employeesSliderOptions.start[0] = null;
                  }
        if(vm.employeesSliderOptions.start[1] == ''){
                  vm.employeesSliderOptions.start[1] = null;
                  }
      if (isDefaultEmployeesValues()) {
              CompanyFilterService.clearEmployeesFilter();
            } else {
            CompanyFilterService.setEmployeesFilter(vm.employeesSliderOptions.start[0],
            vm.employeesSliderOptions.start[1], 1);
            }
        };

    vm.onChangeInCompanyEmployeeGrowthRateFilter = function() {
      if (isDefaultCompanyEmployeeGrowthRateValues()) {
        CompanyFilterService.clearCompanyEmployeeGrowthRateFilter();
      } else {
        CompanyFilterService.setCompanyEmployeeGrowthRateFilter(
            Math.round(vm.companyEmployeeGrowthRateSliderOptions.start[0]),
            Math.round(vm.companyEmployeeGrowthRateSliderOptions.start[1])
        );
      }
    };

    function isDefaultEmployeesValues() {
      return (vm.employeesSliderOptions.start[0] == null || vm.employeesSliderOptions.start[0] == vm.employeesSliderOptions.range.min) &&
        (vm.employeesSliderOptions.start[1] == null || vm.employeesSliderOptions.start[1] == vm.employeesSliderOptions.range.max)
    }

    function isDefaultCompanyEmployeeGrowthRateValues() {
      return vm.companyEmployeeGrowthRateSliderOptions.start[0] == vm.companyEmployeeGrowthRateSliderOptions.range.min &&
          vm.companyEmployeeGrowthRateSliderOptions.start[1] == vm.companyEmployeeGrowthRateSliderOptions.range.max;
    }

    vm.companyEmployeeGrowthRateSliderEvents = {
      change: vm.onChangeInCompanyEmployeeGrowthRateFilter.bind(undefined)
    };

    var companyNameFilterResetListener = $rootScope.$on(VelocitiEvents.COMPANY_NAME_FILTER_CHANGED, resetCompanyName);

    function resetCompanyName() {
      vm.companyName = "";
    }

    $scope.$on('$destroy', companyNameFilterResetListener);

    var companyDomainFilterResetListener = $rootScope.$on(VelocitiEvents.COMPANY_DOMAIN_FILTER_CHANGED, resetCompanyDomain);

    function resetCompanyDomain() {
      vm.domainName = "";
    }

    $scope.$on('$destroy', companyDomainFilterResetListener);

    var employeesFilterResetListener = $rootScope.$on(VelocitiEvents.EMPLOYEE_FILTER_RESET, resetEmployees);

    function resetEmployees() {
      vm.employeesSliderOptions.start = [null, null];
    }

    $scope.$on('$destroy', employeesFilterResetListener);

    var yearEstablishedFilterResetListener = $rootScope.$on(VelocitiEvents.ESTABLISHED_FILTER_RESET, resetYearEstablished);

        function resetYearEstablished() {
          vm.yearEstablishedOptions.start = [null, null];
        }

        $scope.$on('$destroy', yearEstablishedFilterResetListener);

    var allFiltersResetListener = $rootScope.$on(VelocitiEvents.ALL_FILTERS_RESET, function() {
      resetRating();
      resetTurnover();
      resetEmployees();
      updateUSACountryFilterSelected();
      vm.companyName = "";
      vm.domainName = "";
      vm.employeesSliderOptions.start[0] = null;
      vm.employeesSliderOptions.start[1] = null;
      vm.yearEstablishedOptions.start[0] = null;
      vm.yearEstablishedOptions.start[1] = null;
    });

    $scope.$on('$destroy', allFiltersResetListener);

    vm.addCountry = function($label) {
      CompanyFilterService.addSelectedCountry($label);
      vm.selectedCountry = "";
      updateUSACountryFilterSelected();
    };

    vm.addHiringCountry = function(addHiringCountry) {
     const index = vm.country.indexOf(addHiringCountry);
        if (index == -1) {
          vm.country.push(addHiringCountry);
        }
      vm.hiringCountry = null;
    };

    vm.removeCountry = function(removeThisCountry) {
      const index = vm.country.indexOf(removeThisCountry);
      if (index > -1) {
        vm.country.splice(index, 1);
      }
    };
    vm.addHiringDepartment = function(addDepartment) {
    const index = vm.department.indexOf(addDepartment);
        if (index == -1) {
          vm.department.push(addDepartment);
        }
      vm.hiringDepartment = null;
    };

    vm.removeDepartment = function(removeThisDepartment) {
      const index = vm.department.indexOf(removeThisDepartment);
      if (index > -1) {
        vm.department.splice(index, 1);
      }
    };

    vm.addRegion = function($label) {
      CompanyFilterService.addSelectedRegion($label);
      vm.selectedRegion = "";
    };

    vm.addSector = function(sector) {
      CompanyFilterService.addSelectedSector(sector.name);
      CompanyFilterService.filteredSubSectors();
      vm.selectedSector = "";
    };

    vm.addSubSector = function($label) {
      CompanyFilterService.addSelectedSubSector($label);
      vm.selectedSubSector = "";
    };

    vm.addIndustries = function(industry) {
      CompanyFilterService.addSelectedIndustry(industry.name);
      vm.industriesSearchFilter = "";
    };

    vm.addSectorTag = function($label) {
          CompanyFilterService.addSelectedSectorTag($label);
          vm.selectedSectorTag = "";
    };

    vm.addNAICS = function(naics) {
      var splitNAICS = naics.split(" - ");
      var newNAICS ={id : splitNAICS[0], name : splitNAICS[1]};
      CompanyFilterService.addSelectedNAICS(newNAICS);
      vm.selectedNAICS = "";
    };

    vm.addSIC = function(sic) {
      var splitSICS = sic.split(" - ");
      var newSICS ={id : splitSICS[0], name : splitSICS[1]};
      CompanyFilterService.addSelectedSIC(newSICS);
      vm.selectedSIC = "";
    };

    vm.addISIC = function(isic) {
      var splitISICS = isic.split(" - ");
      var newISICS ={id : splitISICS[0], name : splitISICS[1]};
      CompanyFilterService.addSelectedISIC(newISICS);
      vm.selectedISIC = "";
    };

    vm.addScale = function(scale) {
      CompanyFilterService.addSelectedScale(scale);
    };

    vm.addCompanyType = function($label) {
          CompanyFilterService.addSelectedCompanyType($label);
          vm.selectedCompanyType = "";
    };

    vm.addUsState = function($label) {
      CompanyFilterService.addSelectedUsState($label);
      vm.selectedUsState = "";
    };

     vm.addCity = function(cityName) {
      CompanyFilterService.addSelectedCity(cityName);
      vm.selectedCity = "";
    };

    vm.addOverseasOperation = function($label) {
      CompanyFilterService.addSelectedOverseasOperation($label);
      vm.selectedOverseasOperation = "";
    };

    vm.addExhibition = function(exhibition) {
      CompanyFilterService.addSelectedExhibition(exhibition);
      vm.selectedExhibition = "";
    };

    vm.addTradeShow = function(tradeShow) {
      CompanyFilterService.addSelectedTradeShow(tradeShow);
      vm.selectedTradeShow = "";
    };

    vm.selectNewCompaniesOption = function(selectedOption) {
      CompanyFilterService.setSelectedNewCompanyOption(selectedOption);
    };

    vm.selectCompanyEmployeeGrowthOption = function(selectedOption) {
      CompanyFilterService.setCompanyEmployeeGrowthRateOption(selectedOption);
    };

    vm.addNoPresence = function(exhibition) {
      CompanyFilterService.addSelectedNoPresence(exhibition);
      vm.selectedNoPresence = "";
    };

    vm.addSignalTypeFilter = function(types) {
      vm.addSignalFilters(types.signalType, 'signalTypes');
      vm.selectedSignalTypes = "";
    };

    vm.addTargetMarketFilter = function(markets) {
      vm.addSignalFilters(markets.name, 'targetMarkets');
      vm.selectedTargetMarkets = "";
    };

    vm.addSignalCountryFilter = function(countries) {
      vm.addSignalFilters(countries, 'sourceMarkets');
      vm.selectedSourceMarkets = "";
    };

    vm.addSignalDateRangeFilter = function(dateRange) {
      vm.addSignalFilters(dateRange, 'signalDate');
      vm.selectedSignalDateRange = "";
    };

    vm.addSignalFilters = function (value, type) {

        switch (type) {

            case 'targetMarkets':
                vm.signalDataFilterRange.targetMarkets.push(value);
                break;

            case 'sourceMarkets':
                vm.signalDataFilterRange.sourceMarkets.push(value);
                break;

            case 'signalDate':
                vm.signalDataFilterRange.created_from = value.created_from;
                vm.signalDataFilterRange.created_to = value.created_to;
                break;

            case 'signalTypes':
                vm.signalDataFilterRange.signalTypes.push(value);
                break;

            default:
                console.warn("Unknown filter type:", type);
        }

        CompanyFilterService.addSelectedSignalFilters(vm.signalDataFilterRange);
         vm.signalDataFilterRange = {
                signalTypes: [],
                targetMarkets: [],
                sourceMarkets: [],
                createdFrom: "",
                createdTo: ""
            };
    };


    vm.selectTopTargetList = function(list) {
      vm.selectedTopTargetList = list;
      vm.topTargetYears = getALlYearsForTopTargetList(list);

      if (!vm.selectedTopTargetYear) { vm.selectedTopTargetYear = list.currentYear; }

      CompanyFilterService.setTopTargetList(vm.selectedTopTargetList, vm.selectedTopTargetYear);
    };

    vm.selectTopTargetYear = function(year) {
      vm.selectedTopTargetYear = year;
      CompanyFilterService.setTopTargetList(vm.selectedTopTargetList, vm.selectedTopTargetYear);
    };

    vm.lookupCities = function(citySearchTerm) {//we need selected countries
      var deferred = $q.defer();
      var selectedCountries = CompanyFilterService.selectedCountries;
      LookupService.getCities(citySearchTerm,selectedCountries,
        function(cities) {
          deferred.resolve(
            cities
          )
        }
      );
      return deferred.promise;
    }

    function getCountries() {
      LookupService.getCountries(function() {
        vm.countries = LookupService.countryList;
      });
    }

    function getHiringCountries() {
      LookupService.getHiringCountries(function() {
        vm.hiringCountries = LookupService.hiringCountryList;
      });
    }

    function getRegions() {
      LookupService.getRegions(function() {
        vm.regions = LookupService.regions;
      });
    }

    function getSectors() {
//      vm.sectors = angular.copy(LookupService.sectors);
      LookupService.populateSectors(function() {
              vm.sectors = LookupService.sectors;
            });
    }

    function getSubSectors() {
      LookupService.getSubSectors(function() {
        vm.subSectors = LookupService.subSectors;
        vm.filteredSubSector = vm.subSectors;
        CompanyFilterService.getSubSector(vm.subSectors);
      });
    }

    function getSectorTags() {
      LookupService.getSectorTags(function() {
        vm.sectorTags = LookupService.sectorTags;
      });
    }
    function getNAICS() {
      LookupService.getNAICS(function() {
        vm.naics = LookupService.naics;
      });
    }
    function getSIC() {
      LookupService.getSIC(function() {
        vm.sic = LookupService.sic;
      });
    }
    function getISIC() {
      LookupService.getISIC(function() {
        vm.isic = LookupService.isic;
      });
    }
    function getTradeShow() {
      LookupService.getTradeShow(function() {
        vm.tradeShow = LookupService.tradeShow;
      });
    }
    function setScales() {
      vm.scales = LookupService.scales;
    }
    function setCompanyTypes() {
      LookupService.getCompanyTypes(function() {
        vm.companyTypes = LookupService.companyTypes;
      });
    }

    function setNewCompaniesOptions() {
      vm.newCompaniesOptions = LookupService.newCompaniesOptions;
    }

    function getUsStates() {
      LookupService.getUsStates(function() {
        vm.usStates = LookupService.usStates;
      });
    }

    function getExhibitions() {
      ExhibitionService.getExhibitions(function(exhibitions) {
        vm.exhibitions = exhibitions;
      });
    }

    function getRatings() {
      AlgorithmRatingService.getRatings(function(ratings) {
        vm.ratingSteps = ratings.reverse();
        createRatingsSlider();
      });
    }

    function createRatingsSlider() {
      vm.ratingSliderOptions = getRatingsSliderOptions();
    }

    vm.keyPressed = function(event) {
      if (isEscapeKey(event)) {
        vm.companyName = "";
        vm.onChangeInCompanyNameFilter();
      }
    };

    function isEscapeKey(event) {
      return event.keyCode === 27;
    }

    function getALlYearsForTopTargetList(list) {
      var allYears = [list.currentYear];
      for (var i = 0; i < list.previousYears.length; i++) {
        allYears.push(list.previousYears[i]);
      }
      return allYears;
    }

    function getInvestmentSignalTypes() {
      vm.signalTypes = LookupService.signalTypes;
    }

     function getTargetMarket() {
      vm.countryRegionList = LookupService.countryRegionList;
    }

    vm.$onInit = function() {
      getCountries();
      getHiringCountries();
      getRegions();
      getSectors();
      setScales();
      setCompanyTypes();
      setNewCompaniesOptions();
      getRatings();
      getSubSectors();
      getSectorTags();
      getNAICS();
      getSIC();
      getISIC();
      getTradeShow();
      getUsStates();
      getExhibitions();
      getInvestmentSignalTypes();
      getTargetMarket();
      // Check for predefined exhibition
      if (
        $stateParams.exhibition ||
        ($stateParams.topTargetList && $stateParams.topTargetYear)
      ) {
        vm.showAdvancedFeatures = true;
        vm.selectedTopTargetList = $stateParams.topTargetList;
        vm.selectedTopTargetYear = $stateParams.topTargetYear;
        vm.topTargetYears = getALlYearsForTopTargetList(vm.selectedTopTargetList);
      }
    };

    var countryFilterChangedListener = $rootScope.$on(VelocitiEvents.COUNTRY_FILTER_CHANGED, updateUSACountryFilterSelected);

    function updateUSACountryFilterSelected() {
      vm.showUsStateFilter = USACountryFilterSelected();
    }

    $scope.$on('$destroy', countryFilterChangedListener);

    function USACountryFilterSelected() {
      return CompanyFilterService.selectedCountries.includes("United States of America");
    }

    var YEAR_ESTABLISHED_MAX = new Date().getFullYear();
    var YEAR_ESTABLISHED_MIN = YEAR_ESTABLISHED_MAX - 100;

    var yearEstablishedTooltipFormatter = {
      to: function(value) {
        return '<span>' + parseInt(value) + '</span>';
      },
      from: function(value) {
        return value;
      }
    };

    vm.yearEstablishedOptions = {
      start: [null, null],
      step: 1,
      connect: true,
      range: {
        "min": 0,
        "10%": YEAR_ESTABLISHED_MIN,
        "max": YEAR_ESTABLISHED_MAX
      },
      tooltips: [yearEstablishedTooltipFormatter, yearEstablishedTooltipFormatter],
      format: {
        to: function(value) {
          return parseInt(value);
        },
        from: function(value) {
          return parseInt(value);
        }
      }
    };

    vm.onChangeInEstablishedFilter = function() {
      CompanyFilterService.setYearEstablishedRange(vm.yearEstablishedOptions.start[0], vm.yearEstablishedOptions.start[1]);
    }

    vm.populateCompanyEmployeeGrowthRateOptions = {
      start: [0, 10],
      step: 1,
      connect: true,
      range: {
        "min": 0,
        "10%": YEAR_ESTABLISHED_MIN,
        "max": YEAR_ESTABLISHED_MAX
      },
      tooltips: [yearEstablishedTooltipFormatter, yearEstablishedTooltipFormatter],
      format: {
        to: function(value) {
          return parseInt(value);
        },
        from: function(value) {
          return parseInt(value);
        }
      }
    };

    vm.yearEstablishedEvents = {
      change: function(values) {
        CompanyFilterService.setYearEstablishedRange(parseInt(values[0]), parseInt(values[1]));
      }
    };

    vm.fundingSeriesList = [{
            "id": "A",
            "fundingType": "venture_capital",
            "name": "A"
        },
        {
            "id": "B",
            "fundingType": "venture_capital",
            "name": "B"
        },
        {
            "id": "C",
            "fundingType": "venture_capital",
            "name": "C"
        },
        {
            "id": "D",
            "fundingType": "venture_capital",
            "name": "D"
        },
        {
            "id": "E",
            "fundingType": "venture_capital",
            "name": "E"
        },
        {
            "id": "F",
            "fundingType": "venture_capital",
            "name": "F"
        },
        {
            "id": "G",
            "fundingType": "venture_capital",
            "name": "G"
        },
        {
            "id": "H",
            "fundingType": "venture_capital",
            "name": "H"
        },
        {
            "id": "I",
            "fundingType": "venture_capital",
            "name": "I"
        },
        {
            "id": "J",
            "fundingType": "venture_capital",
            "name": "J"
        },
        {
            "id": "K",
            "fundingType": "venture_capital",
            "name": "K"
        },
        {
            "id": "UNATTRIBUTED-VC",
            "fundingType": "venture_capital",
            "name": "Unattributed VC"
        }
    ];
    vm.fundingTypeList = [
                             {
                                 "id": "corporate_round",
                                 "name": "Corporate Round"
                             },
                             {
                                 "id": "debt_financing",
                                 "name": "Debt Financing"
                             },
                             {
                                 "id": "undisclosed",
                                 "name": "Undisclosed"
                             },
                             {
                                 "id": "seed",
                                 "name": "Seed"
                             },
                             {
                                 "id": "angle",
                                 "name": "Angel"
                             },
                             {
                                 "id": "private_equity",
                                 "name": "Private Equity"
                             },
                             {
                                 "id": "crowdfunding",
                                 "name": "Crowdfunding"
                             },
                             {
                                 "id": "pre_seed",
                                 "name": "Pre-Seed"
                             },
                             {
                                 "id": "growth_equity",
                                 "name": "Growth Equity"
                             },
                             {
                                 "id": "convertible_note",
                                 "name": "Convertible Note"
                             },
                             {
                                 "id": "incubator",
                                 "name": "Incubator"
                             },
                             {
                                 "id": "grant",
                                 "name": "Grant"
                             },
                             {
                                 "id": "venture_capital",
                                 "name": "Venture"
                             },
                             {
                                 "id": "unknown",
                                 "name": "Unknown"
                             }
                         ];


vm.selectedFundingIds = [];
vm.toggleFundingSelection = function (fundingId) {
                       var idx = vm.selectedFundingIds.indexOf(fundingId);
                       if (idx > -1) {
                         vm.selectedFundingIds.splice(idx, 1);
                       }
                       else {
                         vm.selectedFundingIds.push(fundingId);
                       }
                       if(fundingId == "venture_capital"){
                          if(vm.selectedFundingSeriesIds.length == 12){
                            vm.subListIsOpen = false;
                            vm.selectedFundingSeriesIds = [];
                          }else{
                            vm.subListIsOpen = true;
                            if(vm.selectedFundingIds.includes("venture_capital")){
                              vm.selectedFundingSeriesIds = ['A','B','C','D','E','F','G','H','I','J','K','UNATTRIBUTED-VC'];
                            }
                          }
                       }
                     };
vm.toggleFundingSeries = function (fundingSeriesId) {
                       var series = vm.selectedFundingSeriesIds.indexOf(fundingSeriesId);
                       if (series > -1) {
                         vm.selectedFundingSeriesIds.splice(series, 1);
                       }
                       else {
                         vm.selectedFundingSeriesIds.push(fundingSeriesId);
                       }
                       if(vm.selectedFundingSeriesIds.length == 12)
                       {
                       var funding_types = vm.selectedFundingIds.includes("venture_capital");
                       if (!funding_types) {
                         vm.selectedFundingIds.push("venture_capital");
                       }
                       }
                     };

              vm.subListIsOpen = false;
              vm.openSubLit =function(){
                if(vm.subListIsOpen == true){
                  vm.subListIsOpen = false;
                }else{
                  vm.subListIsOpen = true;
                }
              }

//start
      $('.date-own').datepicker({
       minViewMode: 2,
       format: 'yyyy',
       autoclose: true
      });


       $('input[name="daterange"]').daterangepicker({
        showDropdowns: true,
        autoUpdateInput: false,
        minYear: 2015
        });

        $('input[name="daterange"]').on('apply.daterangepicker', function(ev, picker) {
            $(this).val(picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'));
             vm.selectedFundingStartDate = picker.startDate.format('YYYY-MM-DD');
             vm.selectedFundingEndDate = picker.endDate.format('YYYY-MM-DD');
        });

        $('input[name="hiringDaterange"]').daterangepicker({
        showDropdowns: true,
        autoUpdateInput: false,
        minYear: 2015
        });

        $('input[name="hiringDaterange"]').on('apply.daterangepicker', function(ev, picker) {
            $(this).val(picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'));
             vm.selectedHiringStartDate = picker.startDate.format('YYYY-MM-DD');
             vm.selectedHiringEndDate = picker.endDate.format('YYYY-MM-DD');
        });
          $('input[name="contactsGrowth"]').daterangepicker({
                  ranges: {
                               'Today': [moment(), moment()],
                               'This Month': [moment().startOf('month'), moment().endOf('month')],
                               'Past Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                               'Past 3 Months': [moment().subtract(3, 'month').startOf('days'), moment()],
                               'Past 6 Months': [moment().subtract(6, 'month').startOf('days'), moment()],
                               'Past 9 Months': [moment().subtract(9, 'month').startOf('days'), moment()]
                            },
                            "showCustomRangeLabel": false,
                             "alwaysShowCalendars": false,
                autoUpdateInput: false,
              });

              $('input[name="hiringDaterange"]').on('cancel.daterangepicker', function(ev, picker) {
                  $(this).val('');
                  vm.selectedHiringStartDate = null;
                  vm.selectedHiringEndDate = null;
              });




              $('input[name="reportrange"]').daterangepicker({
              ranges: {
                                     'Today': [moment(), moment()],
                                     'Past 1 week': [moment().subtract(6, 'days'), moment()],
                                     'Past 2 weeks': [moment().subtract(13, 'days'), moment()],
                                     'Past 3 week': [moment().subtract(20, 'days'), moment()],
                                     'This Month': [moment().startOf('month'), moment().endOf('month')],
                                     'Past Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                                     'Past 3 Months': [moment().subtract(3, 'month').startOf('days'), moment()],
                                     'Past 6 Months': [moment().subtract(6, 'month').startOf('days'), moment()],
                                     'Past 9 Months': [moment().subtract(9, 'month').startOf('days'), moment()]
                                  },
                                  "showCustomRangeLabel": false,
                                   "alwaysShowCalendars": false,
                  autoUpdateInput: false,
                  locale: {
                      cancelLabel: 'Clear'
                  }
              });
              $('input[name="reportrange"]').on('apply.daterangepicker', function(ev, picker) {
                  $(this).val(picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'));
                   vm.selectedFundingStartDate = picker.startDate.format('YYYY-MM-DD');
                   vm.selectedFundingEndDate = picker.endDate.format('YYYY-MM-DD');
              });

              $('input[name="hiringReportrange"]').daterangepicker({
              ranges: {
                                     'Today': [moment(), moment()],
                                     'Past 1 week': [moment().subtract(6, 'days'), moment()],
                                     'Past 2 weeks': [moment().subtract(13, 'days'), moment()],
                                     'Past 3 week': [moment().subtract(20, 'days'), moment()],
                                     'This Month': [moment().startOf('month'), moment().endOf('month')],
                                     'Past Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                                     'Past 3 Months': [moment().subtract(3, 'month').startOf('days'), moment()],
                                     'Past 6 Months': [moment().subtract(6, 'month').startOf('days'), moment()],
                                     'Past 9 Months': [moment().subtract(9, 'month').startOf('days'), moment()]
                                  },
                                  "showCustomRangeLabel": false,
                                   "alwaysShowCalendars": false,
                  autoUpdateInput: false,
                  locale: {
                      cancelLabel: 'Clear'
                  }
              });
              $('input[name="hiringReportrange"]').on('apply.daterangepicker', function(ev, picker) {
                  $(this).val(picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'));
                   vm.selectedHiringStartDate = picker.startDate.format('YYYY-MM-DD');
                   vm.selectedHiringEndDate = picker.endDate.format('YYYY-MM-DD');
              });

              $('input[name="createdDate"]').daterangepicker({
                  showDropdowns: true,
                  autoUpdateInput: false,
                  minYear: 2015
              });

              $('input[name="createdDate"]').on('apply.daterangepicker', function (ev, picker) {

                  $(this).val(
                      picker.startDate.format('DD/MM/YYYY') +
                      ' - ' +
                      picker.endDate.format('DD/MM/YYYY')
                  );

                  var scope = angular.element(this).scope();

                  scope.$apply(function () {

                      // Ensure model object exists
                      if (!scope.clfController.signalDataFilters) {
                          scope.clfController.signalDataFilters = {};
                      }

                      scope.clfController.signalDataFilters.created_from =
                          picker.startDate.format('YYYY-MM-DD');

                      scope.clfController.signalDataFilters.created_to =
                          picker.endDate.format('YYYY-MM-DD');

                      // Call the filter function
                      scope.clfController.addSignalDateRangeFilter(
                          scope.clfController.signalDataFilters
                      );
                  });
              });


              $('input[name="createdDate"]').on('cancel.daterangepicker', function (ev, picker) {

                  $(this).val('');

                  var scope = angular.element(this).scope();

                  scope.$apply(function () {

                      scope.clfController.signalDataFilters.created_from = null;
                      scope.clfController.signalDataFilters.created_to = null;

                      // OPTIONAL: Remove filter on cancel
                      // scope.clfController.addSignalDateRangeFilter(scope.clfController.signalDataFilters);
                  });
              });



              vm.resetHiringDateRange = function() {
              $('input[name="hiringReportrange"]').val('');
              $('input[name="hiringDaterange"]').val('');
              vm.selectedHiringStartDate = null;
              vm.selectedHiringEndDate = null;
              vm.showRequiredRange = false;
              }

              vm.resetDateRange = function() {
              $('input[name="reportrange"]').val('');
              $('input[name="daterange"]').val('');
              vm.selectedFundingStartDate = null;
              vm.selectedFundingEndDate = null;
              vm.showRequiredRange = false;
              }

                  vm.date = {
                      startDate: moment().subtract(1, "days"),
                      endDate: moment()
                  };

                  /* $(".main-checklist > input").change(function() {
                  if(this.checked) {
                    $(".sub-checklist input").prop('checked', true);
                    $(".sub-checklist").toggleClass("vis");
                    vm.selectedFundingIds = ['venture_capital'];
                    vm.selectedFundingSeriesIds = ['A','B','C','D','E','F','G','H','I','J','K','UNATTRIBUTED-VC'];
                    }
                    else{
                    $(".sub-checklist input").prop('checked', false);
                    vm.selectedFundingSeriesIds = [];
                    }
                  });
                   $(".main-checklist > label").on('click', function(){
                    $(".sub-checklist").toggleClass("vis");
                    });*/





  //script
      $(document).keypress(
      function(event){
        if (event.which == '13') {
          event.preventDefault();
        }
      });
      $(".sector-drp-dwn").hide();

      $(".txt-sector").click(function(){
          $(".sector-drp-dwn").show();
      });
      $(".sector-drp-dwn a").click(function(){
          $(".sector-drp-dwn").hide();
      });

      $(document).mouseup(function(e)
      {
          var container = $(".txt-sector");
          if (!container.is(e.target) && container.has(e.target).length === 0)
          {
              $(".sector-drp-dwn").hide();
          }
      });

    vm.noPresenceSearch = '';

    TopTargetListService.getLists().then(function(lists) {
      vm.topTargetLists = lists;
    });

    $rootScope.$watch(
      function () {
        return vm.subSectors;
      },
      function (newValue, oldValue) {
        if (newValue !== oldValue && newValue != null) {
          // Call my function here
          getIndustries();
        }
      },
      true // deep watch (good if it's an array or object)
    );

    function getIndustries(){
      var sectorList = vm.sectors;
      var subSectorList = vm.subSectors;
      var industries = [];

      // Add sectors
      sectorList.forEach(function (sector) {
        industries.push({
          id: sector.id,
          name: sector.name,
          sector: true,
          sl: industries.length + 1
        });
      });

      // Add sub-sectors
      subSectorList.forEach(function (sub) {
        industries.push({
          id: sub.id,
          name: sub.name,
          sector: false,
          sectorId: sub.sectorId,
          sl: industries.length + 1
        });
      });
      vm.industries = industries ;
    }
  }

  /** @ngInject */
  angular
    .module('ocoExternalSite')
    .component('companyListFilters', {
      bindings: {
        searchResults: '<',
        alert: '='
      },
      templateUrl: 'app/components/companyListFilters/companyListFilters.html',
      controller: CompanyListFiltersController,
      controllerAs: 'clfController'
    });
})();



/**
 * Copyright 2017 OCO Global.
 */

(function() {
  'use strict';

  /** @ngInject */
  function CompanyListFilterBadgesController(CompanyFilterService) {
    var vm = this;

    vm.filterService = CompanyFilterService;

    vm.hasFilters = function () {
      return vm.filterService.selectedCountries.length > 0 ||
        vm.filterService.selectedRegions.length > 0 ||
        vm.filterService.selectedIndustry.length > 0 ||
        vm.filterService.selectedScale.length > 0 ||
        vm.filterService.selectedCompanyType.length > 0 ||
        vm.filterService.selectedNAICSs.length > 0 ||
        vm.filterService.selectedSICs.length > 0 ||
        vm.filterService.selectedISICs.length > 0 ||
        vm.filterService.selectedUsStates.length > 0 ||
        vm.filterService.selectedCities.length > 0 ||
        vm.filterService.selectedOverseasOperations.length > 0 ||
        vm.filterService.selectedExhibitions.length > 0 ||
        vm.filterService.tradeShows.length > 0 ||
        vm.filterService.selectedNoPresence.length > 0 ||
        vm.hasRatingFilter() ||
        vm.hasEmployeeFilter() ||
        vm.hasCompanyNameFilter() ||
        vm.hasDomainNameFilter() ||
        vm.hasTurnoverFilter() ||
        vm.hasNewCompaniesFilter() ||
        vm.hasEstablishedFilter() ||
        vm.hasEstablishedFilter() ||
        checkSignalFiltersUsed(vm.filterService.signalDataFilters) ||
        vm.filterService.fundingDateRange != null ||
        vm.filterService.funding_types.length > 0 ||
        vm.filterService.fundingSeries.length > 0 ||
        vm.filterService.hiringDateRange != null ||
        vm.filterService.hiringJobTitle != null ||
        vm.filterService.hiringState != null ||
        vm.filterService.hiring_Country != null ||
        vm.filterService.hiring_Department != null
        vm.hasCompanyEmployeeGrowthRateFilter();
    };

    function checkSignalFiltersUsed(data) {

      if (!data) return false; // If object itself is null

      // Check if all filter fields are empty
      var noFilters =
          (!data.signalTypes || data.signalTypes.length === 0) &&
          (!data.targetMarkets || data.targetMarkets.length === 0) &&
          (!data.sourceMarkets || data.sourceMarkets.length === 0) &&
          (!data.created_from || data.created_from === "") &&
          (!data.created_to || data.created_to === "");

      return !noFilters;
    }

    vm.hasRatingFilter = function () {
      return !(CompanyFilterService.rating == null || ratingAtDefault())
    };

    vm.getSelectedScaleValues = function() {
      return vm.filterService.selectedScale.map(function(scale) {
        return scale.value
      });
    }
    vm.getSelectedCompanyTypeValues = function() {
      return vm.filterService.selectedCompanyType.map(function(companyType) {
        return companyType.value
      });
    }

    function ratingAtDefault() {
      return angular.equals(CompanyFilterService.rating, getDefaultRating())
    }

    function getDefaultRating() {
      return {
        min: 1,
        max: 6,
        scale: 1
      }
    }

    vm.hasCompanyNameFilter = function () {
      return !(CompanyFilterService.query == "")
    };

    vm.hasDomainNameFilter = function () {

      return !(CompanyFilterService.domain == "")
    };

    vm.hasEmployeeFilter = function () {
      return !(CompanyFilterService.employees == null || employeesAtDefault())
    };

    vm.hasEstablishedFilter = function () {
      return !(CompanyFilterService.selectedYearEstablishedMin == null || CompanyFilterService.selectedYearEstablishedMax == null)
    };

    function employeesAtDefault() {
      return angular.equals(CompanyFilterService.employees, getDefaultEmployees())
    }

    function getDefaultEmployees() {
      return {
        min: 0,
        max: 999999,
        scale: 1
      }
    }
    vm.getCompanyName = function() {
      return CompanyFilterService.query;
    };

    vm.getDomainName = function() {
      return CompanyFilterService.domain;
    };
    vm.getEmployees = function() {
      return getEmployeesWithUnits(CompanyFilterService.employees.min) +
        " - " + getEmployeesWithUnits(CompanyFilterService.employees.max)
    };
    vm.getEstablished = function() {
          return CompanyFilterService.selectedYearEstablishedMin +
            " - " + CompanyFilterService.selectedYearEstablishedMax
        };

    function getEmployeesWithUnits(employees) {
      var unit = '';
      if (employees > 999) {
        unit = 'K';
        employees = parseInt(employees / 1000);
      }
      return employees + unit;
    }

    vm.hasTurnoverFilter = function () {
      return !(CompanyFilterService.turnover == null || turnoverAtDefault())
    };

    vm.hasNewCompaniesFilter = function () {
      return CompanyFilterService.includesRecentlyActivated !== null;
    };

    vm.getNewCompanies = function() {
      return CompanyFilterService.includesRecentlyActivated === true ? 'Yes' : 'No';
    };

    vm.hasCompanyEmployeeGrowthRateFilter = function () {
      return CompanyFilterService.companyEmployeeGrowthRate !== null;
    };

    vm.getCompanyEmployeeGrowthRateSelectedOption = function () {
      var greaterThan = CompanyFilterService.companyEmployeeGrowthRate.min;
      var lessThan = CompanyFilterService.companyEmployeeGrowthRate.max;

      if (greaterThan === 100 && lessThan === 100) {
        return 'Greater than 100%';
      }

      if (greaterThan === 0 && lessThan === 0) {
        return '0%';
      }

      return 'Greater than ' + greaterThan.toString() + '% and less than ' + lessThan.toString() + '%';
    };

    function turnoverAtDefault() {
      return angular.equals(CompanyFilterService.turnover, getDefaultTurnover())
    }

    function getDefaultTurnover() {
      return {
        min: 0,
        max: 999.999,
        scale: 1
      }
    }

    vm.getTurnover = function() {
      return getTurnoverWithUnits(CompanyFilterService.turnover.min) +
        " - " + getTurnoverWithUnits(CompanyFilterService.turnover.max)
    };

    function getTurnoverWithUnits(turnover) {
      var unit = 'M';
      if (turnover > 999) {
        unit = 'B';
        turnover = parseInt(turnover / 1000);
      }
      return turnover + unit;
    }

    return vm;
  }

  /** @ngInject */
  angular
    .module('ocoExternalSite')
    .component('companyListFilterBadges', {
      bindings: {
        template  : '@'
      },
      /** @ngInject */
      templateUrl: function($element, $attrs) {
        var templates = {
          'company' : 'app/components/companyListFilterBadges/companyListFilterBadges.html',
          'trends' : 'app/components/companyListFilterBadges/trendsReportFilterBadges.html'
        }
        return templates[$attrs.template];
      },
      controller: ['CompanyFilterService', CompanyListFilterBadgesController],
      controllerAs: 'clfbController'
    });
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  /** @ngInject */
  function CompanyListController(MessageHelper, SortOrder, CompanyListColumns, CompanyFilterService, ModalService) {
    var vm = this;
    vm.filterService = CompanyFilterService;
    vm.nameColumn = CompanyListColumns.NAME;
    vm.countryColumn = CompanyListColumns.COUNTRY;
    vm.sectorColumn = CompanyListColumns.SECTOR;
    vm.scaleColumn = CompanyListColumns.SCALE;
    vm.ratingColumn = CompanyListColumns.RATING;
    vm.hasSearchResults = true;
    vm.isTradeDestinationSet = true;
    var cachedHasTradeFocus = true;
    vm.companyList = null;
    vm.listViewStatus=true;
    vm.gridViewStatus=false;

    var sortUpIcon = "&#xf0de;";
    var sortDownIcon = "&#xf0dd;";
    var sortIcon = "&#xf0dc;";

    vm.sortByColumn;
    vm.sortOrder; // ASCENDING or DESCENDING

    vm.$onInit = function() {
      setIsTradeDestinationSet(vm.isTradeFocused);
      if (angular.isDefined(vm.searchResults) && vm.searchResults !== null) {
        vm.companyList = vm.searchResults.companies;
      }
      resetNumberOfSelectedCompanies();
      resetSort();
    };

    function resetSort() {
      vm.sortByColumn = null;
      vm.sortOrder = SortOrder.ASCENDING;
    }

    vm.companySelectedChanged = function() {
      vm.numOfCompaniesSelected = getNumberOfSelectedCompanies();
    };

    vm.$onChanges = function(changesObject) {
      resetNumberOfSelectedCompanies();
      if (angular.isDefined(changesObject.searchResults) && changesObject.searchResults.currentValue !== null) {
        vm.companyList = changesObject.searchResults.currentValue.companies;
        vm.hasSearchResults = changesObject.searchResults.currentValue.matching !== 0;
        setIsTradeDestinationSet(cachedHasTradeFocus);
      }
      if (angular.isDefined(changesObject.isTradeFocused) && changesObject.isTradeFocused.currentValue != null) {
        setIsTradeDestinationSet(changesObject.isTradeFocused.currentValue);
      }
    };

    function setIsTradeDestinationSet(hasTradeFocus) {
      cachedHasTradeFocus = hasTradeFocus;
      if (!hasTradeFocus) {
        vm.isTradeDestinationSet = true;
      } else {
        vm.isTradeDestinationSet = CompanyFilterService.getTradeDestinationCountryId() !== "";
      }
    }

    vm.changeSortByColumn = function(columnName) {
          CompanyFilterService.checkButtonClick();
      if (isSortByColumn(columnName)) {
        toggleSortOrder();
      } else {
        vm.sortByColumn = columnName;
        vm.sortOrder = SortOrder.ASCENDING;
        CompanyFilterService.changeSortByColumn(vm.sortByColumn, vm.sortOrder);
      }
    };

    vm.getSortIcon = function(columnName) {
      if (isSortByColumn(columnName)) {
        return isSortingInAscendingOrder() ? sortDownIcon : sortUpIcon;
      }
      return sortIcon;
    };

    function isSortByColumn(columnName) {
      return columnName === vm.sortByColumn;
    }

    vm.isCompanyInList = function(velocitiListId) {
      return angular.isDefined(velocitiListId) && velocitiListId !== "";
    };

    function isSortingInAscendingOrder() {
      return vm.sortOrder === SortOrder.ASCENDING;
    }

    function toggleSortOrder() {
      vm.sortOrder = vm.sortOrder === SortOrder.ASCENDING ? SortOrder.DESCENDING : SortOrder.ASCENDING;
      CompanyFilterService.setSortOrder(vm.sortOrder);
    }

    function getNumberOfSelectedCompanies() {
      var totalSelected = 0;
      for (var i = 0; i < vm.companyList.length; i++) {
        if (vm.companyList[i].selected) {
          totalSelected++;
        }
      }
      return totalSelected;
    }

    function resetNumberOfSelectedCompanies() {
      vm.numOfCompaniesSelected = 0;
    }

    vm.showCompanyDetails = function(company) {
      vm.companyDetails = {
        id: company.id,
        name: company.name,
        website: company.website,
        catSector: company.catSector,
        rating: company.rating
      };
    };

    vm.showAddToListModal = function (company) {
      var modal = ModalService.showAddToListModal(company.id);
      modal.result.then(setErrorAlert);
    };

    vm.getExternalUrl = function (input) {
    if(input == null || input == undefined){
      return input;
    }
     var scheme = 'https';
     return input.indexOf('://') > -1 ? input : scheme + '://' + input;
    };

    function setErrorAlert(result) {
      vm.alert = result ? MessageHelper.getErrorAlert(result) : '';
    }

    vm.listView = function(status){
        vm.listViewStatus=status;
        vm.gridViewStatus=false;
        angular.element('.btn-l').addClass("active");
        angular.element('.btn-g').removeClass("active");
    }

    vm.gridView = function(status){
        vm.gridViewStatus=status;
        vm.listViewStatus=false;
         angular.element(".btn-g").addClass("active");
         angular.element(".btn-l").removeClass("active");
    }
  }

  /** @ngInject */
  angular
    .module('ocoExternalSite')
    .component('companyList', {
      bindings: {
        listId: '@',
        searchResults: '<',
        actionButton: '@',
        alert: '=',
        isTradeFocused: '<'
      },
      templateUrl: 'app/components/companyList/companyList.html',
      controller: CompanyListController,
      controllerAs: 'clController'
    });
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  /** @ngInject */
  function CompanyDetailsModalController($location, $anchorScroll, LookupService, ProfileResource, MessageHelper,
                                         $timeout, StringUtils, CompanyService, UserService, $filter, LoadingService,
                                         CompanyResource, RestangularFullResponse, $interval, ModalService) {
    var vm = this;
    vm.modalOpen = false;
    vm.gettingCompanyNews = false;
    vm.gettingCompanyMap = false;
    vm.newsItemsDisplayed = 10;
    vm.showSelectedCompany = false;
    $anchorScroll.yOffset = -40;
    vm.algorithmRating;
    vm.activeDisplay = 'hq';
    vm.showLogo = false;
    vm.logo = '';
    vm.clientPersonalNote = '';
    vm.personalisedResearch = [];
    vm.contacts = [];
    vm.latestFinancialYear = null;
    vm.showSearchModal = false;
    vm.getHiringDetailsList = null;
    vm.getHiringDetailsLoad = false;
    vm.itemsPerPage = 5;
    vm.currentPage = 1;
    vm.lastReturnedKey = "";

    LookupService.getCountries(function() {
      vm.countryLevels = LookupService.countryList;
    });
    vm.senorityLevels = [
      {name: "Entry-Level"},
      {name: "Executive Level"},
      {name: "Experienced Staff"},
      {name: "Middle-Management"},
      {name: "Team-Lead"},
      {name: "Top-Tier Leadership"}
    ];
    vm.departmentLevels = [
      {name: "Administration"},
      {name: "Customer"},
      {name: "Finance"},
      {name: "HR"},
      {name: "IT"},
      {name: "Legal"},
      {name: "Marketing"},
      {name: "Operations"},
      {name: "R&D"},
      {name: "Sales"}
    ];
    vm.roleLevels = [
      {name: "CXO"},
      {name: "Director"},
      {name: "Manager"},
      {name: "Owner"},
      {name: "Partner"},
      {name: "VP"}
    ];

    vm.cognismSearchName = '';
    vm.cognismSearchLocation = '';
    vm.cognismSearchSeniority = '';
    vm.cognismSearchDepartment = '';
    vm.cognismSearchRole = '';

    function Paginator(items, perPage) {
      var pageItems;
      var page;
      var totalPages;

      function updatePageItems() {
        var newPageItems = [];
        var start = (page - 1) * perPage;
        var end = start + perPage;

        if (end > items.length) { end = items.length; }

        for (var i = start; i < end; i++) {
          newPageItems.push(items[i]);
        }

        pageItems = newPageItems;
      }

      function updateTotalPages() {
        totalPages = Math.floor(items.length / perPage) + (items.length % perPage !== 0);
      }

      function updateAll() {
        updatePageItems();
        updateTotalPages();
      }

      this.getItems = function() {
        return pageItems;
      };

      this.getPage = function() {
        return page;
      };

      this.getPerPage = function() {
        return perPage;
      };

      this.getTotalPages = function() {
        return totalPages;
      };

      this.getTotalItems = function() {
        return items ? items.length : 0;
      };

      this.isEmpty = function() {
        return this.getTotalItems() === 0;
      };

      this.setPerPage = function(newPerPage) {
        if (newPerPage === perPage) { return; }
        perPage = newPerPage;
        updateAll();
      };

      this.setItems = function(newItems) {
        if (newItems === items) { return; }
        this.setPage(1);
        items = newItems;
        updateAll();
      };

      this.setPage = function(newPage) {
        if (newPage === page) { return; }
        if (this.getTotalItems() < 1) { return; }
        page = newPage;
        updatePageItems();
      };

      this.prev = function() {
        if (page > 1) { this.setPage(page - 1); }
      };

      this.next = function() {
        if (page < totalPages) { this.setPage(page + 1); }
      };

      Object.defineProperty(this, "empty", {
        get: function() { return this.isEmpty(); }
      });

      Object.defineProperty(this, "length", {
        get: function() { return this.getTotalItems(); }
      });

      Object.defineProperty(this, "items", {
        get: function() { return this.getItems(); },
        set: function(newItems) { this.setItems(newItems); }
      });

      Object.defineProperty(this, "page", {
        get: function() { return this.getPage(); },
        set: function(newPage) { this.setPage(newPage); }
      });

      Object.defineProperty(this, "perPage", {
        get: function() { return this.getPerPage(); },
        set: function(newPerPage) { this.setPerPage(newPerPage); }
      });

      Object.defineProperty(this, "totalItems", {
        get: function() { return this.getTotalItems(); }
      });

      Object.defineProperty(this, "totalPages", {
        get: function() { return this.getTotalPages(); }
      });

      this.setPage(1);
      updateAll();

      return this;
    }

    vm.downloadContacts = function () {
      var companyId = vm.companyDetails.id;
      var companyName = vm.companyDetails.name;

      if (vm.companyDetails.companyUpdateProvider === "Cognism") {
        CompanyService.postContactsExport(companyId, {
          contacts: vm.revealedContacts.map(function(contact) {return contact.cognismID;})
        }, function (result) {
          var blob = new Blob([result], {type: 'application/application/vnd.ms-excel'});
          saveAs(blob, 'Company Contacts - ' + companyName + '.xlsx');
        }, function (error) {
          console.error(error);
        });
      }
    };

     vm.downloadAdditionalContacts = function () {
          var companyId = vm.companyDetails.id;
          var companyName = vm.companyDetails.name;
            CompanyService.getContactsExport(companyId, function (result) {
              var blob = new Blob([result], {type: 'application/application/vnd.ms-excel'});
              saveAs(blob, 'Additional Contacts - ' + companyName + '.xlsx');
            }, function (error) {
              console.error(error);
            });
        };

    vm.hoverIn = function(obj) {
       vm.selectedCompany = obj;
       vm.showSelectedCompany = true;
    }
    vm.setPageSize = function(page) {
      vm.itemsPerPage = page;
      hiringDetails();
    }
    vm.pageNumberChanged = function(){
    vm.currentPage = vm.currentPage;
    hiringDetails();
    }

    vm.hoverOut = function() {
       vm.showSelectedCompany = false;
    }

    vm.tabOpen = function(result) {
       vm.contactTabVisibility = result;
    }

    vm.activateDisplay = function(disp) {
       vm.activeDisplay = disp;
    }

        vm.show=false;
        vm.activeContact = function(){
        vm.contacts = [];
        vm.contacts.page = 0;
          if(vm.show == true){
            vm.show = false;
            vm.isVerified = false;
          }
          else{
            vm.show = true;
            vm.isVerified = true;
          }
          vm.lastReturnedKey = "";
          searchContacts(1);
        }

    vm.getRounded = function(number, decimals) {
      return +(Math.round(number + "e+" + decimals) + "e-" + decimals);
    };

    vm.getExternalUrl = function(input, scheme) {
      if (!scheme) { scheme = 'https'; }
      return input.indexOf('://') > -1 ? input : scheme + '://' + input;
    };

    vm.getTwitterUrl = function(input) {
      return input.indexOf('/') > -1 ? vm.getExternalUrl(input) : 'https://twitter.com/' + input;
    };

     vm.getInvestors = function(input) {
        var investorList = JSON.parse(input);
       var investor = "";
       if (investorList.length > 0) {
        investor = investorList.map(function(elem){
        if(elem != null)
        {
          return elem.name;
        }
        else{
        return "";
        }

                       }).join(",");
                       }
          return investor;
        };

    vm.$onChanges = function(changesObject) {
      vm.companyDetails = changesObject.companyDetails.currentValue;
      if (vm.companyDetails) {
        vm.showLogo = false;
        vm.activeDisplay = 'hq';
        vm.algorithmRating = angular.copy(vm.companyDetails.rating);
        LoadingService.isLoading(true);
        vm.hasLoadedCompanyDetails = false;
        vm.hasLoadedCompanyMap = false;
        getCompanyDetails();
        openModal();
      }
    };

   function filterHiddenContacts(contacts) {
       var filtered = [];
       if (!contacts) {
           return filtered;
       }
       for (var i = 0; i < contacts.length; i++) {
           var contact = contacts[i];
           if (!contact.contactCognismRedeemId) {
               filtered.push(contact);
           }
       }
       return filtered;
   }

   function insertArrayAt(array, index, arrayToInsert) {
       Array.prototype.splice.apply(array, [index, 0].concat(arrayToInsert));
   }

   vm.contactLoading = true;
   vm.totalContacts = 0;
   vm.paginationChanged = function() {
       var contactCount = Math.ceil(vm.contactListData.length / 5) * 5;
       if ((vm.page * 5) <= contactCount) {
           vm.contactListData = [];
           contactPagination(vm.page);
       } else if (contactCount < (vm.page * 5)) {
           vm.addContact = true;
           searchContacts(1);
       }
   }

/*   function searchContacts(page) {
       vm.contactLoading = true;
       var contactRequest = {
           companyId: vm.companyDetails.id,
           indexSize: 50,
           lastReturnedKey: vm.lastReturnedKey,
           searchContactRequest: {
               fullName: vm.cognismSearchName === "" ? null : vm.cognismSearchName,
               countries: vm.cognismSearchLocation === "" ? null : [vm.cognismSearchLocation],
               seniority: vm.cognismSearchRole === "" ? null : [vm.cognismSearchRole],
               jobFunctions: vm.cognismSearchDepartment === "" ? null : [vm.cognismSearchDepartment],
               managementLevel: vm.cognismSearchSeniority === "" ? null : [vm.cognismSearchSeniority]
           }
       }
       vm.listOfContacts = [];
       CompanyService.searchContacts(contactRequest, function(response) {
           var array = (page === 1) ? Array.from({
               length: response.totalResults > 500 ? 500 : response.totalResults
           }, function(_, i) {
               return i + 1;
           }) : vm.peopleSearchResponse;

           array.splice((5 * (page - 1)), 5);
           insertArrayAt(array, (5 * (page - 1)), response.contacts);

           vm.peopleSearchResponse = response.contacts;
           vm.lastReturnedKey = response.lastReturnedKey;

           //New Code vm.contacts.page, vm.contacts.length
           vm.contactCount = response.totalResults;
           contactPagination(page);

       }, function() {
           console.log("error");
       });
   }*/

   function searchContacts(page) {
       vm.contactLoading = true;

       // Build the search request object
       const contactRequest = {
           companyId: vm.companyDetails.id,
           indexSize: 50,
           lastReturnedKey: vm.lastReturnedKey,
           searchContactRequest: {
               fullName: vm.cognismSearchName || null,
               countries: vm.cognismSearchLocation ? [vm.cognismSearchLocation] : null,
               seniority: vm.cognismSearchRole ? [vm.cognismSearchRole] : null,
               jobFunctions: vm.cognismSearchDepartment ? [vm.cognismSearchDepartment] : null,
               managementLevel: vm.cognismSearchSeniority ? [vm.cognismSearchSeniority] : null
           }

       };

       // Initialize list of contacts to empty for the new search
       vm.listOfContacts = [];

       // Call the CompanyService API to search contacts
       CompanyService.searchContacts(contactRequest, function(response) {
           // Update the response data in the appropriate places
           vm.peopleSearchResponse = response.contacts;
           vm.lastReturnedKey = response.lastReturnedKey;

           // Update the total contact count and pagination
           vm.contactCount = response.totalResults;

           // If it's the first page, initialize the page array
           if (page === 1) {
               // Limit total results to 500 if more than that
               const maxResults = Math.min(response.totalResults, 500);
               vm.listOfContacts = response.contacts.slice(0, maxResults);
           } else {
               // For subsequent pages, directly slice the data for pagination
               const startIndex = (page - 1) * 5;
               const endIndex = page * 5;
               vm.listOfContacts = vm.peopleSearchResponse.slice(startIndex, endIndex);
           }

           // Call contactPagination to handle UI pagination logic
           contactPagination(page);

           // Hide loading indicator once the data is fetched
           vm.contactLoading = false;

       }, function() {
           console.error("Error fetching contacts");
           vm.contactLoading = false; // Hide loading indicator on error
       });
   }

   vm.addContact = false;

   function contactPagination(page) {

       vm.listOfContacts = [];

       if (vm.addContact) {
           if (vm.contactListData != vm.peopleSearchResponse) {
               for (var i = 0; i < vm.peopleSearchResponse.length; i++) {
                   vm.contactListData.push(vm.peopleSearchResponse[i]);
               }
               vm.peopleSearchResponse = vm.contactListData;
               vm.addContact = false;
           }
       } else {
           vm.contactListData = vm.peopleSearchResponse;
       }
       vm.listOfContacts = [];
       var tempContact = vm.contactListData;
       vm.totalContacts = tempContact.length + 5;

       vm.totalContacts = vm.totalContacts < vm.contactCount ? vm.totalContacts : vm.contactCount;
       var startPage = (page * 5) - 5;
       var endPage = (page * 5);
       for (startPage; startPage < endPage; startPage++) {
           if (tempContact[startPage] !== null && tempContact[startPage] !== undefined) {
               vm.listOfContacts.push(tempContact[startPage]);
           }
       }
       vm.contactLoading = false;
   }
/*    function contactPagination(page) {
      vm.listOfContacts = [];

      // If a new contact list is added, merge it with the existing list
      if (vm.addContact) {
        if (vm.contactListData !== vm.peopleSearchResponse) {
          vm.contactListData = [...(vm.contactListData || []), ...(vm.peopleSearchResponse || [])];
          vm.peopleSearchResponse = vm.contactListData;
        }
        vm.addContact = false;
      } else {
        vm.contactListData = vm.peopleSearchResponse;
      }

      // Calculate total contacts to display
      vm.totalContacts = Math.min(vm.contactListData.length + 5, vm.contactCount);

      // Get the current page's slice of contacts
      const startPage = (page - 1) * 5;
      const endPage = page * 5;
      vm.listOfContacts = vm.contactListData.slice(startPage, endPage).filter(Boolean);

      vm.contactLoading = false;
    }*/




    function getCompanyDetails() {
      vm.revealedContacts = [];
      CompanyService.getCompanyDetails(vm.companyDetails.id, function (response) {
        vm.algorithmRating = vm.companyDetails.rating ? vm.companyDetails.rating: null ;

        vm.companyDetails = response.plain();
        vm.contactTabVisibility = vm.companyDetails.companyUpdateProvider === 'Cognism' ?'Company':'Additional';
        vm.hasLoadedCompanyDetails = true;
        checkForCompanyLogo();
        checkForWorldMap();
        checkForCompanyMap();
        checkForCompanyNews();
        createAddressAsArray();
        hiringDetails();
        vm.clientPersonalNoteOriginal = response.clientPersonalNote || '';
        vm.clientPersonalNote = response.clientPersonalNote || '';
        vm.personalisedResearch = response.personalisedResearch || [];
          vm.additionalContacts = new Paginator(filterHiddenContacts(vm.companyDetails.contacts), 5);
        vm.latestFinancialYear = getLatestFinancialYear(response.financials || []);
        LoadingService.isLoading(false);
      }, function () {
        companyDetailsError(vm.companyDetails);
      });
      vm.lastReturnedKey = "";
      searchContacts(1);
    }

    vm.displayEmail = function (contact) {
      var personIndex = vm.revealedContacts.findIndex(function (revealedContact) {
        return revealedContact.cognismID === contact.contactCognismId;
      });

      if (personIndex !== -1) {
        return vm.revealedContacts[personIndex].email;
      }

      return "******";
    };

    vm.displayLinkedIn = function (contact) {
      var personIndex = vm.revealedContacts.findIndex(function (revealedContact) {
        return revealedContact.cognismID === contact.contactCognismId;
      });

      if (personIndex !== -1) {
        return vm.revealedContacts[personIndex].linkedInHandle;
      }

      return "#";
    };

    vm.displayTelephone = function (contact) {
      var personIndex = vm.revealedContacts.findIndex(function (revealedContact) {
        return revealedContact.cognismID === contact.contactCognismId;
      });

      if (personIndex !== -1) {
        return vm.revealedContacts[personIndex].telephone;
      }

      return "*****";
    };

    /*vm.revealContact = function (cognismPersonId, companyId, redeemId) {
      CompanyService.revealContact(cognismPersonId, companyId, redeemId, function (response) {

        vm.revealedContacts.push(response);

      }, function (response) {
        vm.user = UserService.getUser();
        console.log(vm.user);
        ModalService.showOkModal(vm.user.fullName + response);
      });
    };*/

    vm.revealContact = function(cognismPersonId, companyId, redeemId) {
      CompanyService.revealContact(cognismPersonId, companyId, redeemId, function(response) {
        vm.revealedContacts.push(response);
      }, function(response) {
        vm.user = UserService.getUser();
        ModalService.showOkModal(vm.user.fullName + ' your ' + response.message);
      });
    };


    function getLatestFinancialYear(years) {
      var latestYear = null;
      for (var i = 0; i < years.length; i++) {
        var year = years[i];
        if (!year.year) { continue ;}
        if (!latestYear || year.year > latestYear.year) { latestYear = year; }
      }
      return latestYear;
    }

    function companyDetailsError(company) {
      vm.alert = MessageHelper.getErrorAlert("Unable to get company details for " + company.name + ". Please try again later.");
      LoadingService.isLoading(false);
      vm.hasLoadedCompanyDetails = false;
    }

    function openModal() {
      vm.showSearchModal = false;
      vm.modalOpen = true;
      vm.cognismContactReset();
      setModalTransition();
    }

    function checkForCompanyLogo() {
      if (vm.companyDetails.insideviewId) {
        getCompanyLogo();
      }
    }

    function checkForCompanyNews() {
      if (vm.companyDetails.insideviewId) {
        getCompanyNews();
      }
    }

    function getCompanyLogo() {
      CompanyService.getLogo(vm.companyDetails.insideviewId, function(logo) {
        vm.logo = logo;
        vm.showLogo = true;
      }, function() {
      })
    }

    function checkForCompanyMap() {
      if (vm.companyDetails.id) {
        getCompanyMap();
      }
    }
    function hiringDetails() {
      if (vm.companyDetails.id) {
        getHiringDetails();
      }
    }

    function checkForWorldMap() {
      if (!vm.loadedWorldMap) {
        getWorldMap();
      }
    }

    function getCompanyNews() {
      vm.gettingCompanyNews = true;
      CompanyService.getCompanyNews(vm.companyDetails.insideviewId, function(companyNews) {
        vm.companyNews = companyNews;
        vm.gettingCompanyNews = false;
      }, function() {
        vm.gettingCompanyNews = false;
      })
    }

    function getCompanyMap() {
      vm.gettingCompanyMap = true;
      CompanyService.getCompanyMap(vm.companyDetails.id, vm.companyDetails.insideviewId, function(companyMap) {
        vm.companyMap = companyMap;
        vm.gettingCompanyMap = false;
        vm.hasLoadedCompanyMap = true;
      }, function() {
        vm.gettingCompanyMap = false;
      })
    }
    function getHiringDetails() {
      vm.getHiringDetailsLoad = true;
      vm.hiringDataSet = {
                              "companyId": vm.companyDetails.id,
                              "page": vm.currentPage,
                              "pageSize": vm.itemsPerPage
                          };
      CompanyService.getHiringDetails( vm.hiringDataSet, function(hiringData) {
        vm.getHiringDetailsList = hiringData;
        vm.currentPage = hiringData.page;
        vm.getHiringDetailsLoad = false;
//        vm.hasLoadedCompanyMap = true;
      }, function() {
        vm.getHiringDetailsLoad = false;

      })
    }

    function resetHiringEvents(){
    vm.currentPage = 1;
    vm.itemsPerPage = 5;
    vm.getHiringDetailsList =null;
    }

    function getWorldMap() {
      CompanyService.getWorldMap( function(worldMap) {
        vm.worldMap = worldMap;
      }, function() {
      })
    }

    function closeModal() {
      vm.modalOpen = false;
      vm.showSearchModal = false;
      delete vm.companyNews;
      delete vm.companyMap;
      setModalTransition();
      LoadingService.isLoading(false);
      vm.hasLoadedCompanyDetails = false;
    }

    function setModalTransition() {
      vm.modalTransition = true;
      $timeout(function () {
        vm.modalTransition = false;
      }, 600);
    }

    function createAddressAsArray() {
      if (vm.companyDetails.address) {
        vm.address = [];
        addAddressParamIfExists(vm.companyDetails.address.line1);
        addAddressParamIfExists(vm.companyDetails.address.line2);
        addAddressParamIfExists(vm.companyDetails.address.line3);
        addAddressParamIfExists(vm.companyDetails.address.city);
        addAddressParamIfExists(vm.companyDetails.address.state);
        if (vm.companyDetails.address.countryId) {
          vm.address.push($filter('countryTitle')(vm.companyDetails.address.countryId));
        }
        addAddressParamIfExists(vm.companyDetails.address.postcode);
      }
    }

    function addAddressParamIfExists(param) {
      if (param) {
        vm.address.push(param)
      }
    }

    vm.closeModal = function() {
      vm.companyDetails = null;
      vm.isReadMoreClick = false;
      vm.newsItemsDisplayed = 10;
      resetHiringEvents();
      resetUserMessages();
      closeModal();
    };

    vm.findCompanySummary = function() {
      var summaryDetails;
      if(vm.hasLoadedCompanyDetails) {
        summaryDetails = findCompanySummary();
      }
      return summaryDetails;
    };
    vm.activeReadMore = function(status) {
      vm.isReadMoreClick = status;
    };

    function findCompanySummary() {
      //to take the 1st company summary.
      var companyNote = vm.companyDetails.notes.length > 0 ? vm.companyDetails.notes[0].details : null
      var companySummary = checkDetailsExists(companyNote);
      if(companySummary == null || companySummary == ''|| companySummary == undefined){
        return "No company summary is present..."
      }
      else {
        return companySummary
      }
    }

    function checkDetailsExists(summaryDetails) {
      return summaryDetails && !StringUtils.isAllSpaces(summaryDetails) ? summaryDetails : undefined;
    }


    vm.anchorScrollTo = function(element) {
      $location.hash(element);
      $anchorScroll();
    };

    vm.getSectorImage = function() {
      if(vm.companyDetails) {
        return findSectorImage()
      }
      return "business@2x.png"
    };

    function findSectorImage() {
      var sector = _.find(LookupService.sectors, function(sector) {
        return vm.companyDetails.catSector === sector.name
      });
      if(angular.isDefined(sector)) {
        return sector.img
      }
      return "business@2x.png"
    }

    vm.requestProfile = function() {
      ProfileResource.submitCompanyForProfile(vm.companyDetails, vm.algorithmRating, success, error);
    };

    vm.updateCompanyNote = function () {
      CompanyResource.updateCompanyNote(vm.companyDetails.id, vm.clientPersonalNote, function onSuccess() {
        vm.clientPersonalNoteOriginal = vm.clientPersonalNote;
      }, function onError() {

      });
    };

    function success() {
      vm.companyDetails.profiles.push(getDefaultProfile());
      vm.companyDetails.profilesPending = true;
      showSuccessMessage("Company profile requested.");
    }

    function getDefaultProfile() {
      return {
        id: null,
        status: "NEW",
        pdfUrl: null,
        users: [UserService.getUsername()],
        groups: []
      };
    }

    function error() {
      showErrorMessage("An error occurred when submitting request. Please try again later.");
    }

    function showSuccessMessage(message) {
      vm.alert = MessageHelper.getSuccessAlert(message);
    }

    function showErrorMessage(message) {
      vm.alert = MessageHelper.getErrorAlert(message);
    }

    function resetUserMessages() {
      vm.alert = "";
    }

    vm.hasCompanyProfiles = function () {
      if (vm.hasLoadedCompanyDetails) {
        return vm.companyDetails.profiles.length > 0;
      }
    };

    vm.hasProfilePending = function () {
      if (vm.hasLoadedCompanyDetails) {
        return vm.companyDetails.profilesPending;
      }
    };

    vm.hasViewableProfile = function () {
      return vm.hasCompanyProfiles() && isLatestProfileComplete();
    };

    function isLatestProfileComplete() {
      return vm.latestProfile().status == "COMPLETE";
    }

    vm.latestProfile = function () {
      if (vm.hasLoadedCompanyDetails) {
        return vm.companyDetails.profiles[vm.companyDetails.profiles.length - 1];
      }
    };

    vm.isNoCompanyNews = function() {
      return !vm.gettingCompanyNews && (!vm.companyNews || vm.companyNews.totalResults == 0)
    };

    vm.showMoreNews = function() {
      vm.newsItemsDisplayed += 10;
    };

    vm.hasKpi = function() {
      if (vm.hasLoadedCompanyDetails) {
        var factors = vm.companyDetails.factors;
        for (var key in factors) if (hasOwnProperty(factors, key)) {
          return true
        }
      }
      return false
    };

    vm.hasPersonalisedResearch = function() {
      return vm.personalisedResearch && vm.personalisedResearch.length;
    };

    function hasOwnProperty(factors, key) {
      return Object.prototype.hasOwnProperty.call(factors, key) && factors[key] == true;
    }

    vm.canShowMore = function() {
      return angular.isDefined(vm.companyNews)
        && vm.newsItemsDisplayed < vm.companyNews.resultsPerPage
        && vm.newsItemsDisplayed < vm.companyNews.totalResults
    }

    vm.toggleSearchModal = function() {
      vm.showSearchModal = !vm.showSearchModal;
    }

    vm.cognismContactReset = function() {
      vm.cognismSearchName = '';
      vm.cognismSearchLocation = '';
      vm.cognismSearchSeniority = '';
      vm.cognismSearchDepartment = '';
      vm.cognismSearchRole = '';
      vm.lastReturnedKey = "";
      vm.page = 1;
      searchContacts(1);
    }

    vm.cognismContactSearch = function() {
      vm.lastReturnedKey = "";
      vm.page = 1;
      vm.totalContacts = 0;
      searchContacts(1);
      vm.showSearchModal = false;
    }



    vm.addCountry = function($label) {
      vm.cognismSearchLocation = $label;
    };

    vm.getTurnover = function(financials) {
    if(financials != undefined){
    var financial = _.find(financials, function(state){ return state.turnover != null; });
        return parseFloat(financial.turnover).toFixed(2);
    }
    };

    vm.getEmployees = function(financials) {
    if(financials != undefined){
    var financial = _.find(financials, function(state){ return state.employees != null; });
      if(financial){
        return financial.employees;

      }
      else{
        return null;
      }
    }
    };
   vm.getEmployeeRanges = function (employees) {
       if (employees > 0 || employees != null){
          return employees;
       }else{
          return 'No data available.';
       }
   };


    vm.currentValue = 2;
      var flag = true;
        $interval(function () {
          if (flag) {
              vm.currentValue += 1;
              if(vm.currentValue == 8){
                  flag = false;
              }
          }else{
              vm.currentValue -= 1;
              if(vm.currentValue == 3){
                  flag = true;
              }
          }
    }, 250);

  }

  /** @ngInject */
  angular
    .module('ocoExternalSite')
    .component('companyDetailsModal', {
      bindings: {
        companyDetails: '<'
      },
      templateUrl: 'app/components/companyDetailsModal/companyDetailsModal.html',
      controller: CompanyDetailsModalController,
      controllerAs: 'cdmController'
    });
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .controller('UserPreferencesController', UserPreferencesController);

  /** @ngInject */
  function UserPreferencesController(LookupService, UserPreferencesService, $scope, $log, MessageHelper, NavigationService, ModalService, CompanyFilterService) {
    var vm = this;
    vm.lookup = LookupService;
    vm.sectors = LookupService.sectors;
    vm.alert = '';
    vm.isCallingServer = false;
    vm.preferencesChanged = false;
    vm.location = null;
    vm.focus = "FDI";

    init();
    function init() {
      getCountries();
      LookupService.resetSectors();
      getUserPreferences();
    }

    function getCountries() {
      LookupService.getCountries(function () {
        vm.countries = LookupService.countryList;
      });
    }

    function getUserPreferences() {
      vm.isCallingServer = true;
      UserPreferencesService.getUserPreferences(setUserPreferences, error, finished);
    }

    function displayModal() {
      var modalinstance = ModalService.showOkCancelModal('You have unsaved changes. <br> Are you sure you would like to exit without saving?');
      modalinstance.result.then(
        function() {
          NavigationService.goToCompanies();
        }
      );
    }

    function setUserPreferences(userPreferences) {
      vm.focus = userPreferences.focus || "FDI";
      if(userPreferences.sectorIds != null) {
        makePreferenceSectorsSelected(userPreferences.sectorIds);
      }
      vm.location = getLocation(userPreferences.location);
    }

    function getLocation(locationId) {
      return vm.countries.find(function (country) {
        return country.id === locationId
      }) || null;
    }

    function error() {
      errorMessage("An error occurred while trying to fetch your current preferences. Please try again later!");
      setDefaultUserPreferences();
    }

    function finished() {
      vm.isCallingServer = false;
      vm.preferencesChanged = false;
      watchForChanges();
    }

    function setDefaultUserPreferences() {
      vm.focus = "FDI";
      vm.location = null;
      makePreferenceSectorsSelected([]);
    }

    function makePreferenceSectorsSelected(sectorIds) {
      LookupService.resetSectors();
      sectorIds.forEach(function(sectorId) {
        var sector = findSectorById(sectorId);
        if(angular.isUndefined(sector)) {
          $log.error("Sector ID " + sectorId + " not found");
        } else {
          sector.isSelected = true
        }
      });
    }

    function findSectorById(sectorId) {
      return vm.sectors.find(function (sector) {
        return sector.id === sectorId
      })
    }

    function watchForChanges() {
      $scope.$watchGroup(getPreferencesToWatch(), function(newValue, oldValue) {
        //Ignore the initial vm load when the oldValue will equal the newValue
        if (isInitialPageLoad(newValue, oldValue)) {
          vm.preferencesChanged = true
        }
      })
    }

    function getPreferencesToWatch() {
      var attributesToWatch = getNonSectorPreferences();
      addSectorsToWatchList(attributesToWatch);
      return attributesToWatch;
    }

    function getNonSectorPreferences() {
      return [
        "userPreferencesController.focus",
        "userPreferencesController.location"
      ];
    }

    function addSectorsToWatchList(attributesToWatch) {
      vm.sectors.forEach(function (sector, index) {
        attributesToWatch.push("userPreferencesController.sectors[" + index + "].isSelected")
      });
    }

    function isInitialPageLoad(newValue, oldValue) {
      return newValue !== oldValue;
    }

    vm.cancel = function() {
      if(vm.preferencesChanged) {
        displayModal();
      } else {
        NavigationService.goToCompanies();
      }
    };

    function errorMessage(message) {
      vm.alert = MessageHelper.getErrorAlert(message)
    }

    vm.hasNoSectorSelected = function() {
      return !vm.sectors.find(function(sector) {
        return sector.isSelected
      });
    };

    vm.hasNoLocation = function() {
      return vm.location === null  || locationIdNotFound()
    };

    vm.submit = function(form) {
      form.$setSubmitted();
      vm.preferencesChanged = false;
      return !vm.hasNoLocation() && vm.updateUserPreferences()
    };

    vm.updateUserPreferences = function() {
      vm.isCallingServer = true;
      UserPreferencesService.updateUserPreferences(userPreferencesParams(), function() {
        ensureTradeDestinationNotSetWhenFocusIsFDI();
        NavigationService.goToCompanies()
      }, function() {
        vm.isCallingServer = false;
        errorMessage("An error has occurred! Please try again later.")
      });
    };

    function ensureTradeDestinationNotSetWhenFocusIsFDI() {
       if (vm.focus === "FDI") {
          CompanyFilterService.resetTradeDestinationCountryId();
        }
    }

    function userPreferencesParams() {
      return {
        focus: vm.focus,
        location: vm.location.id,
        sectorIds: getSelectedSectorIds()
      };
    }

    function getSelectedSectorIds() {
      var selectedSectorIds = [];
      vm.sectors.forEach(function (sector) {
        if (sector.isSelected) {
          selectedSectorIds.push(sector.id)
        }
      });
      return selectedSectorIds;
    }

    vm.toggleSectorSelection = function toggleSelection(sectorId) {
      findSectorById(sectorId).isSelected = !findSectorById(sectorId).isSelected;
      vm.preferencesChanged = true;
    };

    vm.isSectorSelected = function(sectorId) {
      return findSectorById(sectorId).isSelected
    };

    vm.isInvalid = function() {
      return vm.isCallingServer
    };

    vm.checkValidLocationSet = function() {
      if (doesLocationExist()) {
        findLocation();
      }
    };

    function doesLocationExist() {
      return angular.isDefined(vm.location) && vm.location !== null;
    }

    function locationIdNotFound() {
      return doesLocationExist() && angular.isUndefined(vm.location.id);
    }

    function findLocation() {
      if (locationIdNotFound()) {
        var found = _.find(vm.countries, function(country) {
          return country.name.toLowerCase() === vm.location.toLowerCase();
        });
      }

      if(found) {
        vm.location = found
      }
    }

    return vm;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .controller('UpdatePasswordController', UpdatePasswordController);

  /** @ngInject */
  function UpdatePasswordController(UserService, MessageHelper, HttpResponseCodes, $log, $scope, NavigationService) {
    var vm = this;

    init();
    function init() {
      vm.alert = '';
      vm.isCallingServer = false;
      resetPasswordFields();
    }

    function resetPasswordFields() {
      vm.newPassword = '';
      vm.oldPassword = '';
      vm.newPasswordConfirm = '';
    }

    vm.goToMyVelociti = function() {
      NavigationService.goToMyVelociti();
    };

    vm.updatePassword = function() {
      vm.isCallingServer = true;
      var updatePasswordRequest = {
        oldPassword: vm.oldPassword,
        newPassword: vm.newPassword
      };
      UserService.updatePassword(updatePasswordRequest,
        onPasswordChanged,
        onErrorInPasswordChange
      );
    };

    function onPasswordChanged() {
      vm.isCallingServer = false;
      vm.alert = MessageHelper.getSuccessAlert("Password successfully updated");
      resetPasswordFields();
      resetForm();
    }

    function onErrorInPasswordChange(errorResponse) {
      vm.isCallingServer = false;
      if (errorResponse.status === HttpResponseCodes.CONFLICT) {
        vm.alert = MessageHelper.getErrorAlert("Current password is incorrect. Please try again.");
      } else {
        vm.alert = MessageHelper.getErrorAlert("There was an error updating your password. Please try again.");
      }
    }

    function resetForm() {
      $scope.updatePasswordForm.$setUntouched();
      $scope.updatePasswordForm.$setPristine();
    }

    return vm;
  }
})();

/*
 * Copyright (c) OCOGlobal 2017
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .controller('ResetPasswordController', ResetPasswordController);

  /** @ngInject */
  function ResetPasswordController(UserPasswordService, $stateParams, MessageHelper, $scope) {
    var vm = this;

    init();
    function init() {
      vm.alert = '';
      vm.isCallingServer = false;
    }

    vm.passwordsMatch = function() {
      return (angular.equals(vm.newPassword, vm.confirmPassword))
    };

    vm.passwordsValid = function() {
      if (angular.isUndefined(vm.newPassword) || isPasswordOnlySpaces(vm.newPassword)) {
        return false
      } else if (angular.isUndefined(vm.confirmPassword) || isPasswordOnlySpaces(vm.confirmPassword)) {
        return false
      } else {
        return true;
      }
    }

    function isPasswordOnlySpaces(password) {
      return (password.trim() <= 0);
    }

    function getResetPasswordRequest() {
      return {
        userId: $stateParams.userId,
        passwordResetToken: $stateParams.passwordResetToken,
        newPassword: vm.confirmPassword
      }
    }

    function doesUrlContainUserId() {
      return angular.isDefined($stateParams.userId);
    }

    function doesUrlContainHash() {
      return angular.isDefined($stateParams.passwordResetToken);
    }

    vm.resetPassword = function () {
      if (doesUrlContainUserId() && doesUrlContainHash()) {
        vm.isCallingServer = true;
        UserPasswordService.resetPassword(getResetPasswordRequest(),
          onSuccessfulPasswordReset,
          onErrorInPasswordReset
        )
      } else {
        showUnableToResetPasswordErrorMessage();
      }
    };

    function onSuccessfulPasswordReset() {
      vm.isCallingServer = false;
      vm.alert = MessageHelper.getSuccessAlert("Your password has been reset. Please <a ui-sref='login'>log in</a>.");
      resetPasswordFields();
      resetForm();
    }

    function onErrorInPasswordReset() {
      vm.isCallingServer = false;
      showUnableToResetPasswordErrorMessage();
    }

    function showUnableToResetPasswordErrorMessage() {
      vm.alert = MessageHelper.getErrorAlert("Unable to reset password. Please ensure passwords match or request another <a ui-sref='forgotPassword'>reset password</a>.");
    }

    function resetPasswordFields() {
      vm.newPassword = "";
      vm.confirmPassword = "";
    }

    function resetForm() {
      $scope.resetPasswordForm.$setUntouched();
      $scope.resetPasswordForm.$setPristine();
    }
    return vm;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */
(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .controller('RequestedProfilesController', RequestedProfilesController);

  /** @ngInject */
  function RequestedProfilesController(CompanyProfileService, MessageHelper, $scope, $rootScope,
                                       VelocitiEvents, LoadingService, CompanyListColumns, SortOrder) {
    var vm = this;

    vm.sortByColumn = CompanyProfileService.sortByColumn;
    vm.sortOrder = CompanyProfileService.sortOrder;

    var sortUpIcon = "&#xf0de;";
    var sortDownIcon = "&#xf0dd;";
    var sortIcon = "&#xf0dc;";

    init();
    function init() {
      populateColumnTitles();
      getCompanyProfiles();
    }

    function populateColumnTitles() {
      vm.nameColumn = CompanyListColumns.NAME;
      vm.countryColumn = CompanyListColumns.COUNTRY;
      vm.sectorColumn = CompanyListColumns.SECTOR;
      vm.ratingColumn = CompanyListColumns.RATING;
      vm.requestedColumn = CompanyListColumns.REQUESTED;
      vm.isCompleteColumn = CompanyListColumns.IS_COMPLETE;
    }

    vm.changeSortByColumn = function(columnName) {
      if (isSortByColumn(columnName)) {
        toggleSortOrder();
      } else {
        vm.sortByColumn = columnName;
        vm.sortOrder = SortOrder.ASCENDING;
        CompanyProfileService.setColumnSortOrder(vm.sortByColumn, vm.sortOrder)
      }
      getCompanyProfiles();
    };

    function isSortByColumn(columnName) {
      return columnName === vm.sortByColumn;
    }

    function toggleSortOrder() {
      vm.sortOrder = vm.sortOrder === SortOrder.ASCENDING ? SortOrder.DESCENDING : SortOrder.ASCENDING;
      CompanyProfileService.sortOrder = vm.sortOrder;
    }

    vm.getSortIcon = function(columnName) {
      if (isSortByColumn(columnName)) {
        return isSortingInAscendingOrder() ? sortDownIcon : sortUpIcon;
      }
      return sortIcon;
    };

    function isSortingInAscendingOrder() {
      return vm.sortOrder === SortOrder.ASCENDING;
    }

    function getCompanyProfiles() {
      LoadingService.isLoading(true);
      CompanyProfileService.getCompanyProfiles(function (profiles) {
        vm.companyProfiles = profiles;
        LoadingService.isLoading(false);
      }, function () {
        vm.alert = MessageHelper.getErrorAlert("Something went wrong while fetching your profiles. Please try again later.");
        LoadingService.isLoading(false);
      });
    }

    vm.isPending = function (company) {
      return company.status ? company.status !== "COMPLETE" : true;
    };

    var companyFilterChangedListener = $rootScope.$on(VelocitiEvents.COMPANY_FILTER_CHANGED, function() {
      getCompanyProfiles();
    });

    $scope.$on('$destroy', companyFilterChangedListener);

    vm.showCompanyDetails = function(company) {
      vm.companyDetails = {
        id: company.id,
        name: company.name,
        country: company.country,
        catSector: company.catSector,
        scale: company.scale,
        rating: company.rating
      }
    };

    vm.hasSearchResults = function () {
      return !!(vm.companyProfiles && vm.companyProfiles.companies.length > 0);
    };

    var companyProfileChangedListener = $rootScope.$on(VelocitiEvents.COMPANY_PROFILE_CHANGED, function() {
      getCompanyProfiles();
    });

    $scope.$on('$destroy', companyProfileChangedListener);

    return vm;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */
(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .controller('RequestRatingController', RequestRatingController);

  /** @ngInject */
  function RequestRatingController($q, LookupService, CompanyLookupService, CompanyRatingService, NavigationService, MessageHelper, $scope) {
    var vm = this;

    vm.companyLookupService = CompanyLookupService;
    vm.address = null;
    vm.company = {};
    vm.company.address = {};
    vm.isGetttingCompanyName = false;

    init();
    function init() {
      vm.isCallingServer = false;
      LookupService.getCountries(function() {
        vm.countries = LookupService.countryList;
      });
    }

    vm.search = function(companyName) {
      var deferred = $q.defer();
      vm.isGetttingCompanyName = true;
      CompanyLookupService.companyNameLookup(companyName, function(response) {
        vm.companiesLookedUp = response;
        deferred.resolve(
          response
        )
      });
      deferred.promise.then(
        function success() {
          vm.isGetttingCompanyName = false;
        },
         function error() {
          vm.isGetttingCompanyName = false;
        }
      )
      return deferred.promise;
    }

    function submitCompanyForAssessment(company) {
      if(locationIdFound()) {
        vm.isCallingServer = true;
        CompanyRatingService.requestCompanyRating(company,
          onRatingSuccess,
          function (response) {
            onRatingError(response)
          }
        );
      }
    }

    function onRatingSuccess() {
      vm.isCallingServer = false;
      vm.alert = MessageHelper.getSuccessAlert("Rating successfully requested.")
      clearForm();
    }

    function onRatingError(response) {
      vm.isCallingServer = false;
      if (response.data[0].search("country") >= 0) {
        vm.alert = MessageHelper.getErrorAlert("Country is invalid, please select a country from the drop down.")
      } else if (response.status === 409) {
        vm.alert = MessageHelper.getErrorAlert(response.data[0])
      }
      else {
        vm.alert = MessageHelper.getErrorAlert("Unable to submit company for rating. Please try again later.")
      }
    }

    function clearForm() {
      $scope.requestRatingForm.$setPristine();
      $scope.requestRatingForm.$setUntouched();
      vm.company.name = ""
      vm.address = ""
      vm.company.website = ""
    }

    vm.populateLocation = function() {
      if (doesLocationExist()) {
        getLocation();
      }
    }

    function locationIdNotFound() {
      return angular.isUndefined(vm.address.id);
    }

    function locationIdFound() {
      return angular.isDefined(vm.address.id);
    }

    function doesLocationExist() {
      return angular.isDefined(vm.address) && vm.address !== null;
    }

    function getLocation() {
      if (locationIdNotFound()) {
        var found = vm.countries.find(function (country) {
          return country.name.toLowerCase() === vm.address.toLowerCase();
        })
      }

      if(found) {
        vm.address = found
      }
      vm.isCallingServer = false;
    }

    vm.hasNoLocation = function() {
      return !doesLocationExist()  || locationIdNotFound()
    }

    vm.hasNoCompanyName = function () {
      return angular.isUndefined(vm.company.name) || isEmptyObject(vm.company.name);
    }

    vm.onSelect = function(selectedCompany) {
      if(doesSelectedCompanyExist(selectedCompany)) {
        NavigationService.goToCompanySearchWithParams(selectedCompany);
      }
    }

    function doesSelectedCompanyExist(selectedCompany) {
      for(var i = 1; i < vm.companiesLookedUp.length; i++) {
        if (selectedCompany.toLowerCase() === vm.companiesLookedUp[i].text.toLowerCase()) {
          return true;
        }
      }
      return false;
    }

    vm.hasNoWebsite = function () {
      return angular.isUndefined(vm.company.website) || isEmptyObject(vm.company.website);
    }

    vm.submitForm = function () {
      vm.company.address.countryId = vm.address.id;
      submitCompanyForAssessment(vm.company);
    }

    function isEmptyObject(objectToCheck) {
      return Object.keys(objectToCheck).length === 0;
    }

    return vm;
  }
})();

/*
 * Copyright (c) OCOGlobal 2017
 */

(function() {
  'use strict';

  angular
    .module('ocoExternalSite')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController(UserService, MessageHelper, UserPreferencesService, NavigationService, $interval,  $scope, $timeout) {
    var vm = this;

    vm.isCallingServer = false;
    vm.otpModal = false;
    vm.verifyOtpForm = { trustDevice : false };
    var TOTAL_SECONDS = 600;
    var timerInterval;
    var startTime = null;
    var endTime = null;
    // ── Timer ──────────────────────────────────────────────
    function startTimer() {
      if (timerInterval) $interval.cancel(timerInterval);

      startTime = Date.now();
      endTime = startTime + (TOTAL_SECONDS * 1000);

      vm.canResend = false;
      vm.isUrgent = false;
      vm.progressWidth = 100;
      vm.timeDisplay = formatTime(TOTAL_SECONDS);

      timerInterval = $interval(function() {
        var remaining = Math.round((endTime - Date.now()) / 1000);

        if (remaining <= 0) {
          $interval.cancel(timerInterval);
          vm.timeDisplay = '00:00';
          vm.progressWidth = 0;
          vm.isUrgent = false;
          vm.canResend = true;
          return;
        }

        vm.timeDisplay = formatTime(remaining);
        vm.progressWidth = Math.round((remaining / TOTAL_SECONDS) * 100);
        vm.isUrgent = remaining <= 10;
      }, 1000);
    }
    // ── Helpers ────────────────────────────────────────────
    function formatTime(s) {
      var m = Math.floor(s / 60);
      var sec = s % 60;
      return pad(m) + ':' + pad(sec);
    }

    function pad(n) {
      return n < 10 ? '0' + n : '' + n;
    }

    function focusInput(index) {
      var inputs = document.querySelectorAll('.otp-digit');
      if (inputs[index]) inputs[index].focus();
    }

    function highlightEmpty() {
      var inputs = document.querySelectorAll('.otp-digit');
      vm.digits.forEach(function(d, i) {
        if (!d.value) {
          inputs[i].style.borderColor = '#E24B4A';
          $timeout(function() { inputs[i].style.borderColor = ''; }, 800);
        }
      });
    }

    $scope.$on('$destroy', function() {
      if (timerInterval) $interval.cancel(timerInterval);
    });

// ── Helper to build blank digits array ────────────────────
    function buildDigits() {
      var digits = [];
      for (var i = 0; i < 6; i++) {
        digits.push({ value: '' });
      }
      return digits;
    }
     function openOtpModal() {
      vm.digits = buildDigits();
      vm.verified = false;
      vm.verifying = false;
      vm.verifyLabel = 'Verify Code';
      vm.otpModal = true;
      startTimer();
      $timeout(function() { focusInput(0); }, 100);
    }
    // ── OTP Input Handlers ─────────────────────────────────
    vm.onDigitChange = function(index) {
      var raw = vm.digits[index].value || '';
      var clean = raw.replace(/[^0-9]/g, '');

      // Handle paste of full OTP
      if (clean.length > 1) {
        var chars = clean.slice(0, 6).split('');

        chars.forEach(function(ch, i) {
          if (vm.digits[i]) {
            vm.digits[i].value = ch;
          }
        });

        focusInput(Math.min(chars.length, 5));
        return;
      }

      vm.digits[index].value = clean;

      // Auto move next
      if (clean && index < 5) {
        $timeout(function() {
          focusInput(index + 1);
        });
      }
    };
    vm.onKeyDown = function(event, index) {
      if (event.key === 'Backspace' && !vm.digits[index].value && index > 0) {
        $timeout(function() {
          focusInput(index - 1);
        });
      }
    };

    function closeOtpModal() {
      vm.otpModal = false;
      if (timerInterval) $interval.cancel(timerInterval);
    }
    // ── Resend OTP ─────────────────────────────────────────────
    vm.resetTimer = function() {
      if (!vm.tempToken) return;

      var otpRequest = {};
      otpRequest.tempToken = vm.tempToken;
      UserService.resendOtp(otpRequest, function (response){
        if (timerInterval) $interval.cancel(timerInterval);
        vm.digits = buildDigits();
        vm.verified = false;
        vm.verifying = false;
        vm.verifyLabel = 'Verify Code';
        $timeout(function() { focusInput(0); }, 50);
        startTimer();
        vm.alert = MessageHelper.getSuccessAlert(response.message, vm);
      }, function (err){
        showErrorMessage(err);
      });
    };

    // ── Verify OTP ─────────────────────────────────────────────
    vm.handleVerify = function() {
      var code = '';
      for (var i = 0; i < vm.digits.length; i++) {
        code += vm.digits[i].value;
      }

      if (code.length < 6) {
        highlightEmpty();
        return;
      }

      vm.verifying = true;
      vm.verifyLabel = 'Verifying...';

      var otpRequest = {
        tempToken: vm.tempToken,
        otp: code,
        trustDevice: vm.verifyOtpForm.trustDevice
      };

      UserService.verifyOtp(otpRequest,
        function() {
          vm.verifying = false;
          vm.verified = true;
          vm.verifyLabel = 'Verified!';
          $interval.cancel(timerInterval);

          $timeout(function() {
            closeOtpModal();
            onVerifyOtp();
          }, 800);
        },
        function(error) {
          vm.verifying = false;
          vm.verifyLabel = 'Verify Code';
          var msg = (error && error.data) ? error.data : "Incorrect OTP";
          vm.alert = MessageHelper.getErrorAlert(msg, vm);
          $timeout(function() {
            vm.alert = null;
          }, 10000);
        });
    };


    init();
    function init() {
      vm.alert = '';
    }

    vm.login = function() {
      vm.isCallingServer = true;
      UserService.login(
        getUserCredentials(),
        onLoginSubmit,
        onErrorInLogin
      );
    };

    function onLoginSubmit(response){
      if(response.mfaRequired){
        vm.tempToken = response.tempToken;
        openOtpModal();
      }
      else{
        UserService.storeUser(response);
        onVerifyOtp();
      }
      vm.alert = MessageHelper.getSuccessAlert(response.message, vm);
      $timeout(function() {
        vm.alert = null;
      }, 10000);
    }

    function getUserCredentials() {
      return {username: vm.username, password: vm.password};
    }

    function showErrorMessage(message) {
      vm.alert = MessageHelper.getErrorAlert(message);
    }

    function onVerifyOtp() {
        UserPreferencesService.getUserPreferences(
          onUserPreferencesFetched,
          onErrorFetchingUserPreferences,
          onFinishedFetchingUserPreferences
        );
    }

    function onErrorInLogin() {
      vm.isCallingServer = false;
      showErrorMessage("Sorry we could not find a matching username and password. Have you <a ui-sref='forgotPassword'>forgotten your password</a>?");
    }

    function onUserPreferencesFetched(userPreferences) {
      if (areUserPreferencesComplete(userPreferences)) {
        NavigationService.goToCompanies();
      } else {
        NavigationService.goToWelcome();
      }
    }

    function areUserPreferencesComplete(userPreferences) {
      return userPreferences.location !== null;
    }

    function onErrorFetchingUserPreferences() {
      NavigationService.goToCompanies();
    }

    function onFinishedFetchingUserPreferences() {
      vm.isCallingServer = false;
    }

    return vm;
  }
})();

/*
 * Copyright (c) OCOGlobal 2017
 */

(function() {
  'use strict';

  angular
    .module('ocoExternalSite')
    .controller('ForgotPasswordController', ForgotPasswordController);

  /** @ngInject */
  function ForgotPasswordController(UserPasswordService, $state, RouterStates, $log, $document) {
    var vm = this;
    init();
    function init() {
      vm.emailAddress = '';
      vm.alert = '';
    }

    function resetEmailAddressInput() {
      var inputField = $document[0].getElementsByName("forgotPasswordForm")[0];
      inputField.reset();
    }

    vm.submitPasswordReset = function() {
      UserPasswordService.resetPasswordRequest(vm.emailAddress,
        function() {
          successMessage("If an account exists for <strong>" + vm.emailAddress + "</strong>, you should receive an email containing " +
            "instructions on how to create a new password.<br><a href='' ui-sref='login'>Return to the sign in page.</a>");
          resetEmailAddressInput();
        },
        function(error) {
          errorMessage("An error occurred while trying to send password reset email, please try again later" +
            "<br><a href='' ui-sref='login'>Return to the sign in page.</a>");
          $log.error(error);
        }
      )
    };

    vm.goToLogin = function() {
      $state.go(RouterStates.LOGIN)
    };

    function errorMessage(message) {
      vm.alert = {
        type: 'error',
        message: message
      };
    }

    function successMessage(message) {
      vm.alert = {
        type: 'success',
        message: message
      };
    }

    return vm;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .controller('NotFoundController', NotFoundController);

  /** @ngInject */
  function NotFoundController($document, $window) {
    var vm = this;

    var backbutton = $document[0].getElementById("backButton");
    backbutton.onclick = function(e){
      e = e || $window.event; // support  for IE8 and lower
      e.preventDefault(); // stop browser from doing native logic
      $window.history.back();
    }

    return vm;
  }
})();

/*
 * Copyright (c) OCOGlobal 2017
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .controller('VelocitiListSearchCompaniesController', VelocitiListSearchCompaniesController);

  /** @ngInject */
  function VelocitiListSearchCompaniesController(
    CompanyService,
    $stateParams,
    CompanyFilterService,
    MessageHelper,
    $rootScope,
    VelocitiEvents,
    $scope,
    UserPreferencesService) {
    var vm = this;
    vm.searchCountResultsPage = null;
    vm.searchCountResultsCount = null;
    vm.searchCountResults = {'matching' : 0, 'page' : 1};

    vm.search = function () {
      vm.isSearching = true;
      CompanyService.searchOnCurrentFilter(
        onSearchResultsFound,
        onErrorFindingSearchResults
      );
      CompanyService.searchOnCurrentFilterForCount(
        onTotalSearchResultsFound,
        onErrorFindingSearchResults
      );
    };

    function onSearchResultsFound(response) {
      vm.isSearching = false;
      resetUserMessages();
      vm.searchResults = response;
      vm.companies = response.companies;
      vm.searchCountResultsPage = response.page;
      calculatePaginationAndTotalCompany();
    }
    function onTotalSearchResultsFound(response) {
    vm.isSearching = false;
    resetUserMessages();
    vm.searchCountResultsCount = response.matching;
    vm.noCompaniesInList = vm.searchResults.matching === 0;
    calculatePaginationAndTotalCompany();
    }

    function calculatePaginationAndTotalCompany(){
            vm.searchCountResults = {'matching' : vm.searchCountResultsCount, 'page' : vm.searchCountResultsPage};
    }

    function onErrorFindingSearchResults() {
      vm.isSearching = false;
      showErrorMessage("An error occurred when searching. Please try again.");
    }

    var companyFilterChangedListener = $rootScope.$on(VelocitiEvents.COMPANY_FILTER_CHANGED, function () {
      vm.search();
    });

    $scope.$on('$destroy', companyFilterChangedListener);

    function showErrorMessage(message) {
      vm.alert = MessageHelper.getErrorAlert(message);
    }

    function getVariablesFromStateParams() {
      vm.listName = $stateParams.name;
      vm.listId = $stateParams.id;
    }

    init();
    function init() {
      resetUserMessages();
      vm.isSearching = false;
      vm.searchResults = null;
      getVariablesFromStateParams();
      CompanyFilterService.resetSearchFilterToDefault();
      CompanyFilterService.setForSearchingInList(vm.listId);
      UserPreferencesService.getUserPreferences(
        afterUserPreferencesRetrieved,
        function() {
          // do nothing on error. Search on defaults
        },
        vm.search
      );
    }

    function afterUserPreferencesRetrieved(userPreferences) {
      setFocus(userPreferences.focus);
      vm.userLocationId = userPreferences.location;
    }

    function setFocus(focus) {
      vm.isTradeFocused = focus === "Trade";
    }

    function resetUserMessages() {
      vm.alert = "";
    }
  }
})();

/*
 * Copyright (c) OCOGlobal 2017
 */

(function() {
  'use strict';

  angular
    .module('ocoExternalSite')
    .controller('VelocitiListController', VelocitiListController);

  /** @ngInject */
  function VelocitiListController(
    CompanyService,
    $stateParams,
    CompanyFilterService,
    MessageHelper,
    $rootScope,
    VelocitiEvents,
    $scope,
    NavigationService,
    UserPreferencesService) {

    var vm = this;
    vm.noCompaniesInList = false;
    vm.hasSearchResults = false;
    vm.searchCountResultsPage = null;
    vm.searchCountResultsCount = null;
    vm.searchCountResults = {'matching' : 0, 'page' : 1};

    vm.search = function() {
      vm.isSearching = true;
      CompanyService.searchOnCurrentFilter(
        onSearchResultsFound,
        onErrorFindingSearchResults
      );
      CompanyService.searchOnCurrentFilterForCount(
      onTotalSearchResultsFound,
      onErrorFindingSearchResults
      );
    };

    function onSearchResultsFound(response) {
      vm.isSearching = false;
      resetUserMessages();
      vm.searchResults = response;
      vm.companies = response.companies;
      vm.searchCountResultsPage = response.page;
      vm.hasSearchResults = !vm.noCompaniesInList;
      calculatePaginationAndTotalCompany();
    }

    function onTotalSearchResultsFound(response) {
    vm.isSearching = false;
    resetUserMessages();
    vm.searchCountResultsCount = response.matching;
    vm.noCompaniesInList = vm.searchCountResultsCount === 0;
    calculatePaginationAndTotalCompany();
    }

    function calculatePaginationAndTotalCompany(){
            vm.searchCountResults = {'matching' : vm.searchCountResultsCount, 'page' : vm.searchCountResultsPage};
    }

    function onErrorFindingSearchResults() {
      vm.isSearching = false;
      showErrorMessage("An error occurred when getting companies. Please try again later.");
    }

    var companyFilterChangedListener = $rootScope.$on(VelocitiEvents.COMPANY_FILTER_CHANGED, function() {
      vm.search();
    });

    $scope.$on('$destroy', companyFilterChangedListener);

    vm.goToAddCompanies = function () {
      NavigationService.goToVelocitiListSearchCompanies(vm.listId, vm.listName);
    };

    function init() {
      resetUserMessages();
      vm.isSearching = false;
      vm.searchResults = null;
      getVariablesFromStateParams();
      CompanyFilterService.setVelocityListFilter(vm.listId);
      UserPreferencesService.getUserPreferences(
        afterUserPreferencesRetrieved,
        function() {
          // do nothing on error. Search on defaults
        },
        vm.search
      );
    }

    function afterUserPreferencesRetrieved(userPreferences) {
      setFocus(userPreferences.focus);
      vm.userLocationId = userPreferences.location;
    }

    function setFocus(focus) {
      vm.isTradeFocused = focus === "Trade";
    }

    function showErrorMessage(message) {
      vm.alert = MessageHelper.getErrorAlert(message);
    }

    function getVariablesFromStateParams() {
      vm.listName = $stateParams.name;
      vm.listId = $stateParams.id;
    }

    init();

    function resetUserMessages() {
      vm.alert = "";
    }
  }
})();

/**
 * Copyright 2020 OCO Global.
 */

(function() {
  'use strict';

  /** @ngInject **/
  angular
    .module('ocoExternalSite')
    .controller('TopTargetListsController', function ($scope, $state, RouterStates, TopTargetListService) {
      $scope.typeFilterOptions = [{
        label: 'All List Types',
        value: null,
      }, {
        label: 'Velociti Lists',
        value: 'velociti',
      }, {
        label: 'Worldwide Lists',
        value: 'worldwide',
      }];
       $scope.currentYear = new Date().getUTCFullYear();
       $scope.yearChecking = null;
       $scope.loadingTopTargetList = -1;
       $scope.modifiedList = [{"year": null , "content" : []}];
      $scope.yearFilterOptions = [{
          label: "Select All Year",
          value: null,
        },{
          label: $scope.currentYear,
          value: $scope.currentYear,
        }, {
          label: ($scope.currentYear-1),
          value: ($scope.currentYear-1),
        }, {
          label: ($scope.currentYear-2),
          value: ($scope.currentYear-2),
        }, {
          label: ($scope.currentYear-3),
          value: ($scope.currentYear-3),
      }];


      $scope.typeFilter = $scope.typeFilterOptions[0];
      $scope.selectedYearFilter = $scope.yearFilterOptions[0];

      Object.defineProperties($scope, {
        listFilter: {
          get: function() {
            var filter = {};
            if ($scope.typeFilter && $scope.typeFilter.value) { filter.type = $scope.typeFilter.value; }
            return filter;
          }
        },
        typeFilterLabel: {
          get: function() {
            return $scope.typeFilter ? $scope.typeFilter.label : null;
          }
        },
      });
Object.defineProperties($scope, {
        yearFilter: {
          get: function() {
            var filter = {};
            if ($scope.selectedYearFilter && $scope.selectedYearFilter.value) { filter.year = $scope.selectedYearFilter.value; }
            return filter;
          }
        },
        yearFilterLabel: {
          get: function() {
            return $scope.selectedYearFilter ? $scope.selectedYearFilter.label : null;
          }
        },
      });

      TopTargetListService.getLists().then(function(lists) {
        $scope.lists = lists;
         $scope.lists.sort(sortByProperty('currentYear'));
                  $scope.lists.reverse();
                  var position = 0;
                  for(var i=0; i < $scope.lists.length; i++){
                      if(isSameYear($scope.lists[i].currentYear)){
                          $scope.modifiedList.push({"year": $scope.lists[i].currentYear ,
                                      "content" : [{"id": $scope.lists[i].id, "name": $scope.lists[i].name, "image": $scope.lists[i].image,
                                      "type": $scope.lists[i].type, "currentYear": $scope.lists[i].currentYear, "previousYears":$scope.lists[i].previousYears,
                                      "totalCompanies":$scope.lists[i].totalCompanies, "$$hashKey":$scope.lists[i].$$hashKey}]});
                          position += 1
                      }
                      else{
                        $scope.modifiedList[position].content.push({"id": $scope.lists[i].id, "name": $scope.lists[i].name, "image": $scope.lists[i].image,
                                       "type": $scope.lists[i].type, "currentYear": $scope.lists[i].currentYear, "previousYears":$scope.lists[i].previousYears,
                                       "totalCompanies":$scope.lists[i].totalCompanies, "$$hashKey":$scope.lists[i].$$hashKey});
                      }
                  }

                  if($scope.lists.length > 0){
                    $scope.loadingTopTargetList = 1;
                  }
                  else{
                    $scope.loadingTopTargetList = 0;
                  }
      });

      $scope.goToList = function ($event, list) {
        $scope.goToListAndYear($event, list, list.currentYear);
      };

      $scope.goToListAndYear = function ($event, list, year) {
        $event.stopPropagation();
        $state.go(RouterStates.COMPANIES, {
          topTargetList: list,
          topTargetYear: year
        });
      };

      $scope.setTypeFilter = function(option) {
        $scope.typeFilter = option;
      };
       $scope.setYearFilter = function(option) {
              $scope.selectedYearFilter = option;
            };

            function isSameYear(year) {
              if($scope.yearChecking == year ){
                $scope.yearChecking = year;
                return false;
              }
              else{
                $scope.yearChecking = year;
                return true;
              }
            };

            function sortByProperty(property){
               return function(a,b){
                  if(a[property] > b[property])
                     return 1;
                  else if(a[property] < b[property])
                     return -1;

                  return 0;
               }
            }
    });
})();

/**
 * Copyright 2017 OCO Global.
 */

(function() {
  'use strict';

  angular
    .module('ocoExternalSite')
    .controller('MyListsController', MyListsController);

  /** @ngInject */
  function MyListsController(MyListsSummaryService, MessageHelper, SectorImageMapperService, ModalService,
                             VelocitiListService, StringUtils, NavigationService) {
    var vm = this;
    vm.isSearching = false;
    vm.isEditing = false;
    vm.isUpdating = false;
    vm.isAdding = false;
    vm.thereAreListsToDisplay = false;
    vm.velocitiListSummaries = [];
    var velocitiListSummariesWithoutChanges = [];
    vm.rightButtonText = "Edit Lists";
    vm.sortButtonText = "Recently Edited";
    vm.addModal = {};

    vm.getMyListsSummarySortedByMostRecent = function() {
      vm.isSearching = true;
      vm.sortButtonText = "Recently Edited";
      getMyListsSummarySortedByMostRecent();
    };

    function getMyListsSummarySortedByMostRecent() {
      MyListsSummaryService.getMyListsSummarySortedByMostRecent(
        onSummaryFound,
        onErrorFindingSummary
      );
    }

    vm.goToList = function(velocitiListSummary) {
      if (!vm.isEditing) {
        NavigationService.goToVelocitiList(velocitiListSummary.listId, velocitiListSummary.name);
      }
    };

    vm.getMyListsSummarySortedByName = function() {
      vm.isSearching = true;
      vm.sortButtonText = "Name";
      getMyListsSummarySortedByName();
    };

    function getMyListsSummarySortedByName() {
      MyListsSummaryService.getMyListsSummarySortedByName(
        onSummaryFound,
        onErrorFindingSummary
      );
    }

    vm.toggleEditing = function(listSummaries) {
      vm.alert = '';
      if (vm.isEditing) {
        saveListNamesEdits(listSummaries)
      } else {
        toggleEditing()
      }
    };

    function toggleEditing() {
      vm.isEditing = !vm.isEditing;
      vm.rightButtonText = vm.isEditing ? "Finished Editing" : "Edit Lists";
    }

    function saveListNamesEdits(listSummaries) {
      listSummaries.forEach(function (summary, index, array) {
        if(isNewListName(summary)) {
          updatesHaveStarted();
          updateList(summary, function () {
            updatesHaveFinished();
            finishEditing(index, array);
          }, function () {
            vm.alert = MessageHelper.getErrorAlert("Unable to update lists. Please try again later");
            updatesHaveFinished();
          })
        } else {
          finishEditing(index, array);
        }
      });
    }

    function finishEditing(index, array) {
      if (isLastItem(index, array) && hasNoError()) {
        toggleEditing();
      }
    }

    function isLastItem(index, array) {
      return index === array.length - 1;
    }

    function hasNoError() {
      return vm.alert === '';
    }

    vm.keyPressed = function(event, summaryToUpdate) {
      if (isEnterKey(event) || isTabKey(event)) {
        resetUserMessages();
        event.preventDefault();
        if (!isNewListName(summaryToUpdate)) {
          tabToNextList(summaryToUpdate);
          return;
        }

        updatesHaveStarted();
        updateList(summaryToUpdate,
          function() {
            updatesHaveFinished();
            tabToNextList(summaryToUpdate)
          },
          function() {
            vm.alert = MessageHelper.getErrorAlert("We had trouble updating your list. Please try again later.");
            updatesHaveFinished();
          }
        );
      }
    };

    function isEnterKey(event) {
      return event.keyCode === 13;
    }

    function isTabKey(event) {
      return event.keyCode === 9;
    }

    function isNewListName(listToUpdate) {
      var indexOfMatchingList = velocitiListSummariesWithoutChanges.findIndex(function(summary) {
        return summary.name.toUpperCase() === listToUpdate.name.toUpperCase() && summary.listId === listToUpdate.listId;
      });
      return indexOfMatchingList === -1;
    }

    function tabToNextList(listToTabFrom) {
      var currentListIndex = vm.velocitiListSummaries.findIndex(function(summary) {
        return summary.listId === listToTabFrom.listId;
      });
      if (isNotLastList(currentListIndex)) {
        angular.element('#' + vm.velocitiListSummaries[currentListIndex + 1].listId).focus();
      }
    }

    function isNotLastList(listIndex) {
      return listIndex !== vm.velocitiListSummaries.length - 1
    }

    vm.deleteList = function(listToDeleteId, listName) {
      updatesHaveStarted();
      resetUserMessages();
      var modalInstance = ModalService.showOkCancelModal("Are you sure you want to delete the " + listName + " list?")
      modalInstance.result.then(
        function() {
          VelocitiListService.deleteList(listToDeleteId,
            function() {
              removeDeletedItemFromVelocitiListSummaries(listToDeleteId);
              updatesHaveFinished();
            },
            function() {
              vm.alert = MessageHelper.getErrorAlert("We had trouble deleting your list. Please try again later.");
              updatesHaveFinished();
            });
        },
        function() {
          updatesHaveFinished();
        }
      );
    };

    function updatesHaveStarted() {
      vm.isUpdating = true;
    }

    function updatesHaveFinished() {
      vm.isUpdating = false;
    }

    function addListHasStarted() {
      vm.isAdding = true;
    }

    function addListHasFinished() {
      vm.isAdding = false;
    }

    vm.addList = function() {
      addListHasStarted();
      var modalInstance = ModalService.showNewListModal();
      modalInstance.result.then(
        addListWithSpecifiedName,
        function() {
          addListHasFinished();
        });
    };

    function addListWithSpecifiedName(listName) {
      VelocitiListService.addList(getListToAdd(listName),
        function(addedList) {
          addListHasFinished();
          NavigationService.goToVelocitiList(addedList.id, addedList.name);
        },
        function(error) {
          if (isDuplicateListError(error)) {
            vm.alert = MessageHelper.getErrorAlert("You already have a list called " + listName + ". You cannot create duplicate lists.");
          } else {
            vm.alert = MessageHelper.getErrorAlert("We had trouble adding your list. Please try again later.");
          }
          addListHasFinished();
        });
    }

    function getListToAdd(listName) {
      return {
        name: listName
      };
    }

    function isDuplicateListError(error) {
      return error.status === 409;
    }

    function removeDeletedItemFromVelocitiListSummaries(listToDeleteId) {
      var newVelocitiListSummaries = [];
      var j = 0;
      for (var i = 0; i < vm.velocitiListSummaries.length; i++) {
        if (vm.velocitiListSummaries[i].listId !== listToDeleteId) {
          newVelocitiListSummaries[j] = vm.velocitiListSummaries[i];
          j++
        }
      }
      setVelocitiListSummaries(newVelocitiListSummaries);
    }

    function setVelocitiListSummaries(listsToSet) {
      vm.velocitiListSummaries = listsToSet;
      angular.copy(listsToSet, velocitiListSummariesWithoutChanges);
      vm.thereAreListsToDisplay = listsToSet.length > 0;
    }

    function updateList(listToUpdate, success, error) {
      resetUserMessages();
      if (isBlankListName(listToUpdate.name)) {
        vm.alert = MessageHelper.getErrorAlert("You must provide a list name.");
        updatesHaveFinished();
        return;
      }
      if (isDuplicateListName(listToUpdate)) {
        vm.alert = MessageHelper.getErrorAlert("You cannot use duplicate list names. Please see your " + listToUpdate.name.toUpperCase() + " lists.");
        updatesHaveFinished();
        return;
      }

      updateListWithoutChanges(listToUpdate);
      VelocitiListService.updateList(getVelocitiList(listToUpdate), success, error);
    }

    function updateListWithoutChanges(listToUpdate) {
      var index = vm.velocitiListSummaries.findIndex(function(summary) {
        return summary.listId === listToUpdate.listId;
      });

      if (index >= 0) {
        velocitiListSummariesWithoutChanges[index] = angular.copy(vm.velocitiListSummaries[index]);
      }
    }

    function isBlankListName(name) {
      return StringUtils.isEmpty(name.trim());
    }

    function isDuplicateListName(listToUpdate) {
      var index = vm.velocitiListSummaries.findIndex(function(summary) {
        return summary.name.toUpperCase() === listToUpdate.name.toUpperCase() && summary.listId !== listToUpdate.listId;
      });
      return index !== -1;
    }

    function onSummaryFound(response) {
      vm.isSearching = false;
      for (var i = 0; i < response.length; i++) {
        response[i].imageUrl = SectorImageMapperService.getSectorImageUrl(response[i].sectorWhichDescribesList);
      }
      setVelocitiListSummaries(response);
    }

    function onErrorFindingSummary() {
      vm.isSearching = false;
      vm.alert = MessageHelper.getErrorAlert("We were unable to get your lists at this time. Please try later.");
    }

    function init() {
      resetUserMessages();
      vm.getMyListsSummarySortedByMostRecent();
    }

    function resetUserMessages() {
      vm.alert = "";
    }

    function getVelocitiList(velocitiListSummary) {
      return {
        "id": velocitiListSummary.listId,
        "name": velocitiListSummary.name
      };
    }

    init();

    return vm;
  }
})();

/*
 * Copyright 2016 Instil Software.
 */

(function() {
  'use strict';

  angular
    .module('ocoExternalSite')
    .controller('LayoutController', LayoutController);

  /** @ngInject */
  function LayoutController(UserService, $state, $scope) {
    var vm = this;
    vm.userService = UserService;
    vm.username = UserService.getUsername();
    vm.currentYear = getCurrentYear();

    $scope.$on("$stateChangeStart", function(event, toState) {
      toggleSidebar(toState.url.substring(1));
      toggleIsWhiteBackground(toState.name);
    });
    function toggleSidebar(name) {
      vm.isShowingSidebar = !(name === "myVelociti" || name === "welcome" || name === "notFound");
    }

    function toggleIsWhiteBackground(name) {
      vm.isWhiteBackground = name === "userPreferences"
        || name === "companies"
        || name === "myLists"
        || name === "topTargetLists"
        || name === "requestRating"
        || name === "exhibitorAnalysis"
        || name === "updatePassword"
        || name === "contact";
    }

    function getCurrentYear() {
      return (new Date()).getFullYear()
    }

    function init() {
      toggleSidebar($state.current.name);
      toggleIsWhiteBackground($state.current.name)
    }

    init();

    return vm;
  }
})();

/* eslint-disable no-console */

(function() {
  'use strict';

  /** @ngInject */
  function InvestmentSignalsController($scope, CompanyService, InvestSignalResource, LookupService,ModalService,  $location ) {
    var vm = this;

    var months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ];

    var YEAR_ESTABLISHED_MAX = new Date().getFullYear();
    var YEAR_ESTABLISHED_MIN = YEAR_ESTABLISHED_MAX - 100;

    function generatePublishedSinceOptions(qty) {
      var results = [];
      var today = new Date();
      var year = today.getFullYear();
      var month = today.getMonth();
      for (var i = 0; i < qty; i++) {
        results.push({
          date: new Date(year, month),
          label: months[month] + " " + year
        });
        month--;
        if (month < 0) {
          month = 11;
          year--;
        }
      }
      return results;
    }

    function performSearch() {
      var request = {};
      if (vm.search.name) { request.company_name = vm.search.name; }
      if (vm.search.hq) { request.hq = vm.search.hq; }
      if (vm.search.region) { request.region = vm.search.region; }
      if (vm.search.sector) { request.sectors = vm.search.sector; }
      if (vm.search.targetMarket) { request.target_markets = vm.search.targetMarket; }
      if (vm.search.noPresence) { request.no_presence = [vm.search.noPresence]; }
      if (vm.search.noOverseasPresence) { request.no_overseas_presence = [vm.search.noOverseasPresence]; }
      if (vm.published_from) { request.published_from = vm.published_from; }
      if (vm.published_to) { request.published_to = vm.published_to; }
//      if (vm.search.publishedSince) { request.published_since = getPublishedSinceDate(vm.search.publishedSince.date); }
      if (vm.search.yearEstablished) { request.year_established = vm.search.yearEstablished; }

      request.limit = vm.resultsPerPage;
      request.start = vm.resultsPerPage * (vm.currentPage - 1);

      InvestSignalResource.searchPublished(request).then(function(response) {
        var limit = response.limit;
        var results = response.results;
        var start = response.start;
        var total = response.total;
        vm.results = results;
        vm.totalResults = total;
        vm.currentPage = Math.floor(start / limit) + 1;
        vm.isLoading = false;

      }, function(error) {
        vm.isLoading = false;
      });

    }

    function onSearchChange(newValue, oldValue) {
      if (newValue !== oldValue) { performSearch(); }
    }

    function updateAutoComplete(callback) {
      return function(newValue, oldValue) {
        if (newValue == oldValue) { return; }
        if (!newValue) { callback(''); }
        else {
          if (vm.countries.indexOf(newValue) <= -1) { return; }
          callback(newValue);
        }
      };
    }

    vm.currentPage = 1;
    vm.countries = [];
    vm.hqSearch = '';
    vm.noPresenceSearch = '';
    vm.noOverseasPresenceSearch = '';
    vm.isLoading = true;
    vm.regions = [];
    vm.results = null;
    vm.dateRange = null;
    published_from: null;
    published_to: null;
    vm.resultsPerPage = 10;
    vm.search = {
      name: '',
      hq: '',
      region: '',
      sector: [],
      targetMarket: [],
      noPresence: '',
      noOverseasPresence: '',
//      published_from: null,
//      published_to: null,
      yearEstablished: {
        min: null,
        max: null
      }
    };
    vm.publishedSinceOptions = generatePublishedSinceOptions(24);
    vm.sectors = [];
    vm.totalResults = 0;
    vm.status = "Download"

    var yearEstablishedTooltipFormatter = {
      to: function(value) {
        return '<span>' + value + '</span>';
      },
      from: function(value) {
        return value;
      }
    };

    vm.yearEstablishedOptions = {
      start: [YEAR_ESTABLISHED_MIN, YEAR_ESTABLISHED_MAX],
      step: 1,
      connect: true,
      range: {
        min: YEAR_ESTABLISHED_MIN,
        max: YEAR_ESTABLISHED_MAX
      },
      tooltips: [yearEstablishedTooltipFormatter, yearEstablishedTooltipFormatter],
      format: {
        to: function(value) {
          return parseInt(value);
        },
        from: function(value) {
          return parseInt(value);
        }
      }
    };

    vm.yearEstablishedEvents = {
      change: function(values) {
        vm.search.yearEstablished.min = parseInt(values[0]);
        vm.search.yearEstablished.max = parseInt(values[1]);
        performSearch();
      }
    };

    vm.formatPublishedAt = function(input) {
      var date = new Date(input);
      return months[date.getMonth()] + ' ' + date.getFullYear();
    };

    vm.downloadList = function() {
    vm.isLoading = true;
     var request = {};
          if (vm.search.name) { request.company_name = vm.search.name; }
          if (vm.search.hq) { request.hq = vm.search.hq; }
          if (vm.search.region) { request.region = vm.search.region; }
          if (vm.search.sector) { request.sectors = vm.search.sector; }
          if (vm.search.targetMarket) { request.target_markets = vm.search.targetMarket; }
          if (vm.search.noPresence) { request.no_presence = [vm.search.noPresence]; }
          if (vm.search.noOverseasPresence) { request.no_overseas_presence = [vm.search.noOverseasPresence]; }
          if (vm.dateRange) { request.published_from = vm.published_from; }
          if (vm.dateRange) { request.published_to = vm.published_to; }
//          if (vm.search.publishedSince) { request.published_since = getPublishedSinceDate(vm.search.publishedSince.date); }
          if (vm.search.yearEstablished) { request.year_established = vm.search.yearEstablished; }

          request.limit = vm.resultsPerPage;
          request.start = vm.resultsPerPage * (vm.currentPage - 1);
          vm.status = "Downloading";
          InvestSignalResource.exportSignals(request).then(function(response) {
          showMessage(response);
          vm.status = "Download";
                    }, function(error) {
                      vm.status = "Download";
                      vm.isLoading = false;
                    });
    };
    function showMessage(message) {
      return ModalService.showOkCancelModal(message).result;
    }




    vm.showCompanyDetails = function(signal) {
      CompanyService.getCompanyDetails(signal.company_id, function (company) {
        vm.companyDetails = {
          id: company.id,
          name: company.name,
          website: company.website,
          catSector: company.catSector,
          rating: company.grade
        };
      }, function() {});
    };

    angular.forEach(vm.search, function(value, key) {
      $scope.$watch("investmentSignalsController.search." + key, onSearchChange);
    });

    $scope.$watch("investmentSignalsController.currentPage", onSearchChange);
    $scope.$watch("investmentSignalsController.resultsPerPage", onSearchChange);

    $scope.$watch("investmentSignalsController.hqSearch", updateAutoComplete(function(value) {
      vm.search.hq = value;
    }));

    $scope.$watch("investmentSignalsController.noPresenceSearch", updateAutoComplete(function(value) {
      vm.search.noPresence = value;
    }));

    $scope.$watch("investmentSignalsController.noOverseasPresenceSearch", updateAutoComplete(function(value) {
      vm.search.noOverseasPresence = value;
    }));

     var countriesLoaded = false;
     var regionsLoaded = false;

    LookupService.getCountries(function() {
      var countries = [];
      angular.forEach(LookupService.countryList, function(country) {
        countries.push(country.name);
      });
      vm.countries = countries;
      countriesLoaded = true;
      buildMixedList();
    });

    LookupService.getRegions(function() {
      vm.regions = LookupService.regions;
      regionsLoaded = true;
      buildMixedList();
    });

    function buildMixedList() {

        if (!(countriesLoaded && regionsLoaded)) return;

        var mixed = [];
        var serial = 1;

        // Add regions
        vm.regions.forEach(function (regions) {
            mixed.push({
                id: serial++,
                name: regions.name
            });
        });

        // Add countries
        vm.countries.forEach(function (name) {
            mixed.push({
                id: serial++,
                name: name
            });
        });

        vm.countryRegionList = mixed;

    }

    // Watch the lookupService.sectors until it is filled by API
    $scope.$watch(
      function () { return LookupService.sectors; },
      function (newVal) {
        if (newVal && newVal.length > 0) {
            vm.sectors = newVal;   // now UI gets the actual data
        }
      },
      true
    );

    vm.readMore = function(id){
      vm.testText = id;
    }

    vm.readLess = function(id){
      vm.testText = id;
    }

    $('input[name="daterange"]').daterangepicker({
        format: 'dd/mm/yyyy',
        minViewMode: "months"
    });
    $('input[name="daterange"]').on('apply.daterangepicker', function(ev, picker) {
        $(this).val(picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'));
        vm.published_from = getFormattedDate(picker.startDate.format('DD/MM/YYYY'));
        vm.published_to = getFormattedDate(picker.endDate.format('DD/MM/YYYY'));
        performSearch();
    });

    // convert the date into the IST format
    function getFormattedDate(date) {
        if (date == null) return null;
        var dateStr = date;
        var dateParts = dateStr.split('/');
        var newDateStr = dateParts[1] + '/' + dateParts[0] + '/' + dateParts[2];
        var dateObj = new Date(newDateStr);
        dateObj.setHours(0, 0, 0, 0);
        return dateObj;
    }

    $('input[name="daterange"]').on('cancel.daterangepicker', function(ev, picker) {
        $(this).val('');
        if(vm.published_from){
          vm.published_from = null;
          vm.published_to = null;
          performSearch();
        }

    });
    vm.removeFilter = function (type) {
        switch (type) {
            case 'name':
                vm.search.name = "";
                break;

            case 'country':
                vm.hqSearch = "";
                break;

            case 'region':
                vm.search.region = "";
                break;

            case 'sector':
                vm.search.sector = [];
                break;

            case 'targetMarket':
                vm.search.targetMarket = [];
                break;

            case 'dateRange':
                vm.dateRange = null;
                $('input[name="daterange"]').data('daterangepicker').clickCancel();
                break;
        }
    };

    vm.addSector = function (name) {
        if (vm.search.sector.indexOf(name) === -1) {
            vm.search.sector.push(name);
            performSearch();
        }
    };

    vm.addTargetMarket = function (name) {
        if (vm.search.targetMarket.indexOf(name) === -1) {
            vm.search.targetMarket.push(name);
            performSearch();
        }
    };

    vm.removeSector = function(name) {
        vm.search.sector = vm.search.sector.filter(function(s) { return s !== name; });
    };

    vm.removeTargetMarket = function(name) {
        vm.search.targetMarket = vm.search.targetMarket.filter(function(m) { return m !== name; });
    };



    performSearch();


  }

  angular
    .module('ocoExternalSite')
    .controller('InvestmentSignalsController', InvestmentSignalsController);
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .controller('ExhibitorAnalysisController', ExhibitorAnalysisController )
    .directive("scrollToTopWhen", function ($timeout) {
       function link (scope, element, attrs) {
         scope.$on(attrs.scrollToTopWhen, function () {
           $timeout(function () {
             angular.element(element)[0].scrollTop = 0;
           });
         });
       }
       return { link: link };
    });
  /** @ngInject */
  function ExhibitorAnalysisController($scope, $window, ExhibitionService, MessageHelper) {
    var vm = this;

    vm.exhibitions = [];
    vm.alert = '';
    vm.exhibitionsLoaded = false;
    vm.exhibitionYearsLoaded = false;
    vm.showingYear = (new Date()).getFullYear();
    vm.currentYear = vm.showingYear;

    getExhibitions( vm.showingYear );
    getExhibitionYears();

    vm.scrollTop = function() {
      $window.scrollTo(0,0);
    };

    vm.loadExhibitions = function(){
       vm.exhibitionsLoaded = false;

       var onSuccess = function(exhibitions) {
        ensureExhibitionLinksHaveHttp(exhibitions);
        vm.exhibitions = exhibitions;
        vm.exhibitionsLoaded = true;
       }

       var onFailure = function() {
        errorMessage("An error occurred while trying to fetch upcoming exhibitions. Please, try again later!");
        vm.exhibitionsLoaded = true;
       }

       ExhibitionService.getExhibitionsInYear(vm.showingYear,onSuccess,onFailure);
       $scope.$broadcast("exhibitions_loaded");
    }

    vm.loadExhibitionsInYear = function(exhibitionYear) {
       vm.showingYear=exhibitionYear;
       vm.loadExhibitions();
    }

    function getExhibitions( showingYear ) {
      ExhibitionService.getExhibitionsInYear(showingYear, function(exhibitions) {
        ensureExhibitionLinksHaveHttp(exhibitions);
        vm.exhibitions = exhibitions;
        vm.exhibitionsLoaded = true;
      }, function() {
        errorMessage("An error occurred while trying to fetch upcoming exhibitions. Please, try again later!");
        vm.exhibitionsLoaded = true;
      })
    }

    function getExhibitionYears() {
      ExhibitionService.getExhibitionYears(function(exhibitionYears) {
        vm.exhibitionYears = exhibitionYears.map(String);
        vm.exhibitionYearsLoaded = true;
      }, function() {
        errorMessage("An error occurred while trying to fetch archived exhibitions. Please, try again later!");
        vm.archivedYearsLoaded = true;
      })
    }

    function ensureExhibitionLinksHaveHttp(exhibitions) {
      angular.forEach(exhibitions, function (exhibition) {
        if(!doesExhibitionLinkContainHttp(exhibition.link) && !doesExhibitionLinkContainHttps(exhibition.link)) {
          exhibition.link = 'http://' + exhibition.link;
        }
      });
    }

    function doesExhibitionLinkContainHttp(link) {
      return link.includes("http://");
    }

    function doesExhibitionLinkContainHttps(link) {
      return link.includes("https://");
    }

    function errorMessage(message) {
      vm.alert = MessageHelper.getErrorAlert(message)
    }

    vm.hasExhibitions = function() {
      return vm.exhibitions.length > 0;
    };

    vm.hasExhibitionYears = function() {
      return vm.exhibitionYears.length > 0;
    };

    return vm;
  }
})();

/*
 * Copyright (c) OCOGlobal 2017
 */

(function() {
  'use strict';

  angular
    .module('ocoExternalSite')
    .controller('WelcomeController', WelcomeController);

  /** @ngInject */
  function WelcomeController() {
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .controller('MyVelocitiController', MyVelocitiController);

  /** @ngInject */
  function MyVelocitiController(UserService) {
    var vm = this;

    vm.user = UserService.getUser();
    vm.currentDate = moment().format('Do MMMM YYYY');

    return vm;
  }
})();

/*
 * Copyright (c) OCOGlobal 2018
 */

(function() {
  'use strict';

  angular
    .module('ocoExternalSite')
    .controller('DemoVideoController', DemoVideoController );

  /** @ngInject */
  function DemoVideoController() {
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .controller('ContactController', ContactController);

  /** @ngInject */
  function ContactController(ContactService, MessageHelper, $scope) {
    var vm = this;

    vm.sendEmail = function() {
      ContactService.sendEmail(getEmail(), function () {
        vm.alert = MessageHelper.getSuccessAlert("Your email has been sent.")
        clearForm();
      }, function () {
        vm.alert = MessageHelper.getErrorAlert("We were unable to send messages at this time.  Please try again later.")
      });
    };

    function getEmail() {
      return "Sender Name: " + vm.sendersName + "\n" +
      "Subject: " + vm.emailSubject + "\n" +
      "Message:\n" +  vm.emailMessage;
    }

     function clearForm() {
      $scope.contactMessageForm.$setPristine();
      $scope.contactMessageForm.$setUntouched();
      vm.sendersName = ""
      vm.emailSubject = ""
      vm.emailMessage = ""
    }

    return vm;
  }
})();

/*
 * Copyright (c) OCOGlobal 2017
 */

(function() {
  'use strict';

  angular
    .module('ocoExternalSite')
    .controller('InvestmentSignalSearchController', InvestmentSignalSearchController);

  /** @ngInject */
  function InvestmentSignalSearchController(InvestSignalService, InvestSignalFilterService, MessageHelper, $rootScope,
    VelocitiEvents, $scope, $state, UserPreferencesService, LookupService, $stateParams) {
    var vm = this;

    vm.search = function() {
      vm.isSearching = true;
      /*InvestSignalService.searchOnCurrentFilter(
        onSearchResultsFound,
        onErrorFindingSearchResults
      );*/
    };

    var companyFilterChangedListener = $rootScope.$on(VelocitiEvents.COMPANY_FILTER_CHANGED, function() {
      vm.search();
    });

    $scope.$on('$destroy', companyFilterChangedListener);

    init();
    function init() {
      resetUserMessages();
      vm.isSearching = false;
      vm.searchResults = null;
      InvestSignalFilterService.resetSearchFilterToDefault();
      UserPreferencesService.getUserPreferences(
        afterUserPreferencesRetrieved,
        function() {
          // do nothing on error. Search on defaults
        },
        startSearchingIfAppropriate
      );
    }

    function afterUserPreferencesRetrieved(userPreferences) {
      setFocus(userPreferences.focus);
      setUpSearchFilters(userPreferences);
      vm.userLocationId = userPreferences.location;
      if (vm.isTradeFocused) {
        addCountryToCurrentFilter(userPreferences.location);
      }

    }

    function setFocus(focus) {
      vm.isTradeFocused = focus === "Trade";
    }

    function setUpSearchFilters(userPreferences) {
      if (isCompanyNameInQueryParams()) {
        addCompanyNameToCurrentFilter($state.params.companyText);
      } else {
        addSectorsToCurrentFilter(userPreferences.sectorIds);
      }
    }

    function startSearchingIfAppropriate() {
      if (vm.isTradeFocused && !isTradeDestinationSet()) {
        return;
      }

      // Check for predefined exhibition
      if ($stateParams.exhibition) {
        InvestSignalFilterService.resetSearchFilterToDefault();
        InvestSignalFilterService.selectedExhibitions.push($stateParams.exhibition);
      }

      vm.search();
    }

    function isTradeDestinationSet() {
      return InvestSignalFilterService.getTradeDestinationCountryId() !== "";
    }

    function addSectorsToCurrentFilter(sectorIds) {
      if (isIdDefined(sectorIds)) {
        angular.forEach(sectorIds, function(sectorId) {
          InvestSignalFilterService.selectedSectors.push(getSectorForId(sectorId).name);
        })
      }
    }

    function addCompanyNameToCurrentFilter(companyName) {
      InvestSignalFilterService.changeCompanyNameWithoutPublishingEvent(companyName);
    }

    function getSectorForId(sectorId) {
      return LookupService.sectors.find(function(sector) {
        return sector.id === sectorId;
      })
    }

    function addCountryToCurrentFilter(countryId) {
      if (isIdDefined(countryId)) {
        InvestSignalFilterService.selectedCountries.push(getCountryForId(countryId).name)
      }
    }

    function getCountryForId(countryId) {
      return LookupService.countryList.find(function(country) {
        return country.id === countryId;
      });
    }

    function isCompanyNameInQueryParams() {
      return angular.isDefined($state.params.companyText) && $state.params.companyText !== null;
    }

    function resetUserMessages() {
      vm.alert = "";
    }

    function isIdDefined(id) {
      return id != null
    }
  }
})();

/*
 * Copyright (c) OCOGlobal 2017
 */

(function() {
  'use strict';

  angular
    .module('ocoExternalSite')
    .controller('CompanySearchController', CompanySearchController);

  /** @ngInject */
  function CompanySearchController(CompanyService, CompanyFilterService, MessageHelper, $rootScope,
    VelocitiEvents, $scope, $state, UserPreferencesService, LookupService, $stateParams) {
    var vm = this;
    vm.isCompanySearchShow = true;
    vm.searchCountResultsPage = null;
    vm.searchCountResultsCount = null;
    vm.searchCountResults = {'matching' : 0, 'page' : 1};
    vm.search = function() {
      vm.isSearching = true;
      CompanyService.searchOnCurrentFilter(
        onSearchResultsFound,
        onErrorFindingSearchResults
      );
     CompanyService.searchOnCurrentFilterForCount(
      onTotalSearchResultsFound,
      onErrorFindingSearchResults
      );
    };
//    vm.onChangeInCompanyNameFilter=function(){
//    if(vm.companyName!=""){
//    CompanyFilterService.changeCompanyName(vm.companyName);
//    vm.searchShow = false;
//    }
//    else{
//    CompanyFilterService.changeCompanyName(vm.companyName);
//    vm.searchShow = true;
//    }
//    };
//    vm.clearSearch=function(){
//    vm.companyName=null;
//    vm.searchShow = true;
//    CompanyFilterService.removeCompanyNameFilter();
//    };
    function onSearchResultsFound(response) {
      vm.isSearching = false;
      resetUserMessages();
      vm.searchResults = response;
      if(!CompanyFilterService.checkDefaultFiltersWithoutSort()){
              response.companies = null;
              vm.companies = response.companies;
      }
      else{
              vm.companies = response.companies;
              vm.searchCountResultsPage = response.page;
              calculatePaginationAndTotalCompany();
      }
    }

    function onTotalSearchResultsFound(response) {
    vm.isSearching = false;
    resetUserMessages();
    vm.searchCountResultsCount = response.matching;
    calculatePaginationAndTotalCompany();
    }

    function calculatePaginationAndTotalCompany(){
            vm.searchCountResults = {'matching' : vm.searchCountResultsCount, 'page' : vm.searchCountResultsPage};
    }

    function onErrorFindingSearchResults() {
      vm.isSearching = false;
      showErrorMessage("An error occurred when searching. Please try again.");
    }

    var companyFilterChangedListener = $rootScope.$on(VelocitiEvents.COMPANY_FILTER_CHANGED, function() {
      vm.search();
    });

    $scope.$on('$destroy', companyFilterChangedListener);

    function showErrorMessage(message) {
      vm.alert = MessageHelper.getErrorAlert(message);
    }

    init();
    function init() {
      resetUserMessages();
      vm.isSearching = false;
      vm.searchResults = null;
      CompanyFilterService.resetSearchFilterToDefault();
      UserPreferencesService.getUserPreferences(
        afterUserPreferencesRetrieved,
        function() {
          // do nothing on error. Search on defaults
        },
        startSearchingIfAppropriate
      );
    }

    function afterUserPreferencesRetrieved(userPreferences) {
      setFocus(userPreferences.focus);
      setUpSearchFilters(userPreferences);
      vm.userLocationId = userPreferences.location;
      if (vm.isTradeFocused) {
        addCountryToCurrentFilter(userPreferences.location);
      }

    }

    function setFocus(focus) {
      vm.isTradeFocused = focus === "Trade";
    }

    function setUpSearchFilters(userPreferences) {
      if (isCompanyNameInQueryParams()) {
        addCompanyNameToCurrentFilter($state.params.companyText);
      } else {
        addSectorsToCurrentFilter(userPreferences.sectorIds);
      }
    }

    function startSearchingIfAppropriate() {
      if (vm.isTradeFocused && !isTradeDestinationSet()) {
        return;
      }

      // Check for predefined exhibition
      if ($stateParams.exhibition) {
        CompanyFilterService.resetSearchFilterToDefault();
        CompanyFilterService.selectedExhibitions.push($stateParams.exhibition);
      }

      // Check for predefined top target list
      if ($stateParams.topTargetList && $stateParams.topTargetYear) {
        CompanyFilterService.resetSearchFilterToDefault();
        CompanyFilterService.selectedTopTargetList = $stateParams.topTargetList;
        CompanyFilterService.selectedTopTargetYear = $stateParams.topTargetYear;
      }

      if (CompanyFilterService.filtersAreSetToDefaults()) {
        //return;
      }
          vm.search();
    }

    function isTradeDestinationSet() {
      return CompanyFilterService.getTradeDestinationCountryId() !== "";
    }

    function addSectorsToCurrentFilter(sectorIds) {
      if (isIdDefined(sectorIds)) {
        angular.forEach(sectorIds, function(sectorId) {
          CompanyFilterService.selectedSectors.push(getSectorForId(sectorId).name);
        })
      }
    }

    function addCompanyNameToCurrentFilter(companyName) {
      CompanyFilterService.changeCompanyNameWithoutPublishingEvent(companyName);
    }

    function getSectorForId(sectorId) {
      return LookupService.sectors.find(function(sector) {
        return sector.id === sectorId;
      })
    }

    function addCountryToCurrentFilter(countryId) {
      if (isIdDefined(countryId)) {
        CompanyFilterService.selectedCountries.push(getCountryForId(countryId).name)
      }
    }

    function getCountryForId(countryId) {
      return LookupService.countryList.find(function(country) {
        return country.id === countryId;
      });
    }

    function isCompanyNameInQueryParams() {
      return angular.isDefined($state.params.companyText) && $state.params.companyText !== null;
    }

    function resetUserMessages() {
      vm.alert = "";
    }

    function isIdDefined(id) {
      return id != null
    }

    //need to change into angulerJS

    $('.m-menu').click(function(){
       $(this).parent().find('.sub-menu').toggle();
        $('.m-up').toggle();
        $('.m-down').toggle();
      });

      $('.mt1').click(function(){
       $('.main-tab-1').show();
       $('.main-tab-2').hide();
        $('.mt1').addClass('act');
         $('.mt2').addClass('dact');
      });

      $('.mt2').click(function(){
       $('.main-tab-2').show();
       $('.main-tab-1').hide();
        $('.mt1').removeClass('act');
         $('.mt2').removeClass('dact');
      });

       $('.w-d').click(function(){
       $('.w-l').toggleClass('show');
       $('.w-d-area').toggleClass('wc');
      });

       $('.week-option').click(function(){
       $('.w-l').removeClass('show');
       $('.w-d-area').removeClass('wc');
      });


 //end
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('VelocitiListCompanyService', VelocitiListCompanyService);

  /** @ngInject */
  function VelocitiListCompanyService(VelocitiListCompanyResource) {
    var velocitiListCompanyService = {};

    velocitiListCompanyService.deleteCompanyFromList = function(listId, companyId, success, error) {
       VelocitiListCompanyResource.deleteCompanyFromList(listId, companyId, success, error);
    };

    velocitiListCompanyService.addCompanyToList = function(listId, companyId, success, error) {
       VelocitiListCompanyResource.addCompanyToList(getVelocityListCompany(listId, companyId), success, error);
    };

    function getVelocityListCompany(listIdValue, companyIdValue) {
      return {
        companyId: companyIdValue,
        listId: listIdValue
      };
    }

    velocitiListCompanyService.addCompaniesToList = function(listId, searchRequest, success, error) {
      VelocitiListCompanyResource.addCompaniesToList(listId, searchRequest, success, error);
    };

    return velocitiListCompanyService;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('VelocitiListService', VelocitiListService);

  /** @ngInject */
  function VelocitiListService(VelocitiListResource) {
    var velocitiListService = {};

    velocitiListService.addList = function(list, success, error) {
       VelocitiListResource.addList(list, success, error);
    };

    velocitiListService.deleteList = function(listId, success, error) {
       VelocitiListResource.deleteList(listId, success, error);
    };

    velocitiListService.updateList = function(listId, success, error) {
       VelocitiListResource.updateList(listId, success, error);
    };

    velocitiListService.addList = function(list, success, error) {
       VelocitiListResource.addList(list, success, error);
    };

    return velocitiListService;
  }
})();

/**
 * Copyright 2015 OCO Global.
 */

(function() {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('UserPreferencesService', UserPreferencesService);

  /** @ngInject */
  function UserPreferencesService(UserPreferencesResource, $log) {
    var userPreferencesService = {};

    userPreferencesService.getUserPreferences = function(success, error, finished) {
      UserPreferencesResource.getUserPreferences().then(function(response) {
        success(response.plain());
        finished();
      }, function(response) {
        $log.error(response);
        error();
        finished();
      });
    };

    userPreferencesService.updateUserPreferences = function(updatedUserPreferences, success, error) {
      UserPreferencesResource.updateUserPreferences(updatedUserPreferences).then(success, error);
    };

    return userPreferencesService;
  }
})();

/**
 * Copyright 2015 OCO Global.
 */

(function() {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('UserPasswordService', UserPasswordService);

  /** @ngInject */
  function UserPasswordService(UserPasswordResource) {
    var userPasswordService = {};

    userPasswordService.resetPasswordRequest = function(emailAddress, success, error) {
      UserPasswordResource.resetPasswordRequest(emailAddress).then(success, error)
    };

    userPasswordService.resetPassword = function(resetPasswordRequest, success, error) {
      UserPasswordResource.resetPassword(resetPasswordRequest).then(
        function(response) {
          success(response);
        }, function(response) {
          error(response);
        }
      )
    };

    return userPasswordService;
  }
})();

/**
 * Copyright 2015 OCO Global.
 */

(function() {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('UserService', UserService);

  /** @ngInject */
  function UserService($http, $cookies, Base64, UserResource, RouterStates, $state, Roles, StorageKeys, $q, $uibModal) {
    var userService = {};

    userService.storeUser = function (user){
      delete user.profilePicture;
      $cookies.putObject('user', userToStoreWithoutUnnecessaryData(user));
    };

    userService.login = function(user, success, error) {
      UserResource.login(user).then(function(response) {
        if(!response.mfaRequired){
          saveTokens(response.authToken);
          setAuthHeader(response.authToken);
        }
        success(response);
      }, error);
    };

    userService.verifyOtp = function (otp, success, error){
      UserResource.verifyOtp(otp).then(function (response){
        _rolePromise = null;
        saveTokens(response.authToken);
        setAuthHeader(response.authToken);
        UserResource.getUser().then(function (response){
          delete response.profilePicture;
          $cookies.putObject('user', userToStoreWithoutUnnecessaryData(response));
        });
        success();
      }, error);
    };

    userService.resendOtp = function (otpRequest, success, error){
      UserResource.resendOtp(otpRequest).then(success, error);
    };

    /**
     * For now strip these elements out as make cookie large for no reason.
     * Can switch storage medium in future if need to be reinstated.
     */
    function userToStoreWithoutUnnecessaryData(response) {
      var userWithoutUnnecessaryData = response.plain();
      delete userWithoutUnnecessaryData.permittedCampaigns;
      delete userWithoutUnnecessaryData.permittedRegions;
      delete userWithoutUnnecessaryData.permittedCountries;
      return userWithoutUnnecessaryData;
    }

    function setAuthHeader(base64Value) {
      $http.defaults.headers.common.Authorization = 'Bearer ' + base64Value;
    }

    function encodeToken(token) {
      return btoa(token);
    }

    function decodeToken(encoded) {
      return atob(encoded);
    }

    function decodeStoredToken(encoded) {
      if (!encoded) {
        return null;
      }

      try {
        return decodeToken(encoded);
      } catch (e) {
        return encoded;
      }
    }

// ── Storage Helpers ────────────────────────────────────────
    function saveTokens(authToken) {
      if (authToken) {
        localStorage.setItem(StorageKeys.AUTH_TOKEN, encodeToken(authToken));
      }
      setAuthHeader(authToken);
    }

    userService.getAuthToken = function() {
      var encoded = localStorage.getItem(StorageKeys.AUTH_TOKEN);
      if (encoded) {
        return decodeStoredToken(encoded);
      }
      return null;
    };

    function clearTokens() {
      localStorage.removeItem(StorageKeys.AUTH_TOKEN);
      // localStorage.removeItem(StorageKeys.DEVICE_TOKEN);
    }

    function setLogoutEvent(message){
      localStorage.setItem('logout-event', JSON.stringify({
        message: message || 'Logged out',
        ts: Date.now()   // ensures value changes even if message repeats, so event always fires
      }));
    }

    userService.logout = function() {
      _rolePromise = null;
      UserResource.logout().then(function (){
        userService.removeStoredUser();
        clearTokens();
        $state.go(RouterStates.LOGIN);
      }, function (err){
        console.error(err);
      });

    };

    userService.logoutAllDevices = function (){
      var modalInstance = $uibModal.open({
        windowClass: 'logout-all-modal',
        template:
          '<div class="logout-modal">' +
          '  <div class="logout-modal__icon">' +
          '    <i class="fa fa-desktop" aria-hidden="true"></i>' +
          '  </div>' +
          '  <h4>Log out of all devices?</h4>' +
          '  <p>This ends every active session, including this one. You\'ll need to sign in again everywhere.</p>' +
          '  <div class="logout-modal__actions">' +
          '    <button class="btn-secondary" ng-click="$dismiss()">Cancel</button>' +
          '    <button class="btn-danger" ng-click="$close()">Log out all</button>' +
          '  </div>' +
          '</div>'
      });

      modalInstance.result.then(function (){
        UserResource.logoutAllDevices().then(function (){
          userService.forceLogout();
        }, function (err){
          console.error(err);
        });
      });
    };

    userService.forceLogout = function (){
      _rolePromise = null;
      userService.removeStoredUser();
      setLogoutEvent();
      $state.go(RouterStates.LOGIN);
    };

    userService.removeStoredUser = function () {
      $http.defaults.headers.common.Authorization = 'Bearer ';
      $cookies.remove('user');
    };

    userService.updatePassword = function(updatePasswordRequest, success, error) {
      UserResource.updateUserPassword(
        updatePasswordRequest,
        function() {
          // updatePasswordInStoredCredentials(updatePasswordRequest.newPassword);
          success();
        },
        error);
    };

    function updatePasswordInStoredCredentials(newPassword) {
      var user = {
        username: userService.getUsername(),
        password: newPassword
      };
      // encodeCredentials(user);
    }

    userService.submitPasswordReset = function(emailAddress, success, error) {
      UserResource.submitUserPassword(emailAddress).then(success, error)
    };

    // There are currently only two roles in they system
    // In future this functionality should be extended if more roles required.
    var _rolePromise = null;
    userService.getRole = function() {
      if (_rolePromise) {
        return _rolePromise;
      }

      _rolePromise = isLoggedIn().then(function(loggedIn) {
        return loggedIn ? Roles.USER : Roles.ANONYMOUS;
      });

      return _rolePromise;
    };

    function isLoggedIn() {
      var token = userService.getAuthToken();
      if (!token) {
        return $q.when(false);
      }

      setAuthHeader(token);
      if(userService.getUser()){
        return $q.when(true);
      }

      return UserResource.getUser()
        .then(function (response) {
          delete response.profilePicture;

          $cookies.putObject(
            'user',
            userToStoreWithoutUnnecessaryData(response)
          );

          return true;
        })
        .catch(function () {
          clearTokens();
          return false;
        });
    }

    userService.clearRoleCache = function() {
      _rolePromise = null;
    };

    userService.getUsername = function() {
      return $cookies.getObject('user').username;
    };

    userService.getUser = function() {
      return $cookies.getObject('user');
    };

    userService.resetPassword = function(resetPasswordRequest, success, error) {
      UserResource.resetPassword(resetPasswordRequest).then(success, error);
    };

    return userService;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('TrendsReportService', TrendsReportService);

  /** @ngInject */
  function TrendsReportService(TrendsReportResource, CompanyResource, LoadingService, CompanyFilterService, UserPreferencesService, LookupService, MessageHelper, $filter, HttpUtils, StringUtils) {
    var trendsReportService = {};
    trendsReportService.alerts = [];

    function setFilterData() {
      UserPreferencesService.getUserPreferences(
        afterUserPreferencesRetrieved,
        function () {
          displayErrorMessageAndFinishLoading('Unable to get user preferences.  Please try again later.');
        },
        function () {
          // Do nothing on finishing.
        }
      );
    }

    function afterUserPreferencesRetrieved(userPreferences) {
      setFocus(userPreferences);
      setHomeLocation(userPreferences);
      setDestinationLocation();
      setSectors();
      setCurrentYear();
    }

    function setFocus(userPreferences) {
      trendsReportService.focus = userPreferences.focus;
    }

    function setHomeLocation(userPreferences) {
      trendsReportService.homeLocation = userPreferences.location;
    }

    function setDestinationLocation() {
      trendsReportService.destinationLocation = CompanyFilterService.getCurrentFilter().tradeDestinationCountryId;
    }

    function setSectors() {
      trendsReportService.sectors = CompanyFilterService.getCurrentFilter().sectors;
    }

    function setCurrentYear() {
      trendsReportService.currentYear = (new Date()).getFullYear()
    }

    trendsReportService.requestTrendsReport = function () {
      LoadingService.isLoading(true);
      setFilterData();
      calculateTrendsReportStatistics();
      collateCompanyDetails();
      HttpUtils.waitForHttpRequestsToFinish(100, generateTrendsReport);
    };

    function calculateTrendsReportStatistics() {
      TrendsReportResource.calculateTrendsReportStatistics(
        currentFilterShowingHighRatedCompanies(),
        function (trendsReportStatistics) {
          trendsReportService.trendsReportStatistics = trendsReportStatistics;
        },
        function () {
          displayErrorMessageAndFinishLoading('Unable to calculate trends report statistics.  Please try again later.');
        }
      )
    }

    function collateCompanyDetails() {
      CompanyResource.companyLookup(
        currentFilterShowing20CompaniesSortedByRating(),
        function (companiesListResponse) {
          getAllCompanyDetails(companiesListResponse);
        },
        function () {
          displayErrorMessageAndFinishLoading('Unable to collate company details.  Please try again later.');
        }
      );
    }

    function generateTrendsReport() {
      TrendsReportResource.generateTrendsReport(
        getTrendsReportHtml(),
        function () {
          setFinishedDownloadingFlags();
        },
        function () {
          displayErrorMessageAndFinishLoading('Unable to generate trends report.  Please try again later.')
        }
      );
    }

    function currentFilterShowing20CompaniesSortedByRating() {
      var filter = CompanyFilterService.getCurrentFilter();
      filter.count = 20;
      filter.sort = '{"rating":1}';
      return filter;
    }

    function currentFilterShowingHighRatedCompanies() {
      var filter = CompanyFilterService.getCurrentFilter();
      filter.rating = {min: 1, max: 3, scale: 1}
      return filter;
    }

    function getAllCompanyDetails(companiesListResponse) {
      trendsReportService.companyDetails = [];
      companiesListResponse.companies.forEach(function (company) {
        getCompanyDetails(company);
      });
    }

    function getCompanyDetails(company) {
      CompanyResource.getCompanyDetails(
        company.id,
        function (companyDetailsResponse) {
          addCompanyDetails(companyDetailsResponse, company);
        },
        function () {
          displayErrorMessageAndFinishLoading('Unable to get company details.  Please try again later.')
        }
      );
    }

    function addCompanyDetails(companyDetailsResponse, company) {
      var companyDetails = {};
      companyDetails.name = companyDetailsResponse.name;
      companyDetails.country = companyDetailsResponse.address.countryId;
      companyDetails.sector = companyDetailsResponse.catSector;
      companyDetails.scale = companyDetailsResponse.scale;
      companyDetails.established = companyDetailsResponse.established;
      companyDetails.telephone = companyDetailsResponse.telephone;
      companyDetails.email = companyDetailsResponse.email;
      companyDetails.financials = companyDetailsResponse.financials;
      companyDetails.contacts = companyDetailsResponse.contacts;
      companyDetails.website = companyDetailsResponse.website;
      companyDetails.factors = companyDetailsResponse.factors;
      companyDetails.rating = company.rating;
      companyDetails.hasKpi = hasKpi(companyDetailsResponse.factors)
      companyDetails.address = makeAddress(companyDetailsResponse);
      companyDetails.summary = findCompanySummary(companyDetailsResponse)
      companyDetails.sectorImage = findSectorImage(companyDetailsResponse);

      trendsReportService.companyDetails.push(companyDetails);
    }

    function checkDetailsExists(summaryDetails) {
      return StringUtils.isAllSpaces(summaryDetails) ? undefined : summaryDetails;
    }

    function hasKpi(factors) {
      for (var key in factors) {
        if (hasOwnProperty(factors, key)) {
          return true;
        }
      }
      return false;
    }

    function hasOwnProperty(factors, key) {
      return Object.prototype.hasOwnProperty.call(factors, key) && factors[key] == true;
    }

    function makeAddress(companyDetailsResponse) {
      if (companyDetailsResponse.address) {
        var address = [];
        addAddressParamIfExists(companyDetailsResponse.address.line1, address);
        addAddressParamIfExists(companyDetailsResponse.address.line2, address);
        addAddressParamIfExists(companyDetailsResponse.address.line3, address);
        addAddressParamIfExists(companyDetailsResponse.address.city, address);
        addAddressParamIfExists(companyDetailsResponse.address.state, address);
        if (companyDetailsResponse.address.countryId) {
          address.push($filter('countryTitle')(companyDetailsResponse.address.countryId))
        }
        addAddressParamIfExists(companyDetailsResponse.address.postcode, address);
        return address;
      }
    }

    function addAddressParamIfExists(param, address) {
      if (param) {
        address.push(param)
      }
    }

    function findCompanySummary(companyDetailsResponse) {
      var companySummary = _.find(companyDetailsResponse.notes, function (note) {
        return note.title.match(/company summary/i)
      });
      if (companySummary) {
        companySummary = checkDetailsExists(companySummary.details);
      }
      return companySummary;
    }

    function findSectorImage(companyDetailsResponse) {
      var sector = _.find(LookupService.sectors, function (sector) {
        return companyDetailsResponse.catSector === sector.name
      });
      if (angular.isDefined(sector)) {
        return sector.img.replace('@2x', '');
      }
      return "business.png"
    }

    function setFinishedDownloadingFlags() {
      LoadingService.isLoading(false);
    }

    function getTrendsReportHtml() {
      return angular.element('#trends-report').html();
    }

    function displayErrorMessageAndFinishLoading(errorMessage) {
      trendsReportService.alerts.push(MessageHelper.getErrorAlert(errorMessage));
      setFinishedDownloadingFlags();
    }

    return trendsReportService;
  }
})();

/**
 * Copyright 2021 OCO Global.
 */

(function () {
  'use strict';

  /** @ngInject */
  angular
    .module('ocoExternalSite')
    .factory('TopTargetListService', function (TopTargetListResource) {
      var service = {};

      var lists = [];

      service.getLists = function() {
        return TopTargetListResource.getLists().then(function(response) {
          lists = response;
          return response.plain();
        });
      };

      service.findListById = function(id) {
        return _.find(lists, function(list) {
          return list.id === id;
        });
      };

      service.getListById = function(id) {
        return TopTargetListResource.getListById(id).then(function(response) {
          return response.plain();
        });
      };

      return service;
    });
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('SectorImageMapperService', SectorImageMapperService);

  /** @ngInject */
  function SectorImageMapperService(LookupService) {
    var sectorImageMapperService = {};
    var sectors = LookupService.sectors;
    var imageMapping = {};

    sectorImageMapperService.getSectorImageUrl = function(sector) {
      var imageName = imageMapping[sector];
      if (angular.isDefined(imageName)) {
        return "../../../assets/img/icons/sectors/" +  imageName;
      }

      return "../../../assets/img/icons/my_velociti@2x.png";
    };

    function buildImageMappingDictionary() {
      for(var i = 0; i < sectors.length; i++) {
        imageMapping[sectors[i].name] = sectors[i].img;
      }
    }

    buildImageMappingDictionary();

    return sectorImageMapperService;
  }
})();

'use strict';

angular.module('ocoExternalSite').factory("RestangularFullResponse", function (Restangular) {
  return Restangular.withConfig(function(RestangularConfigurer) {
    RestangularConfigurer.setFullResponse(true);
  });
});

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .service('NavigationService', NavigationService);

  /** @ngInject */
  function NavigationService($state, RouterStates) {
    var service = {};

    service.goToMyVelociti = function () {
      $state.go(RouterStates.MYVELOCITI);
    };

    service.goToCompanies = function () {
      $state.go(RouterStates.COMPANIES);
    };

    service.goToWelcome = function () {
      $state.go(RouterStates.WELCOME);
    };

    service.goToLocation = function (location) {
      $state.go(location);
    };

    service.goToCompanySearchWithParams = function(companyText) {
      $state.go(RouterStates.COMPANIES, {companyText: companyText});
    };

    service.goToVelocitiList = function(listId, listName) {
      $state.go(RouterStates.VELOCITI_LIST, { "id": listId, "name": listName });
    };

    service.goToVelocitiListSearchCompanies = function(listId, listName) {
      $state.go(RouterStates.VELOCITI_LIST_SEARCH_COMPANIES, { "id": listId, "name": listName });
    };

    return service;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('MyListsSummaryService', MyListsSummaryService);

  /** @ngInject */
  function MyListsSummaryService(MyListsSummaryResource) {
    var myListsSummaryService = {};

    myListsSummaryService.getMyListsSummarySortedByName = function(success, error) {
       MyListsSummaryResource.getAllListsSummary(success, error);
    };

    myListsSummaryService.getMyListsSummarySortedByMostRecent = function(success, error) {
       MyListsSummaryResource.getAllListsInMostRecentOrder(success, error);
    };

     myListsSummaryService.getListSummaryById = function(listId, success, error) {
       MyListsSummaryResource.getListSummaryById(listId, success, error);
    };

    myListsSummaryService.addCompanyToList = function(companyToAdd, success, error) {
       MyListsSummaryResource.addCompanyToList(companyToAdd, success, error);
    };

    myListsSummaryService.getMyListIdsForCompany = function(companyId, success, error) {
       MyListsSummaryResource.getMyListIdsForCompany(companyId, success, error);
    };

    myListsSummaryService.deleteCompanyFromList = function(listId, companyId, success, error) {
       MyListsSummaryResource.deleteCompanyFromList(listId, companyId, success, error);
    };
    return myListsSummaryService;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function() {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('ModalService', ModalService);

  /** @ngInject */
  function ModalService($uibModal) {
    var modalService = {};

    modalService.showOkCancelModal = function (displayMessage) {
      return $uibModal.open({
        animation: true,
        component: "modalAlert",
        resolve: {
          message: function () {
            return displayMessage;
          }
        }
      });
    };

    modalService.showOkModal = function (displayMessage) {
      return $uibModal.open({
        animation: true,
        component: "okModal",
        resolve: {
          message: function () {
            return displayMessage;
          }
        }
      });
    };

    modalService.showNewListModal = function() {
      return $uibModal.open({
        animation: true,
        component: "newListModal",
        windowClass: 'addToListModalWindow'
      });
    };

    modalService.showAddToListModal = function(companyId) {
      return $uibModal.open({
        animation: true,
        component: "addToListModal",
        windowClass: 'addToListModalWindow',
        resolve: {
          companyId: function () {
            return companyId
          }
        }
      });
    };

    return modalService;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function() {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('LookupService', LookupService);

  /** @ngInject */
  function LookupService(LookupResource) {
    var lookupService = {};

    init();
    function init() {
      populateSectors();
      getCountries();
      getHiringCountries();
      populateScales();
      populateNewCompaniesOptions();
      getSubSectors();
      getNAICS();
      getSIC();
      getISIC();
      getCompanyTypes();
      getSectorTags();
      getRegions();
      getSignalTypes();
    }

    lookupService.getCountries = function(success) {
      LookupResource.getCountries(function(countries) {
        lookupService.countryList = countries.plain();
        success()
      });
    };

    lookupService.getHiringCountries = function(success) {
      LookupResource.getHiringCountries(function(countries) {
        lookupService.hiringCountryList = countries.plain();
        success()
      });
    };

    lookupService.getRegions = function(success) {
      LookupResource.getRegions(function(regions) {
        lookupService.regions = regions.plain();
        success()
      });
    };

    lookupService.sectors=[];
    lookupService.resetSectors = function() {
      lookupService.sectors.forEach(function(sector) {
        sector.isSelected = false
      })
    };

    lookupService.populateSectors = function(success) {
      LookupResource.populateSectors(function(Sectors) {
        lookupService.Sectors = Sectors.plain();
        success();
      });
    };
    lookupService.getSubSectors = function(success) {
      LookupResource.getSubSectors(function(subSectors) {
        lookupService.subSectors = subSectors.plain();
        success();
      });
    };
    lookupService.getNAICS = function(success) {
      LookupResource.getNAICS(function(naics) {
        lookupService.naics = naics.plain();
        success();
      });
    };
    lookupService.getSIC = function(success) {
      LookupResource.getSIC(function(sic) {
        lookupService.sic = sic.plain();
        success();
      });
    };
    lookupService.getISIC = function(success) {
      LookupResource.getISIC(function(isic) {
        lookupService.isic = isic.plain();
        success();
      });
    };
    lookupService.getTradeShow = function(success) {
      LookupResource.getTradeShow(function(tradeShow) {
        lookupService.tradeShow = tradeShow.plain();
        success();
      });
    };
    lookupService.getCompanyTypes = function(success) {
      LookupResource.getCompanyTypes(function(companyTypes) {
        lookupService.companyTypes = companyTypes.plain();
        success();
      });
    };

  lookupService.getSectorTags = function(success) {
      LookupResource.getSectorTags(function(sectorTags) {
        lookupService.sectorTags = sectorTags.plain();
        success();
      });
    };

    lookupService.getUsStates = function(success) {
      LookupResource.getUsStates(function(usStates) {
        lookupService.usStates = usStates.plain();
        success();
      });
    };

    var countriesLoaded = false;
    var regionsLoaded = false;

    function getRegions() {
        LookupResource.getRegions(function(regions) {
            lookupService.regions = regions.plain();
            success();
        });
    }

    function getCountries() {
        LookupResource.getCountries(function(countries) {
            lookupService.countryList = countries.plain();
            countriesLoaded = true;
            buildMixedList();
        });
    }

    function success() {
        regionsLoaded = true;
        buildMixedList();
    }

    function buildMixedList() {

        if (!(countriesLoaded && regionsLoaded)) return;

        var mixed = [];
        var serial = 1;

        lookupService.regions.forEach(function(region) {
            mixed.push({
                id: serial++,
                name: region.name
            });
        });

        lookupService.countryList.forEach(function(country) {
            mixed.push({
                id: serial++,
                name: country.name
            });
        });

        lookupService.countryRegionList = mixed;
    }


    function getHiringCountries() {
      LookupResource.getHiringCountries(function(countries) {
        lookupService.hiringCountryList = countries.plain();
      });
    }

    function getSubSectors() {
      LookupResource.getSubSectors(function(subSectors) {
        lookupService.subSectors = subSectors.plain();
      });
    }

    function getNAICS() {
      LookupResource.getNAICS(function(naics) {
      lookupService.naics = naics.plain();
      });
    }
    function getSIC() {
      LookupResource.getSIC(function(sic) {
      lookupService.sic = sic.plain();
      });
    }
    function getISIC() {
      LookupResource.getISIC(function(isic) {
        lookupService.isic = isic.plain();
      });
    }
    function getTradeShow() {
      lookupResource.getTradeShow(function(tradeShow) {
        lookupService.tradeShow = tradeShow.plain();
      });
    }
    function getCompanyTypes() {
      LookupResource.getCompanyTypes(function(companyTypes) {
        lookupService.companyTypes = companyTypes.plain();
      });
    }

    function getSectorTags() {
      LookupResource.getSectorTags(function(sectorTags) {
        lookupService.sectorTags = sectorTags.plain();
      });
    }

    function getSignalTypes() {
      LookupResource.getSignalsType(function(signalTypes) {
        lookupService.signalTypes = signalTypes.plain();
      });
    }

    lookupService.getCities = function(citySearchTerm, selectedCountries, success, error) {
      LookupResource.getCities(citySearchTerm, selectedCountries,
        function onSuccess(results) {
          var cityNames = _.map(results, function(city) {
            return city.split(",")[0];
          });
          success(_.uniq(cityNames));
        },
        error);
    }

    function populateSectors() {
        LookupResource.populateSectors(function(sectors) {
        lookupService.sectors = sectors.plain();
    });
    }

    function populateScales() {
      lookupService.scales = [
        { key: 'SME', value: 'SME' },
        { key: 'MID_CAP', value: 'MID-CAP' },
        { key: 'LARGE_CORPORATE', value: 'LARGE CORPORATE' }
      ];
    }
/*function populateCompanyTypes() {
      lookupService.companyTypes = [
        { key: 'Public', value: 'Public' },
        { key: 'Private', value: 'Private' },
        { key: 'Government_Agency', value: 'Government Agency' }
      ];
    }*/

    function populateNewCompaniesOptions() {
      lookupService.newCompaniesOptions = [
        { key: true, value: 'Yes' },
        { key: false, value: 'No' },
      ];
    }

    return lookupService;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function() {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('LoadingService', LoadingService);

  /** @ngInject */
  function LoadingService($rootScope) {
    var loadingService = {};

    loadingService.isLoading = function(isLoading) {
      $rootScope.isLoading = isLoading;
    };

    return loadingService;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function() {
  'use strict';

  angular
    .module('ocoExternalSite')
    .service('InvestSignalFilterService', InvestSignalFilterService);

  /** @ngInject */
  function InvestSignalFilterService(EventBusService, VelocitiEvents) {
    var service = {};

    service.pageSize = 10;
    service.tradeDestinationCountryId = '';

    service.resetSearchFilterToDefault = function() {
      resetSearchFilterWithoutSort();
    };

    function resetSearchFilterWithoutSort() {
      resetToFirstPage();
      service.selectedNames = [];
      service.selectedHQ = [];
      service.selectedSectors = [];
      service.selectedTargetMarkets = [];
      service.query = "";
      service.isSearchingInList = false;
    }

    init();
    function init() {
      service.resetSearchFilterToDefault();
    }

    service.setPageNumber = function(pageNumber) {
      service.table.currentPage = pageNumber;
      notifyListenersThatCompanyFilterChanged();
    };

    service.setPageSize = function(pageSize) {
      service.pageSize = pageSize;
      notifyListenersThatCompanyFilterChanged();
    };

    service.getPageSize = function() {
      return service.pageSize;
    };

    function resetToFirstPage() {
      service.table = {
        currentPage: 1
      };
    }

    service.addSelectedName = function(nameToAdd) {
      addSelectedItem(service.selectedNames, nameToAdd);
    };

    service.addSelectedSector = function(sectorToAdd) {
      addSelectedItem(service.selectedSectors, sectorToAdd);
    };

    service.addSelectedHQ = function(hqToAdd) {
      addSelectedItem(service.selectedHQ, hqToAdd);
    };

    service.addSelectedTargetMakret = function(targetMarketToAdd) {
      addSelectedItem(service.selectedTargetMarkets, targetMarketToAdd);
    };

    function addSelectedItem(itemList, itemToAdd) {
      if (itemList.indexOf(itemToAdd) == -1) {
        itemList.push(itemToAdd);
        resetToFirstPage();
        notifyListenersThatCompanyFilterChanged();
      }
    }

    service.getCurrentFilter = function() {
      return {
        count: service.pageSize,
        page: service.table.currentPage,
        names: service.selectedNames,
        hq: service.selectedHQ,
        targetMarkets: service.selectedTargetMarkets,
        sectors: service.selectedSectors,
        search: service.query,
        isSearchingInList: service.isSearchingInList,
        query: service.query
      };
    };

    service.changeCompanyName = function(companyName) {
      service.changeCompanyNameWithoutPublishingEvent(companyName);
      notifyListenersThatCompanyFilterChanged();
    };

    service.changeCompanyNameWithoutPublishingEvent = function(companyName) {
      service.query = companyName;
      resetToFirstPage();
    };

    service.setVelocityListFilter = function(velocitiListId) {
      service.resetSearchFilterToDefault();
      service.velocitiListId = velocitiListId;
    };

    service.setForSearchingInList = function(velocitiListId) {
      service.isSearchingInList = true;
      service.velocitiListId = velocitiListId;
    };

    function notifyListenersThatCompanyFilterChanged() {
      EventBusService.publishEvent(VelocitiEvents.INVEST_SIGNAL_FILTER_CHANGED);
    }

    return service;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('InvestSignalService', InvestSignalService);

  /** @ngInject */
  function InvestSignalService(InvestSignalResource, $log) {
    var investSignalService = {};

    investSignalService.getInvestSignalDetails = function (signalId, success, error) {
      InvestSignalResource.getSignalDetails(signalId, function (signalDetails) {
        success(signalDetails);
      },
        function (response) {
          $log.debug("Error with status code", response.status);
          error();
        }
      );
    };

    investSignalService.getAllPublishedCompanySignals = function (companyId, success, error) {
      InvestSignalResource.getAllPublishedCompanySignals(companyId,
        function (response) {
          var companySignals = response.plain();
          convertDates(companySignals);
          success(companySignals);
        },
        function (response) {
          $log.debug("Error with status code", response.status);
          error();
        }
      );
    };

    investSignalService.getAllSignals = function (success, error) {
      InvestSignalResource.getAllSignals(function (response) {
          var companySignals = response.plain();
          convertDates(companySignals);
          success(companySignals);
        },
        function (response) {
          $log.debug("Error with status code", response.status);
          error();
        }
      );
    };

    investSignalService.getAllPublishedSignals = function (success, error) {
      InvestSignalResource.getAllPublishedSignals(function (response) {
        if (response != undefined) {
          var companySignals = response.plain();
          convertDates(companySignals);
          success(companySignals);
        }
      },
        function (response) {
          $log.debug("Error with status code", response.status);
          error();
        }
      );
    };

    function convertDates(companySignals) {
      companySignals.forEach(function (signalItem) {
        signalItem.publishDate = new Date(signalItem.publishDate);
        signalItem.creationDate = new Date(signalItem.creationDate);
      });
    }

    return investSignalService;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('ExhibitionService', ExhibitionService);

  /** @ngInject */
  function ExhibitionService(ExhibitionResource, $log, DateUtils) {
    var exhibitionService = {};

    exhibitionService.getExhibitions = function(success, error) {
      ExhibitionResource.getExhibitions(function(exhibitions) {
          convertDates(exhibitions);
          success(exhibitions.plain());
        }, function (response) {
          $log.debug("Error with status code", response.status);
          error();
        }
      );
    };

    exhibitionService.getExhibitionsInYear = function(year, success, error) {
      ExhibitionResource.getExhibitionsInYear(year, function(exhibitions) {
          convertDates(exhibitions);
          success(exhibitions.plain());
        }, function (response) {
          $log.debug("Error with status code", response.status);
          error();
        }
      );
    };

    exhibitionService.getExhibitionYears = function(success, error) {
      ExhibitionResource.getExhibitionYears(function(exhibitionYears) {
          success(exhibitionYears.plain());
        }, function (response) {
          $log.debug("Error with status code", response.status);
          error();
        }
      );
    }

    function convertDates(exhibitions) {
      exhibitions.forEach(function(exhibition) {
        exhibition.startDate = moment(exhibition.startDate);
        exhibition.endDate = moment(exhibition.endDate);
        exhibition.dateRange = DateUtils.createDateRange(exhibition.startDate, exhibition.endDate);
      })
    }

    return exhibitionService;
  }
})();

(function() {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('EventBusService', EventBusService);

  /** @ngInject */
  function EventBusService($rootScope) {
    var eventBusServiceList = {};

    eventBusServiceList.publishEvent = function(eventType) {
      $rootScope.$emit(eventType);
    };

    return eventBusServiceList;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('ContactService', ContactService);

  /** @ngInject */
  function ContactService(ContactResource) {
    var contactService = {};

    contactService.sendEmail = function (email, success, error) {
      ContactResource.sendEmail(email, success, error);
    };

    return contactService;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */
(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('CompanyRatingService', CompanyRatingService);

  /** @ngInject */
  function CompanyRatingService(CompanyRatingResource) {
    var companyRatingService = {};

    companyRatingService.requestCompanyRating = function(company, success, error) {
      CompanyRatingResource.requestCompanyRating(company, success, error);
    }

    return companyRatingService;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('CompanyProfileService', CompanyProfileService);

  /** @ngInject */
  function CompanyProfileService(CompanyProfileResource, SortOrder, CompanyListColumns, EventBusService, VelocitiEvents) {
    var service = {};

    service.sortByColumn = CompanyListColumns.NAME;
    service.sortOrder = SortOrder.ASCENDING;
    service.pageSize = 10;
    service.currentPage = 1;

    service.getCompanyProfiles = function (success, error) {
      CompanyProfileResource.getCompanyProfiles(getRequest(), success, error);
    };

    function getRequest() {
      return {
        count: service.pageSize,
        page: service.currentPage,
        sort: generateSortQuery(),
        state: "COMPANY_ACTIVE"
      };
    }

    function generateSortQuery() {
      return '{"' + service.sortByColumn + '":' + service.sortOrder + '}';
    }

    service.setPageSize = function(pageSize) {
      service.pageSize = pageSize;
      EventBusService.publishEvent(VelocitiEvents.COMPANY_PROFILE_CHANGED);
    };

    service.setPageNumber = function(currentPage) {
      service.currentPage = currentPage;
      EventBusService.publishEvent(VelocitiEvents.COMPANY_PROFILE_CHANGED);
    };

    service.setColumnSortOrder = function(sortByColumn, sortOrder) {
      service.sortByColumn = sortByColumn;
      service.sortOrder = sortOrder;
    };

    return service;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('CompanyLookupService', CompanyLookupService);

  /** @ngInject */
  function CompanyLookupService(CompanyResource) {
    var service = {};

    service.companyNameLookup = function(companyName, success, error) {
      service.companyNameLookupResults = [];
      if (parameterMinLengthReached(companyName)) {
        CompanyResource.companyNameLookup(companyName).then(function (companyNameLookupResults) {
          initialiseFirstResult(companyName);
          mapResults(companyNameLookupResults);
          success(service.companyNameLookupResults)
        }, error);
      }
    };

    function mapResults(companyNameLookupResults) {
      if (resultsNotEmpty(companyNameLookupResults)) {
        mapLookupResults(companyNameLookupResults);
      }
    }

    function resultsNotEmpty(companyNameLookupResults) {
      return angular.isDefined(companyNameLookupResults) && companyNameLookupResults.length !== 0;
    }

    function parameterMinLengthReached(companyName) {
      return companyName.length >= 3;
    }

    function initialiseFirstResult(companyName) {
      service.companyNameLookupResults = [{
        text: companyName,
        company: {
          name: companyName
        }
      }]
    }

    function mapLookupResults(companyNameLookupResults) {
      service.companyNameLookupResults = service.companyNameLookupResults.concat(
        _.map(companyNameLookupResults, function(company) {
          return parseCompanyModel(company);
        })
      )
    }

    function parseCompanyModel(company) {
      return {
        id: company.id,
        text: company.name + ', ' + company.countryName,
        company: {
          id: company.id,
          name: company.name,
          website: company.website,
          address: {
            countryId: company.countryId
          }
        }
      }
    }

    return service;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function() {
  'use strict';

  angular
    .module('ocoExternalSite')
    .service('CompanyFilterService', CompanyFilterService);

  /** @ngInject */
  function CompanyFilterService(EventBusService, VelocitiEvents, LookupService) {
    var service = {};
    service.pageSize = 15;
    service.subSectorList = [];
    service.subSectors = [];
    service.signalDataFilters = {
                                    'signalTypes': [],
                                    'targetMarkets': [],
                                    'sourceMarkets': [],
                                    'createdFrom': "",
                                    'createdTo': ""
                                };
    service.tradeDestinationCountryId = '';
    service.domain ="";

    service.resetSearchFilterToDefault = function() {
      service.sort = setDefaultSort();
      resetSearchFilterWithoutSort();
    };

    function getDefaultFiltersWithoutSort() {
      return {
        selectedRegions: [],
        selectedCountries: [],
        selectedCities: [],
        selectedOverseasOperations: [],
//        selectedSectors: [],
        selectedIndustry: [],
//        selectedSubSectors: [],
//        selectedSectorTags: [],
        selectedNAICSs:[],
        selectedSICs:[],
        selectedISICs:[],
        selectedExhibitions: [],
        query: "",
        domain: "",
        selectedColumn: '',
        lastUpdatedBefore: "",
        selectedCompanyState: "COMPANY_ACTIVE",
        selectedCampaignId: "",
        selectedUsStates: [],
        selectedScale: [],
        selectedCompanyType: [],
        includesRecentlyActivated: null,
        selectedCampaignState: [],
        interactionDate: undefined,
        interestedInTrade: false,
        tradeShows: [],
        velocitiListId: "",
        isSearchingInList: false,
        turnover: null,
        rating: null,
        employees: null,
        selectedNoPresence: [],
        signalDataFilters: {'signalTypes': [],
                                 'targetMarkets': [],
                                 'sourceMarkets': [],
                                 'created_From': "",
                                 'created_To': ""},
        selectedYearEstablishedMin: null,
        selectedYearEstablishedMax: null,
        companyEmployeeGrowthRate: null,
        selectedTopTargetList: null,
        selectedTopTargetYear: null,
        fundingDateRange: null,
        fundingSeries: [],
        funding_types: [],
        fundingAmountInMillions: null,
        hiringDataFilters: null,
        hiringJobTitle: null,
        hiring_Department: null,
        hiring_Country: null,
        hiringState: null
      };
    }

 service.checkDefaultFiltersWithoutSort = function() {
        if(service.rating !== null || service.checkAllFilterWithoutRating())
                {
                return true;
                }
                else{
                return false;
                }
    }

    service.checkAllFilterWithoutRating = function() {
            if(service.selectedRegions.length > 0 ||
                               service.selectedCountries.length > 0 ||
                               service.selectedCities.length > 0 ||
                               service.selectedOverseasOperations.length > 0 ||
                               service.selectedIndustry.length > 0 ||
                               service.selectedNAICSs.length > 0 ||
                               service.selectedSICs.length > 0 ||
                               service.selectedISICs.length > 0 ||
                               service.selectedExhibitions.length > 0 ||
                               service.query !== "" ||
                               service.domain !== "" ||
                               service.selectedColumn !== '' ||
                               service.lastUpdatedBefore !== "" ||
                               service.selectedCompanyState !== "COMPANY_ACTIVE" ||
                               service.selectedCampaignId !== "" ||
                               service.selectedUsStates.length > 0 ||
                               service.selectedScale.length > 0 ||
                               service.selectedCompanyType.length > 0 ||
                               service.includesRecentlyActivated !== null ||
                               service.selectedCampaignState.length > 0 ||
                               service.interactionDate !== undefined ||
                               service.interestedInTrade !== false ||
                               service.tradeShows.length > 0 ||
                               service.velocitiListId !== "" ||
                               service.isSearchingInList !== false ||
                               service.turnover !== null ||
                               service.employees !== null ||
                               service.selectedNoPresence.length > 0 ||
                               checkSignalFiltersUsed(service.signalDataFilters) ||
                               service.selectedYearEstablishedMin !== null ||
                               service.selectedYearEstablishedMax !== null ||
                               service.companyEmployeeGrowthRate !== null ||
                               service.selectedTopTargetList !== null ||
                               service.selectedTopTargetYear !== null||
                               service.fundingDateRange!== null||
                               service.fundingSeries.length > 0 ||
                               service.funding_types.length > 0||
                               service.fundingDealAmount != null||
                               service.hiringDateRange != null)
                    {
                    return true;
                    }
                    else{
                    return false;
                    }
        }

    function checkSignalFiltersUsed(data) {

        if (!data) return false; // If object itself is null

        // Check if all filter fields are empty
        var noFilters =
            (!data.signalTypes || data.signalTypes.length === 0) &&
            (!data.targetMarkets || data.targetMarkets.length === 0) &&
            (!data.sourceMarkets || data.sourceMarkets.length === 0) &&
            (!data.created_from || data.created_from === "") &&
            (!data.created_to || data.created_to === "");

        return !noFilters;
    }


    function resetSearchFilterWithoutSort() {
      resetToFirstPage();
      angular.forEach(getDefaultFiltersWithoutSort(), function(value, key) {
        service[key] = value;
      });
    }

    /**
     * Checks the current applied filters to see if they're currently set to their default values. Any value which isn't
     * set to default will cause the function to return false. If all filters are set to their defaults it will return
     * true.
     *
     * @return {boolean}
     */
    service.filtersAreSetToDefaults = function() {
      var defaults = getDefaultFiltersWithoutSort();
      var keys = Object.keys(defaults);

      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        var value = defaults[key];

        if (!angular.equals(service[key], value)) {
          return false;
        }
      }

      return true;
    };

    init();
    function init() {
      service.resetSearchFilterToDefault();
    }

    service.setPageNumber = function(pageNumber) {
      service.table.currentPage = pageNumber;
      notifyListenersThatCompanyFilterChanged();
    };

    service.setPageSize = function(pageSize) {
      service.pageSize = pageSize;
      notifyListenersThatCompanyFilterChanged();
    };

    service.getPageSize = function() {
      return service.pageSize;
    };

    function resetToFirstPage() {
      service.table = {
        currentPage: 1
      };
    }

    function setDefaultSort() {
      return {
        column: "",
        order: ''
      };
    }

    service.addSelectedCountry = function(countryToAdd) {
      addSelectedItem(service.selectedCountries, countryToAdd);
    };

    service.addSelectedRegion = function(regionToAdd) {
      addSelectedItem(service.selectedRegions, regionToAdd);
    };
/*
    service.addSelectedSector = function(sectorToAdd) {
      addSelectedItem(service.selectedSectors, sectorToAdd);
    };

   service.addSelectedSubSector = function(subSectorToAdd) {
      addSelectedItem(service.selectedSubSectors, subSectorToAdd);
    };*/

    service.addSelectedIndustry = function(industryToAdd) {
      addSelectedItem(service.selectedIndustry, industryToAdd);
    };

    /*service.addSelectedSectorTag = function(sectorTagToAdd) {
          addSelectedItem(service.selectedSectorTags, sectorTagToAdd);
    };*/

    service.addSelectedUsState = function(usStatesToAdd) {
      addSelectedItem(service.selectedUsStates, usStatesToAdd);
    };

    service.addSelectedCity = function(cityToAdd) {
      addSelectedItem(service.selectedCities, cityToAdd);
    };

    service.addSelectedOverseasOperation = function(overseasOperationToAdd) {
      addSelectedItem(service.selectedOverseasOperations, overseasOperationToAdd);
    }

    service.addSelectedExhibition = function(exhibitionToAdd) {
      addSelectedItem(service.selectedExhibitions, exhibitionToAdd);
    };

    service.addSelectedTradeShow = function(tradeShowToAdd) {
      addSelectedItem(service.tradeShows, tradeShowToAdd);
    };

    service.setSelectedNewCompanyOption = function(option) {
      service.includesRecentlyActivated = option.key;
      resetToFirstPage();
      notifyListenersThatCompanyFilterChanged();
    };

    service.addSelectedNoPresence = function(countryToAdd) {
      addSelectedItem(service.selectedNoPresence, countryToAdd);
    };

    service.addSelectedSignalFilters = function (signalFilters) {

        if (signalFilters.signalTypes && signalFilters.signalTypes.length) {
            addSelectedItem.apply(
                undefined,
                [service.signalDataFilters.signalTypes].concat(signalFilters.signalTypes)
            );
        }

        if (signalFilters.targetMarkets && signalFilters.targetMarkets.length) {
            addSelectedItem.apply(
                undefined,
                [service.signalDataFilters.targetMarkets].concat(signalFilters.targetMarkets)
            );
        }

        if (signalFilters.sourceMarkets && signalFilters.sourceMarkets.length) {
            addSelectedItem.apply(
                undefined,
                [service.signalDataFilters.sourceMarkets].concat(signalFilters.sourceMarkets)
            );
        }

        var dateChanged = false;

        if (signalFilters.created_From) {
            service.signalDataFilters.created_from = signalFilters.created_from;
            dateChanged = true;
        }

        if (signalFilters.created_To) {
            service.signalDataFilters.created_to = signalFilters.created_to;
            dateChanged = true;
        }

        // Only call these if date is changed
        if (dateChanged) {
            resetToFirstPage();
            notifyListenersThatCompanyFilterChanged();
        }
    };



    service.setCompanyEmployeeGrowthRateOption = function (option) {
      service.companyEmployeeGrowthRate = option.key;
      resetToFirstPage();
      notifyListenersThatCompanyFilterChanged();
    };

    service.setTopTargetList = function (list, year) {
      service.selectedTopTargetList = list;
      service.selectedTopTargetYear = year;
      resetToFirstPage();
      notifyListenersThatCompanyFilterChanged();
    };

    function generateExhibitions() {
      var exhibitionIds = [];
      angular.forEach(service.selectedExhibitions, function(value) {
        exhibitionIds.push(value.id);
      });

      return exhibitionIds;
    }

    function getTradeShowIds() {
      var tradeShowIds = [];
      angular.forEach(service.tradeShows, function(value) {
        tradeShowIds.push(value.id);
      });

      return tradeShowIds;
    }

    service.addSelectedNAICS = function(naicsToAdd) {
      var found = service.selectedNAICSs.find(function (selectedNAICSs) {
        return angular.equals(selectedNAICSs, naicsToAdd);
      });
      if (!found) {
        service.selectedNAICSs.push(naicsToAdd);
        resetToFirstPage();
        notifyListenersThatCompanyFilterChanged();
      }
    };
    service.addSelectedSIC = function(sicToAdd) {
      var found = service.selectedSICs.find(function (selectedSICs) {
        return angular.equals(selectedSICs, sicToAdd);
      });
      if (!found) {
        service.selectedSICs.push(sicToAdd);
        resetToFirstPage();
        notifyListenersThatCompanyFilterChanged();
      }
    };

    service.addSelectedISIC = function(isicToAdd) {
      var found = service.selectedISICs.find(function (selectedISICs) {
        return angular.equals(selectedISICs, isicToAdd);
      });
      if (!found) {
        service.selectedISICs.push(isicToAdd);
        resetToFirstPage();
        notifyListenersThatCompanyFilterChanged();
      }
    };
    service.addSelectedScale = function(scaleToAdd) {
      var found = service.selectedScale.find(function (selectedScale) {
        return angular.equals(selectedScale, scaleToAdd);
      });
      if (!found) {
        service.selectedScale.push(scaleToAdd);
        resetToFirstPage();
        notifyListenersThatCompanyFilterChanged();
      }
    };

    service.addSelectedCompanyType = function(companyTypeToAdd) {
      addSelectedItem(service.selectedCompanyType, companyTypeToAdd);
    };

    service.setYearEstablishedRange = function(min, max) {
    if  ((min == null || min == '') && (max == null || max == ''))
    {
      service.selectedYearEstablishedMin = null;
      service.selectedYearEstablishedMax = null;
    }
    else {
        service.selectedYearEstablishedMin = min == null || min == '' ? 0 : parseInt(min);
        service.selectedYearEstablishedMax = max == null || max == '' ? (new Date().getFullYear()) : parseInt(max);
    }


      resetToFirstPage();
      notifyListenersThatCompanyFilterChanged();
    };

    function addSelectedItem(itemList, itemToAdd) {
      if (itemList.indexOf(itemToAdd) == -1) {
        itemList.push(itemToAdd);
        resetToFirstPage();
        notifyListenersThatCompanyFilterChanged();
      }
    }

    service.getCurrentFilter = function() {
      var yearEstablished = service.selectedYearEstablishedMin || service.selectedYearEstablishedMax ? {
        min: service.selectedYearEstablishedMin,
        max: service.selectedYearEstablishedMax,
      } : null;
      var fundingDealAmount = service.fundingDealAmount!= null ? {
              min: service.fundingDealAmount.min != null? service.fundingDealAmount.min:null,
              max: service.fundingDealAmount.max != null? service.fundingDealAmount.max:null,
              scale: 1
            } : null;
      return {
        count: service.pageSize,
        page: service.table.currentPage,
        regions: service.selectedRegions,
        countries: service.selectedCountries,
        cities: service.selectedCities,
        overseasOperations: service.selectedOverseasOperations,
//        tradeShow: service.selectedTradeShow,
        /*sectors: service.selectedSectors,
        subSectors: service.selectedSubSectors,*/
        industries: service.selectedIndustry,
        exhibitions: generateExhibitions(),
        tradeShows: getTradeShowIds(),
        search: service.query,
        sort: generateSortQuery(),
        turnover: service.turnover,
        randSpend: service.randSpend,
        employees: service.employees,
        fdiRating: service.fdiRating,
        tradeRating: service.tradeRating,
        innovationRating: service.innovationRating,
        lastUpdatedBefore: service.lastUpdatedBefore,
        state: service.selectedCompanyState,
        userAssociationFilter: service.userAssociationFilter,
        campaign: service.selectedCampaignId,
        usState: service.selectedUsStates,
        selectedScale: getScales(),
        selectedCompanyType: service.selectedCompanyType,
        selectedCampaignState: service.selectedCampaignState,
        interactionDate: service.interactionDate,
        withoutCampaignAssociation: service.withoutCampaignAssociation,
        interestedInTrade: service.interestedInTrade,
        velocitiListId: service.velocitiListId,
        isSearchingInList: service.isSearchingInList,
        query: service.query,
        website: service.domain,
        rating: service.rating,
        tradeDestinationCountryId: service.tradeDestinationCountryId,
        noPresence: service.selectedNoPresence,
        signalDataFilters: service.signalDataFilters,
        yearEstablished: yearEstablished,
        includesRecentlyActivated: service.includesRecentlyActivated,
        companyEmployeeGrowthRate: service.companyEmployeeGrowthRate,
//        sectorTagsIds : service.selectedSectorTags,
        naicsIds : getNAICS(),
        sicIds : getSIC(),
        isicIds : getISIC(),
        fundingDateRange : service.fundingDateRange,
        fundingSeries : service.fundingSeries,
        funding_types : service.funding_types,
        fundingAmountInMillions: fundingDealAmount,
        hiringDataFilters: service.hiringDateRange,
        topTargetList: {
          id: service.selectedTopTargetList ? service.selectedTopTargetList.id : null,
          year: service.selectedTopTargetYear,
        },
      };
    };

    function getNAICS() {
      var naicsIds = [];
      service.selectedNAICSs.forEach(function (naics) {
        naicsIds.push(naics.id)
      });
      return naicsIds;
    }
    function getSIC() {
      var sicIds = [];
      service.selectedSICs.forEach(function (sic) {
        sicIds.push(sic.id)
      });
      return sicIds;
    }
    function getISIC() {
      var isicIds = [];
      service.selectedISICs.forEach(function (isic) {
        isicIds.push(isic.id)
      });
      return isicIds;
    }
    function getScales() {
      var scaleKeys = [];
      service.selectedScale.forEach(function (scale) {
        scaleKeys.push(scale.key)
      });
      return scaleKeys;
    }
//    function getCompanyType() {
//      var companyTypeKeys = [];
//      service.selectedCompanyType.forEach(function (CompanyType) {
//        companyTypeKeys.push(CompanyType.key)
//      });
//      return companyTypeKeys;
//    }

    service.getTradeDestinationCountryId = function() {
      return service.tradeDestinationCountryId;
    }

    service.setTradeDestinationCountryId = function(countryId) {
      service.tradeDestinationCountryId = countryId;
      notifyListenersThatCompanyFilterChanged();
    }

    service.resetTradeDestinationCountryId = function() {
      service.tradeDestinationCountryId = "";
    }

    service.changeSortByColumn = function(newColumn, sortOrder) {
      service.sort.column = newColumn;
      service.sort.order = sortOrder;
      resetToFirstPage();
      notifyListenersThatCompanyFilterChanged();
    };

    service.changeCompanyName = function(companyName) {
      service.changeCompanyNameWithoutPublishingEvent(companyName);
      notifyListenersThatCompanyFilterChanged();
    };

    service.changeDomainName = function(domainName) {
      service.changeDomainNameWithoutPublishingEvent(domainName);
      notifyListenersThatCompanyFilterChanged();
    };

    service.changeCompanyNameWithoutPublishingEvent = function(companyName) {
      service.query = companyName;
      resetToFirstPage();
    };

    service.changeDomainNameWithoutPublishingEvent = function(domainName) {
      service.domain = domainName;
      resetToFirstPage();
    };

      service.fundingDataFiltering = function(fundingData) {
          service.fundingDataFilteringWithoutPublishingEvent(fundingData);
          notifyListenersThatCompanyFilterChanged();
      };
      service.hiringDataFiltering = function(hiringData) {
          service.hiringDataFilteringWithoutPublishingEvent(hiringData);
          notifyListenersThatCompanyFilterChanged();
      };

        service.fundingDataFilteringWithoutPublishingEvent = function(fundingData) {
          EventBusService.publishEvent(VelocitiEvents.ALL_FILTERS_RESET);
//          resetSearchFilterWithoutSort();
         if (fundingData.fundingDateRange != null){
         service.fundingDateRange = fundingData.fundingDateRange;
            }
            if (fundingData.fundingSeries.length > 0){
            service.fundingSeries = fundingData.fundingSeries;
            }
            if (fundingData.funding_types.length > 0){
            service.funding_types = fundingData.funding_types;
            }
            if (fundingData.fundingDealAmount.max != null || fundingData.fundingDealAmount.min != null){
            service.fundingDealAmount = fundingData.fundingDealAmount;
            }else {
              service.fundingDealAmount = null;
            }
          resetToFirstPage();
        };
        service.hiringDataFilteringWithoutPublishingEvent = function(hiringData) {
            if (hiringData != null){
              service.hiringDateRange = hiringData;
            }
            else
            {
              service.hiringDateRange = null;
            }
          resetToFirstPage();
        };

    service.setSortOrder = function(sortOrder) {
      service.sort.order = sortOrder;
      resetToFirstPage();
      notifyListenersThatCompanyFilterChanged();
    };

    service.setVelocityListFilter = function(velocitiListId) {
      service.resetSearchFilterToDefault();
      service.velocitiListId = velocitiListId;
    };

    service.setRatingFilter = function(min, max, scale) {
      service.rating = scaledRange(min, max, scale);
      resetToFirstPage();
      notifyListenersThatCompanyFilterChanged();
    };

    service.clearRatingFilter = function() {
      service.rating = null;
      resetToFirstPage();
      notifyListenersThatCompanyFilterChanged();
    };

    service.setTurnoverFilter = function(min, max, scale) {
      service.turnover = scaledRange(min, max, scale);
      resetToFirstPage();
      notifyListenersThatCompanyFilterChanged();
    };

    service.clearTurnoverFilter = function() {
      service.turnover = null;
      resetToFirstPage();
      notifyListenersThatCompanyFilterChanged();
    };

    service.setEmployeesFilter = function(min, max, scale) {
      if(min == null){
       min = 0;
        }
      if(max == null){
       max = 100000000;
      }
      service.employees = scaledRange(min, max, scale);
      resetToFirstPage();
      notifyListenersThatCompanyFilterChanged();
    };

    service.setCompanyEmployeeGrowthRateFilter = function(min, max) {
      service.companyEmployeeGrowthRate = {
        min: min,
        max: max,
      };

      resetToFirstPage();
      notifyListenersThatCompanyFilterChanged();
    };

    service.clearEmployeesFilter = function() {
      service.employees = null;
      resetToFirstPage();
      notifyListenersThatCompanyFilterChanged();
    };

    service.clearCompanyEmployeeGrowthRateFilter = function() {
      service.companyEmployeeGrowthRate = null;
      resetToFirstPage();
      notifyListenersThatCompanyFilterChanged();
    };

    function scaledRange(minValue, maxValue, scaleValue) {
      return {
        min: minValue,
        max: maxValue,
        scale: scaleValue
      }
    }

    service.setForSearchingInList = function(velocitiListId) {
      service.isSearchingInList = true;
      service.velocitiListId = velocitiListId;
    };

    service.isCheckButtonClick = false;
    service.checkButtonClick = function(){
    service.isCheckButtonClick=true;

    };
    function generateSortQuery() {
    if(service.isCheckButtonClick){
      return '{"' + service.sort.column + '":' + service.sort.order + '}';
      }
      else
      {
      return '{"' + '' + '":' + '' + '}';
      }
    }

    function notifyListenersThatCompanyFilterChanged() {
      EventBusService.publishEvent(VelocitiEvents.COMPANY_FILTER_CHANGED);
    }

    service.removeCountry = function (country) {
      removeItemFromList(service.selectedCountries, country);
      EventBusService.publishEvent(VelocitiEvents.COUNTRY_FILTER_CHANGED);
    };

    service.removeRegion = function (region) {
      removeItemFromList(service.selectedRegions, region);
    };

    service.removeCity = function (city) {
      removeItemFromList(service.selectedCities, city);
    };

    service.removeOverseasOperation= function (overseasOperation) {
      removeItemFromList(service.selectedOverseasOperations, overseasOperation);
    }

/*    service.removeSector = function (sector) {
      removeItemFromList(service.selectedSectors, sector);
      service.filteredSubSectors();
    };*/

    service.removeTradeShow = function (tradeShow) {
      removeItemFromList(service.tradeShows, tradeShow);
    };

    service.removeExhibition = function (exhibition) {
      removeItemFromList(service.selectedExhibitions, exhibition);
    };

    service.removeNoPresence = function (country) {
      removeItemFromList(service.selectedNoPresence, country);
    };

    service.removeNewCompaniesFilter = function () {
      service.includesRecentlyActivated = null;
      notifyListenersThatCompanyFilterChanged();
    };
    service.removeScale = function (scale) {
      var scaleIndex = findScaleIndex(scale);
      if (scaleIndex > -1) {
        service.selectedScale.splice(scaleIndex, 1);
      }
      notifyListenersThatCompanyFilterChanged();
    };
    /*service.removeCompanyType = function (companyType) {
      var companyTypeIndex = findCompanyTypeIndex(companyType);
      if (companyTypeIndex > -1) {
        service.selectedCompanyType.splice(companyTypeIndex, 1);
      }
      notifyListenersThatCompanyFilterChanged();
    };
*/
    service.removeCompanyType = function (companyType) {
          removeItemFromList(service.selectedCompanyType, companyType);
    };
    service.removeCompanyEmployeeGrowthRateFilter = function () {
      service.companyEmployeeGrowthRate = null;
      notifyListenersThatCompanyFilterChanged();
    };

    service.removeSignalType = function(type) {
        removeItemFromList(service.signalDataFilters.signalTypes, type);
    };

    service.removeTargetMarket = function(market) {
        removeItemFromList(service.signalDataFilters.targetMarkets, market);
    };

    service.removeSourceMarket = function(market) {
        removeItemFromList(service.signalDataFilters.sourceMarkets, market);
    };

    service.removeSignalDateRange = function() {
        service.signalDataFilterRange.created_from = "";
        service.signalDataFilterRange.created_to = "";

        notifyListenersThatCompanyFilterChanged();
    };


    function findNAICSIndex(naics) {
      return service.selectedNAICSs.findIndex(function (selectedNAICSs) {
        return angular.equals(selectedNAICSs, naics)
      });
    }
    function findSICIndex(sic) {
      return service.selectedSICs.findIndex(function (selectedSICs) {
        return angular.equals(selectedSICs, sic)
      });
    }
    function findISICIndex(isic) {
      return service.selectedISICs.findIndex(function (selectedISICs) {
        return angular.equals(selectedISICs, isic)
      });
    }
    function findScaleIndex(scale) {
      return service.selectedScale.findIndex(function (selectedScale) {
        return angular.equals(selectedScale, scale)
      });
    }
    /*function findCompanyTypeIndex(companyType) {
      return service.selectedCompanyType.findIndex(function (selectedCompanyType) {
        return angular.equals(selectedCompanyType, companyType)
      });
    }*/


/*    service.removeSubSector = function (subSector) {
      removeItemFromList(service.selectedSubSectors, subSector);
    };*/
    service.removeIndustry = function (industry) {
      removeItemFromList(service.selectedIndustry, industry);
    };

/*    service.removeSectorTag = function (sectorTag) {
      removeItemFromList(service.selectedSectorTags, sectorTag);
    };*/
    service.removeNAICS = function (selectedNAICS) {
      var naicsIndex = findNAICSIndex(selectedNAICS);
      if (naicsIndex > -1) {
        service.selectedNAICSs.splice(naicsIndex, 1);
      }
      notifyListenersThatCompanyFilterChanged();
    };
    service.removeSIC = function (selectedSIC) {
      var sicIndex = findSICIndex(selectedSIC);
      if (sicIndex > -1) {
        service.selectedSICs.splice(sicIndex, 1);
      }
      notifyListenersThatCompanyFilterChanged();
    };
    service.removeISIC = function (selectedISIC) {
      var isicIndex = findISICIndex(selectedISIC);
      if (isicIndex > -1) {
        service.selectedISICs.splice(isicIndex, 1);
      }
      notifyListenersThatCompanyFilterChanged();
    };

    service.removeUsState = function (usState) {
      removeItemFromList(service.selectedUsStates, usState);
    };

    function removeItemFromList(list, item) {
      var itemIndex = list.indexOf(item);
      if (itemIndex > -1) {
        list.splice(itemIndex, 1);
      }
      notifyListenersThatCompanyFilterChanged();
    }

    service.removeRatingFilter = function () {
      service.rating = null;
      resetToFirstPage();
      EventBusService.publishEvent(VelocitiEvents.RATING_FILTER_RESET);
      notifyListenersThatCompanyFilterChanged();
    };

    service.removeEmployeeFilter = function () {
      service.employees = null;
      resetToFirstPage();
      EventBusService.publishEvent(VelocitiEvents.EMPLOYEE_FILTER_RESET);
      notifyListenersThatCompanyFilterChanged();
    };

    service.removeCompanyNameFilter = function () {
      service.query = "";
      resetToFirstPage();
      EventBusService.publishEvent(VelocitiEvents.COMPANY_NAME_FILTER_CHANGED);
      notifyListenersThatCompanyFilterChanged();
    };

    service.removeDomainNameFilter = function () {
      service.domain = "";
      resetToFirstPage();
      EventBusService.publishEvent(VelocitiEvents.COMPANY_DOMAIN_FILTER_CHANGED);
      notifyListenersThatCompanyFilterChanged();
    };

    service.removeEstablishedFilter = function () {
      service.selectedYearEstablishedMin = null;
      service.selectedYearEstablishedMax = null;
      resetToFirstPage();
      EventBusService.publishEvent(VelocitiEvents.ESTABLISHED_FILTER_RESET);
      notifyListenersThatCompanyFilterChanged();
    };

    service.removeTurnoverFilter = function () {
      service.turnover = null;
      resetToFirstPage();
      EventBusService.publishEvent(VelocitiEvents.TURNOVER_FILTER_RESET);
      notifyListenersThatCompanyFilterChanged();
    };

    service.removeCompanyFundingDateRangeFilter = function () {
      service.fundingDateRange = null;
      resetToFirstPage();
      notifyListenersThatCompanyFilterChanged();
    };
    service.removeCompanyFundingAmountFilter = function () {
      service.fundingDealAmount = null;
      resetToFirstPage();
      notifyListenersThatCompanyFilterChanged();
    };
    service.removeCompanyFundingDateRangeFilter = function () {
      service.fundingDateRange = null;
      resetToFirstPage();
      notifyListenersThatCompanyFilterChanged();
    };
    service.removeCompanyFundingTypeFilter = function (funding_type) {
          removeItemFromList(service.funding_types, funding_type);
        };

    service.removeCompanyFundingSeriesFilter = function (funding_Series) {
          removeItemFromList(service.fundingSeries, funding_Series);
        };
    service.removeHiringDateRange = function () {
          service.hiringDateRange = null;
          resetToFirstPage();
          notifyListenersThatCompanyFilterChanged();
        };
        service.removeJobTitle = function () {
          service.hiringDateRange.jobTitle = null;
          resetToFirstPage();
          notifyListenersThatCompanyFilterChanged();
        };
        service.removeHiringState = function () {
          service.hiringDateRange.state = null;
          resetToFirstPage();
          notifyListenersThatCompanyFilterChanged();
        };
        service.removeHiring_Country = function () {
          service.hiringDateRange.country = null;
          resetToFirstPage();
          notifyListenersThatCompanyFilterChanged();
        };
        service.removeHiring_Department = function () {
          service.hiringDateRange.department = null;
          resetToFirstPage();
          notifyListenersThatCompanyFilterChanged();
        };
    service.clearAllFilters = function () {
      service.fundingDateRange = null;
      service.fundingSeries = [];
      service.funding_types = [];
      service.hiringJobTitle = null;
//      service.hiring_Department = null;
//      service.hiring_Country = null;
//      service.hiringState = null;
      service.hiringDateRange = null;
//      service.fundingDealAmount = null;
      resetSearchFilterWithoutSort();
      EventBusService.publishEvent(VelocitiEvents.ALL_FILTERS_RESET);
//      service.filteredSubSectors();
      notifyListenersThatCompanyFilterChanged();
    };

    service.getSubSector = function(subSector){
      service.subSectors = subSector;
      service.subSectorList = subSector;
    }
    /*service.filteredSubSectors = function(){
      service.subSectorList = [];
      if(service.selectedSectors.length > 0){
        var sectors = LookupService.sectors;
        var subSectors = service.selectedSectors;

        //To find the sector id list
        var idList = [];
        subSectors.forEach(function(name) {
            var match = sectors.find(function(item) {
                return item.name === name;
            });
            if (match) {
                idList.push(match.id);
            }
        });

        //To find the subSector based on the selected sector
        var filteredData = service.subSectors.filter(function(item) {
            return idList.includes(item.sectorId);
        });
        //To assign the resultant data to the subSector list
        service.subSectorList = filteredData;
      }else{
          service.subSectorList = service.subSectors;
      }
    }*/


    return service;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('CompanyService', CompanyService);

  /** @ngInject */
  function CompanyService(Base64, CompanyResource, CompanyFilterService, $log, DateUtils, StringUtils, LoadingService) {
    var companyService = {};

    companyService.getCompanyDetails = function(companyId, success, error) {
      CompanyResource.getCompanyDetails(companyId, function(companyDetails) {
          cleanseAddress(companyDetails);
          success(companyDetails);
        },
        function (response) {
          $log.debug("Error with status code", response.status);
          error();
        }
      );
    };

    companyService.searchContacts = function (cognismCompanyId, success, error) {
      CompanyResource.searchContacts(cognismCompanyId, function (companyContacts) {
            success(companyContacts.plain());
          },
          function (response) {
            $log.debug("Error with status code", response.status);
            error();
          }
      );
    };

/*    companyService.revealContact = function (cognismPersonId, companyId, redeemId, success, error) {
      CompanyResource.revealContact(cognismPersonId, companyId, redeemId, function (companyContact) {
            success(companyContact.plain());
          },
          function (response) {
            $log.debug("Error with status code", response.status);
            error();
          }
      );
    };*/

        companyService.revealContact = function(cognismPersonId, companyId, redeemId, success, error) {
          CompanyResource.revealContact(cognismPersonId, companyId, redeemId, function(companyContact) {
              success(companyContact.plain());
            },
            function(response) {
              $log.debug("Error with status code", response.status);
              error(response);  // Pass the response object
            }
          );
        };


    companyService.getLogo = function(companyId, success, error) {
      CompanyResource.getCompanyLogo(companyId, function(logo) {
        if(logo != undefined){
          success( 'data:image/png;base64, ' + logo ); // + arrayBufferToBase64(logo));
        } else{
          error();
        }


       },
      function () {
        error();
      }
      );
    };

    companyService.getCompanyMap = function(companyId, insideviewId, success, error) {
      CompanyResource.getCompanyMap(companyId, insideviewId, function(companyMap) {
          success(companyMap);
        },
        function (response) {
          $log.debug("Error with status code", response.status);
          error();
        }
      );
    };

    companyService.getHiringDetails = function(hiringResponse , success, error) {
      CompanyResource.getHiringDetails(hiringResponse, function(companyMap) {
          success(companyMap);
        },
        function (response) {
          $log.debug("Error with status code", response.status);
          error();
        }
      );
    };

    companyService.getWorldMap = function(success, error) {
      CompanyResource.getWorldMap(function(worldMap) {
          success(worldMap);
        },
        function (response) {
          $log.debug("Error with status code", response.status);
          error();
        }
      );
    };

    function cleanseAddress(companyDetails) {
      var address = companyDetails.address;
      for (var key in address) {
        cleanseStrings(address, key);
      }
    }

    function cleanseStrings(address, key) {
      if (Object.prototype.hasOwnProperty.call(address, key) && typeof address[key] == "string") {
        address[key] = StringUtils.cleanseStringEndings(address[key]);
      }
    }

    companyService.getCompanyNews = function(insideviewId, success, error) {
      CompanyResource.getCompanyNews(insideviewId,
        function(response){
          var companyNews = response.plain();
          convertDates(companyNews);
          success(companyNews);
        },
        function (response) {
          $log.debug("Error with status code", response.status);
          error();
        }
      );
    };

    function convertDates(companyNews) {
      companyNews.newsFeed.forEach(function(newsItem) {
        newsItem.publicationDate = DateUtils.convertDate(newsItem.publicationDate);
      });
    }

    companyService.searchOnCurrentFilter = function(success, error) {
      LoadingService.isLoading(true);
      CompanyResource.companyLookup(
        CompanyFilterService.getCurrentFilter(),
        function(results) {
          success(results);
          LoadingService.isLoading(false);
        },
        function(errorResponse) {
          LoadingService.isLoading(false);
          error(errorResponse);
        });
    };

    companyService.searchOnCurrentFilterForCount = function(success, error) {
      CompanyResource.companyLookupForCount(
        CompanyFilterService.getCurrentFilter(),
          function(results) {
            /*LoadingService.isLoading(false);*/
            success(results);
          },
          function(errorResponse) {
            /*LoadingService.isLoading(false);*/
            error(errorResponse);
          }
        );
    }

    companyService.searchForCompany = function(searchRequest, success, error) {
      CompanyResource.companyLookup(searchRequest, success, error);
      CompanyResource.companyLookupForCount(searchCountRequest, success, error);
    };

    companyService.getContactsExport = function(companyId, success, error) {
      CompanyResource.getContactsExport(companyId, success, error);
    };

    companyService.postContactsExport = function(companyId, contactIds, success, error) {
      CompanyResource.postContactsExport(companyId, contactIds, success, error);
    };

    return companyService;
  }
})();

/**
 * Copyright 2015 OCO Global.
 */

(function() {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('Base64', Base64);

  /** @ngInject */
  function Base64() {
    var keyStr = 'ABCDEFGHIJKLMNOP' +
      'QRSTUVWXYZabcdef' +
      'ghijklmnopqrstuv' +
      'wxyz0123456789+/' +
      '=';
    return {
      encode: function (input) {
        var output = "";
        var chr1, chr2, chr3 = "";
        var enc1, enc2, enc3, enc4 = "";
        var i = 0;

        do {
          chr1 = input.charCodeAt(i++);
          chr2 = input.charCodeAt(i++);
          chr3 = input.charCodeAt(i++);

          enc1 = chr1 >> 2;
          enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
          enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
          enc4 = chr3 & 63;

          if (isNaN(chr2)) {
            enc3 = enc4 = 64;
          } else if (isNaN(chr3)) {
            enc4 = 64;
          }

          output = output +
            keyStr.charAt(enc1) +
            keyStr.charAt(enc2) +
            keyStr.charAt(enc3) +
            keyStr.charAt(enc4);
          chr1 = chr2 = chr3 = "";
          enc1 = enc2 = enc3 = enc4 = "";
        } while (i < input.length);

        return output;
      },

      decode: function (input) {
        var output = "";
        var chr1, chr2, chr3 = "";
        var enc1, enc2, enc3, enc4 = "";
        var i = 0;

        // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
        var base64test = /[^A-Za-z0-9\+\/\=]/g;
        if (base64test.exec(input)) {
          alert("There were invalid base64 characters in the input text.\n" +
            "Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\n" +
            "Expect errors in decoding.");
        }
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

        do {
          enc1 = keyStr.indexOf(input.charAt(i++));
          enc2 = keyStr.indexOf(input.charAt(i++));
          enc3 = keyStr.indexOf(input.charAt(i++));
          enc4 = keyStr.indexOf(input.charAt(i++));

          chr1 = (enc1 << 2) | (enc2 >> 4);
          chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
          chr3 = ((enc3 & 3) << 6) | enc4;

          output = output + String.fromCharCode(chr1);

          if (enc3 != 64) {
            output = output + String.fromCharCode(chr2);
          }
          if (enc4 != 64) {
            output = output + String.fromCharCode(chr3);
          }

          chr1 = chr2 = chr3 = "";
          enc1 = enc2 = enc3 = enc4 = "";

        } while (i < input.length);

        return output;
      }
    };
  }
})();
/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('AlgorithmRatingService', AlgorithmRatingService);

  /** @ngInject */
  function AlgorithmRatingService(AlgorithmRatingResource) {
    var ratingService = {};

    ratingService.getRatings = function (success) {
      AlgorithmRatingResource.getRatings(function (ratings) {
        ratingService.ratings = ratings.plain();
        success(ratingService.ratings);
      });
    };

    return ratingService;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */
(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('VelocitiListCompanyResource', VelocitiListCompanyResource);

  /** @ngInject */
  function VelocitiListCompanyResource(Restangular) {
    var velocitiListCompany = Restangular.all('velocitiListCompany');
    var velocitiListCompanyResource = {};

    velocitiListCompanyResource.deleteCompanyFromList = function(listId, companyId, success, error) {
      return velocitiListCompany
        .customDELETE(listId + "/" + companyId)
        .then(success, error);
    };

    velocitiListCompanyResource.addCompanyToList = function(companyToAdd, success, error) {
      return velocitiListCompany
        .post(companyToAdd)
        .then(success, error);
    };

    velocitiListCompanyResource.addCompaniesToList = function(listId, searchRequest, success, error) {
      return velocitiListCompany
        .one('addCompaniesToList')
        .customPOST(searchRequest, listId, {})
        .then(success, error);
    };

    return velocitiListCompanyResource;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */
(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('VelocitiListResource', VelocitiListResource);

  /** @ngInject */
  function VelocitiListResource(Restangular) {
    var velocitiList = Restangular.all('velocitiList');
    var velocitiListResource = {};

    velocitiListResource.addList = function(list, success, error) {
      return velocitiList
        .post(list)
        .then(success, error);
    };

    velocitiListResource.updateList = function(list, success, error) {
      return velocitiList
        .customPUT(list)
        .then(success, error);
    };

    velocitiListResource.deleteList = function(listId, success, error) {
      return velocitiList
        .customDELETE(listId)
        .then(success, error);
    };

    velocitiListResource.addList = function(list, success, error) {
      return velocitiList
        .post(list)
        .then(success, error);
    };

    return velocitiListResource;
  }
})();

/*
 * Copyright 2017 OCO Global.
 */

(function() {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('UserPreferencesResource', UserPreferencesResource);

  /** @ngInject */
  function UserPreferencesResource(Restangular) {
    var userPreferences = Restangular.all('customerPreferences');
    var userPreferencesResource = {};

    userPreferencesResource.getUserPreferences = function() {
      return userPreferences.get('');
    };

    userPreferencesResource.updateUserPreferences = function(updatedUserPreferences) {
      return userPreferences.post(updatedUserPreferences);
    };

    return userPreferencesResource;
  }
})();


/*
 * Copyright 2017 OCO Global.
 */
(function() {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('UserPasswordResource', UserPasswordResource);

  /** @ngInject */
  function UserPasswordResource(Restangular) {
    var passwords = Restangular.all('password');
    var userPasswordResource = {};

    userPasswordResource.resetPasswordRequest = function(emailAddress) {
      return passwords.all('resetPasswordRequest').post(emailAddress);
    };

    userPasswordResource.resetPassword = function(resetPasswordRequest) {
      return passwords.all('resetPassword').post(resetPasswordRequest);
    }

    return userPasswordResource;
  }
})();

/*
 * Copyright 2017 OCO Global.
 */
(function() {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('UserResource', UserResource);

  /** @ngInject */
  function UserResource(Restangular) {
    var users = Restangular.all('user');
    var userResource = {};

    userResource.login = function(loginRequest) {
      return users.withHttpConfig({ withCredentials: true }).all('login').post(loginRequest);
    };

    userResource.getUser = function (){
      return users.get('me');
    };

    userResource.verifyOtp = function (otpRequest){
      return users.withHttpConfig({ withCredentials: true }).all('verifyOtp').post(otpRequest);
    };

    userResource.resendOtp = function (otpRequest){
      return users.all('resendOtp').post(otpRequest);
    };

    userResource.logout = function (){
      return users.withHttpConfig({ withCredentials: true }).all('logout').post();
    };

    userResource.logoutAllDevices = function (){
      return users.all('logoutAll').post();
    };

    userResource.getUsername = function(userId) {
      return users.one('withPermissions', userId).get();
    };

    userResource.updateUserPassword = function (updatePasswordRequest, success, error) {
      return users.all('updatePassword').post(updatePasswordRequest).then(success, error);
    };

    userResource.submitUserPassword = function(updatePasswordRequest) {
      return users.all('lostPassword').post(updatePasswordRequest);
    };

    userResource.resetPassword = function(resetPasswordRequest) {
      return users.all('resetPassword').post(resetPasswordRequest);
    };

    return userResource;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('TrendsReportResource', TrendsReportResource);

  /** @ngInject */
  function TrendsReportResource(Restangular) {
    var trendsReportResource = {};

    trendsReportResource.generateTrendsReport = function (profileHtml, success, error) {
      Restangular.all("trendsReport/generateTrendsReportPDF")
        .withHttpConfig({ responseType: 'arraybuffer' })
        .post(profileHtml)
        .then(function (pdfResponse) {
          var pdfBlob = new Blob([pdfResponse], { 'type': 'application/pdf' });
          saveAs(pdfBlob, 'trends-report.pdf');
          success();
        }, error);
    };

    trendsReportResource.calculateTrendsReportStatistics = function (currentFilter, success, error) {
      Restangular.all("trendsReport/calculateTrendsReportStatistics").post(currentFilter).then(success, error);
    }

    return trendsReportResource;
  }

})();

/**
 * Copyright 2021 OCO Global.
 */
(function () {
  'use strict';

  /** @ngInject */
  angular
    .module('ocoExternalSite')
    .factory('TopTargetListResource', function (Restangular) {
      var api = Restangular.all('top-target-list');
      var resource = {};

      resource.getLists = function() {
        return api.customGETLIST();
      };

      resource.getListById = function(id) {
        return api.customGET(id);
      };

      return resource;
    });
})();

/**
 * Copyright 2017 OCO Global.
 */
(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('RatingResource', RatingResource);

  /** @ngInject */
  function RatingResource(Restangular) {
    var rating = Restangular.all('rating');
    var ratingResource = {};

    ratingResource.getRatingAverages = function(success, error) {
      rating.get('ratingAverages').then(success, error);
    };

    return ratingResource;
  }

})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('ProfileResource', ProfileResource);

  /** @ngInject */
  function ProfileResource(Restangular) {
    var profile = Restangular.all('profile');
    var profileResource = {};

    profileResource.submitCompanyForProfile = function(company, algorithmRating, success, error) {
      var params = {company: company, rating: algorithmRating};
      profile.all('createProfile').post(params).then(success, error);
    };

    return profileResource;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */
(function() {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('MyListsSummaryResource', MyListsSummaryResource);

  /** @ngInject */
  function MyListsSummaryResource(Restangular) {
    var velocitiListSummary = Restangular.all('velocitiListSummary');
    var velocitiListCompany = Restangular.all('velocitiListCompany');
    var myListsSummaryResource = {};

    myListsSummaryResource.getAllListsSummary = function(success, error) {
      return velocitiListSummary.all("")
        .getList()
        .then(success, error);
    };

    myListsSummaryResource.getAllListsInMostRecentOrder = function(success, error) {
      return velocitiListSummary.all("recent")
        .getList()
        .then(success, error);
    };

    myListsSummaryResource.getListSummaryById = function(listId, success, error) {
      return velocitiListSummary
        .one("specifiedList", listId)
        .get()
        .then(success, error);
    };

    myListsSummaryResource.addCompanyToList = function(companyToAdd, success, error) {
      return velocitiListCompany
        .post(companyToAdd)
        .then(success, error);
    };

    myListsSummaryResource.getMyListIdsForCompany = function(companyId, success, error) {
      return velocitiListCompany
        .one("getAllLists", companyId)
        .getList()
        .then(success, error);
    };

    myListsSummaryResource.deleteCompanyFromList = function(listId, companyId, success, error) {
      return velocitiListCompany
        .one(listId, companyId)
        .remove()
        .then(success, error);
    };

    return myListsSummaryResource;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('LookupResource', LookupResource);

  /** @ngInject */
  function LookupResource(Restangular, $cookies) {
    var lookup = Restangular.all('lookup');
    var industrialDetails = Restangular.all('industrialDetails');
    var tradeShow = Restangular.all('tradeshow');
    var hiring = Restangular.all('hiringData');
    var lookupResource = {};

    lookupResource.getCountries = function(success, error) {
      lookup.one('countries').get().then(success, error);
    };

    lookupResource.getHiringCountries = function(success, error) {
      hiring.one('listCountries').get().then(success, error);
    };

     lookupResource.populateSectors = function (success, error) {
        lookup.one('sectors').get().then(success, error);
     };

    lookupResource.getSubSectors = function (success, error) {
      lookup.one('subSectors').get().then(success, error);
    };

    lookupResource.getNAICS = function (success, error) {
      industrialDetails.one('naics').get().then(success, error);
    };

    lookupResource.getSIC = function (success, error) {
      industrialDetails.one('sic').get().then(success, error);
    };

    lookupResource.getISIC = function (success, error) {
      industrialDetails.one('isic').get().then(success, error);
    };

    if($cookies.getObject('user').roleId == 2){
        lookupResource.getTradeShow = function (success, error) {
          tradeShow.one('client/all').get().then(success, error);
        };
    }
    else
    {
        lookupResource.getTradeShow = function (success, error) {
          tradeShow.one('all').get().then(success, error);
        };
    }

    lookupResource.getCompanyTypes = function (success, error) {
      lookup.one('companyTypes').get().then(success, error);
    };

     lookupResource.getSectorTags = function (success, error) {
          Restangular.one("SectorTagRules/getSectorTags").get().then(success, error);
        };

    lookupResource.getUsStates = function (success, error) {
      lookup.one('usStates').get().then(success, error);
    };

 lookupResource.getCities = function(citySearchTerm, selectedCountries, success, error) {
     var url = "city?";

     if (Array.isArray(selectedCountries) && selectedCountries.length > 0) {
         // Add countries as repeated query params
         url += selectedCountries.map(function(c) {
             return "countries=" + encodeURIComponent(c);
         }).join("&");
         url += "&city=" + encodeURIComponent(citySearchTerm);
     } else {
         // No countries selected – fallback to default
         url += "city=" + encodeURIComponent(citySearchTerm);
     }

     lookup.one(url).get().then(success, error);
 };

    lookupResource.getRegions = function(success, error) {
      lookup.one("regions").get().then(success, error);
    };

    lookupResource.getSignalsType = function(success, error) {
      lookup.one("investmentSignalTypes").get().then(success, error);
    };

    return lookupResource;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */
(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('InvestSignalResource', InvestSignalResource);

  /** @ngInject */
  function InvestSignalResource(Restangular) {
    var signal = Restangular.all('/signal');
    var published = Restangular.all('/signal/published');
    var investSignalResource = {};

    investSignalResource.saveSignal = function(signal, success, error) {
      return signal.post(signal).then(success, error);
    };

    investSignalResource.deleteSignal = function(signal, success, error) {
      return signal.customDelete(signal).then(success, error);
    };

    investSignalResource.getAllSignals = function(success, error) {
      return signal.one('all').get().then(success, error);
    };

    investSignalResource.getAllPublishedSignals = function(success, error) {
      return signal.one('published').get().then(success, error);
    };

    investSignalResource.searchPublished = function(request, success, error) {
      return published.one('search').customPOST(request).then(success, error);
    };

    investSignalResource.exportSignals = function(request, success, error) {
      return published.one('export').customPOST(request).then(success, error);
    };

/*
    investSignalResource.exportSignals = function(request, success, error) {
          return published.one("export")
                  .withHttpConfig({ responseType: 'arraybuffer' })
                  .customPOST(request)
                  .then(function (file) {
                    var blob = new Blob([file], { 'type': 'application/application/vnd.ms-excel' });
                    saveAs(blob, "InvestmentSignalList" + ".xlsx");
                    success();
                  }, error);
        };
*/

    investSignalResource.getAllPublishedCompanySignals = function(companyId, success, error) {
      return published.one(companyId).get().then(success, error);
    };

    investSignalResource.getSignalDetails = function(signalId, success, error) {
      return signal.one(signalId).get().then(success, error);
    };

    investSignalResource.getAllCompanySignalsDetails = function(companyId, success, error) {
      return published.one(companyId).get().then(success, error);
    };

    return investSignalResource;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */
(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('ExhibitionResource', ExhibitionResource);

  /** @ngInject */
  function ExhibitionResource(Restangular) {
    var exhibition = Restangular.all('simpleExhibition');
    var exhibitionResource = {};

    exhibitionResource.getExhibitions = function(success, error) {
      return exhibition.getList().then(success, error);
    };

    exhibitionResource.getExhibitionsInYear = function(year, success, error) {
      return exhibition.one(String(year)).getList().then(success, error);
    };

    exhibitionResource.getExhibitionYears = function(success, error) {
      return exhibition.one('years').getList().then(success, error);
    };

    return exhibitionResource;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */
(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('DownloadReportsResource', DownloadReportsResource);

  /** @ngInject */
  function DownloadReportsResource(Restangular) {
    var downloadReportResource = {};

    /**
     * Using filesaver.js. This is the same as the admin portal.
     * Tried using Angular wrapper for this dependency but had issues so decided to repeat pattern already used
     * in the codebase.
     */
    downloadReportResource.downloadVelocitiListReport = function (velocitiListId, velocitiListName, tradeDestination, success, error) {
      var params = {velocitiListId: velocitiListId, tradeDestination: tradeDestination, isSendEmail: false}
      Restangular.one("reporting/velocitiListExport")
        .withHttpConfig({ responseType: 'arraybuffer' })
        .customGET("", params)
        .then(function (file) {
          var blob = new Blob([file], { 'type': 'application/application/vnd.ms-excel' });
          saveAs(blob, velocitiListName + ".xlsx");
          success();
        }, error);
    };

    downloadReportResource.downloadVelocitiListReportByMail = function (velocitiListId, velocitiListName, tradeDestination, success, error) {
      var params = {velocitiListId: velocitiListId, tradeDestination: tradeDestination, isSendEmail: true}
      Restangular.one("reporting/velocitiListExport")
        .get(params)
        .then(function(response) {
            success(response)
         }, error)
    };

    return downloadReportResource;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('ContactResource', ContactResource);

  /** @ngInject */
  function ContactResource(Restangular) {
    var contact = Restangular.all('remote');
    var contactResource = {};

    contactResource.sendEmail = function (email, success, error) {
      contact.one('sendEmail').customPOST(email).then(success, error);
    };

    return contactResource;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */
(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('CompanyRatingResource', CompanyRatingResource);

  /** @ngInject */
  function CompanyRatingResource(Restangular) {
    var companyRating = Restangular.all('companyAssessments');
    var companyRatingResource = {};

    companyRatingResource.requestCompanyRating = function(company, success, error) {
      return companyRating.one('assessment').customPOST(company).then(success, error);
    };

    return companyRatingResource;
  }

})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('CompanyProfileResource', CompanyProfileResource);

  /** @ngInject */
  function CompanyProfileResource(Restangular) {
    var companyProfile = Restangular.all('companyProfile');
    var profileResource = {};

    profileResource.getCompanyProfiles = function (searchRequest, success, error) {
      companyProfile.customPOST(searchRequest, "list", {}).then(success, error);
    };

    return profileResource;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */
(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('CompanyResource', CompanyResource);

  /** @ngInject */
  function CompanyResource(Restangular) {
    var company = Restangular.all('company');
    var algorithmRatedCompany = Restangular.all('algorithmRatedCompany');
    var cognismPeopleSearch = Restangular.all('cognism/searchContacts');
    var cognismPersonReveal = Restangular.all('cognism/revealContacts');
    var remote = Restangular.all('companyNews');
    var map = Restangular.all('companyFamilyTree/map');
    var logo = Restangular.all('companyNews/logo');
    var companyResource = {};

    companyResource.getContactsExport = function(companyId, success, error) {
      return company.one(companyId).all('export').withHttpConfig({ responseType: 'arraybuffer' }).get("contacts").then(success, error);
    };

    companyResource.postContactsExport = function(companyId, contactIds, success, error) {
      return company.one(companyId).all('export/contacts').withHttpConfig({ responseType: 'arraybuffer' }).post(contactIds).then(success, error);
    };

    companyResource.companyLookup = function(searchRequest, success, error) {
      return algorithmRatedCompany.customPOST(searchRequest, "list", {}).then(success, error);
    };

    companyResource.companyLookupForCount = function(searchCountRequest, success, error) {
      return algorithmRatedCompany.customPOST(searchCountRequest, "count", {}).then(success, error);
    }
    companyResource.getHiringDetails = function(searchHiringRequest, success, error) {
      return company.customPOST(searchHiringRequest, "events/hiring", {}).then(success, error);
    }

    companyResource.getCompanyLogo = function(insideviewId, success, error) {
      return logo.one(insideviewId.toString()).get().then(success, error);
    };

    companyResource.companyNameLookup = function(companyName) {
      return company.customGET('name', {name: companyName})
    };

    companyResource.getCompanyDetails = function(companyId, success, error) {
      return algorithmRatedCompany.one(companyId).get().then(success, error);
    };

    companyResource.searchContacts = function(request, success, error) {
      return cognismPeopleSearch.post(request).then(success, error);
    };

/*    companyResource.revealContact = function(cognismPersonId, companyId, redeemId, success, error) {debugger
      return cognismPersonReveal.post({
        personId: cognismPersonId,
        companyId: companyId,
        redeemId: redeemId
      }).then(success, error);
    };*/
    companyResource.revealContact = function(cognismPersonId, companyId, redeemId, success, error) {
      return cognismPersonReveal.post({
        personId: cognismPersonId,
        companyId: companyId,
        redeemId: redeemId
      }).then(success).catch(function(err) {
          error({ message: err.data[0] });
      });
    };

    companyResource.getCompanyNews = function(insideviewId, success, error) {
      return remote.one(insideviewId.toString()).get().then(success, error);
    };

    companyResource.getCompanyMap = function(companyId, insideviewId, success, error) {
      if(insideviewId == null){
        return map.one(companyId.toString()).get().then(success, error);
      }else{
        return map.one(companyId.toString(), insideviewId.toString()).get().then(success, error);
      }
    };

    companyResource.getWorldMap = function(success, error){
      return map.getList().then(success, error);
    };

    companyResource.updateCompanyNote = function (companyId, note, success, error) {
      return company.one(companyId).all('note').post({
        note: note,
      }).then(success, error);
    };

    return companyResource;
  }
})();

/**
 * Copyright 2017 OCO Global.
 */

(function () {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('AlgorithmRatingResource', AlgorithmRatingResource);

  /** @ngInject */
  function AlgorithmRatingResource(Restangular) {
    var algorithmRating = Restangular.all('algorithmRating');
    var ratingResource = {};

    ratingResource.getRatings = function (success, error) {
      algorithmRating.one('sortedRatings').get().then(success, error);
    };

    return ratingResource;
  }
})();

(function() {
  'use strict';

  angular
    .module('ocoExternalSite')
    .factory('SessionInterceptor', SessionInterceptor);

  /** @ngInject */
  function SessionInterceptor($q, $injector, RouterStates) {
    return {
      responseError: function(rejection) {
        if (rejection.status === 401) {

          var $state = $injector.get('$state');
          var UserService = $injector.get('UserService');

          UserService.forceLogout('Please login again.');
          $state.go(RouterStates.LOGIN);
          // $state.go('login'); // swap 'login' for your actual state name
        }
        return $q.reject(rejection);
      }
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('ocoExternalSite')
    .run(runBlock);

  /** @ngInject */
  function runBlock($window, $rootScope, Roles, UserService, PermRoleStore, $urlRouter, $location, StorageKeys) {

    UserService.getRole();

    $rootScope.inputValid = function (input) {
      return input.$valid && input.$dirty;
    };

    $rootScope.inputInvalid = function (input) {
      return input.$invalid && input.$dirty;
    };

    PermRoleStore.defineRole(Roles.ANONYMOUS, function() {
      return UserService.getRole().then(function (role){
        return role === Roles.ANONYMOUS;
      });
    });

    PermRoleStore.defineRole(Roles.USER, function() {
      return UserService.getRole().then(function (role){
        return role === Roles.USER;
      });
    });

    UserService.getRole().then(function() {
      $urlRouter.sync();
      $urlRouter.listen();
    });

    $rootScope.online = navigator.onLine;
      $window.addEventListener("offline", function() {
        $rootScope.$apply(function() {
          $rootScope.online = false;
        });
      }, false);

      $window.addEventListener("online", function() {
        $rootScope.$apply(function() {
          $rootScope.online = true;
        });
      }, false);

    function redirectToLogin(message) {
      if ($location.path() !== '/login') {
        $rootScope.sessionMessage = message;
        $location.path('/login');
        $rootScope.$applyAsync();  // safe apply since this can be called outside digest
      }
    }
    $window.addEventListener('storage', function(event) {
      if (event.key === 'logout-event' && event.newValue) {
        var data = JSON.parse(event.newValue);
        UserService.removeStoredUser();
        redirectToLogin(data.message);
      }
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('ocoExternalSite')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, RouterStates, Roles, $httpProvider) {

    $urlRouterProvider.deferIntercept();
    $httpProvider.interceptors.push('SessionInterceptor');

    $stateProvider
      .state(RouterStates.LOGIN, {
        url: '',
        templateUrl: 'app/controllers/login/login.html',
        controller: 'LoginController',
        controllerAs: 'loginController',
        data: {
          permissions: {
            only: [Roles.ANONYMOUS],
            redirectTo: RouterStates.COMPANIES
//            redirectTo: RouterStates.USER_PREFERENCES
          }
        },
        resolve: {
          $title: function () {
            return 'Login'
          }
        }
      })
      .state(RouterStates.FORGOT_PASSWORD, {
        url: '/forgotPassword',
        templateUrl: 'app/controllers/login/forgotPassword.html',
        controller: 'ForgotPasswordController',
        controllerAs: 'forgotPasswordController',
        data: {
          permissions: {
            only: [Roles.ANONYMOUS],
            redirectTo: RouterStates.MYVELOCITI
          }
        },
        resolve: {
          $title: function () {
            return 'Forgot Password'
          }
        }
      })
      .state(RouterStates.WELCOME, {
        url: '/welcome',
        templateUrl: 'app/controllers/dashboards/welcome.html',
        controller: 'WelcomeController',
        controllerAs: 'controller',
        parent: RouterStates.LAYOUT,
        data: {
          permissions: {
            only: [Roles.USER],
            redirectTo: RouterStates.LOGIN
          }
        },
        resolve: {
          $title: function () {
            return 'Welcome'
          }
        }
      })
      .state(RouterStates.LAYOUT, {
        url: '/home',
        abstract: true,
        templateUrl: 'app/controllers/layout/layout.html',
        controller: 'LayoutController',
        controllerAs: 'controller',
        data: {
          permissions: {
            only: [Roles.USER],
            redirectTo: RouterStates.LOGIN
          }
        }
      })
      .state(RouterStates.MYVELOCITI, {
        url: '/myVelociti',
        templateUrl: 'app/controllers/dashboards/myVelociti.html',
        controller: 'MyVelocitiController',
        controllerAs: 'mvController',
        parent: RouterStates.LAYOUT,
        data: {
          permissions: {
            only: [Roles.USER],
            redirectTo: RouterStates.LOGIN
          }
        },
        resolve: {
          $title: function() {
            return 'My VELOCITI'
          }
        }
      })
      .state(RouterStates.COMPANIES, {
        url: '/companies',
        templateUrl: 'app/controllers/company/companySearch.html',
        controller: 'CompanySearchController',
        controllerAs: 'compController',
        parent: RouterStates.LAYOUT,
        params: {
          companyText: null,
          exhibition: null,
          topTargetList: null,
          topTargetYear: null,
        },
        data: {
          permissions: {
            only: [Roles.USER],
            redirectTo: RouterStates.LOGIN
          }
        },
        resolve: {
          $title: function() {
            return 'Companies'
          }
        }
      })
      .state(RouterStates.COMPANY_DETAILS, {
        url: '/companyDetails/:companyId',
        templateUrl: 'app/controllers/company/companyDetails.html',
        controller: 'CompanyDetailsController',
        controllerAs: 'controller',
        parent: RouterStates.LAYOUT,
        data: {
          permissions: {
            only: [Roles.USER],
            redirectTo: RouterStates.LOGIN
          }
        },
        resolve: {
          $title: function() {
            return 'Company Details'
          }
        }
      })
      .state(RouterStates.VELOCITI_LIST, {
        url: '/velocitiList/:id/:name',
        templateUrl: 'app/controllers/lists/velocitiList.html',
        controller: 'VelocitiListController',
        controllerAs: 'vlController',
        parent: RouterStates.LAYOUT,
        data: {
          permissions: {
            only: [Roles.USER],
            redirectTo: RouterStates.LOGIN
          }
        },
        resolve: {
          $title: function() {
            return 'Velociti List'
          }
        }
      })
      .state(RouterStates.VELOCITI_LIST_SEARCH_COMPANIES, {
        url: '/velocitiListSearchCompanies/:id/:name',
        templateUrl: 'app/controllers/lists/velocitiListSearchCompanies.html',
        controller: 'VelocitiListSearchCompaniesController',
        controllerAs: 'vlscController',
        parent: RouterStates.LAYOUT,
        data: {
          permissions: {
            only: [Roles.USER],
            redirectTo: RouterStates.LOGIN
          }
        },
        resolve: {
          $title: function() {
            return 'Velociti List'
          }
        }
      })
      .state(RouterStates.MY_LISTS, {
        url: '/myLists',
        templateUrl: 'app/controllers/lists/myLists.html',
        controller: 'MyListsController',
        controllerAs: 'mylController',
        parent: RouterStates.LAYOUT,
        data: {
          permissions: {
            only: [Roles.USER],
            redirectTo: RouterStates.LOGIN
          }
        },
        resolve: {
          $title: function() {
            return 'My Lists'
          }
        }
      })
      .state(RouterStates.TOP_TARGET_LISTS, {
        url: '/topTargetLists',
        templateUrl: 'app/controllers/lists/topTargetLists.html',
        controller: 'TopTargetListsController',
        controllerAs: 'ttlController',
        parent: RouterStates.LAYOUT,
        data: {
          permissions: {
            only: [Roles.USER],
            redirectTo: RouterStates.LOGIN
          }
        },
        resolve: {
          $title: function() {
            return 'Top Target Lists';
          }
        }
      })
      .state(RouterStates.USER_PREFERENCES, {
        url: '/userPreferences',
        templateUrl: 'app/controllers/user/userPreferences.html',
        controller: 'UserPreferencesController',
        controllerAs: 'userPreferencesController',
        parent: RouterStates.LAYOUT,
        data: {
          permissions: {
            only: [Roles.USER],
            redirectTo: RouterStates.LOGIN
          }
        },
        resolve: {
          $title: function() {
            return 'User Preferences'
          }
        }
      })
      .state(RouterStates.UPDATE_PASSWORD, {
        url: '/updatePassword',
        templateUrl: 'app/controllers/user/updatePassword.html',
        controller: 'UpdatePasswordController',
        controllerAs: 'updatePasswordController',
        parent: RouterStates.LAYOUT,
        data: {
          permissions: {
            only: [Roles.USER],
            redirectTo: RouterStates.LOGIN
          }
        },
        resolve: {
          $title: function() {
            return 'Update Password'
          }
        }
      })
      .state(RouterStates.REQUEST_RATING, {
        url: '/requestRating',
        templateUrl: 'app/controllers/requests/requestRating.html',
        controller: 'RequestRatingController',
        controllerAs: 'requestRatingController',
        parent: RouterStates.LAYOUT,
        data: {
          permissions: {
            only: [Roles.USER],
            redirectTo: RouterStates.LOGIN
          }
        },
        resolve: {
          $title: function() {
            return 'Request Rating'
          }
        }
      })
      .state(RouterStates.EXHIBITOR_ANALYSIS, {
        url: '/exhibitorAnalysis',
        templateUrl: 'app/controllers/exhibitor/exhibitorAnalysis.html',
        controller: 'ExhibitorAnalysisController',
        controllerAs: 'eaController',
        parent: RouterStates.LAYOUT,
        data: {
          permissions: {
            only: [Roles.USER],
            redirectTo: RouterStates.LOGIN
          }
        },
        resolve: {
          $title: function() {
            return 'Exhibitor Analysis'
          }
        }
      })
      .state(RouterStates.INVESTMENT_SIGNALS, {
        url: '/investmentSignals',
        templateUrl: 'app/controllers/investmentSignals/investmentSignals.html',
        controller: 'InvestmentSignalsController',
        controllerAs: 'investmentSignalsController',
        parent: RouterStates.LAYOUT,
        data: {
          permissions: {
            only: [Roles.USER],
            redirectTo: RouterStates.LOGIN
          }
        },
        resolve: {
          $title: function() {
            return 'Investment Signals';
          }
        }
      })
//      .state(RouterStates.DEMO_VIDEO, {
//        url: '/demoVideo',
//        templateUrl: 'app/controllers/dashboards/demoVideo.html',
//        controller: 'DemoVideoController',
//        controllerAs: 'demoVideoController',
//        parent: RouterStates.LAYOUT,
//        data: {
//          permissions: {
//            only: [Roles.USER],
//            redirectTo: RouterStates.LOGIN
//          }
//        },
//        resolve: {
//          $title: function() {
//            return 'Demo Video'
//          }
//        }
//      })
      .state(RouterStates.CONTACT, {
        url: '/contact',
        templateUrl: 'app/controllers/contact/contact.html',
        controller: 'ContactController',
        controllerAs: 'contactController',
        parent: RouterStates.LAYOUT,
        data: {
          permissions: {
            only: [Roles.USER],
            redirectTo: RouterStates.LOGIN
          }
        },
        resolve: {
          $title: function() {
            return 'Contact'
          }
        }
      })
      .state(RouterStates.NOT_FOUND, {
        url: '/notFound',
        templateUrl: 'app/controllers/notFound/notFound.html',
        controller: 'NotFoundController',
        controllerAs: 'controller',
        parent: RouterStates.LAYOUT,
        resolve: {
          $title: function() {
            return 'Not Found'
          }
        }
      })
      .state(RouterStates.RESET_PASSWORD, {
        url: '/resetPassword/:userId/:passwordResetToken',
        templateUrl: 'app/controllers/resetPassword/resetPassword.html',
        controller: 'ResetPasswordController',
        controllerAs: 'resetPasswordController',
        resolve: {
          $title: function() {
            return "Reset Password"
          }
        }
      })
      .state(RouterStates.REQUESTED_PROFILES, {
        url: '/requestedProfiles',
        templateUrl: 'app/controllers/requests/requestedProfiles.html',
        controller: 'RequestedProfilesController',
        controllerAs: 'rpController',
        parent: RouterStates.LAYOUT,
        resolve: {
          $title: function() {
            return "Requested Profiles"
          }
        }
      });

    /*
     * This default should be done like this to get around a known issue with angular-permission module.
     * See https://github.com/Narzerus/angular-permission/wiki/Installation-guide-for-ui-router#known-issues
     */
    $urlRouterProvider.otherwise(function($injector) {
      var $state = $injector.get("$state");
      var UserService = $injector.get("UserService");
      var userRole = '';
      UserService.getRole().then(function(role) {
        userRole = role;
        if (userRole === Roles.USER) {
          $state.go(RouterStates.COMPANIES); // or wherever logged-in users should land
        } else if(userRole === Roles.ANONYMOUS) {
          $state.go(RouterStates.LOGIN);
        }
      });
    });
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('ocoExternalSite')
    .constant('malarkey', malarkey)
    .constant('moment', moment)
    .constant('RouterStates', {
      LAYOUT: 'layout',
      LOGIN: 'login',
      FORGOT_PASSWORD: 'forgotPassword',
      WELCOME: 'welcome',
      MYVELOCITI: 'myVelociti',
      COMPANIES: 'companies',
      COMPANY_DETAILS: 'companyDetails',
      MY_LISTS: 'myLists',
      TOP_TARGET_LISTS: 'topTargetLists',
      VELOCITI_LIST: 'velocitiList',
      VELOCITI_LIST_SEARCH_COMPANIES: 'velocitiListSearchCompanies',
      USER_PREFERENCES: 'userPreferences',
      UPDATE_PASSWORD: 'updatePassword',
      REQUEST_RATING: 'requestRating',
      EXHIBITOR_ANALYSIS: 'exhibitorAnalysis',
      INVESTMENT_SIGNALS: 'investmentSignals',
      DEMO_VIDEO: 'demoVideo',
      CONTACT: 'contact',
      NOT_FOUND: 'notFound',
      RESET_PASSWORD: "resetPassword",
      REQUESTED_PROFILES: "requestedProfiles"
    })
    .constant('HttpResponseCodes', {
      CONFLICT: 409,
      UNAUTHORIZED: 401
    })
    .constant('CompanyListColumns', {
      NAME: "lowerCaseName",
      COUNTRY: "address.country",
      SECTOR: "sector",
      SCALE: "category",
      RATING: "rating",
      REQUESTED: "dateRequested",
      IS_COMPLETE: "isComplete"
    })
    .constant('SortOrder', {
      ASCENDING: 1,
      DESCENDING: -1
    })
    .constant('VelocitiEvents', {
      COMPANY_FILTER_CHANGED: "companyFilteredChanged",
      COMPANY_NAME_FILTER_CHANGED: "companyNameFilteredChanged",
      COMPANY_DOMAIN_FILTER_CHANGED: "companyDomainFilteredChanged",
      TURNOVER_FILTER_RESET: "turnoverFilteredReset",
      RATING_FILTER_RESET: "ratingFilteredReset",
      EMPLOYEE_FILTER_RESET: "employeeFilteredReset",
      ESTABLISHED_FILTER_RESET: "yearEstablishedFilteredReset",
      ALL_FILTERS_RESET: "allFiltersReset",
      COMPANY_PROFILE_CHANGED: "companyProfileChanged",
      COUNTRY_FILTER_CHANGED: "countryFilterChanged"
    })
    .constant('Roles', {
      ANONYMOUS: 'ANONYMOUS',
      USER: 'USER'
    })
    .constant('StorageKeys',{
      AUTH_TOKEN: 'app_auth_token'
    });
})();

(function() {
  'use strict';

  angular
    .module('ocoExternalSite')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, envServiceProvider, RestangularProvider, $animateProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Fixes issue with CSS transition and ng-repeat showing state items
    // see https://github.com/angular/angular.js/issues/5376
    $animateProvider.classNameFilter(/animated/);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;

    // Set environment endpoints
    envServiceProvider.config({
      domains: {
        development: ['localhost'],
        staging: ['velociti-staging.ocoglobal.com'],
        production: ['velociti.ocoglobal.com'],
        production_alternative: ['www.velociti.ocoglobal.com']
      },
      vars: {
        development: {
          apiUrl: 'http://localhost:3000',
          staticUrl: 'http://localhost:3000'
        },
        staging: {
          apiUrl: 'https://velociti-staging.ocoglobal.com/',
          staticUrl: 'https://velociti-staging.ocoglobal.com'
        },
        production: {
          apiUrl: 'https://velociti.ocoglobal.com/',
          staticUrl: 'https://velociti.ocoglobal.com'
        },
        production_alternative: {
          apiUrl: 'https://www.velociti.ocoglobal.com/',
          staticUrl: 'https://www.velociti.ocoglobal.com'
        }
      }
    });

    // run the environment check, so the comprobation is made before controllers and services are built
    envServiceProvider.check();

    // Set backend base endpoint URL based on what environment the app is hosted in
    RestangularProvider.setBaseUrl(envServiceProvider.read('apiUrl') + '/api/v2/');
  }

})();

function ScaledRange() {
    this.max = 0;
    this.min = 0;
    this.scale = 1;
    this.postfixes = {1: "", 1000: ""};
    this.scaleDescriptions = {1: "", 1000: ""}
}

ScaledRange.prototype.updateScale = function () {
    this.scale = (this.scale == 1 ? 1000 : 1);
};

ScaledRange.prototype.postfix = function () {
    return this.postfixes[this.scale];
};

ScaledRange.prototype.scaleDescription = function () {
    return this.scaleDescriptions[this.scale];
};

ScaledRange.prototype.formatter = function (value) {
    return value + this.postfix();
};

if(!('contains' in String.prototype)) {
    String.prototype.contains = function(str, startIndex) {
        return -1 !== String.prototype.indexOf.call(this, str, startIndex);
    }
}
angular.module("ocoExternalSite").run(["$templateCache", function($templateCache) {$templateCache.put("app/controllers/company/companySearch.html","<!--\r\n  ~ Copyright (c) OCOGlobal 2017\r\n  --><sidebar></sidebar><div id=company-search class=category-menu><div id=mainWindow><div class=upper-block><single-message-summary alert=compController.alert></single-message-summary><company-search-title search-results=compController.searchCountResults alert=compController.alert></company-search-title><trade-destination user-location-id=compController.userLocationId ng-show=compController.isTradeFocused></trade-destination></div><div class=custom-block><div class=col-30 ng-class=\"{\'trigger\' : !compController.isCompanySearchShow}\"><!--<ul class=\"main-tab\">\r\n          <li class=\"main-tab mt2\">Company</li>\r\n        </ul>--><div class=badge-container><company-list-filter-badges template=company></company-list-filter-badges></div><company-list-filters></company-list-filters></div><div class=col-70 ng-class=\"{\'trigger\' : !compController.isCompanySearchShow}\"><div class=close-search-filter><svg xmlns=http://www.w3.org/2000/svg width=25 height=25 fill=#fff class=\"bi bi-filter-left clck1\" ng-show=compController.isCompanySearchShow ng-click=\"compController.isCompanySearchShow = false;\" viewBox=\"0 0 16 16\"><path fill-rule=evenodd d=\"M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z\"/></svg></div><!--        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"38\" height=\"38\" fill=\"#fff\" ng-show=\"compController.isCompanySearchShow\" ng-click=\"compController.isCompanySearchShow = false;\" class=\"bi bi-filter-left clck1\" viewBox=\"0 0 16 16\">--><!--          <path d=\"M2 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z\"/>--><!--        </svg>--> <svg xmlns=http://www.w3.org/2000/svg width=38 height=38 fill=#fff class=\"bi bi-funnel-fill bi-filter-right clck2\" viewBox=\"0 0 16 16\" ng-show=!compController.isCompanySearchShow ng-click=\"compController.isCompanySearchShow = true;\"><path d=\"M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z\"/></svg><!--        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"45\" height=\"45\" fill=\"#fff\" ng-show=\"!compController.isCompanySearchShow\" ng-click=\"compController.isCompanySearchShow = true;\" class=\"bi bi-filter-right clck2\" viewBox=\"0 0 16 16\">--><!--          <path d=\"M14 10.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5zm0-3a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0 0 1h7a.5.5 0 0 0 .5-.5zm0-3a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0 0 1h11a.5.5 0 0 0 .5-.5z\"/>--><!--        </svg>--><!--        <i ng-show=\"compController.isCompanySearchShow\" ng-click=\"compController.isCompanySearchShow = false;\" class=\"fas fa-stream clck1\" aria-hidden=\"true\" title=\"To build a target list please add search options\"></i>--><!--        <i ng-show=\"!compController.isCompanySearchShow\" ng-click=\"compController.isCompanySearchShow = true;\"  class=\"fa fa-filter clck2\" aria-hidden=\"true\" title=\"To build a target list please add search options\"></i>--><!--\r\n        <div ng-class=\"{\'search-field-adj\' : !compController.isCompanySearchShow}\"  class=\"row comp-search-field\">\r\n          <div class=\" search-group\">\r\n            <input type=\"text\" class=\"form-control search-co-input\" placeholder=\"Company names...\"\r\n                   aria-describedby=\"basic-addon2\"\r\n                   ng-model=\"compController.companyName\"\r\n                   ng-model-options=\"{debounce: 500}\"\r\n                   ng-change=\"compController.onChangeInCompanyNameFilter()\">\r\n            <span class=\"search-co-icon\" id=\"search-company\">\r\n\r\n\r\n\r\n            <svg ng-if=\"compController.searchShow\" xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" class=\"bi bi-search\" viewBox=\"0 0 16 16\">\r\n              <path\r\n                d=\"M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z\" />\r\n            </svg>\r\n            <svg ng-if=\"!compController.searchShow\" ng-click=\"compController.clearSearch()\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"currentColor\" class=\"bi bi-x\" viewBox=\"0 0 16 16\">\r\n              <path d=\"M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z\"/>\r\n            </svg>\r\n              </span>\r\n          </div>\r\n        </div>\r\n--><!--        <div class=\"search-btn-block\">--><!--          <button class=\"btn colr primary\" ng-click=\"cstController.saveAsList()\" ng-disabled=\"$root.isLoading\">Save as List</button>--><!--          <button class=\"btn colr primary btn-dark-blue\" ng-click=\"cstController.saveAsList()\" ng-disabled=\"$root.isLoading\">Download</button>--><!--        </div>--><div class=\"data-table comp-search-data\" ng-class=\"{\'blank-left\' : !compController.isCompanySearchShow}\"><company-list is-trade-focused=compController.isTradeFocused search-results=compController.searchResults alert=compController.alert></company-list><company-list-paging search-results=compController.searchCountResults></company-list-paging></div></div></div></div></div>");
$templateCache.put("app/controllers/companyInvestmentSignal/investSignalSearch.html","<!--\r\n  ~ Copyright (c) OCOGlobal 2017\r\n  --><sidebar></sidebar><div id=company-search><div id=mainWindow class=invest-signal-search><single-message-summary alert=investSigController.alert></single-message-summary><!-- <invest-signal-search-title search-results=investSigController.searchResults alert=\"investSigController.alert\"></invest-signal-search-title>\r\n\r\n    <trade-destination user-location-id=\"investSigController.userLocationId\" ng-show=\"investSigController.isTradeFocused\"></trade-destination>\r\n\r\n    <company-list-filters></company-list-filters>\r\n\r\n    <company-list-filter-badges template=\'company\'></company-list-filter-badges> --><invest-signal-list search-results=investSigController.searchResults alert=investSigController.alert></invest-signal-list></div></div>");
$templateCache.put("app/controllers/contact/contact.html","<!--\r\n  ~ Copyright (c) OCOGlobal 2017\r\n  --><sidebar></sidebar><div id=contact><div id=mainWindow><single-message-summary alert=contactController.alert></single-message-summary><div id=contactForm><div class=contactForm_inner><header><h1>Contact</h1><div class=clearfix></div></header><section><form name=contactMessageForm ng-submit=\"contactMessageForm.$valid && contactController.sendEmail()\" novalidate><div class=description><p>Enter your contact details and message, a representative will contact you back as soon as possible.</p></div><div class=form-group ng-class=\"{ \'has-error\' : contactMessageForm.$submitted && contactMessageForm.sendersName.$invalid }\"><label for=company_name>Name</label><input name=sendersName type=text id=company_name ng-model=contactController.sendersName required><div ng-messages=\"contactMessageForm.$submitted && contactMessageForm.sendersName.$error\" class=small-error><span ng-message=required>Your name is required</span></div></div><div class=form-group ng-class=\"{ \'has-error\' : contactMessageForm.$submitted && contactMessageForm.emailSubject.$invalid }\"><label for=company_subject>Subject</label><input name=emailSubject type=text id=company_subject ng-model=contactController.emailSubject required><div ng-messages=\"contactMessageForm.$submitted && contactMessageForm.emailSubject.$error\" class=small-error><span ng-message=required>Subject matter is required</span></div></div><div class=form-group ng-class=\"{ \'has-error\' : contactMessageForm.$submitted && contactMessageForm.emailMessage.$invalid }\"><label for=contactTextArea>Message</label><textarea id=contactTextArea name=emailMessage rows=5 ng-model=contactController.emailMessage required></textarea><div ng-messages=\"contactMessageForm.$submitted && contactMessageForm.emailMessage.$error\" class=small-error><span id=contactTextAreaError ng-message=required>Message is required</span></div></div><div class=form-button_block><button class=\"btn colr primary\" type=submit>Send</button></div></form></section></div></div></div></div>");
$templateCache.put("app/controllers/dashboards/demoVideo.html","<!--\r\n  ~ Copyright (c) OCOGlobal 2018\r\n  --><sidebar></sidebar><div id=demoVideo><div id=demo-video><div id=mainWindow><section id=demo_video_content><iframe id=vimeoFrame src=\"https://player.vimeo.com/video/250645089?autoplay=1\" awidth=720 aheight=576 frameborder=0 webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></section></div></div></div>");
$templateCache.put("app/controllers/dashboards/myVelociti.html","<!--\r\n  ~ Copyright (c) OCOGlobal 2017\r\n  --><div id=my-velociti><div id=mainWindow><section><h1>My VELOCITI</h1><div class=row><article id=edit-profile><a ui-sref=userPreferences><div class=\"icon profile\"><img src=../../../assets/img/icons/profile.png srcset=\"../../../assets/img/icons/profile.png 1x, ../../../assets/img/icons/profile@2x.png 2x\"></div><div class=title>User<br>Preferences</div></a></article><article id=companies><a ui-sref=companies><div class=\"icon search\"><img src=../../../assets/img/icons/search.png srcset=\"../../../assets/img/icons/search.png 1x, ../../../assets/img/icons/search@2x.png 2x\"></div><div class=title>Company<br>Search</div></a></article><article id=my-lists><a ui-sref=myLists><div class=\"icon lists\"><img src=../../../assets/img/icons/my_velociti.png srcset=\"../../../assets/img/icons/my_velociti.png 1x, ../../../assets/img/icons/my_velociti@2x.png 2x\"></div><div class=title>My Velociti<br>Lists</div></a></article><article id=request-rating><a ui-sref=requestRating><div class=\"icon rating\"><img src=../../../assets/img/icons/request_rating.png srcset=\"../../../assets/img/icons/request_rating.png 1x, ../../../assets/img/icons/request_rating@2x.png 2x\"></div><div class=title>Request<br>Rating</div></a></article><article id=requested-profiles><a ui-sref=requestedProfiles><div class=\"icon exhibitor\"><img src=../../../assets/img/icons/company_profiles.png srcset=\"../../../assets/img/icons/company_profiles.png 1x, ../../../assets/img/icons/company_profiles@2x.png 2x\"></div><div class=title>View<br>Profiles</div></a></article><article id=exhibitor-analysis><a ui-sref=exhibitorAnalysis><div class=\"icon exhibitor\"><img src=../../../assets/img/icons/exhibitor.png srcset=\"../../../assets/img/icons/exhibitor.png 1x, ../../../assets/img/icons/exhibitor@2x.png 2x\"></div><div class=title>Exhibitor<br>Analysis</div></a></article></div><h3><span id=fullName ng-if=mvController.user.fullName>{{mvController.user.fullName}} : </span><span id=organisation ng-if=mvController.user.organisation.name>{{mvController.user.organisation.name}} : </span><span id=currentDate>{{mvController.currentDate | date: \'dd-MM-yyyy\'}}</span></h3></section></div><div class=background></div></div><script>$(document).ready(function(){\r\n    if( $(\'body\').find(\'#login\').length > 0 ){\r\n      $(\'body\').addClass(\'color-bck\');\r\n    }\r\n    else{\r\n       $(\'body\').removeClass(\'color-bck\');\r\n    }\r\n    });</script>");
$templateCache.put("app/controllers/dashboards/welcome.html","<!--\r\n  ~ Copyright (c) OCOGlobal 2017\r\n  --><div id=welcome><div id=mainWindow><section><div class=text-center><img src=../../../assets/img/velociti_brand.png alt=VELOCITI srcset=\"../../../assets/img/velociti_brand.png 1x, ../../../assets/img/velociti_brand@2x.png 2x\"><h1>Welcome to Velociti</h1><p>OCO’s business intelligence platform VELOCITI employs data-mining techniques and machine-learning algorithms to calculate ratings for companies that describe their propensity to invest and their readiness to trade/export. Velociti will help you accelerate your lead generation efforts by providing you with actionable insights.</p><p>To personalise your results and tailor the company information you will view, please use the next page to set up your preferences for FDI or Trade focus, source market and target sectors. This will allow VELOCITI to return the best results.</p><a id=letsGetStarted ui-sref=userPreferences class=\"btn colr primary xlg\">Let\'s get started</a></div></section></div><div class=background></div></div><script>$(document).ready(function(){\r\n    if( $(\'body\').find(\'#login\').length > 0 ){\r\n      $(\'body\').addClass(\'color-bck\');\r\n    }\r\n    else{\r\n       $(\'body\').removeClass(\'color-bck\');\r\n    }\r\n    });</script>");
$templateCache.put("app/controllers/exhibitor/exhibitorAnalysis.html","<!--\r\n  ~ Copyright (c) OCOGlobal 2017\r\n  --><style>.img-block{\r\n  display: flex;\r\n    overflow-x: auto;\r\n    scrollbar-color: #b7b7b7 #f5f5f5;\r\n  scrollbar-width: thin;\r\n  }\r\n  .img-block::-webkit-scrollbar-track{\r\n   -webkit-box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.3);\r\n  background-color: #f5f5f5;\r\n  }\r\n  .img-block::-webkit-scrollbar{\r\n  width: 5px;\r\n  background-color: #f5f5f5;\r\n  }\r\n  .img-block::-webkit-scrollbar-thumb\r\n {\r\n  background-color: #b7b7b7;\r\n  border: 1px solid #b7b7b7;\r\n}</style><sidebar></sidebar><div id=exhibitorAnalysis><div id=exhibitor-analysis class=ex-analysis><div id=mainWindow><single-message-summary alert=eaController.alert></single-message-summary><div class=exib-container><section id=exhibitor_content><article id=exhibitor_intro class=\"box-shadow sky-box\"><header><h1>Exhibitor Analysis</h1><div class=clearfix></div></header><section><p>Professional planning and execution is the critical success factor in uncovering and progressing investment opportunities at trade shows. This includes research and qualification of the companies, effective outreach, a solid meeting programme and timely follow up of leads.</p><p>Velociti’s exhibitor analysis service covers major trade shows worldwide and simplifies both the planning and follow-up stages to harness the power of trade shows.</p><p>Companies are filtered down to the top 100+ based on various growth factors, and then using our unique rating system, customized scores are provided based on your location. It helps to prioritize prospects so you can focus on getting more leads and more investments.</p></section></article><article id=exhibitor_how class=\"box-shadow sky-box\"><header><h2>Just 3 Easy Steps To Better Results!</h2></header><section><ol><li>Companies / attendees are scored on Velociti for their FDI and Trade potential using our unique Country Attractiveness model</li><li>A target list is developed using additional business intelligence and qualitative analysis on the companies</li><li>The list is then uploaded to Velociti where you can select companies scoring above B- as these are the most likely FDI or Trade prospects for your region</li></ol><p>For a customised exhibitor analysis list that is specific for your regional offer and includes a full report on company details, rationale on investment / reasons to target and contact person, please contact: <a href=mailto:support@ocoglobal.com>support@ocoglobal.com</a></p><button ui-sref=contact class=\"btn btn-dark-blue custom-btn\">Contact</button></section></article></section><aside id=keyshows><div class=trade_shows><header><h2>Trade Shows {{eaController.showingYear}}</h2></header><section id=keyshows_intro><p>The service can cover analysis on exhibitors at the following shows:</p></section><div class=\"keyshows__scroll custom-scroll\" style-bak=\"overflow-y: auto; overflow-x: hidden; height: 22em;\" scroll-to-top-when=exhibitions_loaded><section class=\"keyshow repeat-keyshow\" ng-repeat=\"exhibition in eaController.exhibitions | orderBy : \'startDate\'\"><div class=keyshow__thumb><a ui-sref=\"companies({exhibition: exhibition})\"><img ng-src={{exhibition.image}}></a></div><div class=keyshow__desc><h3><a ng-href={{exhibition.link}} target=_blank>{{exhibition.name}}</a></h3><p><strong>Location:</strong> {{exhibition.location}}<br><strong>Date:</strong> {{exhibition.dateRange}}<br><strong>Sectors:</strong> {{exhibition.sectors}}</p></div></section><div ng-if=\"eaController.exhibitions.length == 0\"><i><center>No Trade Show Is available</center></i></div></div><div id=loading-exhibitions ng-hide=eaController.exhibitionsLoaded><p>Loading Exhibitions...</p></div><div id=no-exhibitions ng-show=\"eaController.exhibitionsLoaded && !eaController.hasExhibitions()\"></div></div><section class=\"keyshow keyshow_past sky-box box-shadow calendar-sec custom-cal-grid\" ng-if=\"eaController.exhibitionYears && eaController.exhibitionYears.length>1\"><!--           <header><h2>Trade Shows</h2></header>--><div class=\"img-block calendar-list-container custom-scroll\"><div class=calendar-block ng-repeat=\"exhibitionYear in eaController.exhibitionYears\" ng-click=eaController.loadExhibitionsInYear(exhibitionYear) ng-if=\"eaController.showingYear!=exhibitionYear\"><svg xmlns=http://www.w3.org/2000/svg width=60 height=60 fill=currentColor class=\"bi bi-calendar-fill\" viewBox=\"0 0 16 16\"><path d=\"M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5h16V4H0V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5z\"/></svg> <span class=cal-year>{{exhibitionYear}}</span></div></div><!--          <div class=\"img-block\">--><!--           <img ng-repeat=\"exhibitionYear in eaController.exhibitionYears\" ng-click=\"eaController.loadExhibitionsInYear(exhibitionYear)\"--><!--                ng-src=\"../../../assets/img/icons/archive/archive-{{exhibitionYear}}.png\" style=\"padding: 5px\" ng-if=\"eaController.showingYear!=exhibitionYear\">--><!--          </div>--></section><!-- <div ng-include=\"url\"></div> --></aside></div></div></div></div>");
$templateCache.put("app/controllers/investmentSignals/investmentSignals.html","<style>section.filter.investment_signals_custom form .filter_item{\r\n      margin-bottom: 0;\r\n    }\r\n\r\n    section.filter.investment_signals_custom form .filter_item input[type=\"text\"] {\r\n      padding: 10px;\r\n      border-radius: 4px;\r\n      height: 2.5rem;\r\n      border: 1px solid #bdbaba;\r\n    }\r\n\r\n    section.filter.investment_signals_custom form .filter_item.drop-custom input[type=\"text\"]{\r\n      border: 1px solid #ddd;\r\n      background-color: #fff;\r\n      box-shadow: 1px 1px 1px 0px rgba(0 0 0 / 0.05);\r\n      -webkit-box-shadow: 1px 1px 1px 0px rgba(0 0 0 / 0.05);\r\n      -moz-box-shadow: 1px 1px 1px 0px rgba(0 0 0 / 0.05);\r\n    }\r\n    section.filter.investment_signals_custom form .filter_item.drop-custom ul{\r\n      scrollbar-width: thin;\r\n    }\r\n    section.filter.investment_signals_custom form .filter_item.drop-custom ul::-webkit-scrollbar-track{\r\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.15);\r\n    background-color: #F7F7F7;\r\n    }\r\n\r\n    section.filter.investment_signals_custom form .filter_item.drop-custom ul::-webkit-scrollbar{\r\n      width: 7px;\r\n      height: 7px;\r\n      background-color: #F7F7F7;\r\n    }\r\n\r\n    section.filter.investment_signals_custom form .filter_item.drop-custom ul::-webkit-scrollbar-thumb{\r\n      background-color: #bdbaba;\r\n      border: 2px solid #bdbaba;\r\n    }\r\n    .min-results-height{\r\n      position: relative;\r\n      min-height: 300px;\r\n    }\r\n\r\n     .investment_signals_custom .title_div button {\r\n    background-color: #0c2752 !important;\r\n    border: 1px solid #0c2752 !important;\r\n    color: #fff !important;}\r\n\r\n    .investment_signals_custom .inline-form{\r\n      display: flex;\r\n      flex-wrap: wrap;\r\n      margin-bottom: 1em;\r\n    }\r\n    .selected-filters {\r\n  margin-top: 15px;\r\n}\r\n\r\n.tag {\r\n  display: inline-block;\r\n  background: #e5f2ff;\r\n  border: 1px solid #b3d7ff;\r\n  color: #0056b3;\r\n  padding: 6px 10px;\r\n  margin: 4px;\r\n  border-radius: 20px;\r\n  font-size: 13px;\r\n}\r\n\r\n.tag .remove {\r\n  margin-left: 8px;\r\n  cursor: pointer;\r\n  color: #ff3333;\r\n  font-weight: bold;\r\n}</style><sidebar></sidebar><div id=company-search><div id=mainWindow class=invest-signal-search><section class=signals-list><section class=\"investment-signals filter investment_signals_custom\"><div class=title_div><div class=search-title><h1 class=cus-title-size>Company Investment Signal Search</h1></div><div class=search-title><button class=\"btn colr btn-dark-blue custom-btn\" ng-click=investmentSignalsController.downloadList()><!--              ng-disabled=\"$root.isLoading\"--> <span class=\"{{investmentSignalsController.status == \'Downloading\' ? \'processing\' : \'\' }}\">{{investmentSignalsController.status}}</span></button></div></div><div><h5>{{investmentSignalsController.totalResults}} {{investmentSignalsController.totalResults > 1 ? \'Signals\' :\'Signal\'}}</h5></div><div class=signal-input ng-model-options=\"{ allowInvalid: true, debounce: 500 }\"><form class=\"inline-form custom-form-style\"><div class=filter_item title={{investmentSignalsController.search.name}}><input id=name type=text class=form-control placeholder=Name autocomplete=off ng-model=investmentSignalsController.search.name></div><div class=filter_item title={{investmentSignalsController.hqSearch}}><input id=country class=single type=text placeholder=\"Source Market\" autocomplete=disabled ng-model=investmentSignalsController.hqSearch uib-typeahead=\"country as country for country in investmentSignalsController.countries | filter: $viewValue | limitTo: 12\"></div><div uib-dropdown class=\"filter_item drop-custom\" title={{investmentSignalsController.search.region}}><input id=region class=single uib-dropdown-toggle type=text placeholder=Region autocomplete=disabled ng-readonly=true ng-model=investmentSignalsController.search.region><ul class=dropdown-menu uib-dropdown-menu><li><a ng-click=\"investmentSignalsController.search.region = \'\'\">Any Region</a></li><li ng-repeat=\"region in investmentSignalsController.regions\"><a ng-click=\"investmentSignalsController.search.region = region.name\">{{ region.name }}</a></li></ul></div><div uib-dropdown class=\"filter_item drop-custom\"><input id=sectors class=single uib-dropdown-toggle type=text placeholder=Sectors ng-readonly=true ng-model=investmentSignalsController.search.sector><ul class=dropdown-menu uib-dropdown-menu><li><a ng-click=\"investmentSignalsController.search.sector = []\">Any Sector</a></li><li ng-repeat=\"sector in investmentSignalsController.sectors\"><a ng-click=investmentSignalsController.addSector(sector.name)>{{ sector.name }}</a></li></ul></div><div uib-dropdown class=\"filter_item drop-custom\"><input id=markets class=single uib-dropdown-toggle type=text placeholder=\"Target Markets\" ng-readonly=true ng-model=investmentSignalsController.search.targetMarket><ul class=dropdown-menu uib-dropdown-menu><li><a ng-click=\"investmentSignalsController.search.targetMarket = []\">Any Target Market</a></li><li ng-repeat=\"item in investmentSignalsController.countryRegionList\"><a ng-click=investmentSignalsController.addTargetMarket(item.name)>{{ item.name }}</a></li></ul></div><div uib-dropdown class=\"filter_item drop-custom\" title={{investmentSignalsController.dateRange}}><input type=text name=daterange class=cus-date-picker placeholder=\"Published Since\" ng-model=investmentSignalsController.dateRange></div></form><!-- Selected Filters Section --><div class=selected-filters ng-if=\"investmentSignalsController.search.name ||\r\n            investmentSignalsController.hqSearch ||\r\n            investmentSignalsController.search.region ||\r\n            investmentSignalsController.search.sector ||\r\n            investmentSignalsController.search.targetMarket ||\r\n            investmentSignalsController.dateRange\"><!-- Name --> <span class=tag ng-if=investmentSignalsController.search.name><strong>Name:</strong> {{ investmentSignalsController.search.name }} <span class=remove ng-click=\"investmentSignalsController.removeFilter(\'name\')\">×</span> </span><!-- Source Market / Country --> <span class=tag ng-if=investmentSignalsController.hqSearch><strong>Source Market:</strong> {{ investmentSignalsController.hqSearch }} <span class=remove ng-click=\"investmentSignalsController.removeFilter(\'country\')\">×</span> </span><!-- Region --> <span class=tag ng-if=investmentSignalsController.search.region><strong>Region:</strong> {{ investmentSignalsController.search.region }} <span class=remove ng-click=\"investmentSignalsController.removeFilter(\'region\')\">×</span> </span><!-- Sector Multi-tags --> <span class=tag ng-repeat=\"sector in investmentSignalsController.search.sector\"><strong>Sector:</strong> {{ sector }} <span class=remove ng-click=investmentSignalsController.removeSector(sector)>×</span> </span><!-- Target Market Multi-tags --> <span class=tag ng-repeat=\"tm in investmentSignalsController.search.targetMarket\"><strong>Target Market:</strong> {{ tm }} <span class=remove ng-click=investmentSignalsController.removeTargetMarket(tm)>×</span> </span><!-- Published Since / Date Range --> <span class=tag ng-if=investmentSignalsController.dateRange><strong>Published Since:</strong> {{ investmentSignalsController.dateRange }} <span class=remove ng-click=\"investmentSignalsController.removeFilter(\'dateRange\')\">×</span></span></div></div><article ng-if=\"investmentSignalsController.results !== null && investmentSignalsController.results.length < 1\" class=\"no_results min-results-height\"><h1 class=search-note>Sorry we couldn\'t find any matches</h1></article><article ng-if=\"investmentSignalsController.results !== null && investmentSignalsController.results.length > 0\" ng-repeat=\"result in investmentSignalsController.results\"><div class=\"cus-row comp-list box-shadow\"><div class=cus-col-md-4><div class=\"cus-panel cus-panel-default company-panel\"><div class=cus-panel-body><div class=\"comp-content comp-flex\"><!--<div class=\"comp-img\">\r\n                      <img class=\"logo comp-logo\" ng-if=\"result.logo != undefined && !result.logo.contains(\'data:image/\')\" src=\"data:image/png;base64, {{ result.logo }}\" />\r\n                      <img class=\"logo comp-logo\" ng-if=\"result.logo != undefined && result.logo.contains(\'data:image/\')\" src=\"{{ result.logo }}\"/>\r\n                      <img class=\"logo comp-logo\" ng-if=\"result.logo == undefined\"/>\r\n                    </div>--><div class=comp-img><img class=\"logo comp-logo\" ng-src=\"https://logo.debounce.com/{{result.company_name+\'.com\'}}\" onerror=\"this.src=\'../assets/img/DefaultCompanyIcon.png\'\"></div><div class=comp-details><h3>Company : <span><a class=company-name ng-click=investmentSignalsController.showCompanyDetails(result)>{{ result.company_name }}</a></span></h3><div class=\"comp-option comp-flex invest-sig-list\"><ul><li><strong>Source Market :</strong> {{ result.hq }}</li><li><strong>Sector :</strong> {{ result.sector.join(\', \') }}</li><li><strong>Target Markets :</strong> {{ result.target_markets_regions.join(\', \') }}</li><li><strong>Target Market Countries :</strong> {{ result.target_markets_countries.join(\', \') }}</li><li><strong>Type :</strong> {{ result.type.join(\', \') }}</li><li><strong>Published :</strong> {{ investmentSignalsController.formatPublishedAt(result.published_at) }}</li></ul></div><!--                      <button type=\"button\" class=\"btn colr primary custom-btn\"><a href=\"{{ result.press_release_url }}\"  target=\"_blank\">Press Release</a>--><!--                      </button>--></div><a class=p-release href=\"{{ result.press_release_url }}\" title=\"Press Release\" target=_blank><svg xmlns=http://www.w3.org/2000/svg width=16 height=16 fill=currentColor class=\"bi bi-megaphone-fill\" viewBox=\"0 0 16 16\"><path d=\"M13 2.5a1.5 1.5 0 0 1 3 0v11a1.5 1.5 0 0 1-3 0v-11zm-1 .724c-2.067.95-4.539 1.481-7 1.656v6.237a25.222 25.222 0 0 1 1.088.085c2.053.204 4.038.668 5.912 1.56V3.224zm-8 7.841V4.934c-.68.027-1.399.043-2.008.053A2.02 2.02 0 0 0 0 7v2c0 1.106.896 1.996 1.994 2.009a68.14 68.14 0 0 1 .496.008 64 64 0 0 1 1.51.048zm1.39 1.081c.285.021.569.047.85.078l.253 1.69a1 1 0 0 1-.983 1.187h-.548a1 1 0 0 1-.916-.599l-1.314-2.48a65.81 65.81 0 0 1 1.692.064c.327.017.65.037.966.06z\"/></svg></a></div></div></div></div><div class=cus-col-md-8><div class=\"cus-panel cus-panel-default company-panel investment-info\"><div class=cus-panel-body><div class=comp-content><h3>Investment Signal</h3><p class=txt-excerpt ng-init=\"result.showFull=false\"><span>{{ (result.text.length > 700 && !result.showFull) ? (result.text.substring(0,700) + \'...\') : result.text }} </span><a href=\"\" ng-if=\"result.text.length > 700\" ng-click=\"result.showFull = !result.showFull\" class=see-more-link>{{ result.showFull ? \'See less\' : \'See more\' }}</a></p><!--<p class=\"txt-excerpt\"\r\n                       ng-repeat=\"text in result.text.split(\'\\n\') track by $index\">\r\n                      <span ng-if=\"investmentSignalsController.testText != result.id\">{{text | limitTo: 500 }}</span>\r\n                      <span ng-if=\"investmentSignalsController.testText == result.id \">{{text}}</span>\r\n                      <span class=\"txt-blue\" ng-if=\"text.length >= 500 && investmentSignalsController.testText != result.id\" ng-click=\"investmentSignalsController.readMore(result.id)\"><b><i> ...read more</i></b></span>\r\n                      <span class=\"txt-blue\" ng-if=\"text.length >= 500 &&  investmentSignalsController.testText == result.id\" ng-click=\"investmentSignalsController.readLess(null)\"><b><i> ...read less</i></b></span>\r\n                    </p>--></div></div></div></div></div><!--<table>\r\n                      <tbody>\r\n                      <tr>\r\n                        <div class=\"company-logo\">\r\n                          <img class=\"logo\" ng-if=\"result.logo != undefined && !result.logo.contains(\'data:image/\')\" src=\"data:image/png;base64, {{ result.logo }}\" />\r\n                          <img class=\"logo\" ng-if=\"result.logo != undefined && result.logo.contains(\'data:image/\')\" src=\"{{ result.logo }}\"/>\r\n                          <img class=\"logo\" ng-if=\"result.logo == undefined\"/>\r\n                        </div>\r\n                        <div class=\"company-details\">\r\n                          <h3>Company <a class=\"company-name\" ng-click=\"investmentSignalsController.showCompanyDetails(result)\">{{ result.company_name }}</a></h3>\r\n                          <h3>HQ <strong>{{ result.hq }}</strong></h3>\r\n                          <h3>Sector <strong>{{ result.sector }}</strong></h3>\r\n                          <h3>Target Markets <strong>{{ result.target_markets.join(\', \') }}</strong></h3>\r\n                          <h3>Published <strong>{{ investmentSignalsController.formatPublishedAt(result.published_at) }}</strong></h3>\r\n                          <a href=\"{{ result.press_release_url }}\" class=\"pr-button\" target=\"_blank\">Press Release</a>\r\n                        </div>\r\n                        <div class=\"investment-signal\">\r\n                          <h3>Investment Signal</h3>\r\n                          <p ng-repeat=\"text in result.text.split(\'\\n\') track by $index\">{{text}}</p>\r\n                        </div>\r\n                      </tr>\r\n                      </tbody>\r\n                    </table>--></article><span class=companies-list style=\"color: #666665\"><div class=companies__pagesize style=\"margin-bottom: 2%\">Showing<div class=pagesize__dropdown><span>{{ investmentSignalsController.resultsPerPage }}</span><i class=\"fa fa-angle-down\"></i><div class=pagesize__dropdown-dropdown><a ng-click=\"investmentSignalsController.resultsPerPage = 10\">10</a> <a ng-click=\"investmentSignalsController.resultsPerPage = 20\">20</a> <a ng-click=\"investmentSignalsController.resultsPerPage = 40\">40</a></div></div>records per page</div><div class=companies__pagination><ul uib-pagination class=custom-pagination total-items=investmentSignalsController.totalResults boundary-links=true max-size=3 ng-model=investmentSignalsController.currentPage previous-text=&#xf104; next-text=&#xf105; last-text=&#xf101; first-text=&#xf100; items-per-page=investmentSignalsController.resultsPerPage></ul></div></span></section></section><company-details-modal company-details=investmentSignalsController.companyDetails></company-details-modal></div></div><style>.processing{\r\n     position: relative;\r\n     }\r\n  .processing::after{\r\n    content: \" .\";\r\n    position: absolute;\r\n    animation: processing 1s steps(5, end) infinite;\r\n  }\r\n@keyframes processing {\r\n  0%, 20% {\r\n    color: rgba(0,0,0,0);\r\n    text-shadow:\r\n      .25em 0 0 rgba(0,0,0,0),\r\n      .5em 0 0 rgba(0,0,0,0);}\r\n  40% {\r\n    color: white;\r\n    text-shadow:\r\n      .25em 0 0 rgba(0,0,0,0),\r\n      .5em 0 0 rgba(0,0,0,0);}\r\n  60% {\r\n    text-shadow:\r\n      .25em 0 0 white,\r\n      .5em 0 0 rgba(0,0,0,0);}\r\n  80%, 100% {\r\n    text-shadow:\r\n      .25em 0 0 white,\r\n      .5em 0 0 white;}\r\n  }\r\n  .sidebar-date-picker {\r\n    width: 96% !important;\r\n    height: 40px;\r\n    font-size: 14px;\r\n    padding-left: 10px;\r\n}</style>");
$templateCache.put("app/controllers/layout/layout.html","<!--\r\n  ~ Copyright (c) OCOGlobal 2017\r\n  --><header class=header><div class=header__logo><img src=../../../assets/img/velociti_logo.png srcset=\"../../../assets/img/velociti_logo.png 1x, ../../../assets/img/velociti_logo@2x.png 2x\" alt=VELOCITI> <span class=noInternetWarning ng-hide=online><i class=\"fa fa-exclamation-triangle\"></i>&nbsp;Warning no internet connection detected</span></div><nav class=header__user-controls><ul><li class=top-email><a ui-sref=userPreferences>{{controller.username}}</a></li><li class=top-icon><a id=security ui-sref=updatePassword><i class=\"fa fa-lock\" aria-hidden=true></i></a></li><li class=\"top-icon logout-dropdown\"><a id=logoutButton href=\"\"><i class=\"fa fa-sign-out\" aria-hidden=true></i></a><ul class=logout-menu><li><a href=\"\" ng-click=controller.userService.logout()><i class=\"fa fa-sign-out\" aria-hidden=true></i> Log out</a></li><li class=logout-all><a href=\"\" ng-click=controller.userService.logoutAllDevices()><i class=\"fa fa-desktop\" aria-hidden=true></i> Log out of all devices</a></li></ul></li></ul></nav></header><main role=main ng-class=\"{with_sidebar: controller.isShowingSidebar, with_white_background: controller.isWhiteBackground}\"><div ui-view class=content></div><!--\r\n  <div class=\"footer_blk\">\r\n    <div class=\"copyright\">\r\n      <p>&copy; {{controller.currentYear}} VELOCITI. All rights reserved.</p>\r\n    </div>\r\n    <nav class=\"social\">\r\n      <ul>\r\n        <li><a href=\"https://www.linkedin.com/company-beta/70206/\" target=\"_blank\"><i class=\"fa fa-linkedin\" aria-hidden=\"true\"></i></a></li>\r\n        <li><a href=\"https://twitter.com/OCO_VELOCITI\" target=\"_blank\"><i class=\"fa fa-twitter\" aria-hidden=\"true\"></i></a></li>\r\n        <li><a href=\"https://vimeo.com/user24637474\" target=\"_blank\"><i class=\"fa fa-vimeo-square\" aria-hidden=\"true\"></i></a></li>\r\n      </ul>\r\n    </nav>\r\n  </div>\r\n--></main><footer><div class=copyright><p>&copy; {{controller.currentYear}} VELOCITI. All rights reserved.</p></div><nav class=social><ul><li><a href=https://www.linkedin.com/company-beta/70206/ target=_blank><i class=\"fa fa-linkedin\" aria-hidden=true></i></a></li><li><a href=https://twitter.com/OCO_VELOCITI target=_blank><i class=\"fa fa-twitter\" aria-hidden=true></i></a></li><li><a href=https://vimeo.com/user24637474 target=_blank><i class=\"fa fa-vimeo-square\" aria-hidden=true></i></a></li></ul></nav></footer><!-- This shows the background image in the sidebar --><div ng-class=\"{background: controller.isShowingSidebar}\"></div>");
$templateCache.put("app/controllers/lists/myLists.html","<!--\r\n  ~ Copyright (c) OCOGlobal 2017\r\n  --><style></style><sidebar></sidebar><div id=my-velociti-lists><div id=mainWindow><div id=my_lists><header><single-message-summary alert=mylController.alert></single-message-summary><h1>My Velociti Lists</h1><div class=header__btn-block><button class=\"btn btn-dark-blue custom-btn\" ng-click=mylController.addList() ng-class=\"{loading: mylController.isAdding}\">Add New List</button> <button class=\"btn brdr primary custom-btn\" id=edit_list ng-click=mylController.toggleEditing(mylController.velocitiListSummaries) ng-class=\"{loading: mylController.isUpdating}\">{{mylController.rightButtonText}}</button></div><div class=header__sort>Order by<div class=header__dropdown><span>{{mylController.sortButtonText}}</span><i class=\"fa fa-angle-down\"></i><div class=header__dropdown-dropdown><a href=\"\" ng-click=mylController.getMyListsSummarySortedByMostRecent()>Recently Edited</a> <a href=\"\" ng-click=mylController.getMyListsSummarySortedByName()>Name</a></div></div></div><div class=clearfix></div></header><section class=lists><!-- Basic searching message for slow connections --><article class=lists__no-list ng-show=mylController.isSearching><p>Searching for your lists.....</p></article><!-- Lists view --><article ng-show=\"mylController.thereAreListsToDisplay && !mylController.isSearching\" class=\"list__item custom-list-item\" ng-class=\"{edit: mylController.isEditing}\" ng-repeat=\"velocitiListSummary in mylController.velocitiListSummaries\"><div class=\"list__item-inner box-shadow\" ng-class=\"{hoverHand: !mylController.isEditing}\" ng-click=mylController.goToList(velocitiListSummary)><div class=list__item-icon><i class=\"icon default_list\"><img ng-src={{velocitiListSummary.imageUrl}}></i></div><div class=list__item-title><textarea id={{velocitiListSummary.listId}} class=custom-scrollbar maxlength=100 scroll-to-top=!mylController.isEditing ng-disabled=!mylController.isEditing ng-model=velocitiListSummary.name ng-keydown=\"mylController.keyPressed($event, velocitiListSummary)\">\r\n              </textarea><div class=list__item-count>{{velocitiListSummary.numberOfCompaniesInList}} Companies</div></div><a ng-click=\"mylController.deleteList(velocitiListSummary.listId, velocitiListSummary.name)\" class=list__item-delete><i class=\"fa fa-times-circle\" aria-hidden=true></i></a></div></article><!-- No lists view --><article class=lists__no-list ng-hide=\"mylController.thereAreListsToDisplay || mylController.isSearching\"><h3>You don\'t have any lists yet...</h3><p>Let\'s get started shall we?</p><button ng-click=mylController.addList() class=\"btn btn-dark-blue custom-btn\">Add New List</button></article></section></div></div></div>");
$templateCache.put("app/controllers/lists/topTargetLists.html","<!--\r\n  ~ Copyright (c) OCOGlobal 2020\r\n  --><sidebar></sidebar><div id=top-target-lists><div id=mainWindow><header><div class=pull-right><section class=\"top-target-lists filter custom-top-target-list\"><form><div uib-dropdown class=filter_item><input name=top_target_list_select id=typeFilter class=single href uib-dropdown-toggle type=text ng-model=typeFilterLabel placeholder=\"Select List Type\" ng-readonly=true><ul class=dropdown-menu uib-dropdown-menu><li ng-repeat=\"option in typeFilterOptions\" ng-click=setTypeFilter(option)><a href=\"\">{{ option.label }}</a></li></ul></div></form></section></div><div class=pull-right><section class=\"top-target-lists filter custom-top-target-list\"><form><div uib-dropdown class=filter_item><input name=top_target_list_select id=yearFilter class=single href uib-dropdown-toggle type=text ng-model=yearFilterLabel placeholder=\"Select List By Year\" ng-readonly=true><ul class=dropdown-menu uib-dropdown-menu><li ng-repeat=\"year in yearFilterOptions\" ng-click=setYearFilter(year)><a href=\"\">{{ year.label }}</a></li></ul></div></form></section></div><h1>Top Target Lists</h1><div class=clearfix></div></header><div id=my_lists><section class=\"lists top-tgt-list\"><div ng-if=\"loadingTopTargetList == 1\" class=list-yearly-container><div class=list-yearly ng-repeat=\"lists in modifiedList | filter: yearFilter | filter: content.listFilter \"><div ng-if=\"lists.year  != null\" class=list-yearly-title><h4>{{lists.year}}</h4><hr></div><article ng-repeat=\"list in lists.content |filter: listFilter\" class=\"custom-list-item list__item\"><div class=list-year-item><div class=list__item-inner ng-click=\"goToList($event, list)\"><div class=list__item-icon style=\"background-image: url({{ list.image }})\"></div><div class=list__item-title><h3 style=\"text-transform: none\">{{ list.name }}</h3><div class=list__item-count>{{ list.totalCompanies | number }} Companies <span ng-if=list.previousYears.length>| </span><span ng-if=list.previousYears.length uib-dropdown><a uib-dropdown-toggle ng-click=$event.stopPropagation() style=\"color: #e7e8e9\">&blacktriangledown; Previous Years</a><ul class=dropdown-menu uib-dropdown-menu><li ng-repeat=\"year in list.previousYears\" ng-click=\"goToListAndYear($event, list, year)\"><a>{{year}}</a></li></ul></span></div></div></div></div></article><div class=clear></div></div><!--<article ng-repeat=\"list in lists | filter: listFilter| filter: yearFilter | orderBy:\'-currentYear\' \" ng-show=\"true\" class=\"list__item custom-list-item\">\r\n          <div ng-if=\"isSameYear(list.currentYear)\">\r\n              </br>\r\n                <h4>{{list.currentYear}}</h4>\r\n              <hr>\r\n          </div>\r\n          <div class=\"list__item-inner\" ng-click=\"goToList($event, list)\">\r\n            <div class=\"list__item-icon\" style=\"background-image: url({{ list.image }});\">\r\n&lt;!&ndash;              <i class=\"icon default_list\">&ndash;&gt;\r\n&lt;!&ndash;                <img ng-src=\"{{ list.image }}\">&ndash;&gt;\r\n&lt;!&ndash;              </i>&ndash;&gt;\r\n            </div>\r\n            <div class=\"list__item-title\">\r\n              <h3 style=\"text-transform: none\">{{ list.name }} ({{list.currentYear}})</h3>\r\n              <div class=\"list__item-count\">\r\n                {{ list.totalCompanies | number }} Companies\r\n                <span ng-if=\"list.previousYears.length\"> | </span>\r\n                <span ng-if=\"list.previousYears.length\" uib-dropdown>\r\n                  <a uib-dropdown-toggle ng-click=\"$event.stopPropagation()\" style=\"color: #e7e8e9\">&blacktriangledown; Previous Years</a>\r\n                  <ul class=\"dropdown-menu\" uib-dropdown-menu>\r\n                    <li ng-repeat=\"year in list.previousYears\" ng-click=\"goToListAndYear($event, list, year)\">\r\n                      <a>{{year}}</a>\r\n                    </li>\r\n                  </ul>\r\n                </span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </article--></div><!--        <div ng-if=\"loadingTopTargetList == -1\">\r\n                  <article ng-show=\"true\" class=\"list__item custom-list-item\">\r\n                    <center><h2>Loading ...</h2></center>\r\n                    <div class=\"spinner-box\">\r\n                      <div class=\"pulse-container\">\r\n                        <div class=\"pulse-bubble pulse-bubble-1\"></div>\r\n                        <div class=\"pulse-bubble pulse-bubble-2\"></div>\r\n                        <div class=\"pulse-bubble pulse-bubble-3\"></div>\r\n                      </div>\r\n                    </div>\r\n                  </article>\r\n                </div>\r\n                <div ng-if=\"loadingTopTargetList == 0\">--><div class=flex-100 ng-if=\"loadingTopTargetList == -1\"><article ng-show=true class=\"list__item custom-list-item loading-container\"><h2>Loading</h2><div class=spinner-box><div class=pulse-container><div class=\"pulse-bubble pulse-bubble-1\"></div><div class=\"pulse-bubble pulse-bubble-2\"></div><div class=\"pulse-bubble pulse-bubble-3\"></div></div></div></article></div><div class=flex-100 ng-if=\"loadingTopTargetList == 0\"><article ng-show=true class=\"list__item custom-list-item loading-container\"><h2>No Item Found</h2><svg xmlns=http://www.w3.org/2000/svg width=45 height=45 fill=#01738f class=\"bi bi-file-earmark-excel\" viewBox=\"0 0 16 16\"><path d=\"M5.884 6.68a.5.5 0 1 0-.768.64L7.349 10l-2.233 2.68a.5.5 0 0 0 .768.64L8 10.781l2.116 2.54a.5.5 0 0 0 .768-.641L8.651 10l2.233-2.68a.5.5 0 0 0-.768-.64L8 9.219l-2.116-2.54z\"/><path d=\"M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z\"/></svg></article></div></section></div></div></div>");
$templateCache.put("app/controllers/lists/velocitiList.html","<!--\r\n  ~ Copyright (c) OCOGlobal 2017\r\n  --><sidebar></sidebar><div id=my_list><div id=mainWindow><single-message-summary alert=vlController.alert></single-message-summary><velociti-list-title alert=vlController.alert is-on-list=true list-name={{vlController.listName}} list-id={{vlController.listId}}></velociti-list-title><div class=tab-content><header><company-list-results-totals search-results=vlController.searchCountResults></company-list-results-totals></header><div role=tabpanel class=\"tab-pane slide in active\" id=list><!-- list tab pane --><trade-destination user-location-id=vlController.userLocationId ng-show=vlController.isTradeFocused></trade-destination><company-list ng-show=\"vlController.hasSearchResults || $root.isLoading\" search-results=vlController.searchResults alert=vlController.alert action-button=REMOVE_FROM_LIST list-id={{vlController.listId}} is-trade-focused=vlController.isTradeFocused></company-list><company-list-paging ng-show=\"vlController.hasSearchResults || $root.isLoading\" search-results=vlController.searchCountResults></company-list-paging><!-- Empty list view --><section class=lists ng-show=vlController.noCompaniesInList><article class=lists__no-list ng-hide=mylController.thereAreListsToDisplay><h3>Your list is empty...</h3><p>Let\'s get started shall we?</p><button ng-click=vlController.goToAddCompanies() class=\"btn colr primary\">Add Companies</button></article></section></div></div></div></div>");
$templateCache.put("app/controllers/lists/velocitiListSearchCompanies.html","<!--\r\n  ~ Copyright (c) OCOGlobal 2017\r\n  --><sidebar></sidebar><div id=my_list class=category-menu><div id=mainWindow><single-message-summary alert=vlController.alert></single-message-summary><velociti-list-title is-on-list=false list-name={{vlscController.listName}} list-id={{vlscController.listId}}></velociti-list-title><div class=tab-content><header class=velocititabheader><company-list-results-totals search-results=vlscController.searchCountResults></company-list-results-totals></header><div role=tabpanel class=\"tab-pane slide in active\" id=list><!-- list tab pane --><div class=\"custom-block custom-block2\"><div class=col-30 ng-class=\"{\'trigger\' : compController.isCompanySearchShow}\"><!--            <ul class=\"main-tab\">--><!--              <li class=\"main-tab mt2\">Company</li>--><!--            </ul>--><div class=badge-container><company-list-filter-badges template=company></company-list-filter-badges></div><company-list-filters></company-list-filters></div><div class=col-70 ng-class=\"{\'trigger\' : compController.isCompanySearchShow}\"><!--            <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"50\" height=\"50\" fill=\"#fff\" ng-show=\"compController.isCompanySearchShow\" ng-click=\"compController.isCompanySearchShow = false;\" class=\"bi bi-filter-left clck2\" viewBox=\"0 0 16 16\">--><!--              <path d=\"M2 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z\"/>--><!--            </svg>--><!--            <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"50\" height=\"50\" fill=\"#fff\" ng-show=\"!compController.isCompanySearchShow\" ng-click=\"compController.isCompanySearchShow = true;\" class=\"bi bi-filter-right clck1\" viewBox=\"0 0 16 16\">--><!--              <path d=\"M14 10.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5zm0-3a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0 0 1h7a.5.5 0 0 0 .5-.5zm0-3a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0 0 1h11a.5.5 0 0 0 .5-.5z\"/>--><!--            </svg>--><div class=close-search-filter><svg xmlns=http://www.w3.org/2000/svg width=25 height=25 fill=#fff class=\"bi bi-filter-left clck1\" ng-show=!compController.isCompanySearchShow ng-click=\"compController.isCompanySearchShow = true;\" viewBox=\"0 0 16 16\"><path fill-rule=evenodd d=\"M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z\"/></svg></div><svg xmlns=http://www.w3.org/2000/svg width=38 height=38 fill=#fff class=\"bi bi-funnel-fill bi-filter-right clck2\" viewBox=\"0 0 16 16\" ng-show=compController.isCompanySearchShow ng-click=\"compController.isCompanySearchShow = false;\"><path d=\"M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z\"/></svg><!--<i ng-show=\"compController.isCompanySearchShow\" ng-click=\"compController.isCompanySearchShow = false;\" class=\"fa fa-filter clck1\" aria-hidden=\"true\" title=\"To build a target list please add search options\"></i>\r\n            <i ng-show=\"!compController.isCompanySearchShow\" ng-click=\"compController.isCompanySearchShow = true;\"  class=\"fa fa-filter clck2\" aria-hidden=\"true\" title=\"To build a target list please add search options\"></i>--><div class=\"data-table my-list-data\" ng-class=\"{\'blank-left\' : !compController.isCompanySearchShow}\"><company-list search-results=vlscController.searchResults action-button=ADD_TO_LIST alert=vlscController.alert list-id={{vlscController.listId}} is-trade-focused=vlscController.isTradeFocused></company-list><company-list-paging search-results=vlscController.searchCountResults></company-list-paging></div></div></div><trade-destination user-location-id=vlscController.userLocationId ng-show=vlscController.isTradeFocused></trade-destination></div></div></div></div>");
$templateCache.put("app/controllers/requests/requestRating.html","<!--\r\n  ~ Copyright (c) OCOGlobal 2017\r\n  --><sidebar></sidebar><div id=request-rating><div id=requestRating><div id=mainWindow><single-message-summary alert=requestRatingController.alert></single-message-summary><section><div id=ratingForm><div class=ratingForm_inner><header><h1>Request Company Rating</h1><div class=clearfix></div></header><form name=requestRatingForm ng-submit=\"requestRatingForm.$valid && requestRatingController.submitForm()\" novalidate><section class=req-comp><div class=description><p>To allow us to provide a rating for your company, please provide us with the company name, country and website.</p><p>You will be notified once your company has been rated.</p></div><div id=company-section class=form-group ng-class=\"{\'has-error\': requestRatingForm.$submitted && requestRatingController.hasNoCompanyName(), \'loading\': requestRatingController.isGetttingCompanyName}\"><label class=control-label for=company>Company Name</label><input name=company id=company class=location type=text ng-model=requestRatingController.company.name placeholder=\"Enter 3 or more letters\" uib-typeahead=\"result.text for result in requestRatingController.search($viewValue)\" typeahead-min-length=3 typeahead-wait-ms=500 autocomplete=off typeahead-on-select=requestRatingController.onSelect(requestRatingController.company.name) required> <small id=no-company-error class=small-error ng-show=\"requestRatingForm.$submitted && requestRatingController.hasNoCompanyName()\">A company name must be entered</small></div><div id=location-section class=form-group ng-class=\"{\'has-error\': requestRatingForm.$submitted && requestRatingController.hasNoLocation()}\"><label class=control-label for=location>Location</label><input name=location id=location class=location type=text ng-model=requestRatingController.address placeholder=\"Please Enter Location\" ng-blur=requestRatingController.populateLocation() uib-typeahead=\"country as country.name for country in requestRatingController.countries | filter: $viewValue | limitTo:12\" autocomplete=off required> <small id=no-location-error class=small-error ng-show=\"requestRatingForm.$submitted && requestRatingForm.location.$error && requestRatingController.hasNoLocation()\">A location must be set</small></div><div id=website-section class=form-group ng-class=\"{\'has-error\': requestRatingForm.$submitted && requestRatingController.hasNoWebsite()}\"><label class=control-label for=website>Website</label><input name=website id=website class=location type=text ng-model=requestRatingController.company.website placeholder=\"Please Enter Website\" autocomplete=off required> <small id=no-website-error class=small-error ng-show=\"requestRatingForm.$submitted && requestRatingController.hasNoWebsite()\">A website must be entered</small></div><div class=form-button_block><button class=\"btn btn-dark-blue custom-btn l-btn\" ng-class=\"{\'loading\': requestRatingController.isCallingServer}\" type=submit ng-disabled=\"requestRatingController.isCallingServer || requestRatingForm.$invalid\">Request</button></div></section></form></div></div><div id=sideSection class=comp-rate-side><h3>Company Rating</h3><img src=assets/img/company_rating_sample.png alt=\"Sample company rating\"></div></section></div></div></div>");
$templateCache.put("app/controllers/requests/requestedProfiles.html","<!--\r\n  ~ Copyright (c) OCOGlobal 2017\r\n  --><sidebar></sidebar><div id=requested_profiles><div id=mainWindow><single-message-summary alert=rpController.alert></single-message-summary><header><h1>Requested Profiles</h1><div class=clearfix></div></header><section class=\"profiles-list custom-profile-list\"><div ng-show=$root.isLoading class=profiles-list__loader><div class=inner><div class=spinner></div></div></div><table class=view-Profile-table ng-show=\"rpController.companyProfiles.companies.length > 0 || $root.isLoading\"><thead><tr><th ng-class=\"{active: rpController.sortByColumn === rpController.nameColumn}\" ng-click=rpController.changeSortByColumn(rpController.nameColumn)>Company <span class=company-sort ng-bind-html=rpController.getSortIcon(rpController.nameColumn)></span></th><th ng-class=\"{active: rpController.sortByColumn === rpController.countryColumn}\" ng-click=rpController.changeSortByColumn(rpController.countryColumn)>Country <span class=company-sort ng-bind-html=rpController.getSortIcon(rpController.countryColumn)></span></th><th ng-class=\"{active: rpController.sortByColumn === rpController.sectorColumn}\" ng-click=rpController.changeSortByColumn(rpController.sectorColumn)>Sector <span class=company-sort ng-bind-html=rpController.getSortIcon(rpController.sectorColumn)></span></th><th ng-class=\"{active: rpController.sortByColumn === rpController.requestedColumn}\" ng-click=rpController.changeSortByColumn(rpController.requestedColumn)>Date Created <span class=company-sort ng-bind-html=rpController.getSortIcon(rpController.requestedColumn)></span></th><th ng-class=\"{active: rpController.sortByColumn === rpController.isCompleteColumn}\" ng-click=rpController.changeSortByColumn(rpController.isCompleteColumn)>Status <span class=company-sort ng-bind-html=rpController.getSortIcon(rpController.isCompleteColumn)></span></th></tr></thead><tbody><tr ng-repeat=\"companyProfile in rpController.companyProfiles.companies\"><td>{{companyProfile.name}}</td><td>{{companyProfile.country}}</td><td>{{companyProfile.catSector}}</td><td>{{companyProfile.dateRequested | date:\'dd-MM-yyyy\'}}</td><td class=no-action ng-if=companyProfile.isComplete><a href=\"\" class=\"btn btn-dark-blue custom-btn hover-wh-txt\" target=_blank ng-href={{companyProfile.pdfUrl}}>View profile</a></td><td class=no-action ng-if=!companyProfile.isComplete><a href=\"\" class=\"btn btn-dark-blue custom-btn hover-wh-txt\">Pending</a></td></tr></tbody></table><section class=lists ng-show=\"!rpController.hasSearchResults() && !$root.isLoading\"><article class=lists__no-list><h3>You don\'t have any profiles yet...</h3><p>You can request a profile on a company\'s details page.</p><button ui-sref=companies class=\"btn btn-dark-blue custom-btn\">Search Companies</button></article></section><company-profile-list-paging ng-show=\"rpController.hasSearchResults() || $root.isLoading\" search-results=rpController.companyProfiles></company-profile-list-paging></section></div></div><company-details-modal company-details=rpController.companyDetails></company-details-modal>");
$templateCache.put("app/controllers/login/forgotPassword.html","<!--\r\n  ~ Copyright (c) OCOGlobal 2017\r\n  --><div id=forgotPassword><main role=main><div id=mainWindow><section><img src=../../../assets/img/velociti_brand.png alt=VELOCITI srcset=\"../../../assets/img/velociti_brand.png 1x, ../../../assets/img/velociti_brand@2x.png 2x\"> <img src=../../../assets/img/velociti_logo_xl.png alt=VELOCITI srcset=\"../../../assets/img/velociti_logo_xl.png 1x, ../../../assets/img/velociti_logo_xl@2x.png 2x\"><form name=forgotPasswordForm ng-submit=forgotPasswordController.submitPasswordReset() novalidate><single-message-summary alert=forgotPasswordController.alert></single-message-summary><div class=form-group ng-class=\"{ \'has-error\' : inputInvalid(forgotPasswordForm.emailAddress) }\"><input name=emailAddress type=text class=\"form-control center-block\" placeholder=\"Email / Username\" ng-model=forgotPasswordController.emailAddress required></div><button id=forgotPasswordButton type=submit class=\"btn colr primary lg\" ng-disabled=forgotPasswordForm.$invalid>Reset Password</button></form><h2>Company analytics<br>from another dimension.</h2></section></div><div class=background></div></main></div><footer><div class=copyright><p>&copy; 2017 VELOCITI. All rights reserved.</p></div><nav class=social><ul><!--<li><a href=\"#\"><i class=\"fa fa-linkedin\" aria-hidden=\"true\"></i></a></li>\r\n      <li><a href=\"#\"><i class=\"fa fa-twitter\" aria-hidden=\"true\"></i></a></li>\r\n      &lt;!&ndash;<li><a href=\"#\"><i class=\"fa fa-vimeo\" aria-hidden=\"true\"></i></a></li>&ndash;&gt;\r\n      <li><a href=\"#\"><i class=\"fa fa-vimeo-square\" aria-hidden=\"true\"></i></a></li>\r\n--><li><a href=https://www.linkedin.com/company-beta/70206/ target=_blank><i class=\"fa fa-linkedin\" aria-hidden=true></i></a></li><li><a href=https://twitter.com/OCO_VELOCITI target=_blank><i class=\"fa fa-twitter\" aria-hidden=true></i></a></li><li><a href=https://vimeo.com/user24637474 target=_blank><i class=\"fa fa-vimeo-square\" aria-hidden=true></i></a></li></ul></nav></footer>");
$templateCache.put("app/controllers/login/login.html","<!--\r\n  ~ Copyright (c) OCOGlobal 2017\r\n  --><div id=login><main role=main><div id=mainWindow><single-message-summary alert=loginController.alert ng-if=loginController.otpModal></single-message-summary><section ng-hide=loginController.otpModal><img src=../../../assets/img/velociti_brand.png alt=VELOCITI srcset=\"../../../assets/img/velociti_brand.png 1x, ../../../assets/img/velociti_brand@2x.png 2x\"> <img src=../../../assets/img/velociti_logo_xl.png alt=VELOCITI srcset=\"../../../assets/img/velociti_logo_xl.png 1x, ../../../assets/img/velociti_logo_xl@2x.png 2x\"><form name=loginForm ng-submit=loginController.login() novalidate><single-message-summary alert=loginController.alert></single-message-summary><div class=form-group><input name=username type=text class=\"form-control center-block\" placeholder=Username ng-model=loginController.username required></div><div class=form-group><input name=password type=password class=\"form-control center-block\" placeholder=Password ng-model=loginController.password required></div><button id=loginButton type=submit class=\"btn btn-dark-blue btn-l\" ng-disabled=\"loginForm.$invalid || loginController.isCallingServer\">Log In</button></form><a id=forgottenPassword ui-sref=forgotPassword class=a-light>Forgotten Password?</a><h2>Company analytics<br>from another dimension.</h2></section><div class=otp-wrapper ng-if=loginController.otpModal><div class=city-glow></div><div class=otp-card><div class=card-badge><span class=dot-pulse></span> Secure Verification</div><div class=card-title>OTP Verification</div><div class=card-subtitle>We sent a one-time password to your registered email</div><div class=otp-input-row><input autocomplete=one-time-code ng-repeat=\"(i, digit) in loginController.digits track by $index\" class=otp-digit ng-class=\"{ filled: digit.value }\" maxlength=1 type=text inputmode=numeric ng-model=digit.value ng-change=loginController.onDigitChange($index) ng-keydown=\"loginController.onKeyDown($event, $index)\" id=\"otp-input-{{ $index }}\"></div><div class=progress-bar-wrap><div class=progress-bar-fill ng-class=\"{ urgent: loginController.isUrgent }\" ng-style=\"{ width: loginController.progressWidth + \'%\' }\"></div></div><div class=timer-row><div class=timer-label>Resend code in</div><div style=\"display:flex; align-items:center; gap:10px\"><span class=timer-count ng-class=\"{ urgent: isUrgent }\">{{ loginController.timeDisplay }}</span> <button class=resend-btn ng-disabled=!loginController.canResend ng-click=loginController.resetTimer()>Resend OTP</button></div></div><div class=trust-device-wrapper><input type=checkbox id=trustDevice ng-model=loginController.verifyOtpForm.trustDevice class=trust-device><label for=trustDevice>Trust this device</label></div><button class=verify-btn ng-class=\"{ success: loginController.verified }\" ng-disabled=\"loginController.verifying || loginController.verified\" ng-click=loginController.handleVerify()>{{ loginController.verifyLabel }}</button><div class=divider></div><div class=secure-note><svg width=12 height=12 viewBox=\"0 0 16 16\" fill=none><rect x=3 y=7 width=10 height=7 rx=2 stroke=#a0acb8 stroke-width=1.2 /><path d=\"M5.5 7V5a2.5 2.5 0 015 0v2\" stroke=#a0acb8 stroke-width=1.2 stroke-linecap=round /></svg> Your code is encrypted and expires in 10 minutes</div></div></div></div></main><div class=background></div></div><footer><div class=copyright><p>&copy; 2017 VELOCITI. All rights reserved.</p></div><nav class=social><ul><!--<li><a href=\"#\"><i class=\"fa fa-linkedin\" aria-hidden=\"true\"></i></a></li>\r\n      <li><a href=\"#\"><i class=\"fa fa-twitter\" aria-hidden=\"true\"></i></a></li>\r\n      &lt;!&ndash;<li><a href=\"#\"><i class=\"fa fa-vimeo\" aria-hidden=\"true\"></i></a></li>&ndash;&gt;\r\n      <li><a href=\"#\"><i class=\"fa fa-vimeo-square\" aria-hidden=\"true\"></i></a></li>\r\n--><li><a href=https://www.linkedin.com/company-beta/70206/ target=_blank><i class=\"fa fa-linkedin\" aria-hidden=true></i></a></li><li><a href=https://twitter.com/OCO_VELOCITI target=_blank><i class=\"fa fa-twitter\" aria-hidden=true></i></a></li><li><a href=https://vimeo.com/user24637474 target=_blank><i class=\"fa fa-vimeo-square\" aria-hidden=true></i></a></li></ul></nav></footer><script>$(document).ready(function(){\r\n    if( $(\'body\').find(\'#login\').length > 0 ){\r\n      $(\'body\').addClass(\'color-bck\');\r\n    }\r\n    else{\r\n       $(\'body\').removeClass(\'color-bck\');\r\n    }\r\n    });</script>");
$templateCache.put("app/controllers/notFound/notFound.html","<!--\r\n  ~ Copyright (c) OCOGlobal 2017\r\n  --><div id=fourohfour><div id=mainWindow><section><img src=./img/icons/satellite.png alt=\"404 Page Not Found\" srcset=\"assets/img/icons/satellite.png 1x, assets/img/icons/satellite@2x.png 2x\"><h1>Oops! Page not found</h1><p>Looks like you have reached another dimension.</p><div class=\"label label__blue\">You can go back to <a href=# id=backButton>where you were</a><br>or head straight to <a ui-sref=myVelociti id=myVelocitiLink>My Velociti</a></div><p>Error code: 404</p></section></div></div>");
$templateCache.put("app/controllers/resetPassword/resetPassword.html","<!--\r\n  ~ Copyright (c) OCOGlobal 2017\r\n  --><div id=resetPassword><main role=main><div id=mainWindow><section><img src=assets/img/velociti_brand.png alt=VELOCITI srcset=\"assets/img/velociti_brand.png 1x, assets/img/velociti_brand@2x.png 2x\"> <img src=assets/img/velociti_logo_xl.png alt=VELOCITI srcset=\"assets/img/velociti_logo_xl.png 1x, assets/img/velociti_logo_xl@2x.png 2x\"><form name=resetPasswordForm ng-submit=\"resetPasswordForm.$valid && resetPasswordController.resetPassword()\" novalidate><single-message-summary alert=resetPasswordController.alert></single-message-summary><!-- New Password --><div class=form-group ng-class=\"{ \'has-error\' : resetPasswordForm.$submitted && resetPasswordForm.newPassword.$invalid }\"><input name=newPassword type=password class=\"form-control center-block\" placeholder=\"New Password\" ng-model=resetPasswordController.newPassword minlength=8 required><div ng-messages=\"resetPasswordForm.$submitted && resetPasswordForm.newPassword.$error\" class=small-error><span ng-message=required>New password is required</span></div></div><!-- Confirm New Password --><div class=form-group ng-class=\"{ \'has-error\' : resetPasswordForm.$submitted && resetPasswordForm.confirmPassword.$invalid }\"><input name=confirmPassword type=password class=\"form-control center-block\" placeholder=\"Confirm Password\" ng-model=resetPasswordController.confirmPassword value-match=resetPasswordController.newPassword minlength=8 required><div ng-messages=\"resetPasswordForm.$submitted && resetPasswordForm.confirmPassword.$error\" class=small-error><span ng-message=required>Confirm password is required</span> <span ng-message=match>Passwords do not match</span></div></div><button id=resetPasswordButton type=submit class=\"btn colr primary lg\" ng-disabled=\"resetPasswordController.isCallingServer || !resetPasswordController.passwordsValid()\">Reset Password</button></form><h2>Company analytics<br>from another dimension.</h2></section></div><div class=background></div></main></div><footer><div class=copyright><p>&copy; 2017 VELOCITI. All rights reserved.</p></div><nav class=social><ul><li><a href=#><i class=\"fa fa-linkedin\" aria-hidden=true></i></a></li><li><a href=#><i class=\"fa fa-twitter\" aria-hidden=true></i></a></li><li><a href=#><i class=\"fa fa-vimeo-square\" aria-hidden=true></i></a></li><li><a href=https://www.linkedin.com/company-beta/70206/ target=_blank><i class=\"fa fa-linkedin\" aria-hidden=true></i></a></li><li><a href=https://twitter.com/OCO_VELOCITI target=_blank><i class=\"fa fa-twitter\" aria-hidden=true></i></a></li><li><a href=https://vimeo.com/user24637474 target=_blank><i class=\"fa fa-vimeo-square\" aria-hidden=true></i></a></li></ul></nav></footer>");
$templateCache.put("app/controllers/user/updatePassword.html","<!--\r\n  ~ Copyright (c) OCOGlobal 2017\r\n  --><sidebar></sidebar><div id=update-password><div id=mainWindow><single-message-summary alert=updatePasswordController.alert></single-message-summary><header><h1>Update Password</h1><div class=header__btn-block><button class=\"btn btn-dark-blue custom-btn cst-w\" type=submit ng-disabled=updatePasswordController.isCallingServer form=updatePassword>Save</button> <button class=\"close-button custom-btn\" ng-click=updatePasswordController.goToMyVelociti() ng-disabled=updatePasswordController.isCallingServer>Cancel</button></div><div class=clearfix></div></header><section><form name=updatePasswordForm id=updatePassword ng-submit=\"updatePasswordForm.$valid && updatePasswordController.updatePassword()\" novalidate><!-- Old Password --><div id=old-password-group class=form-group ng-class=\"{\'has-error\': updatePasswordForm.$submitted && updatePasswordForm.oldPassword.$invalid}\"><label for=old-password>Old Password</label><input name=oldPassword class=br-4 type=password id=old-password ng-model=updatePasswordController.oldPassword required><div ng-messages=\"updatePasswordForm.$submitted && updatePasswordForm.oldPassword.$error\" class=small-error><span id=old-password-required-error ng-message=required>Old password is required</span></div></div><!-- New Password --><div class=form-group id=new-password-group ng-class=\"{\'has-error\': updatePasswordForm.$submitted && updatePasswordForm.newPassword.$invalid}\"><label for=new-password>New Password</label><input name=newPassword type=password class=br-4 id=new-password ng-model=updatePasswordController.newPassword required><div ng-messages=\"updatePasswordForm.$submitted && updatePasswordForm.newPassword.$error\" class=small-error><span id=new-password-required-error ng-message=required>New password is required</span></div></div><!-- Confirm new password --><div class=form-group id=confirm-password-group ng-class=\"{\'has-error\': updatePasswordForm.$submitted && updatePasswordForm.confirmNewPassword.$invalid}\"><label for=confirm-password>Confirm New Password</label><input name=confirmNewPassword type=password class=br-4 id=confirm-password ng-model=updatePasswordController.newPasswordConfirm value-match=updatePasswordController.newPassword required><div ng-messages=\"updatePasswordForm.$submitted && updatePasswordForm.confirmNewPassword.$error\" class=small-error><span id=confirm-password-required-error ng-message=required>Confirm new password is required</span> <span id=confirm-password-match-error ng-message=match>New passwords do not match</span></div></div></form></section></div></div>");
$templateCache.put("app/controllers/user/userPreferences.html","<!--\r\n  ~ Copyright (c) OCOGlobal 2017\r\n  --><sidebar></sidebar><div id=settings><div id=mainWindow><single-message-summary alert=userPreferencesController.alert></single-message-summary><header><h1>User Preferences</h1><div class=header__btn-block><button class=\"btn custom-btn btn-dark-blue\" ng-click=userPreferencesController.submit(userPreferencesForm) ng-disabled=userPreferencesController.isCallingServer type=submit>Save</button> <button class=\"btn brdr custom-btn\" ng-disabled=userPreferencesController.isCallingServer ng-click=userPreferencesController.cancel()>Cancel</button></div><div class=clearfix></div></header><section class=focus_settings><form name=userPreferencesForm class=user-pref-custom><!--                <div class=\"form-group\" style=\"display: none;\">--><!--                    <label>Focus</label>--><!--                    <div class=\"btn-group\" data-toggle=\"buttons\" ng-model=\"userPreferencesController.focus\">--><!--                        <div class=\"btn-holder\">--><!--                            <input type=\"radio\" id=\"trade\" name=\"focus\" value=\"Trade\" autofocus=\"true\" ng-model=\"userPreferencesController.focus\"/>--><!--                            <label id=\"trade-label\" for=\"trade\" class=\"btn\">Trade</label>--><!--                        </div>--><!--                        <div class=\"btn-holder\">--><!--                            <input type=\"radio\" id=\"fdi\" name=\"focus\" value=\"FDI\" ng-model=\"userPreferencesController.focus\"/>--><!--                            <label id=\"fdi-label\" for=\"fdi\" class=\"btn\">FDI</label>--><!--                        </div>--><!--                    </div>--><!--                </div>--><div id=location-section class=form-group ng-class=\"{\'has-error\': userPreferencesForm.$submitted && userPreferencesController.hasNoLocation()}\"><label for=location>Location</label><input name=location id=location class=location type=text ng-model=userPreferencesController.location placeholder=\"Please Enter Location\" ng-blur=userPreferencesController.checkValidLocationSet() uib-typeahead=\"country as country.name for country in userPreferencesController.countries | filter: $viewValue | limitTo:12\" autocomplete=off> <small id=no-location-error class=small-error ng-show=\"userPreferencesForm.$submitted && userPreferencesController.hasNoLocation()\">A location must be set</small></div><div class=\"form-group has-error sector-icons\"><label class=top-align>Sectors</label><div class=icon-group data-toggle=buttons><input id=agriculture type=checkbox name=sector[] autocomplete=off ng-click=userPreferencesController.toggleSectorSelection(24) ng-checked=userPreferencesController.isSectorSelected(24)><label id=agriculture-label for=agriculture class=icon><img src=../../../assets/img/icons/sectors/agriculture.png> <span>Agriculture</span></label><input id=aerospace type=checkbox name=sector[] autocomplete=off ng-click=userPreferencesController.toggleSectorSelection(2) ng-checked=userPreferencesController.isSectorSelected(2)><label id=aerospace-label for=aerospace class=icon><img src=../../../assets/img/icons/sectors/aero.png> <span>Aerospace<br>& Defense</span></label><input id=automotive type=checkbox name=sector[] autocomplete=off ng-click=userPreferencesController.toggleSectorSelection(25) ng-checked=userPreferencesController.isSectorSelected(25)><label id=automotive-label for=automotive class=icon><img src=../../../assets/img/icons/sectors/automotive.png> <span>Automotive</span></label><input id=business type=checkbox name=sector[] autocomplete=off ng-click=userPreferencesController.toggleSectorSelection(4) ng-checked=userPreferencesController.isSectorSelected(4)><label id=business-label for=business class=icon><img src=../../../assets/img/icons/sectors/business.png> <span>Business &amp;<br>Professional Services</span></label><input id=chemicals type=checkbox name=sector[] autocomplete=off ng-click=userPreferencesController.toggleSectorSelection(5) ng-checked=userPreferencesController.isSectorSelected(5)><label id=chemicals-label for=chemicals class=icon><img src=../../../assets/img/icons/sectors/chemicals.png> <span>Chemicals, Plastics<br>&amp; Rubber</span></label><input id=communications type=checkbox name=sector[] autocomplete=off ng-click=userPreferencesController.toggleSectorSelection(7) ng-checked=userPreferencesController.isSectorSelected(7)><label id=communications-label for=communications class=icon><img src=../../../assets/img/icons/sectors/communications.png> <span>Communications</span></label><input id=construction type=checkbox name=sector[] autocomplete=off ng-click=userPreferencesController.toggleSectorSelection(8) ng-checked=userPreferencesController.isSectorSelected(8)><label id=construction-label for=construction class=icon><img src=../../../assets/img/icons/sectors/construction.png> <span>Construction</span></label><input id=consumer_products type=checkbox name=sector[] autocomplete=off ng-click=userPreferencesController.toggleSectorSelection(9) ng-checked=userPreferencesController.isSectorSelected(9)><label id=consumer_products-label for=consumer_products class=icon><img src=../../../assets/img/icons/sectors/consumer.png> <span>Consumer Products</span></label><input id=digital_media type=checkbox name=sector[] autocomplete=off ng-click=userPreferencesController.toggleSectorSelection(10) ng-checked=userPreferencesController.isSectorSelected(10)><label id=digital_media-label for=digital_media class=icon><img src=../../../assets/img/icons/sectors/digital_media.png> <span>Media</span></label><input id=electronics type=checkbox name=sector[] autocomplete=off ng-click=userPreferencesController.toggleSectorSelection(11) ng-checked=userPreferencesController.isSectorSelected(11)><label id=electronics-label for=electronics class=icon><img src=../../../assets/img/icons/sectors/electronics.png> <span>Electronics</span></label><input id=energy type=checkbox name=sector[] autocomplete=off ng-click=userPreferencesController.toggleSectorSelection(12) ng-checked=userPreferencesController.isSectorSelected(12)><label id=energy-label for=energy class=icon><img src=../../../assets/img/icons/sectors/energy.png> <span>Energy &amp; Environmental</span></label><input id=fintech type=checkbox name=sector[] autocomplete=off ng-click=userPreferencesController.toggleSectorSelection(13) ng-checked=userPreferencesController.isSectorSelected(13)><label id=fintech-label for=fintech class=icon><img src=../../../assets/img/icons/sectors/financial.png> <span>Financial Services</span></label><input id=food type=checkbox name=sector[] autocomplete=off ng-click=userPreferencesController.toggleSectorSelection(14) ng-checked=userPreferencesController.isSectorSelected(14)><label id=food-label for=food class=icon><img src=../../../assets/img/icons/sectors/food_bev_tobacco.png> <span>Food, Beverages &amp; Tobacco</span></label><input id=healthcare type=checkbox name=sector[] autocomplete=off ng-click=userPreferencesController.toggleSectorSelection(15) ng-checked=userPreferencesController.isSectorSelected(15)><label id=healthcare-label for=healthcare class=icon><img src=../../../assets/img/icons/sectors/healthcare.png> <span>Healthcare</span></label><input id=industrial type=checkbox name=sector[] autocomplete=off ng-click=userPreferencesController.toggleSectorSelection(16) ng-checked=userPreferencesController.isSectorSelected(16)><label id=industrial-label for=industrial class=\"icon long-sector-name-icon\"><img src=../../../assets/img/icons/sectors/industrial.png> <span>Advanced Materials, Industrial Equipment &amp; Manufacturing</span></label><input id=it type=checkbox name=sector[] autocomplete=off ng-click=userPreferencesController.toggleSectorSelection(17) ng-checked=userPreferencesController.isSectorSelected(17)><label id=it-label for=it class=icon><img src=../../../assets/img/icons/sectors/it_software.png> <span>IT &amp; Software</span></label><input id=leisure_tourism type=checkbox name=sector[] autocomplete=off ng-click=userPreferencesController.toggleSectorSelection(18) ng-checked=userPreferencesController.isSectorSelected(18)><label id=leisure_tourism-label for=leisure_tourism class=icon><img src=../../../assets/img/icons/sectors/leisure_tourism.png> <span>Leisure &amp; Tourism</span></label><input id=logistics_distro type=checkbox name=sector[] autocomplete=off ng-click=userPreferencesController.toggleSectorSelection(19) ng-checked=userPreferencesController.isSectorSelected(19)><label id=logistics_distro-label for=logistics_distro class=icon><img src=../../../assets/img/icons/sectors/logistics_distro.png> <span>Logistics &amp; Transportation</span></label><input id=mining_metals type=checkbox name=sector[] autocomplete=off ng-click=userPreferencesController.toggleSectorSelection(21) ng-checked=userPreferencesController.isSectorSelected(21)><label id=mining_metals-label for=mining_metals class=icon><img src=../../../assets/img/icons/sectors/mining_metals.png> <span>Mining &amp; Metals</span></label><input id=pharmaceuticals type=checkbox name=sector[] autocomplete=off ng-click=userPreferencesController.toggleSectorSelection(22) ng-checked=userPreferencesController.isSectorSelected(22)><label id=pharmaceuticals-label for=pharmaceuticals class=icon><img src=../../../assets/img/icons/sectors/pharma.png> <span>Pharmaceuticals &amp; Biotechnology</span></label></div></div></form></section></div></div><script>$(document).ready(function(){\r\n    if( $(\'body\').find(\'#login\').length > 0 ){\r\n      $(\'body\').addClass(\'color-bck\');\r\n    }\r\n    else{\r\n       $(\'body\').removeClass(\'color-bck\');\r\n    }\r\n    });</script>");
$templateCache.put("app/components/companyDetailsModal/companyDetailsModal.html","<style>.employeeRange td {\r\n  border: 1px solid grey;\r\n  border-collapse: collapse;\r\n  padding: 5px;\r\n}</style><section id=companies__detail ng-class=\"cdmController.modalOpen ? \'modal-visible\' : \'modal-closed\'\" ng-style=\"{\'display\' : cdmController.modalOpen || cdmController.modalTransition ? \'block\' : \'none\'}\"><div class=\"companies__detail-page custom-company-detail\"><button class=\"detail_close modal-close-btn\" ng-click=cdmController.closeModal()>X</button><div class=inner><single-message-summary alert=cdmController.alert></single-message-summary><header><div class=left_header><h1 style=\"position: relative\">{{cdmController.companyDetails.name}}</h1><div><img ng-show=cdmController.showLogo ng-src={{cdmController.logo}}> <img ng-if=\"!cdmController.showLogo && cdmController.companyDetails.website != null\" ng-hide=$root.isLoading onerror=\"this.src=\'../assets/img/DefaultCompanyIcon.png\'\" ng-src=\"https://logo.debounce.com/{{cdmController.companyDetails.website != null? cdmController.companyDetails.website.replace(\'www.\',\'\'): cdmController.companyDetails.name+\'.com\'}}\"></div></div><div class=header__btn-block><button ng-if=\"!cdmController.hasCompanyProfiles() && !cdmController.hasProfilePending()\" class=\"btn btn-dark-blue custom-btn\" ng-click=cdmController.requestProfile() ng-disabled=!cdmController.hasLoadedCompanyDetails>Request Profile</button> <button ng-if=cdmController.hasProfilePending() class=\"btn btn-dark-blue custom-btn\" disabled>Profile Pending</button> <a ng-if=cdmController.hasViewableProfile() class=\"btn colr primary\" target=_blank ng-href={{cdmController.latestProfile().pdfUrl}}>View Profile</a></div><div class=clearfix></div></header><article><div class=class-name></div><nav style=display:none><ul><li><a href=\"\" ng-click=\"cdmController.anchorScrollTo(\'summary_details\')\">Summary Details</a></li><li><a href=\"\" ng-click=\"cdmController.anchorScrollTo(\'financials\')\">Financials</a></li><li class=d_none><a href=\"\" ng-click=\"cdmController.anchorScrollTo(\'news\')\">News</a></li><li><a href=\"\" ng-click=\"cdmController.anchorScrollTo(\'funding_data\')\">Funding Details</a></li></ul></nav><div ng-show=$root.isLoading class=companyDetailsSpinner><div class=inner></div></div><section id=summary_details ng-hide=$root.isLoading class=\"bd-t bd-b\"><h4 class=sm-h3>{{cdmController.findCompanySummary() ? \"Summary Details\" : \"\"}}</h4><p class=txt-excerpt><span ng-if=\"cdmController.findCompanySummary() && !cdmController.isReadMoreClick\">{{cdmController.findCompanySummary()| limitTo: 200 }}</span> <span ng-if=\"cdmController.findCompanySummary() && cdmController.isReadMoreClick\">{{cdmController.findCompanySummary()}}</span> <span ng-if=\"cdmController.findCompanySummary().length >= 200 && !cdmController.isReadMoreClick\" ng-click=cdmController.activeReadMore(true)><b><i><font color=#007dc3>...read more</font></i></b></span> <span ng-if=cdmController.isReadMoreClick ng-click=cdmController.activeReadMore(false)><b><i><font color=#007dc3>...read less</font></i></b></span></p><ul><li ng-if=\"cdmController.companyDetails.sectors.length > 0\"><h4><b>Sector</b></h4><span ng-repeat=\"sector in cdmController.companyDetails.sectors\">{{sector}}</span></li><li ng-if=\"cdmController.companyDetails.subSectorIds.length > 0\"><h4><b>Subsectors</b></h4><span ng-repeat=\"subsector in cdmController.companyDetails.subSectorIds\">{{subsector | subSector}}{{$last ? \'\' : \', \'}}</span></li><li ng-if=cdmController.companyDetails.established><h4><b>Year Established</b></h4>{{cdmController.companyDetails.established}}</li><li ng-if=cdmController.companyDetails.telephone><h4><b>Telephone</b></h4>{{cdmController.companyDetails.telephone}}</li><li ng-if=cdmController.companyDetails.email><h4><b>Email</b></h4>{{cdmController.companyDetails.email}}</li><li ng-if=cdmController.companyDetails.address><h4><b>Address</b></h4><span>{{cdmController.address.join(\", \")}}</span></li><li><div class=detail__contacts-website ng-if=cdmController.companyDetails.website ng-hide=$root.isLoading><a ng-href=\"{{ cdmController.getExternalUrl(cdmController.companyDetails.website, \'http\') }}\" target=_blank>{{cdmController.companyDetails.website}}</a></div><a ng-if=cdmController.companyDetails.linkedin ng-href=\"{{ cdmController.getExternalUrl(cdmController.companyDetails.linkedin) }}\" target=_blank><i class=\"fa fa-linkedin-square fa-2x\" style=\"color: #007bb6\"></i></a> <a ng-if=cdmController.companyDetails.twitter ng-href=\"{{ cdmController.getTwitterUrl(cdmController.companyDetails.twitter) }}\" target=_blank><i class=\"fa fa-twitter-square fa-2x\" style=\"color: #00aced\"></i></a></li></ul></section><section id=financials ng-hide=$root.isLoading class=bd-b><h4 class=sm-h3>Performance Indicators</h4><p ng-if=cdmController.getTurnover(cdmController.companyDetails.financials)><strong><b>Revenue (M$):</b> </strong>{{ cdmController.getTurnover(cdmController.companyDetails.financials) }}</p><p><strong><b>Employees: </b></strong>{{ cdmController.getEmployeeRanges(cdmController.companyDetails.currentEmployees) | kmbFormat}}</p></section><section id=map ng-show=\"cdmController.hasLoadedCompanyDetails && cdmController.companyDetails.id\" class=bd-b><h4 class=sm-h3>Location Hot Spots</h4><div id=map-buttons ng-show=cdmController.hasLoadedCompanyMap class=map-btn><h4 ng-attr-class=\"{{cdmController.activeDisplay==\'hq\'?\'btn-hq-engaged\':\'btn-hq\'}}\" ng-click=\"cdmController.activateDisplay(\'hq\')\">Head Office</h4><h4 ng-attr-class=\"{{cdmController.activeDisplay==\'hq\'?\'btn-sub\':\'btn-sub-engaged\'}}\" ng-click=\"cdmController.activateDisplay(\'sub\')\">Office Locations</h4></div><div class=clearfix><svg viewBox=\"0 0 845.2 458\" class=company-map ng-if=cdmController.hasLoadedCompanyMap ng-mouseleave=cdmController.hoverOut()><circle ng-repeat=\"coord in cdmController.worldMap\" ng-attr-cx={{coord.x/10}} ng-attr-cy={{coord.y/10}} ng-attr-r=1.9 /><circle ng-repeat=\"coord in cdmController.companyMap\" ng-if=!coord.isHQ ng-attr-cx={{coord.x/10}} ng-attr-cy={{coord.y/10}} ng-attr-class=\"{{cdmController.activeDisplay==\'sub\'?\'sub-pulse\':\'sub\'}}\" ng-mouseenter=cdmController.hoverIn(coord) ng-attr-r=\"{{cdmController.activeDisplay==\'sub\' ? cdmController.currentValue: \'7\'}}\"/><circle ng-repeat=\"coord in cdmController.companyMap\" ng-if=coord.isHQ ng-attr-cx={{coord.x/10}} ng-attr-cy={{coord.y/10}} ng-attr-class=\"{{cdmController.activeDisplay==\'hq\'?\'hq-pulse\':\'hq\'}}\" ng-mouseenter=cdmController.hoverIn(coord) ng-attr-r=\"{{cdmController.activeDisplay==\'hq\' ? cdmController.currentValue : \'7\'}}\"/></svg><ul><li ng-if=!cdmController.hasLoadedCompanyMap>Loading...</li><li><h4 ng-attr-class=\"{{cdmController.selectedCompany.isHQ?\'hq\':\'sub\'}}\">{{cdmController.showSelectedCompany && cdmController.selectedCompany.isHQ?\'Head office\':\'\'}} {{cdmController.showSelectedCompany && !cdmController.selectedCompany.isHQ?cdmController.selectedCompany.city:\'\'}}&nbsp;</h4>{{cdmController.showSelectedCompany && (cdmController.selectedCompany.city || cdmController.selectedCompany.state)?cdmController.selectedCompany.name:\'\'}}</li><li>{{cdmController.showSelectedCompany && cdmController.selectedCompany.isHQ?cdmController.selectedCompany.city + \', \':\'\'}} {{cdmController.showSelectedCompany && cdmController.selectedCompany.state?cdmController.selectedCompany.state + \', \':\'\'}} {{cdmController.showSelectedCompany && cdmController.selectedCompany.country?cdmController.selectedCompany.country:\'\'}}&nbsp;</li></ul></section><section id=personalisedResearch ng-hide=\"$root.isLoading || !cdmController.hasPersonalisedResearch()\"><h4>Personalised Research</h4><ul><li ng-repeat=\"research in cdmController.personalisedResearch\" class=research-item><div class=research-date>{{ research.updatedAt || research.createdAt | date: \'d MMMM yyyy\'}}</div><div class=research-content>{{ research.content }}</div></li></ul></section><section id=news ng-hide=$root.isLoading><h4>News</h4><ul><li ng-if=cdmController.gettingCompanyNews>Loading . . .</li><li ng-if=cdmController.isNoCompanyNews()>No news available at this time</li><li ng-repeat=\"newsItem in cdmController.companyNews.newsFeed | limitTo:cdmController.newsItemsDisplayed\">- {{newsItem.publicationDate.getDate() | dateSuffix}} {{newsItem.publicationDate | date : \'MMMM yyyy\'}}: <a ng-href={{newsItem.url}} target=_blank>{{newsItem.title}}</a></li></ul><div id=show-more><a ng-if=cdmController.canShowMore() ng-hide=\"cdmController.gettingCompanyNews || cdmController.isNoCompanyNews()\" href=\"\" ng-click=cdmController.showMoreNews()>Show more</a></div></section><section id=funding_data ng-hide=$root.isLoading class=bd-b><h4 class=sm-h3>Funding Details</h4><ul class=\"fund_d_content fund-data-list\"><li class=hir_emp_list ng-if=\"cdmController.companyDetails.events.length <= 0\">No funding details available at this time</li><li ng-repeat=\"eventsItem in cdmController.companyDetails.events\"><p ng-if=eventsItem.eventAt><strong>Date:</strong> <span class=fund-data>{{eventsItem.eventAt | date:\'dd/MM/yyyy\'}}</span></p><p ng-if=eventsItem.fundingType class=capitalize><strong>Funding Type:</strong> <span class=fund-data>{{ eventsItem.fundingType.replace(\'_\', \' \')}}</span></p><p ng-if=eventsItem.series><strong>Series:</strong> <span class=fund-data>{{eventsItem.series}}</span></p><p><strong>Amount(M$):</strong> <span class=fund-data>{{eventsItem.moneyRaisedInMillionsUsd}}</span></p><p><strong>Investors:</strong> <span class=fund-data>{{eventsItem.investors}}</span></p></li></ul></section><!--        <section id=\"hiring_data\" ng-hide=\"$root.isLoading\">\r\n          <h4 class=\"sm-h3\">Hiring Details</h4>\r\n          <div ng-if=\"cdmController.getHiringDetailsList.total == 0 || cdmController.getHiringDetailsList.total == null\">\r\n            <p class=\"no_contactspara hir_emp_list\" >No Hiring data available at this time</p>\r\n          </div>\r\n          <table class=\"hr_details\" ng-if=\"cdmController.getHiringDetailsList.hiringEvents != null\">\r\n            <thead>\r\n              <tr>\r\n                <th width=\"25%\">Date</th>\r\n                <th width=\"75%\">Description</th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n&lt;!&ndash;            {{cdmController.getHiringDetailsList}}&ndash;&gt;\r\n              <tr class=\"hr_details_li\"  ng-repeat=\"hiring in cdmController.getHiringDetailsList.hiringEvents\">\r\n                <td width=\"25%\" class=\"dt\">\r\n                  <span>{{hiring.jobDate}}</span>\r\n                </td>\r\n                <td width=\"75%\" class=\"desc\">\r\n                  <strong>Job Title : </strong>{{hiring.jobTitle}}<br/>\r\n                  <strong>Employer : </strong>{{hiring.employer}} <br/>\r\n                  <strong>Location : </strong>{{hiring.country}}, {{hiring.city}} <br/>\r\n                  <a href=\"{{hiring.url}}\" target=\"_blank\">Job Link</a>\r\n                </td>\r\n              </tr>\r\n\r\n              <tr class=\"hr_details_li\" ng-if=\"cdmController.getHiringDetailsLoad\">\r\n                    <td class=\"desc\"><strong>Hiring is Loading...</strong></td>\r\n              </tr>\r\n            </tbody>\r\n            <tfoot>\r\n              <tr>\r\n                <td colspan=\"2\">\r\n                  <span class=\"companies-list\">\r\n  <div class=\"companies__pagesize\">Showing\r\n      <div class=\"pagesize__dropdown\">\r\n        <span>{{cdmController.itemsPerPage}}</span><i class=\"fa fa-angle-down\"></i>\r\n        <div class=\"pagesize__dropdown-dropdown\">\r\n          <a name=\"pageSize10\"\r\n             href=\"\"\r\n             ng-click=\"cdmController.setPageSize(5)\">5</a>\r\n          <a name=\"pageSize20\"\r\n             href=\"\"\r\n             ng-click=\"cdmController.setPageSize(15)\">15</a>\r\n          <a name=\"pageSize40\"\r\n             href=\"\"\r\n             ng-click=\"cdmController.setPageSize(30)\">30</a>\r\n        </div>\r\n      </div> records per page\r\n  </div>\r\n  <div class=\"companies__pagination\">\r\n	  <ul uib-pagination\r\n        class=\"custom-pagination\"\r\n        total-items=\"cdmController.getHiringDetailsList.total\"\r\n        boundary-links=\"true\"\r\n        max-size=\"3\"\r\n        ng-model=\"cdmController.currentPage\"\r\n        previous-text=\"&#xf104;\"\r\n        next-text=\"&#xf105;\"\r\n        last-text=\"&#xf101;\"\r\n        first-text=\"&#xf100;\"\r\n        items-per-page=\"cdmController.itemsPerPage\"\r\n        ng-change=\"cdmController.pageNumberChanged()\">\r\n    </ul>\r\n  </div>\r\n</span>\r\n\r\n                </td>\r\n              </tr>\r\n            </tfoot>\r\n          </table>\r\n        </section>--></article><aside><article class=\"detail__ratings bd-b\"><div class=\"detail__divider bd-t bd-b\"><h3 class=sm-h3>Rating</h3><!--\r\n									--><h3 class=sm-h3>Sector</h3></div><div class=detail__ratings-inner><div class=detail__ratings-rating>{{cdmController.algorithmRating}}</div><div class=detail__ratings-sector><img ng-src=../../../assets/img/icons/sectors/{{cdmController.getSectorImage()}}></div></div></article><article class=detail__contacts><div class=\"tab_sec custom-tab-sec\" style=\"width: 100%\"><div class=tab><button class=tablinks ng-class=\"{\'active\':(cdmController.contactTabVisibility == \'Company\')}\" ng-click=\"cdmController.tabOpen(\'Company\')\">Company Contacts</button> <button class=tablinks ng-class=\"{\'active\':(cdmController.contactTabVisibility == \'Additional\')}\" ng-click=\"cdmController.tabOpen(\'Additional\')\">Additional Contacts</button></div><div id=Company class=tabcontent style=\"display: block\" ng-if=\"cdmController.contactTabVisibility == \'Company\'\"><div class=detail__divider__header><div class=clearfix><h3 ng-if=\"cdmController.companyDetails.companyUpdateProvider !== \'Cognism\'\" class=\"pull-left sm-h3\">Contacts</h3><h3 ng-if=\"cdmController.companyDetails.companyUpdateProvider == \'Cognism\'\" class=\"pull-left sm-h3\">Contacts ({{ cdmController.contactCount }})</h3><div class=company_contacts-flex-inputs><div ng-if=\"cdmController.companyDetails.companyUpdateProvider == \'Cognism\'\" class=\"search-toggle input-group text-right cognism-search-wrap cognism-search-wrap-flex\" ng-class=\"{open: cdmController.showSearchModal}\"><div class=text-contact-search><input name=searchName id=searchName class=\"single cognismSearchName\" type=text ng-model=cdmController.cognismSearchName placeholder=\"Search Contacts\"> <a class=text-contact-search-button ng-click=cdmController.cognismContactSearch()></a></div><a class=btn-contact-search ng-click=cdmController.toggleSearchModal()></a><!--<div class=\"verify-chk {{cdmController.show ? \'active-verify\' : \'\'}}\" ng-click=\"cdmController.activeContact()\">\r\n                        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" class=\"bi bi-patch-check-fill\" viewBox=\"0 0 16 16\">\r\n                          <path d=\"M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01-.622-.636zm.287 5.984-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708.708z\"/>\r\n                        </svg>\r\n                        <div class=\"verify-content\">\r\n                          <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" class=\"bi bi-patch-check\" viewBox=\"0 0 16 16\">\r\n                            <path fill-rule=\"evenodd\" d=\"M10.354 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708 0z\"/>\r\n                            <path d=\"m10.273 2.513-.921-.944.715-.698.622.637.89-.011a2.89 2.89 0 0 1 2.924 2.924l-.01.89.636.622a2.89 2.89 0 0 1 0 4.134l-.637.622.011.89a2.89 2.89 0 0 1-2.924 2.924l-.89-.01-.622.636a2.89 2.89 0 0 1-4.134 0l-.622-.637-.89.011a2.89 2.89 0 0 1-2.924-2.924l.01-.89-.636-.622a2.89 2.89 0 0 1 0-4.134l.637-.622-.011-.89a2.89 2.89 0 0 1 2.924-2.924l.89.01.622-.636a2.89 2.89 0 0 1 4.134 0l-.715.698a1.89 1.89 0 0 0-2.704 0l-.92.944-1.32-.016a1.89 1.89 0 0 0-1.911 1.912l.016 1.318-.944.921a1.89 1.89 0 0 0 0 2.704l.944.92-.016 1.32a1.89 1.89 0 0 0 1.912 1.911l1.318-.016.921.944a1.89 1.89 0 0 0 2.704 0l.92-.944 1.32.016a1.89 1.89 0 0 0 1.911-1.912l-.016-1.318.944-.921a1.89 1.89 0 0 0 0-2.704l-.944-.92.016-1.32a1.89 1.89 0 0 0-1.912-1.911l-1.318.016z\"/>\r\n                          </svg>\r\n                          <span>Only show verified contacts</span>\r\n                        </div>\r\n                        &lt;!&ndash;                        <input type=\"checkbox\" name=\"verified_contact\" value=\"verified\"><label>Verified only</label>&ndash;&gt;\r\n                      </div>--><div class=dropdown-menu-contact-search><section class=\"form-group flex-wrap-row filter\"><form><div class=filter_item><input name=searchlocation id=searchlocation class=single href uib-dropdown-toggle type=text ng-model=cdmController.cognismSearchLocation typeahead-on-select=cdmController.addCountry($label) placeholder=Location uib-typeahead=\"country as country.name for country in cdmController.countryLevels | filter: $viewValue | limitTo:12 | nonSelectedCountry\" autocomplete=off><!--                                                      <ul class=\"dropdown-menu\" uib-dropdown-menu>\r\n                                                        <li ng-repeat=\"location in cdmController.countryLevels\"\r\n                                                            ng-class=\"{active: hovering}\"\r\n                                                            ng-mouseover=\"hovering = true\"\r\n                                                            ng-mouseleave=\"hovering = false\"\r\n                                                            ng-click=\"cdmController.cognismSearchLocation = location.name\">\r\n                                                          <a href=\"\">{{location.name}}</a>\r\n                                                        </li>\r\n                                                      </ul>--></div><div uib-dropdown class=filter_item><input name=seniority id=seniority class=single href uib-dropdown-toggle type=text ng-model=cdmController.cognismSearchSeniority placeholder=Seniority ng-readonly=true><ul class=dropdown-menu uib-dropdown-menu><li ng-repeat=\"seniority in cdmController.senorityLevels\" ng-class=\"{active: hovering}\" ng-mouseover=\"hovering = true\" ng-mouseleave=\"hovering = false\" ng-click=\"cdmController.cognismSearchSeniority = seniority.name\"><a href=\"\">{{seniority.name}}</a></li></ul></div><div uib-dropdown class=filter_item><input name=department id=department class=single href uib-dropdown-toggle type=text ng-model=cdmController.cognismSearchDepartment placeholder=Department ng-readonly=true><ul class=dropdown-menu uib-dropdown-menu><li ng-repeat=\"department in cdmController.departmentLevels\" ng-class=\"{active: hovering}\" ng-mouseover=\"hovering = true\" ng-mouseleave=\"hovering = false\" ng-click=\"cdmController.cognismSearchDepartment = department.name\"><a href=\"\">{{department.name}}</a></li></ul></div><div uib-dropdown class=filter_item><input name=role id=role class=single href uib-dropdown-toggle type=text ng-model=cdmController.cognismSearchRole placeholder=Role ng-readonly=true><ul class=dropdown-menu uib-dropdown-menu><li ng-repeat=\"role in cdmController.roleLevels\" ng-class=\"{active: hovering}\" ng-mouseover=\"hovering = true\" ng-mouseleave=\"hovering = false\" ng-click=\"cdmController.cognismSearchRole = role.name\"><a href=\"\">{{role.name}}</a></li></ul></div></form></section><a class=\"btn btn-green\" ng-click=cdmController.cognismContactSearch()>Filter</a> <a class=\"btn btn-white\" ng-click=cdmController.cognismContactReset()>Clear All</a></div></div><div class=detail__contacts-download ng-hide=\"cdmController.contacts.empty || $root.isLoading\" hidden><a href=\"\" ng-click=cdmController.downloadContacts()><img src=../../../assets/img/icons/file.png srcset=\"../../../assets/img/icons/file.png 1x, ../../../assets/img/icons/file@2x.png 2x\"></a></div></div></div></div><div ng-if=\"$root.isLoading || cdmController.contactLoading\" class=detail__contacts-contact><p><span>Contacts Loading...</span></p></div><div ng-if=\"!$root.isLoading || cdmController.contactLoading\" class=\"detail__contacts-contact cus-detail-contact\" ng-repeat=\"contact in cdmController.listOfContacts\"><p><span ng-if=contact.fullName><strong>Name: </strong>{{contact.fullName}}<br></span><span ng-if=contact.jobTitle><strong>Position: </strong>{{contact.jobTitle}}<br></span><span ng-if=contact.hasEmail><strong>Email: </strong><a href=mailto:{{cdmController.displayEmail(contact)}}>{{cdmController.displayEmail(contact)}}</a><br></span><span ng-if=contact.hasMobilePhoneNumbers><strong>Telephone: </strong><a href=tel:{{cdmController.displayTelephone(contact)}}>{{cdmController.displayTelephone(contact)}}</a><br></span><a ng-if=contact.hasLinkedinUrl href={{cdmController.displayLinkedIn(contact)}} target=_blank title=\"At first click on reveal\"><i class=\"fa fa-linkedin-square fa-1x\" style=\"color: #007bb6\"></i> </a><br><button ng-click=\"cdmController.revealContact(contact.contactCognismId, cdmController.companyDetails.id, contact.contactCognismRedeemId)\" class=\"btn {{cdmController.displayEmail(contact) == \'******\' ? \'btn-dark-blue\':\'btn-light-blue\'}} custom-btn sm-btn\" ng-if=\"cdmController.companyDetails.companyUpdateProvider == \'Cognism\' && !contact.revealed\">Reveal Contact</button> <button ng-click=\"cdmController.revealContact(contact.contactCognismId, cdmController.companyDetails.id, contact.contactCognismRedeemId)\" class=\"btn {{cdmController.displayEmail(contact) == \'******\' ? \'btn-dark-blue\':\'btn-light-blue\'}} custom-btn sm-btn\" title=\"This contact already reveled\" ng-if=\"cdmController.companyDetails.companyUpdateProvider == \'Cognism\' && contact.revealed\">Show Contact</button></p></div><p class=no_contactspara ng-hide=\"cdmController.totalContacts > 0 || $root.isLoading\">No contacts available at this time, please check additional contacts</p><div ng-if=!$root.isLoading class=\"companies__pagination detail__contacts-pagination\"><ul uib-pagination total-items=cdmController.totalContacts boundary-links=true max-size=3 ng-model=cdmController.page previous-text=&#xf104; next-text=&#xf105; last-text=&#xf101; first-text=&#xf100; ng-change=cdmController.paginationChanged() items-per-page=cdmController.itemsPerPage></ul><!-- <ul uib-pagination\r\n                    total-items=\"cdmController.companyDetails.companyUpdateProvider == \'Cognism\' ? (cdmController.contactCount > 500 ? 500 : cdmController.contactCount) : cdmController.totalContacts\"\r\n                    boundary-links=\"true\"\r\n                    max-size=\"3\"\r\n                    ng-model=\"cdmController.contacts.page\"\r\n                    previous-text=\"&#xf104;\"\r\n                    next-text=\"&#xf105;\"\r\n                    last-text=\"&#xf101;\"\r\n                    first-text=\"&#xf100;\"\r\n                    ng-change=\"cdmController.paginationChanged()\"\r\n                    items-per-page=\"cdmController.contacts.perPage\">\r\n                </ul>--></div></div><div id=Additional class=tabcontent style=\"display: block\" ng-if=\"cdmController.contactTabVisibility  == \'Additional\'\"><div class=detail__divider__header><div class=clearfix><h3 class=pull-left>Contacts</h3><div class=detail__contacts-download ng-hide=\"cdmController.contacts.empty || $root.isLoading\"><a href=\"\" ng-click=cdmController.downloadAdditionalContacts()><img src=../../../assets/img/icons/file.png srcset=\"../../../assets/img/icons/file.png 1x, ../../../assets/img/icons/file@2x.png 2x\"></a></div></div></div><div ng-if=$root.isLoading class=detail__contacts-contact><p><span>Contacts Loading...</span></p></div><div ng-if=!$root.isLoading class=detail__contacts-contact ng-repeat=\"contact in cdmController.additionalContacts.items\"><p><span ng-if=contact.name><strong>Name: </strong>{{contact.title}} {{contact.name}}<br></span><span ng-if=contact.position><strong>Position: </strong>{{contact.position}}<br></span><span ng-if=contact.email><strong>Email: </strong><a href=mailto:{{contact.email}}>{{contact.email}}</a><br></span><span ng-if=contact.telephone><strong>Telephone: </strong><a href=tel:{{contact.telephone}}>{{contact.telephone}}</a><br></span><a ng-if=contact.linkedInHandle href=https://www.linkedin.com/in/{{contact.linkedInHandle}} target=_blank><i class=\"fa fa-linkedin-square fa-1x\" style=\"color: #007bb6\"></i></a></p></div><p class=no_contactspara ng-hide=\"cdmController.additionalContacts.totalItems || $root.isLoading\">No contacts available at this time</p><div ng-if=!$root.isLoading class=\"companies__pagination detail__contacts-pagination\"><ul uib-pagination total-items=cdmController.additionalContacts.length boundary-links=true max-size=3 ng-model=cdmController.additionalContacts.page previous-text=&#xf104; next-text=&#xf105; last-text=&#xf101; first-text=&#xf100; ng-change=cdmController.paginationChanged() items-per-page=cdmController.additionalContacts.perPage></ul></div></div></div></article><article class=company__note><div class=\"detail__dividertest bd-t\" style=\"padding: 0.5em 0\"><div class=clearfix><h3 class=\"pull-left sm-h3\">Company Note</h3></div></div><div class=detail__company-note class=bd-b><div ng-show=$root.isLoading><p><span>Company Note Loading...</span></p></div><div ng-hide=$root.isLoading><div><textarea name=company-note id=company-note rows=3 ng-model=cdmController.clientPersonalNote></textarea></div><div style=\"padding-bottom: 10px\"><button ng-click=cdmController.updateCompanyNote() class=\"btn btn-dark-blue custom-btn sm-btn\" ng-disabled=\"cdmController.clientPersonalNote === cdmController.clientPersonalNoteOriginal\">Update</button></div></div></div></article></aside><div class=clearfix></div></div></div></section>");
$templateCache.put("app/components/companyList/companyList.html","<div class=list-top-option><!--  <div class=\"new_Company\">--><!--    <div class=\"new-company-switch\"  title=\"Show only new Companies\">--><!--      <input type=\"checkbox\" ng-model=\"clController.newCompany\">--><!--      <span class=\"slider round\"></span>--><!--    </div>--><!--  </div>--><div id=btnContainer><button class=\"btn-l btn-swtch active\" ng-click=clController.listView(true)><!--    <i class=\"fa fa-bars\"></i> <i class=\"bi bi-list-task\"></i>--> <svg xmlns=http://www.w3.org/2000/svg width=17 height=17 class=\"bi bi-list-task\" viewBox=\"0 0 16 16\"><path fill-rule=evenodd d=\"M2 2.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H2zM3 3H2v1h1V3z\"/><path d=\"M5 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM5.5 7a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zm0 4a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9z\"/><path fill-rule=evenodd d=\"M1.5 7a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V7zM2 7h1v1H2V7zm0 3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H2zm1 .5H2v1h1v-1z\"/></svg></button> <button class=\"btn-g btn-swtch\" ng-click=clController.gridView(true)><!--    <i class=\"fa fa-th-large\"></i> --> <svg xmlns=http://www.w3.org/2000/svg width=17 height=17 class=\"bi bi-grid-fill\" viewBox=\"0 0 16 16\"><path d=\"M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3z\"/></svg></button></div></div><section class=companies-list id=company_search_grid><div class=\"company-search-results min-results-height\"><div class=\"search-default search-note text-center {{clController.listViewStatus ? \'extra-list-p\' : \'\'}}\" ng-hide=clController.filterService.checkDefaultFiltersWithoutSort()><img class=list-not-found src=../../../assets/img/needCompanySearch.png><p>To build a target list please add search options</p></div><div class=\"cus-row comp-list-grid fl-wrap\" ng-show=clController.gridViewStatus><div class=cus-col-sm-4 ng-show=\"clController.filterService.checkDefaultFiltersWithoutSort() && clController.hasSearchResults && clController.isTradeDestinationSet\" ng-repeat=\"company in clController.companyList\"><div class=\"cus-panel cus-panel-default company-panel box-shadow\"><div class=cus-panel-body><div class=liked-block><velociti-list-edit-company-button ng-show=\"clController.actionButton === \'REMOVE_FROM_LIST\'\" company-id={{company.id}} company-name={{company.name}} is-in-list=true alert=clController.alert list-id={{clController.listId}}></velociti-list-edit-company-button><!--            adding to velociti list button--><velociti-list-edit-company-button ng-show=\"clController.actionButton === \'ADD_TO_LIST\'\" company-id={{company.id}} company-name={{company.name}} is-in-list=clController.isCompanyInList(company.velocitiListId) alert=clController.alert list-id={{clController.listId}}></velociti-list-edit-company-button><a ng-show=\"clController.actionButton !== \'REMOVE_FROM_LIST\' && clController.actionButton !== \'ADD_TO_LIST\'\" ng-click=clController.showAddToListModal(company) class=\"button__small no-action_dropdown\" title=\"Add to list\"><!--              <img class=\"list-icon\" src=\"../../../assets/img/icons/add_to_list.png\">--> <svg id=add xmlns=http://www.w3.org/2000/svg width=24 height=24 viewBox=\"0 0 24 24\"><path id=Path_7541 data-name=\"Path 7541\" d=M14.25,0H2.75A2.748,2.748,0,0,0,0,2.75v15.5A2.748,2.748,0,0,0,2.75,21H9.34a8.731,8.731,0,0,1-.84-3.75,8.46,8.46,0,0,1,.64-3.26,8.242,8.242,0,0,1,.74-1.45A8.827,8.827,0,0,1,12.36,10a7.7,7.7,0,0,1,1.63-.86A8.18,8.18,0,0,1,17,8.51V2.75A2.748,2.748,0,0,0,14.25,0Z fill=#eceff1 /><g id=Group_10291 data-name=\"Group 10291\"><path id=Path_7542 data-name=\"Path 7542\" d=M14,9a.615.615,0,0,1-.01.14,7.7,7.7,0,0,0-1.63.86H4A1,1,0,0,1,4,8h9A1,1,0,0,1,14,9Z fill=#90a4ae /><path id=Path_7543 data-name=\"Path 7543\" d=M9.88,12.54a8.242,8.242,0,0,0-.74,1.45A.615.615,0,0,1,9,14H4a1,1,0,0,1,0-2H9A.989.989,0,0,1,9.88,12.54Z fill=#90a4ae /><path id=Path_7544 data-name=\"Path 7544\" d=M8,6H4A1,1,0,0,1,4,4H8A1,1,0,0,1,8,6Z fill=#90a4ae /></g><path id=Path_7545 data-name=\"Path 7545\" d=M17.25,24A6.75,6.75,0,1,1,24,17.25,6.758,6.758,0,0,1,17.25,24Z fill=#0c2752 /><path id=Path_7546 data-name=\"Path 7546\" d=M17.25,21a1,1,0,0,1-1-1V14.5a1,1,0,0,1,2,0V20A1,1,0,0,1,17.25,21Z fill=#fff /><path id=Path_7547 data-name=\"Path 7547\" d=M20,18.25H14.5a1,1,0,0,1,0-2H20a1,1,0,0,1,0,2Z fill=#fff /></svg></a></div><div class=comp-content><img ng-if=\"company.website != null\" class=comp-logo ng-src=\"https://logo.debounce.com/{{company.website != null? company.website.replace(\'www.\',\'\'): company.name+\'.com\'}}\" onerror=\"this.src=\'../assets/img/DefaultCompanyIcon.png\'\" ng-click=clController.showCompanyDetails(company)> <img ng-if=\"company.website == null\" class=comp-logo ng-src=../assets/img/DefaultCompanyIcon.png><div class=comp-title-soc><h3 ng-click=clController.showCompanyDetails(company)>{{company.name}} <span ng-if=company.recentlyActivated class=newly-added-company>New</span></h3><div class=\"{{company.linkedin ? \'\' : \'unClickable\'}} comp-social\"><a href={{clController.getExternalUrl(company.linkedin)}} target=_blank><svg xmlns=http://www.w3.org/2000/svg width=16 height=16 fill=#0a66c2 class=\"bi bi-linkedin comp-linked-in\" viewBox=\"0 0 16 16\"><path d=\"M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z\"/></svg></a></div></div><div class=\"comp-option custom-scroll comp-max-height\"><ul ng-click=clController.showCompanyDetails(company)><li><strong>Country :</strong> {{company.country}}</li><li><strong>Sector :</strong> {{company.catSector}}</li><li><strong>Scale :</strong>{{company.scale | scale}}</li><li><strong>Ratings :</strong>{{company.rating}}</li><li><strong>Total Contact :</strong>{{company.totalContactCount > 0 ? company.totalContactCount : 0}}</li></ul><!--<div class=\"comp-auth\" hidden>By <img src=\"../assets/img/DefaultCompanyIcon.png\" alt=\"\" class=\"comp-prof\"> John\r\n                  Smith</div>--></div></div></div></div></div></div><div ng-show=$root.isLoading class=companies-list__loader><div class=inner><div class=spinner></div></div></div><table ng-show=clController.listViewStatus class=com-srch-list-v><thead><tr><th></th><th></th><th ng-class=\"{active: clController.sortByColumn === clController.nameColumn}\" ng-click=clController.changeSortByColumn(clController.nameColumn)>Name <span class=company-sort ng-bind-html=clController.getSortIcon(clController.nameColumn)></span></th><th ng-class=\"{active: clController.sortByColumn === clController.countryColumn}\" ng-click=clController.changeSortByColumn(clController.countryColumn)>Country <span class=company-sort ng-bind-html=clController.getSortIcon(clController.countryColumn)></span></th><th ng-class=\"{active: clController.sortByColumn === clController.sectorColumn}\" ng-click=clController.changeSortByColumn(clController.sectorColumn)>Sector <span class=company-sort ng-bind-html=clController.getSortIcon(clController.sectorColumn)></span></th><th ng-class=\"{active: clController.sortByColumn === clController.scaleColumn}\" ng-click=clController.changeSortByColumn(clController.scaleColumn)>Scale <span class=company-sort ng-bind-html=clController.getSortIcon(clController.scaleColumn)></span></th><th ng-class=\"{active: clController.sortByColumn === clController.ratingColumn}\" ng-click=clController.changeSortByColumn(clController.ratingColumn)>Rating <span class=company-sort ng-bind-html=clController.getSortIcon(clController.ratingColumn)></span></th><!--<th ng-class=\"{active: clController.sortByColumn === clController.totalContactColumn}\"\r\n            ng-click=\"clController.changeSortByColumn(clController.totalContactColumn)\">\r\n          Contact<span class=company-sort ng-bind-html=\"clController.getSortIcon(clController.totalContactColumn)\"></span>\r\n        </th>--><th>No. of Contacts</th><!--      <th>--><!--        LinkedIn--><!--      </th>--><th>Add</th></tr></thead><tbody><tr ng-hide=\"(!clController.filterService.checkDefaultFiltersWithoutSort() || clController.hasSearchResults && clController.isTradeDestinationSet) || !clController.isTradeDestinationSet\" class=no_results><td colspan=9>Sorry we couldn\'t find any matches,<br>please adjust your search criteria</td></tr><!--<tr  ng-hide=\"clController.filterService.checkDefaultFiltersWithoutSort()\" class=\"no_results\">\r\n        <td colspan=\"9\">\r\n          <div class=\"search-default search-note text-center\" ng-hide=\"clController.filterService.checkDefaultFiltersWithoutSort()\">\r\n            <img class=\"list-not-found\" src=\"../../../assets/img/needCompanySearch.png\">\r\n            <p>To build a target list please add search options</p>\r\n          </div>\r\n        </td>\r\n      </tr>--><tr ng-hide=clController.isTradeDestinationSet class=no_results><td colspan=9>Company matches will appear when<br>you specify your Trade Destination</td></tr><tr ng-show=\"clController.filterService.checkDefaultFiltersWithoutSort() && clController.hasSearchResults && clController.isTradeDestinationSet\" ng-repeat=\"company in clController.companyList\"><td class=spacer ng-click=clController.showCompanyDetails(company)></td><td ng-click=clController.showCompanyDetails(company) class=company_listimg><div class=list-new-comp><img ng-if=\"company.website != null\" ng-src=\"https://logo.debounce.com/{{company.website != null? company.website.replace(\'www.\',\'\'): company.name+\'.com\'}}\" onerror=\"this.src=\'../assets/img/DefaultCompanyIcon.png\', this.style.height = \'32px\',this.style.width = \'32px\'\"> <img ng-if=\"company.website == null\" ng-src=../assets/img/DefaultCompanyIcon.png><div ng-if=company.recentlyActivated class=comp-new-tag><div class=new-tag-container><span class=newly-added-company>New</span> <span class=new-tag-back></span></div></div></div></td><td><div class=com-src-info-main><div class=com-src-info><span ng-click=clController.showCompanyDetails(company) class=com-src-name>{{company.name}}</span><div class=\"{{company.linkedin ? \'\' : \'unClickable\'}}\"><div class=comp-social><a href={{clController.getExternalUrl(company.linkedin)}} target=_blank><svg xmlns=http://www.w3.org/2000/svg width=12 height=12 fill=#0a66c2 class=\"bi bi-linkedin comp-linked-in\" viewBox=\"0 0 16 16\"><path d=\"M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z\"/></svg></a></div></div></div></div></td><td ng-click=clController.showCompanyDetails(company) ng-click=clController.showCompanyDetails(company)>{{company.country}}</td><td ng-click=clController.showCompanyDetails(company)><span ng-repeat=\"sector in company.sectors\">{{sector}}</span></td><td ng-click=clController.showCompanyDetails(company)>{{company.scale | scale}}</td><td ng-click=clController.showCompanyDetails(company)>{{company.rating}}</td><td ng-click=clController.showCompanyDetails(company) class=no-people><svg ng-if=\"company.totalContactCount > 0 \" xmlns=http://www.w3.org/2000/svg width=16 height=16 fill=#0c2752 class=\"bi bi-people-fill people-icon\" viewBox=\"0 0 16 16\"><path d=\"M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7Zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-5.784 6A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216ZM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z\"/></svg> <svg ng-if=\"!company.totalContactCount \" xmlns=http://www.w3.org/2000/svg width=18 height=18 fill=#0c2752 class=\"bi bi-person-fill-slash people-icon\" viewBox=\"0 0 16 16\"><path d=\"M13.879 10.414a2.501 2.501 0 0 0-3.465 3.465l3.465-3.465Zm.707.707-3.465 3.465a2.501 2.501 0 0 0 3.465-3.465Zm-4.56-1.096a3.5 3.5 0 1 1 4.949 4.95 3.5 3.5 0 0 1-4.95-4.95ZM11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-9 8c0 1 1 1 1 1h5.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.544-3.393C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4Z\"/></svg><div class=people-count>{{company.totalContactCount > 0 ? company.totalContactCount : 0}}</div></td><td class=no-action><!-- removing from velociti list button --><velociti-list-edit-company-button ng-show=\"clController.actionButton === \'REMOVE_FROM_LIST\'\" company-id={{company.id}} company-name={{company.name}} is-in-list=true alert=clController.alert list-id={{clController.listId}}></velociti-list-edit-company-button><!-- adding to velociti list button --><velociti-list-edit-company-button ng-show=\"clController.actionButton === \'ADD_TO_LIST\'\" company-id={{company.id}} company-name={{company.name}} is-in-list=clController.isCompanyInList(company.listId) alert=clController.alert list-id={{clController.listId}}></velociti-list-edit-company-button><a title=\"Add to list\" ng-show=\"clController.actionButton !== \'REMOVE_FROM_LIST\' && clController.actionButton !== \'ADD_TO_LIST\'\" ng-click=clController.showAddToListModal(company) class=\"button__small no-action_dropdown\"><!--          <img src=\"../../../assets/img/icons/add_to_list.png\">--> <svg id=add xmlns=http://www.w3.org/2000/svg width=24 height=24 viewBox=\"0 0 24 24\"><path id=Path_7541 data-name=\"Path 7541\" d=M14.25,0H2.75A2.748,2.748,0,0,0,0,2.75v15.5A2.748,2.748,0,0,0,2.75,21H9.34a8.731,8.731,0,0,1-.84-3.75,8.46,8.46,0,0,1,.64-3.26,8.242,8.242,0,0,1,.74-1.45A8.827,8.827,0,0,1,12.36,10a7.7,7.7,0,0,1,1.63-.86A8.18,8.18,0,0,1,17,8.51V2.75A2.748,2.748,0,0,0,14.25,0Z fill=#eceff1 /><g id=Group_10291 data-name=\"Group 10291\"><path id=Path_7542 data-name=\"Path 7542\" d=M14,9a.615.615,0,0,1-.01.14,7.7,7.7,0,0,0-1.63.86H4A1,1,0,0,1,4,8h9A1,1,0,0,1,14,9Z fill=#90a4ae /><path id=Path_7543 data-name=\"Path 7543\" d=M9.88,12.54a8.242,8.242,0,0,0-.74,1.45A.615.615,0,0,1,9,14H4a1,1,0,0,1,0-2H9A.989.989,0,0,1,9.88,12.54Z fill=#90a4ae /><path id=Path_7544 data-name=\"Path 7544\" d=M8,6H4A1,1,0,0,1,4,4H8A1,1,0,0,1,8,6Z fill=#90a4ae /></g><path id=Path_7545 data-name=\"Path 7545\" d=M17.25,24A6.75,6.75,0,1,1,24,17.25,6.758,6.758,0,0,1,17.25,24Z fill=#0c2752 /><path id=Path_7546 data-name=\"Path 7546\" d=M17.25,21a1,1,0,0,1-1-1V14.5a1,1,0,0,1,2,0V20A1,1,0,0,1,17.25,21Z fill=#fff /><path id=Path_7547 data-name=\"Path 7547\" d=M20,18.25H14.5a1,1,0,0,1,0-2H20a1,1,0,0,1,0,2Z fill=#fff /></svg></a></td></tr></tbody></table></div></section><company-details-modal company-details=clController.companyDetails></company-details-modal><script>jQuery(document).ready(function ($) {\r\n\r\n    $(\".liked-block\").on(\'click\', function () {\r\n        $(this).toggleClass(\"liked\");\r\n    });\r\n  });</script>");
$templateCache.put("app/components/companyListFilterBadges/companyListFilterBadges.html","<section class=active-filters ng-if=clfbController.hasFilters()><div class=filter-header><div class=filter-header-title><div class=filter-head-icon><svg xmlns=http://www.w3.org/2000/svg width=16 height=16 class=\"bi bi-check-circle-fill\" viewBox=\"0 0 16 16\" style=\"margin-top: -1px\"><path d=\"M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z\"/></svg></div><span>Active Filters</span></div></div><div class=\"active-filters_applied custom-scrollbar\"><a name=countryBadge ng-repeat=\"countryBadge in clfbController.filterService.selectedCountries\" ng-click=clfbController.filterService.removeCountry(countryBadge) class=filter href>{{countryBadge}} <span><i class=\"fa fa-close\"></i></span> </a><a name=regionBadge ng-repeat=\"regionBadge in clfbController.filterService.selectedRegions\" ng-click=clfbController.filterService.removeRegion(regionBadge) class=filter href>{{regionBadge}} <span><i class=\"fa fa-close\"></i></span> </a><!--    <a name=\"sectorBadge\"\r\n       ng-repeat=\"sectorBadge in clfbController.filterService.selectedSectors\"\r\n       ng-click=\"clfbController.filterService.removeSector(sectorBadge)\"\r\n       class=\"filter\" href>{{sectorBadge}}\r\n      <span><i class=\"fa fa-close\"></i></span>\r\n    </a>--> <a name=industryBadge ng-repeat=\"industryBadge in clfbController.filterService.selectedIndustry\" ng-click=clfbController.filterService.removeIndustry(industryBadge) class=filter href>Industry : {{industryBadge}} <span><i class=\"fa fa-close\"></i></span> </a><a name=scaleBadge ng-repeat=\"scaleBadge in clfbController.filterService.selectedScale\" ng-click=clfbController.filterService.removeScale(scaleBadge) class=filter href>{{scaleBadge.value}} <span><i class=\"fa fa-close\"></i></span> </a><!--<a name=\"companyTypeBadge\"\r\n       ng-repeat=\"companyTypeBadge in clfbController.filterService.selectedCompanyType\"\r\n       ng-click=\"clfbController.filterService.removeCompanyType(companyTypeBadge)\"\r\n       class=\"filter\" href>{{companyTypeBadge.value}}\r\n      <span><i class=\"fa fa-close\"></i></span>\r\n    </a>--> <a name=NAICSBadge ng-repeat=\"selectedNAICSBadge in clfbController.filterService.selectedNAICSs\" ng-click=clfbController.filterService.removeNAICS(selectedNAICSBadge) class=filter href>{{selectedNAICSBadge.id}} - {{selectedNAICSBadge.name}} <span><i class=\"fa fa-close\"></i></span> </a><a name=SICBadge ng-repeat=\"selectedSICBadge in clfbController.filterService.selectedSICs\" ng-click=clfbController.filterService.removeSIC(selectedSICBadge) class=filter href>{{selectedSICBadge.id}} - {{selectedSICBadge.name}} <span><i class=\"fa fa-close\"></i></span> </a><a name=ISICBadge ng-repeat=\"selectedISICBadge in clfbController.filterService.selectedISICs\" ng-click=clfbController.filterService.removeISIC(selectedISICBadge) class=filter href>{{selectedISICBadge.id}} - {{selectedISICBadge.name}} <span><i class=\"fa fa-close\"></i></span> </a><a name=ratingBadge ng-if=clfbController.hasRatingFilter() ng-click=clfbController.filterService.removeRatingFilter() class=filter href>Rating: ({{clfbController.filterService.rating.min | rating}}) - ({{clfbController.filterService.rating.max | rating}}) <span><i class=\"fa fa-close\"></i></span> </a><!--<a name=\"subSectorBadge\"\r\n       ng-repeat=\"subSectorBadge in clfbController.filterService.selectedSubSectors\"\r\n       ng-click=\"clfbController.filterService.removeSubSector(subSectorBadge)\"\r\n       class=\"filter\" href>{{subSectorBadge}}\r\n      <span><i class=\"fa fa-close\"></i></span>\r\n    </a>\r\n    <a name=\"SectorTagBadge\"\r\n       ng-repeat=\"sectorTagBadge in clfbController.filterService.selectedSectorTags\"\r\n       ng-click=\"clfbController.filterService.removeSectorTag(sectorTagBadge)\"\r\n       class=\"filter\" href>{{sectorTagBadge}}\r\n      <span><i class=\"fa fa-close\"></i></span>\r\n    </a>--> <a name=companyTypeBadge ng-repeat=\"companyTypeBadge in clfbController.filterService.selectedCompanyType\" ng-click=clfbController.filterService.removeCompanyType(companyTypeBadge) class=filter href>{{companyTypeBadge}} <span><i class=\"fa fa-close\"></i></span> </a><!--    new filter 9-14-2022--><!--    <a name=\"NAICSBadge\"\r\n       ng-repeat=\"selectedNAICSBadge in clfbController.filterService.selectedNAICSs\"\r\n       ng-click=\"clfbController.filterService.removeNAICS(selectedNAICSBadge)\"\r\n       class=\"filter\" href>{{selectedNAICSBadge}}\r\n      <span><i class=\"fa fa-close\"></i></span>\r\n    </a>--><!--<a name=\"SICBadge\"\r\n       ng-repeat=\"selectedSICBadge in clfbController.filterService.selectedSICs\"\r\n       ng-click=\"clfbController.filterService.removeSIC(selectedSICBadge)\"\r\n       class=\"filter\" href>{{selectedSICBadge}}\r\n      <span><i class=\"fa fa-close\"></i></span>\r\n    </a>--><!-- <a name=\"ISICBadge\"\r\n       ng-repeat=\"selectedISICBadge in clfbController.filterService.selectedISICs\"\r\n       ng-click=\"clfbController.filterService.removeISIC(selectedISICBadge)\"\r\n       class=\"filter\" href>{{selectedISICBadge}}\r\n      <span><i class=\"fa fa-close\"></i></span>\r\n    </a>--><!--    end new filter--><!--    <a name=\"companyTypeBadge\"--><!--       ng-repeat=\"companyTypeBadge in clfbController.filterService.selectedCompanyType\"--><!--       ng-click=\"clfbController.filterService.removeCompanyType(companyTypeBadge)\"--><!--       class=\"filter\" href>{{companyTypeBadge}}--><!--      <span><i class=\"fa fa-close\"></i></span>--><!--    </a>--> <a name=cityBadge ng-repeat=\"cityBadge in clfbController.filterService.selectedCities\" ng-click=clfbController.filterService.removeCity(cityBadge) class=filter href>{{cityBadge}} <span><i class=\"fa fa-close\"></i></span> </a><a name=overseasOperationBadge ng-repeat=\"overseasOperationBadge in clfbController.filterService.selectedOverseasOperations\" ng-click=clfbController.filterService.removeOverseasOperation(overseasOperationBadge) class=filter href>Overseas Presence: {{overseasOperationBadge}} <span><i class=\"fa fa-close\"></i></span> </a><a name=usStateBadge ng-repeat=\"usStateBadge in clfbController.filterService.selectedUsStates\" ng-click=clfbController.filterService.removeUsState(usStateBadge) class=filter href>{{usStateBadge}} <span><i class=\"fa fa-close\"></i></span> </a><a name=companyNameBadge ng-if=clfbController.hasCompanyNameFilter() ng-click=clfbController.filterService.removeCompanyNameFilter() class=filter href>Company Name: {{clfbController.getCompanyName() | uppercase}} <span><i class=\"fa fa-close\"></i></span> </a><a name=domainNameBadge ng-if=clfbController.hasDomainNameFilter() ng-click=clfbController.filterService.removeDomainNameFilter() class=filter href>Domain (URL): {{clfbController.getDomainName() | uppercase}} <span><i class=\"fa fa-close\"></i></span> </a><a name=employeeBadge ng-if=clfbController.hasEmployeeFilter() ng-click=clfbController.filterService.removeEmployeeFilter() class=filter href>Employees: {{clfbController.getEmployees()}} <span><i class=\"fa fa-close\"></i></span> </a><a name=establishedBadge ng-if=clfbController.hasEstablishedFilter() ng-click=clfbController.filterService.removeEstablishedFilter() class=filter href>Year Established: {{clfbController.getEstablished()}} <span><i class=\"fa fa-close\"></i></span> </a><a name=turnoverBadge ng-if=clfbController.hasTurnoverFilter() ng-click=clfbController.filterService.removeTurnoverFilter() class=filter href>Turnover: {{clfbController.getTurnover()}} <span><i class=\"fa fa-close\"></i></span> </a><a name=exhibitionBadge ng-repeat=\"exhibitionBadge in clfbController.filterService.selectedExhibitions\" ng-click=clfbController.filterService.removeExhibition(exhibitionBadge) class=filter href>{{exhibitionBadge.name}} <span><i class=\"fa fa-close\"></i></span> </a><a name=tradeShowBadge ng-repeat=\"tradeShowBadge in clfbController.filterService.tradeShows\" ng-click=clfbController.filterService.removeTradeShow(tradeShowBadge) class=filter href>Trade Show:{{tradeShowBadge.name}} <span><i class=\"fa fa-close\"></i></span> </a><a name=noPresenceBadge ng-repeat=\"noPresenceBadge in clfbController.filterService.selectedNoPresence\" ng-click=clfbController.filterService.removeNoPresence(noPresenceBadge) class=filter href>No Presence: {{noPresenceBadge}} <span><i class=\"fa fa-close\"></i></span> </a><a name=newCompaniesOnlyBadge ng-if=clfbController.hasNewCompaniesFilter() ng-click=clfbController.filterService.removeNewCompaniesFilter() class=filter href>New Companies: {{clfbController.getNewCompanies()}} <span><i class=\"fa fa-close\"></i></span> </a><a name=companyEmployeeGrowthRate ng-if=clfbController.hasCompanyEmployeeGrowthRateFilter() ng-click=clfbController.filterService.removeCompanyEmployeeGrowthRateFilter() class=filter href>Employee Growth Rate: {{clfbController.getCompanyEmployeeGrowthRateSelectedOption()}} <span><i class=\"fa fa-close\"></i></span> </a><a name=companyFundingDateRangeBadge ng-if=\"clfbController.filterService.fundingDateRange != null\" ng-click=clfbController.filterService.removeCompanyFundingDateRangeFilter() class=filter href>Funding Date Range: {{clfbController.filterService.fundingDateRange.fromDate}} - {{clfbController.filterService.fundingDateRange.toDate}} <span><i class=\"fa fa-close\"></i></span> </a><a name=companyFundingTypeBadge ng-repeat=\"fundingTypesBadge in clfbController.filterService.funding_types\" ng-click=clfbController.filterService.removeCompanyFundingTypeFilter(fundingTypesBadge) class=filter href>{{fundingTypesBadge}} <span><i class=\"fa fa-close\"></i></span> </a><a name=companyFundingSeriesBadge ng-repeat=\"fundingSeriesBadge in clfbController.filterService.fundingSeries\" ng-click=clfbController.filterService.removeCompanyFundingSeriesFilter(fundingSeriesBadge) class=filter href>{{fundingSeriesBadge}} <span><i class=\"fa fa-close\"></i></span> </a><a name=companyFundingDealAmountBadge ng-if=\"clfbController.filterService.fundingDealAmount != null\" ng-click=clfbController.filterService.removeCompanyFundingAmountFilter() class=filter href>Minimum Deal Amount($M): {{clfbController.filterService.fundingDealAmount.min}} - Maximum Deal Amount($M): {{clfbController.filterService.fundingDealAmount.max}} <span><i class=\"fa fa-close\"></i></span> </a><a name=companyHiringDateRangeBadge ng-if=\"clfbController.filterService.hiringDateRange != null\" ng-click=clfbController.filterService.removeHiringDateRange() class=filter href>Hiring Date Range: {{clfbController.filterService.hiringDateRange.fromDate}} - {{clfbController.filterService.hiringDateRange.toDate}} <span><i class=\"fa fa-close\"></i></span> </a><a name=hiringJobTitle ng-if=\"clfbController.filterService.hiringDateRange.jobTitle \" ng-click=clfbController.filterService.removeJobTitle() class=filter href>Job Title: <span ng-repeat=\"jobTitle in clfbController.filterService.hiringDateRange.jobTitle\">{{jobTitle}}</span> <span><i class=\"fa fa-close\"></i></span> </a><a name=hiringState ng-if=clfbController.filterService.hiringDateRange.state ng-click=clfbController.filterService.removeHiringState() class=filter href>Hiring State: <span ng-repeat=\"state in clfbController.filterService.hiringDateRange.state\">{{state}}</span> <span><i class=\"fa fa-close\"></i></span> </a><a name=hiring_Country ng-if=clfbController.filterService.hiringDateRange.country ng-click=clfbController.filterService.removeHiring_Country() class=filter href>Hiring Countries:<span ng-repeat=\"country in clfbController.filterService.hiringDateRange.country\">{{country}},</span> <span><i class=\"fa fa-close\"></i></span> </a><a name=hiring_Department ng-if=clfbController.filterService.hiringDateRange.department ng-click=clfbController.filterService.removeHiring_Department() class=filter href>Hiring Departments: <span ng-repeat=\"department in clfbController.filterService.hiringDateRange.department\">{{department}},</span> <span><i class=\"fa fa-close\"></i></span> </a><!-- SIGNAL TYPES --> <a name=signal_Types ng-repeat=\"type in clfbController.filterService.signalDataFilters.signalTypes\" ng-if=\"type && type !== \'\'\" ng-click=clfbController.filterService.removeSignalType(type) class=filter href>Signal Type: {{type}} <span><i class=\"fa fa-close\"></i></span> </a><!-- TARGET MARKETS --> <a name=target_Markets ng-repeat=\"market in clfbController.filterService.signalDataFilters.targetMarkets\" ng-if=\"market && market !== \'\'\" ng-click=clfbController.filterService.removeTargetMarket(market) class=filter href>Target Market: {{market}} <span><i class=\"fa fa-close\"></i></span> </a><!-- SOURCE MARKETS --> <a name=source_Markets ng-repeat=\"market in clfbController.filterService.signalDataFilters.sourceMarkets\" ng-if=\"market && market !== \'\'\" ng-click=clfbController.filterService.removeSourceMarket(market) class=filter href>Source Market: {{market}} <span><i class=\"fa fa-close\"></i></span> </a><!-- DATE RANGE --> <a name=signal_Date ng-if=\"clfbController.filterService.signalDataFilters.created_from &&\r\n          clfbController.filterService.signalDataFilters.created_to\" ng-click=clfbController.filterService.removeSignalDateRange() class=filter href>Date Range: {{clfbController.filterService.signalDataFilters.created_from}} - {{clfbController.filterService.signalDataFilters.created_to}} <span><i class=\"fa fa-close\"></i></span></a></div><div class=clear-filter><button name=clearFilters class=emp-btn title=\"Clear Filters\" href ng-click=clfbController.filterService.clearAllFilters()><svg id=Layer_1 fill=#0c2752 enable-background=\"new 0 0 24 24\" height=22 viewBox=\"0 0 24 24\" width=22 xmlns=http://www.w3.org/2000/svg><g><path d=\"m11 21.4c-.4 0-.7-.1-1.1-.3-.6-.4-.9-1-.9-1.7v-6l-5.4-5.4c-.4-.4-.6-.9-.6-1.4v-1.6c0-1.1.9-2 2-2h2.5c.6 0 1 .4 1 1s-.4 1-1 1h-2.5v1.6l5.4 5.4c.4.4.6.9.6 1.4v6l2-1v-5c0-.5.2-1 .6-1.4l1.2-1.2c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-1.2 1.2v5c0 .8-.4 1.4-1.1 1.8l-2 1c-.3.1-.6.2-.9.2zm7-11.4c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l1.7-1.7v-1.6h-6c-.6 0-1-.4-1-1s.4-1 1-1h6c1.1 0 2 .9 2 2v1.6c0 .5-.2 1-.6 1.4l-1.7 1.7c-.2.2-.4.3-.7.3z\"/></g><g><path d=\"m19 16c-.3 0-.5-.1-.7-.3l-14-14c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l14 14c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3z\"/></g></svg></button></div></section>");
$templateCache.put("app/components/companyListFilterBadges/trendsReportFilterBadges.html","<section class=trends-report ng-if=clfbController.hasFilters()><div><div ng-if=clfbController.filterService.selectedCountries.length><strong>Country </strong>{{clfbController.filterService.selectedCountries.join(\", \")}}</div><div ng-if=clfbController.filterService.selectedScale.length><strong>Scale </strong>{{clfbController.getSelectedScaleValues().join(\", \")}}</div><div ng-if=clfbController.filterService.rating><strong>Rating </strong>({{clfbController.filterService.rating.min | rating}}) - ({{clfbController.filterService.rating.max | rating}})</div><div ng-if=clfbController.filterService.selectedSubSectors.length><strong>Subsector </strong>{{clfbController.filterService.selectedSubSectors.join(\", \")}}</div><div ng-if=clfbController.filterService.selectedCities.length><strong>Cities </strong>{{clfbController.filterService.selectedCities.join(\", \")}}</div><div ng-if=clfbController.filterService.selectedOverseasOperations.length><strong>Overseas Presence </strong>{{clfbController.filterService.selectedOverseasOperations.join(\", \")}}</div><div ng-if=clfbController.filterService.selectedUsStates.length><strong>US States </strong>{{clfbController.filterService.selectedUsStates.join(\", \")}}</div><div ng-if=clfbController.hasEmployeeFilter()><strong>Employees </strong>{{clfbController.getEmployees()}}</div><div ng-if=clfbController.hasTurnoverFilter()><strong>Turnover </strong>{{clfbController.getTurnover()}}</div></div></section>");
$templateCache.put("app/components/companyListFilters/companyListFilters.html","<style>.daterangepicker .table-condensed thead tr th.month select {display: block !important; padding-left: 7.5px; padding-right: 7.5px;}\r\n  .daterangepicker .table-condensed thead tr th.month select.yearselect {\r\n    display: block !important;\r\n    position: absolute;\r\n    top: 0px;\r\n    left: 60%;\r\n  }\r\n  .daterangepicker .table-condensed thead tr th.month {position: relative;}</style><section class=\"filter comp-search-filter\"><div class=filter-header><div class=filter-header-title><div class=filter-head-icon><svg xmlns=http://www.w3.org/2000/svg width=16 height=16 class=\"bi bi-funnel-fill\" viewBox=\"0 0 16 16\"><path d=\"M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z\"/></svg></div><span>Filters</span></div></div><form class=custom-form-style><ul class=\"filter-menu main-tab-2 custom-scrollbar\"><li><div class=\"filter_item company-filter-upper-item\"><input name=company type=text ng-model=clfController.companyName ng-model-options=\"{debounce: 1300}\" ng-change=clfController.onChangeInCompanyNameFilter() class=\"filter-company_name input-no-border\" ng-keydown=clfController.keyPressed($event) placeholder=\"Company Name...\"> <span class=search-icon><svg xmlns=http://www.w3.org/2000/svg width=14 height=14 fill=currentColor class=\"bi bi-search\" viewBox=\"0 0 16 16\"><path d=\"M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z\"/></svg></span></div></li><li><a class=m-menu ng-click=clfController.subMenuShow(1)>General Information <i class=\"fa fa-chevron-down m-down\" ng-show=\"clfController.subCategoryShow != 1\" aria-hidden=true></i><i class=\"fa fa-chevron-up m-up\" ng-show=\"clfController.subCategoryShow == 1\" aria-hidden=true></i></a><div ng-show=\"clfController.subCategoryShow == 1\" class=sub-menu><div uib-dropdown class=filter_item><input name=domain type=text ng-model=clfController.domainName ng-model-options=\"{debounce: 1300}\" ng-change=clfController.onChangeInDomainNameFilter() class=single placeholder=\"Domain URL\"></div><div uib-dropdown class=filter_item><input name=scales id=scales class=single href uib-dropdown-toggle type=text ng-model=clfController.selectedScale placeholder=Scale ng-readonly=true><ul class=dropdown-menu uib-dropdown-menu><li ng-repeat=\"scale in clfController.scales | nonSelectedScale\" ng-class=\"{active: hovering}\" ng-mouseover=\"hovering = true\" ng-mouseleave=\"hovering = false\" ng-click=clfController.addScale(scale)><a href=\"\">{{scale.value}}</a></li></ul></div><div class=\"filter_item range-item\"><label><strong>Employees</strong></label><div class=range-limit><input name=employees_min type=text ng-model=clfController.employeesSliderOptions.start[0] ng-model-options=\"{debounce: 500}\" class=filter-company_name ng-change=clfController.onChangeInEmployeesFilter() placeholder=From> <input name=employees_max type=text ng-model=clfController.employeesSliderOptions.start[1] ng-model-options=\"{debounce: 500}\" class=filter-company_name ng-change=clfController.onChangeInEmployeesFilter() class=filter-company_name placeholder=To></div></div><div class=\"filter_item range-item\"><label><strong>Established</strong></label><div class=range-limit><input class=\"date-own form-control\" ng-change=clfController.onChangeInEstablishedFilter() ng-model=clfController.yearEstablishedOptions.start[0] style=\"width: 300px\" type=text placeholder=Min> <input class=\"date-own form-control\" ng-change=clfController.onChangeInEstablishedFilter() ng-model=clfController.yearEstablishedOptions.start[1] style=\"width: 300px\" type=text placeholder=Max></div></div><div class=filter_slider><label><strong>Turnover</strong></label><div class=range-slider_wrapper><div class=range-slider><div id=turnover_slider ya-no-ui-slider=clfController.turnoverSliderOptions ya-no-ui-slider-events=clfController.turnoverSliderEvents></div></div><div class=range-limit><div class=lowest_value-label>$</div><div class=highest_value-label>$$</div></div><input type=hidden name=turnover_min> <input type=hidden name=turnover_max></div></div></div></li><li><a class=m-menu ng-click=clfController.subMenuShow(2)>Location <i class=\"fa fa-chevron-down m-down\" ng-show=\"clfController.subCategoryShow != 2\" aria-hidden=true></i><i class=\"fa fa-chevron-up m-up\" aria-hidden=true ng-show=\"clfController.subCategoryShow == 2\"></i></a><div ng-show=\"clfController.subCategoryShow == 2\" class=sub-menu><div uib-dropdown class=filter_item><input name=region id=region class=single href uib-dropdown-toggle type=text ng-model=clfController.selectedRegion placeholder=Region ng-readonly=true><ul class=dropdown-menu uib-dropdown-menu><li ng-repeat=\"region in clfController.regions | nonSelectedRegion\" ng-class=\"{active: hovering}\" ng-mouseover=\"hovering = true\" ng-mouseleave=\"hovering = false\" ng-click=clfController.addRegion(region.name)><a href=\"\">{{region.name}}</a></li></ul></div><div class=filter_item><input name=country id=country class=single type=text ng-model=clfController.selectedCountry typeahead-on-select=clfController.addCountry($label) placeholder=Country uib-typeahead=\"country as country.name for country in clfController.countries | filter: $viewValue | limitTo:12 | nonSelectedCountry\" autocomplete=off></div><div class=filter_item><input name=city id=city class=single type=text ng-model=clfController.selectedCity typeahead-min-length=3 typeahead-wait-ms=500 typeahead-on-select=clfController.addCity($label) placeholder=City uib-typeahead=\"city for city in clfController.lookupCities($viewValue)\" autocomplete=off style=\"text-transform: none\" autocapitalize=off></div><div class=filter_item><input name=usStates id=usStates ng-show=clfController.showUsStateFilter class=single type=text ng-model=clfController.selectedUsState typeahead-on-select=clfController.addUsState($label) placeholder=\"Us State\" uib-typeahead=\"usState as usState.state for usState in clfController.usStates | filter: $viewValue | limitTo:12 | nonSelectedUsState\" autocomplete=off></div><div class=filter_item><input name=overseasOperation id=overseasOperation class=single type=text ng-model=clfController.selectedOverseasOperation typeahead-on-select=clfController.addOverseasOperation($label) typeahead-wait-ms=500 placeholder=\"Overseas Presence\" uib-typeahead=\"country as country.name for country in clfController.countries | filter: $viewValue | limitTo:12 | nonSelectedCountry\" autocomplete=off></div><div class=filter_item><input id=no_presence class=single type=text placeholder=\"No Presence\" autocomplete=disabled typeahead-on-select=clfController.addNoPresence($label) ng-model=clfController.selectedNoPresence uib-typeahead=\"country as country.name for country in clfController.countries | filter: $viewValue | limitTo: 12 | nonSelectedCountry\"></div></div></li><li><a class=m-menu ng-click=clfController.subMenuShow(3)>Industries <i class=\"fa fa-chevron-down m-down\" ng-show=\"clfController.subCategoryShow != 3\" aria-hidden=true></i><i class=\"fa fa-chevron-up m-up\" ng-show=\"clfController.subCategoryShow == 3\" aria-hidden=true></i></a><div ng-show=\"clfController.subCategoryShow == 3\" class=sub-menu><!--          <div class=\"filter_item\">\r\n                      <input name=\"sectors\"\r\n                             id=\"sectors\"\r\n                             class=\"single\"\r\n                             type=\"text\"\r\n                             ng-model=\"clfController.selectedSector\"\r\n                             typeahead-on-select=\"clfController.addSector($label)\"\r\n                             typeahead-min-length=\"0\"\r\n                             placeholder=\"Sector\"\r\n                             uib-typeahead=\"sector as sector.name for sector in clfController.sectors | filter: $viewValue | nonSelectedSector \"\r\n                             autocomplete=\"off\">\r\n                    </div>--><div class=filter_item><div id=InsDrop class=dropdown><input type=text placeholder=Industries id=IndusDropDown class=txt-sector ng-model=clfController.industriesSearchFilter><div class=\"sector-drp-dwn custom-scroll\"><a ng-click=clfController.addIndustries(industry) ng-repeat=\" industry in clfController.industries |filter : clfController.industriesSearchFilter \">{{industry.name}}</a></div></div></div><!--<div class=\"filter_item\">\r\n            <div id=\"sectorDrop\" class=\"dropdown\">\r\n              <input type=\"text\" placeholder=\"Sector\" id=\"Sector\" class=\"txt-sector\" ng-model=\"clfController.sectorSearchFilter\">\r\n              <div class=\"sector-drp-dwn custom-scroll\">\r\n                <a ng-click=\"clfController.addSector(sector)\" ng-repeat=\" sector in clfController.sectors |filter : clfController.sectorSearchFilter | nonSelectedSector\" >{{sector.name}}</a>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n\r\n          <div class=\"filter_item\">\r\n            <input name=\"subSectors\"\r\n                   id=\"subSectors\"\r\n                   class=\"single\"\r\n                   type=\"text\"\r\n                   ng-model=\"clfController.selectedSubSector\"\r\n                   typeahead-on-select=\"clfController.addSubSector($label)\"\r\n                   typeahead-min-length=\"0\"\r\n                   placeholder=\"SubSector\"\r\n                   uib-typeahead=\"subSector as subSector.name for subSector in clfController.companyFilterService.subSectorList | filter: $viewValue | nonSelectedSubSector \"\r\n                   autocomplete=\"off\">\r\n          </div>\r\n          <div class=\"filter_item\">\r\n            <input name=\"sectorTags\"\r\n                   id=\"sectorTags\"\r\n                   class=\"single\"\r\n                   type=\"text\"\r\n                   ng-model=\"clfController.selectedSectorTag\"\r\n                   typeahead-on-select=\"clfController.addSectorTag($label)\"\r\n                   typeahead-min-length=\"0\"\r\n                   placeholder=\"Sector Tag\"\r\n                   uib-typeahead=\"sectorTag as sectorTag.tag for sectorTag in clfController.sectorTags | filter: $viewValue | nonSelectedSectorTag \"\r\n                   autocomplete=\"off\">\r\n          </div>--><div class=filter_item><input name=NAICS id=NAICS class=single type=text ng-model=clfController.selectedNAICS typeahead-on-select=clfController.addNAICS($label) typeahead-min-length=0 placeholder=NAICS uib-typeahead=\"naics as naics.id + \' - \'+ naics.name for naics in clfController.naics | filter: $viewValue \" autocomplete=off></div><div class=filter_item><input name=SIC id=SIC class=single type=text ng-model=clfController.selectedSIC typeahead-on-select=clfController.addSIC($label) typeahead-min-length=0 placeholder=SIC uib-typeahead=\"sic as sic.id + \' - \'+ sic.name for sic in clfController.sic | filter: $viewValue \" autocomplete=off></div><div class=filter_item><input name=ISIC id=ISIC class=single type=text ng-model=clfController.selectedISIC typeahead-on-select=clfController.addISIC($label) typeahead-min-length=0 placeholder=ISIC uib-typeahead=\"isic as isic.id + \' - \'+ isic.name for isic in clfController.isic | filter: $viewValue \" autocomplete=off></div></div></li><li><a class=m-menu ng-click=clfController.subMenuShow(4)>Growth Triggers <i class=\"fa fa-chevron-down m-down\" ng-show=\"clfController.subCategoryShow != 4\" aria-hidden=true></i><i class=\"fa fa-chevron-up m-up\" ng-show=\"clfController.subCategoryShow == 4\" aria-hidden=true></i></a><div ng-show=\"clfController.subCategoryShow == 4\" class=sub-menu><div class=modal_op_buttons><div uib-dropdown class=growth-btn><button id=trigger-btn ng-click=clfController.fundingModalShow(true) class=cus-btn>Company Funding</button></div><!--<div uib-dropdown class=\"growth-btn\">\r\n              <button id=\"hiring-btn\" ng-click=\"clfController.hiringModalShow(true)\"  class=\"cus-btn\">Hiring</button>\r\n            </div>--></div><div class=filter_item id=new_company_select style=display:none><div uib-dropdown class=filter_item><input name=new_company_select id=newCompaniesOnly class=single href uib-dropdown-toggle type=text ng-model=clfController.selectedNewCompaniesOption placeholder=\"New Companies Only\" ng-readonly=true><ul class=dropdown-menu uib-dropdown-menu><li ng-repeat=\"option in clfController.newCompaniesOptions\" ng-class=\"{active: hovering}\" ng-mouseover=\"hovering = true\" ng-mouseleave=\"hovering = false\" ng-click=clfController.selectNewCompaniesOption(option)><a href=\"\">{{option.value}}</a></li></ul></div></div><div class=filter_slider id=employee_growth_rate_slider ng-hide=true><label>Employee Growth Rate</label><div class=clear></div><div class=range-slider_wrapper><div class=range-slider><div id=company_employee_growth_rate_slider ya-no-ui-slider=clfController.companyEmployeeGrowthRateSliderOptions ya-no-ui-slider-events=clfController.companyEmployeeGrowthRateSliderEvents></div></div><div class=range-limit><div class=lowest_value-label>0%</div><div class=highest_value-label>&gt;100%</div></div><input type=hidden name=company_employee_growth_rate_min> <input type=hidden name=company_employee_growth_rate_max></div></div><div class=filter_item ng-hide=true><input class=filter-company_name type=text name=contactsGrowth placeholder=\"Contacts Growth\" autocomplete=off id=contactsGrowth readonly></div></div></li><!-- <li>\r\n        <a class=\"m-menu\" ng-click=\"clfController.subMenuShow(5)\">VELOCITI Lists <i class=\"fa fa-chevron-down m-down\" ng-show=\"clfController.subCategoryShow != 5\" aria-hidden=\"true\"></i><i class=\"fa fa-chevron-up m-up\" ng-show=\"clfController.subCategoryShow == 5\" aria-hidden=\"true\"></i></a>\r\n        <div ng-show=\"clfController.subCategoryShow == 5\" class=\"sub-menu\">\r\n          </div>\r\n          <div class=\"filter_item\" id=\"top_target_list\">\r\n            <div uib-dropdown class=\"filter_item scroll-index toptl\">\r\n              <input name=\"top_target_list_select\"\r\n                     id=\"topTargetList\"\r\n                     class=\"single\"\r\n                     href uib-dropdown-toggle\r\n                     type=\"text\"\r\n                     ng-model=\"clfController.selectedTopTargetListName\"\r\n                     placeholder=\"Top Target List\"\r\n                     ng-readonly=\"true\">\r\n              <ul class=\"dropdown-menu\" uib-dropdown-menu>\r\n                <li ng-repeat=\"option in clfController.topTargetLists\"\r\n                    ng-class=\"{active: hovering}\"\r\n                    ng-mouseover=\"hovering = true\"\r\n                    ng-mouseleave=\"hovering = false\"\r\n                    ng-click=\"clfController.selectTopTargetList(option)\"><a href=\"\">{{ option.name }}</a></li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n          <div class=\"filter_item\">\r\n            <div id=\"tradeShowDrop\" class=\"dropdown\">\r\n              <input type=\"text\" placeholder=\"Trade Show\" id=\"tradeShow\" class=\"txt-sector\" ng-model=\"clfController.tradeShowSearchFilter\">\r\n              <div class=\"sector-drp-dwn custom-scroll\">\r\n                <a ng-click=\"clfController.addTradeShow(tradeShow)\" ng-repeat=\" tradeShow in clfController.tradeShow | filter : clfController.tradeShowSearchFilter | filter : { \'publish\' : true}\"\" >{{tradeShow.name}}</a>\r\n                <a ng-click=\"clfController.addTradeShow(tradeShow)\" ng-repeat=\" tradeShow in clfController.tradeShow | filter : clfController.tradeShowSearchFilter \" >{{tradeShow.name}}</a>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n      </li>--><!--<li>\r\n        <a class=\"m-menu\" ng-click=\"clfController.subMenuShow(6)\">Signal\r\n          <i class=\"fa fa-chevron-down m-down\" ng-show=\"clfController.subCategoryShow != 6\" aria-hidden=\"true\"></i><i class=\"fa fa-chevron-up m-up\" ng-show=\"clfController.subCategoryShow == 6\" aria-hidden=\"true\"></i></a>\r\n        <div ng-show=\"clfController.subCategoryShow == 6\" class=\"sub-menu\">\r\n          <div uib-dropdown class=\"filter_item\">\r\n            <input name=\"Type\"\r\n                   id=\"signalType\"\r\n                   class=\"single\"\r\n                   href uib-dropdown-toggle\r\n                   type=\"text\"\r\n                   ng-model=\"clfController.selectedSignalTypes\"\r\n                   placeholder=\"Type\"\r\n                   ng-readonly=\"true\">\r\n            <ul class=\"dropdown-menu\" uib-dropdown-menu>\r\n              <li ng-repeat=\"type in clfController.signalTypes \"\r\n                  ng-class=\"{active: hovering}\"\r\n                  ng-mouseover=\"hovering = true\"\r\n                  ng-mouseleave=\"hovering = false\"\r\n                  ng-click=\"clfController.addSignalTypeFilter(type)\"><a href=\"\">{{type.signalType}}</a>\r\n              </li>\r\n            </ul>\r\n          </div>\r\n\r\n          <div uib-dropdown class=\"filter_item\">\r\n            <input name=\"targetMarket\"\r\n                   id=\"targetMarket\"\r\n                   class=\"single\"\r\n                   href uib-dropdown-toggle\r\n                   type=\"text\"\r\n                   ng-model=\"clfController.selectedTargetMarkets\"\r\n                   placeholder=\"Target Market\"\r\n                   ng-readonly=\"true\">\r\n            <ul class=\"dropdown-menu\" uib-dropdown-menu>\r\n              <li ng-repeat=\"type in clfController.countryRegionList \"\r\n                  ng-class=\"{active: hovering}\"\r\n                  ng-mouseover=\"hovering = true\"\r\n                  ng-mouseleave=\"hovering = false\"\r\n                  ng-click=\"clfController.addTargetMarketFilter(type)\"><a href=\"\">{{type.name}}</a>\r\n              </li>\r\n            </ul>\r\n          </div>\r\n          <div class=\"filter_item\">\r\n            <input name=\"country\"\r\n                   id=\"SourceMarket\"\r\n                   class=\"single\"\r\n                   type=\"text\"\r\n                   ng-model=\"clfController.selectedSourceMarkets\"\r\n                   typeahead-on-select=\"clfController.addSignalCountryFilter($label)\"\r\n                   placeholder=\"Source Market\"\r\n                   uib-typeahead=\"country as country.name for country in clfController.countries | filter: $viewValue | limitTo:12 | nonSelectedCountry\"\r\n                   autocomplete=\"off\">\r\n          </div>\r\n          <div class=\"filter_item\">\r\n            <input name=\"createdDate\"\r\n                   id=\"createdDate\"\r\n                   class=\"single cus-date-picker\"\r\n                   type=\"text\"\r\n                   placeholder=\"Created Date\"\r\n                   typeahead-on-select=\"clfController.addSignalDateRangeFilter($item)\"\r\n                   ng-model=\"clfController.selectedSignalDateRange\"\r\n                   readonly>\r\n          </div>\r\n\r\n        </div>\r\n      </li>--></ul></form><div class=filter-header><div class=filter-header-title><div class=filter-head-icon><svg xmlns=http://www.w3.org/2000/svg width=16 height=16 class=\"bi bi-star-fill\" viewBox=\"0 0 16 16\" style=\"margin-top: -1px\"><path d=\"M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z\"/></svg></div><span>Rating</span></div></div><div class=out-rating><div class=filter_slider><label><strong>Rating</strong></label><div class=\"range-slider_wrapper rating-level\"><div class=range-slider><div id=rating_slider ya-no-ui-slider=clfController.ratingSliderOptions ya-no-ui-slider-events=clfController.ratingSliderEvents></div></div><div class=range-limit><div class=lowest_value-label>{{clfController.ratingSteps[0].rating}}</div><div class=highest_value-label>{{clfController.ratingSteps[clfController.ratingSteps.length - 1].rating}}</div></div><input type=hidden name=rating_min> <input type=hidden name=rating_max></div></div></div></section><script></script><div id=cus-modal ng-show=clfController.isFundingModalShow><div class=modal-container><div class=content-modal><form><div class=\"mod-form-header event_modal_head green-header\"><h4>Company Funding</h4><div id=close-modal ng-click=clfController.fundingModalShow(false) class=\"close-button light-close\">X</div></div><div class=\"mod-form-upper event_body custom_event-body\"><div class=mod-title></div><div class=\"mod-date custom-mod-date\"><div class=def-50><div class=sel-item-date-picker><input type=radio name=fav_language checked ng-click=clfController.isDateRangeSectionShow(false)><label>Time Range</label></div><div class=company_input_group><input class=def-input ng-disabled=\"!(clfController.isDateRangeShow == false)\" type=text name=reportrange autocomplete=off id=reportrange placeholder=\"Select Time Range\" readonly><i class=\"fa fa-caret-down\"></i></div><label ng-if=\"!clfController.isDateRangeShow && clfController.showRequiredRange\">*Time Range is required</label></div><div class=def-50><div class=sel-item-date-picker><input type=radio name=fav_language ng-click=clfController.isDateRangeSectionShow(true)><label>Date Range</label></div><div class=company_input_group><input ng-disabled=!clfController.isDateRangeShow class=def-input type=text name=daterange autocomplete=off placeholder=\"Start Date - End Date\"><i class=\"fa fa-caret-down\"></i></div><label ng-if=\"clfController.isDateRangeShow && clfController.showRequiredRange\">*Date Range is required</label></div></div><div class=\"mod-sel custom-mod-sel\"><span class=mod-sel-title>Deal Amount ( <i class=\"fa fa-dollar\"></i>Million )</span></div><div class=\"mod-date custom-mod-date\"><div class=def-50><input ng-model=clfController.dealMinAmount class=def-input min=0 maxlength=10 type=number autocomplete=off placeholder=Min></div><div class=def-50><input ng-model=clfController.dealMaxAmount min=0 class=def-input type=number autocomplete=off placeholder=Max></div></div><div class=\"mod-sel custom-mod-sel\"><span class=mod-sel-title>Select a Funding Type:</span><div class=\"mod-sel-option custom-scrollbar\"><div class=sel-item ng-repeat=\"item in clfController.fundingTypeList track by item.id\"><input type=checkbox name=selectedIds[] value={{item.id}} ng-checked=\"clfController.selectedFundingIds.indexOf(item.id) > -1\" ng-click=clfController.toggleFundingSelection(item.id)><label for={{item.id}}>{{item.name}}</label><i ng-click=clfController.openSubLit() ng-if=\"item.id == \'venture_capital\'\" class=\"fa fa-caret-down\"></i></div><div class=main-checklist><div class=sel-item><ul class=\"sub-checklist vis\" ng-if=clfController.subListIsOpen><li ng-repeat=\"item in clfController.fundingSeriesList track by item.id\"><input type=checkbox name=selectedSeriesIds[] value={{item.id}} ng-checked=\"clfController.selectedFundingSeriesIds.indexOf(item.id) > -1\" ng-click=clfController.toggleFundingSeries(item.id)><label for={{item.id}}>{{item.name}}</label></li></ul></div></div></div></div></div><div class=\"mod-form-lower pad-rt-10\"><a ng-click=clfController.fundingModalShow(false) class=\"close-button custom-btn\">Cancel</a> <input ng-click=clfController.fundingModalSave() type=submit value=Submit></div></form></div></div></div><div id=cus-modal-h ng-show=clfController.isHiringModalShow><div class=modal-container><div class=content-modal><form><div class=\"mod-form-header event_modal_head green-header\"><h4>Company Hiring</h4><div id=close-modal-h ng-click=clfController.hiringModalShow(false) class=\"close-button light-close\">X</div></div><div class=\"mod-form-upper event_body custom_event-body\"><div class=mod-title></div><div class=\"mod-date custom-mod-date\"><div class=def-50><div class=sel-item-date-picker><input type=radio name=fav_language checked ng-click=clfController.isHiringDateRangeSectionShow(false)><label>Time Range</label></div><div class=company_input_group><input class=def-input ng-disabled=\"!(clfController.isHiringDateRangeShow == false)\" type=text name=hiringReportrange autocomplete=off id=hiringReportrange placeholder=\"Select Time Range\" readonly><i class=\"fa fa-caret-down\"></i></div><label ng-if=\"!clfController.isHiringDateRangeShow && clfController.showRequiredRange\">*Time Range is required</label></div><div class=def-50><div class=sel-item-date-picker><input type=radio name=fav_language ng-click=clfController.isHiringDateRangeSectionShow(true)><label>Date Range</label></div><div class=company_input_group><input ng-disabled=!clfController.isHiringDateRangeShow class=def-input type=text name=hiringDaterange id=hiringDaterange autocomplete=off placeholder=\"Start Date - End Date\"><i class=\"fa fa-caret-down\"></i></div><label ng-if=\"clfController.isHiringDateRangeShow && clfController.showRequiredRange\">*Date Range is required</label></div></div><div class=\"mod-sel custom-mod-sel\"><span class=mod-sel-title>Job title</span></div><div class=\"mod-date custom-mod-date\"><div class=def-100 style=\"width: 360px\"><input ng-model=clfController.jobTitle class=def-input type=text autocomplete=off placeholder=\"Job Title\"></div></div><div class=\"mod-sel custom-mod-sel mb_5\" style=\"width:100%; height:100%; overflow:hidden\"><span class=\"mod-sel-title color_black\">Department</span></div><div class=\"mod-date custom-mod-date\"><div class=def-100 style=\"width: 360px\"><div class=filter_item><input name=department id=hiring_department class=\"single cus-input custom-scrollbar\" type=text ng-model=clfController.hiringDepartment typeahead-on-select=clfController.addHiringDepartment($label) placeholder=Department uib-typeahead=\"department as department.name for department in clfController.hiringDepartmentsList | filter: $viewValue | limitTo:12 | nonSelectedCountry\" autocomplete=off></div><div class=\"selected_items_h custom-scrollbar\"><div ng-repeat=\"department in clfController.department\" class=item-h><div ng-click=clfController.removeDepartment(department)><div class=close-btn>x</div>{{department}}</div></div></div><!--              <input ng-model=\"clfController.department\" class=\"def-input\"  type=\"text\" autocomplete=\"off\" placeholder=\"Department\" />--></div></div><div class=\"mod-sel custom-mod-sel mb_5\" style=\"width:100%; height:100%; overflow:hidden\"><span class=\"mod-sel-title color_black\">Country</span></div><div class=\"mod-date custom-mod-date\"><div class=def-100 style=\"width: 360px\"><div class=filter_item><input name=country id=hiring_country class=\"single cus-input custom-scrollbar\" type=text ng-model=clfController.hiringCountry typeahead-on-select=clfController.addHiringCountry($label) placeholder=Country uib-typeahead=\"country as country for country in clfController.hiringCountries | limitTo:12 \" autocomplete=off></div><div class=\"selected_items_h custom-scrollbar\"><div ng-repeat=\"country in clfController.country\" class=item-h><div ng-click=clfController.removeCountry(country)><div class=close-btn>x</div>{{country}}</div></div></div></div></div><div class=\"mod-sel custom-mod-sel mb_5\" style=\"width:100%; height:100%; overflow:hidden\"><span class=\"mod-sel-title color_black\">State</span></div><div class=\"mod-date custom-mod-date\"><div class=def-100 style=\"width: 360px\"><input ng-model=clfController.state class=def-input type=text autocomplete=off placeholder=State></div></div></div><div class=mod-form-lower><a ng-click=clfController.hiringModalShow(false) class=\"close-button custom-btn\">Cancel</a> <input ng-click=clfController.hiringModalSave() type=submit value=Submit></div></form></div></div></div>");
$templateCache.put("app/components/companyListPaging/companyListPaging.html","<span class=companies-list><div class=companies__pagesize>Showing<div class=pagesize__dropdown><span>{{clpController.itemsPerPage}}</span><i class=\"fa fa-angle-down\"></i><div class=pagesize__dropdown-dropdown><a name=pageSize10 href=\"\" ng-click=clpController.setPageSize(15)>15</a> <a name=pageSize20 href=\"\" ng-click=clpController.setPageSize(30)>30</a> <a name=pageSize40 href=\"\" ng-click=clpController.setPageSize(45)>45</a></div></div>records per page</div><div class=companies__pagination><ul uib-pagination class=custom-pagination total-items=clpController.totalNumberOfResults boundary-links=true max-size=3 ng-model=clpController.currentPage previous-text=&#xf104; next-text=&#xf105; last-text=&#xf101; first-text=&#xf100; items-per-page=clpController.itemsPerPage ng-change=clpController.pageNumberChanged()></ul></div></span>");
$templateCache.put("app/components/companySearchTitle/companySearchTitle.html","<header><div ng-if=cstController.trendsReportService.alerts ng-repeat=\"alert in cstController.trendsReportService.alerts | limitTo : 3\"><single-message-summary alert=alert></single-message-summary></div><h1 class=cus-title-size>Company Search</h1><div class=\"header__btn-block search-btn-block\"><button class=\"btn btn-dark-blue custom-btn\" ng-click=cstController.saveAsList() ng-disabled=$root.isLoading>Save as List</button></div><!--  <div class=\"header__btn-block tooltip\" title=\"{{cstController.tooltipMessage}}\">\r\n    <button class=\"btn colr primary\" ng-click=\"cstController.requestTrendsReport()\" ng-disabled=\"$root.isLoading || cstController.notFilteringCountryOrSector || cstController.numberOfFilteredCompanies === 0\">\r\n              Create Report\r\n    </button>\r\n  </div>--><results-scale search-results=cstController.searchResults scale-data=cstController.searchResults.companyScaleCounts></results-scale><company-list-results-totals search-results=cstController.searchResults></company-list-results-totals><div id=trends-report ng-hide=true><ng-include src=\"\'assets/pdf-templates/trends-report.html\'\"></ng-include></div><div class=clearfix></div></header><script>$(document).ready(function(){\r\n    if( $(\'body\').find(\'#login\').length > 0 ){\r\n      $(\'body\').addClass(\'color-bck\');\r\n    }\r\n    else{\r\n       $(\'body\').removeClass(\'color-bck\');\r\n    }\r\n    });</script>");
$templateCache.put("app/components/companyListResultsTotals/companyListResultsTotals.html","<div class=header__result-count><span>{{clrtController.getCompaniesWithUnits(clrtController.numOfCompaniesFound)}}</span> Companies</div>");
$templateCache.put("app/components/investSignalList/investSignalList.html","<section class=signals-list><div ng-show=$rootScope.isLoading class=companies-list__loader><div class=inner><div class=spinner></div></div></div><section class=\"investment-signals filter\"><div class=search-title><h1>Company Investment Signal Search</h1></div><div class=signal-input><span><input id=name type=text class=form-control placeholder=Name ng-model=islController.search.name ng-change=islController.filter()></span><span class=filter_item><input name=country id=country class=single type=text ng-model=islController.search.hq ng-change=islController.filter() placeholder=HQ uib-typeahead=\"country as country.name for country in islController.countries | filter: $viewValue | limitTo:12\" autocomplete=off> </span><span uib-dropdown class=filter_item><input name=sectors id=sectors class=single href uib-dropdown-toggle type=text ng-model=islController.search.sector.name ng-init=\"islController.search.sector.name = \'\'\" ng-change=islController.filter() placeholder=Sector ng-readonly=true><ul class=dropdown-menu uib-dropdown-menu><li ng-class=\"{active: hoveringN}\" ng-mouseover=\"hoveringN = true\" ng-mouseleave=\"hoveringN = false\" ng-click=\"islController.search.sector.name = \'\'\"><a href=\"\">None</a></li><li ng-repeat=\"sector in islController.sectors\" ng-class=\"{active: hovering}\" ng-mouseover=\"hovering = true\" ng-mouseleave=\"hovering = false\" ng-click=\"islController.search.sector.name = sector.name\"><a href=\"\">{{sector.name}}</a></li></ul></span><span uib-dropdown class=filter_item><input name=markets id=markets class=single href uib-dropdown-toggle type=text ng-model=islController.search.targetMarkets.name ng-init=\"islController.search.targetMarkets.name = \'\'\" ng-change=islController.filter() placeholder=\"Target Markets\" autocomplete=disabled><ul class=dropdown-menu uib-dropdown-menu><li ng-class=\"{active: hoveringN}\" ng-mouseover=\"hoveringN = true\" ng-mouseleave=\"hoveringN = false\" ng-click=\"islController.search.targetMarkets.name = \'\'\"><a href=\"\">None</a></li><li ng-repeat=\"target in islController.regions\" ng-class=\"{active: hovering}\" ng-mouseover=\"hovering = true\" ng-mouseleave=\"hovering = false\" ng-click=\"islController.search.targetMarkets.name = target.name\"><a href=\"\">{{target.name}}</a></li></ul></span><span uib-dropdown class=filter_item><input name=publishDate id=publishDate class=single href uib-dropdown-toggle type=text ng-model=islController.search.publishDate ng-init=\"islController.search.publishDate = \'\'\" ng-change=islController.filter() placeholder=\"Published Since\"><ul class=dropdown-menu uib-dropdown-menu><li ng-class=\"{active: hoveringN}\" ng-mouseover=\"hoveringN = true\" ng-mouseleave=\"hoveringN = false\" ng-click=\"islController.search.publishDate = \'\'\"><a href=\"\">None</a></li><li ng-repeat=\"target in islController.publishSince\" ng-class=\"{active: hovering}\" ng-mouseover=\"hovering = true\" ng-mouseleave=\"hovering = false\" ng-click=\"islController.search.publishDate = (target | date: \'MMM y\')\"><a href=\"\">{{target | date: \"MMM y\"}}</a></li></ul><!-- (target | date:\'yyyy-MM\'); --></span></div><article ng-show=\"( islController.signalList | filter:islController.filterList:islController.search.hq.name:islController.search.name:islController.search.sector.name:islController.search.targetMarkets.name:islController.publishDate).length == 0\" class=no_results><h1>Sorry we couldn\'t find any matches</h1></article><article ng-repeat=\"signal in data = islController.signalList | filter:islController.filterList:islController.search.hq.name:islController.search.name:islController.search.sector.name:islController.search.targetMarkets.name:islController.publishDate | start: (islController.currentPage-1)*islController.itemsPerPage | limitTo:islController.itemsPerPage track by $index\"><table><tbody><tr><div class=company-logo style=\"min-height: 210px;float:left; width:25%; position: relative\"><img id=logo ng-if=\"signal.logo != undefined && !signal.logo.contains(\'data:image/\')\" src=\"data:image/png;base64, {{signal.logo}}\"> <img id=logo ng-if=\"signal.logo != undefined && signal.logo.contains(\'data:image/\')\" src={{signal.logo}}> <img id=logo ng-if=\"signal.logo == undefined\"></div><div class=company-details style=\"min-height: 210px; float: left; width: 25%; position: relative\"><h3>Company <strong id=companyName ng-click=islController.showCompanyDetails(signal)>{{signal.companyName}}</strong></h3><h3>HQ <strong>{{signal.hq}}</strong></h3><h3>Sector <strong>{{signal.sector}}</strong></h3><h3>Target Markets <strong>{{signal.targetMarkets.join(\', \')}}</strong></h3><h3>Published <strong>{{signal.publishDate}}</strong></h3><a href={{signal.pressReleaseUrl}} class=pr-button target=_blank>Press Release</a></div><div class=investment-signal style=\"min-height: 210px;float: left;width: 50%;border-left: 1px solid #666665;padding-left: 4em; margin-bottom: 1.3%\"><h3>Investment Signal</h3><p ng-repeat=\"text in signal.text.split(\'\\n\') track by $index\">{{text}}</p></div></tr></tbody><div><hr class=space-line></div></table></article><span class=companies-list style=\"color: #666665\"><div class=companies__pagesize style=\"margin-bottom: 2%\">Showing<div class=pagesize__dropdown><span>{{islController.itemsPerPage}}</span><i class=\"fa fa-angle-down\"></i><div class=pagesize__dropdown-dropdown><a name=pageSize10 href=\"\" ng-click=islController.setItemsPerPage(10)>10</a> <a name=pageSize20 href=\"\" ng-click=islController.setItemsPerPage(20)>20</a> <a name=pageSize40 href=\"\" ng-click=islController.setItemsPerPage(40)>40</a></div></div>records per page</div><div class=companies__pagination><ul uib-pagination total-items=\"(islController.signalList | filter:islController.filterList:islController.search.hq.name:islController.search.name:islController.search.sector.name:islController.search.targetMarkets.name:islController.publishDate).length\" boundary-links=true max-size=3 ng-model=islController.currentPage previous-text=&#xf104; next-text=&#xf105; last-text=&#xf101; first-text=&#xf100; items-per-page=islController.itemsPerPage ng-change=islController.pageNumberChanged()></ul></div></span></section></section><company-details-modal company-details=islController.companyDetails></company-details-modal><style>#logo{\r\n    max-height: 210px;\r\n    max-width: 95%;\r\n  }\r\n  #companyName{\r\n    color: #337ab7;\r\n  }\r\n  #companyName:hover {\r\n    color: #235480;\r\n    text-decoration: underline;\r\n  }\r\n  .search-title{\r\n    display: inline-block;\r\n    margin-bottom: 2%;\r\n  }\r\n  .investment-signals h1 {\r\n    float: left;\r\n    margin: 0;\r\n    line-height: 1em;\r\n    font-size: 2.5em;\r\n    font-weight: 300;\r\n    color: #666665;\r\n    letter-spacing: -0.025em;\r\n  }\r\n  .company-details h3 {\r\n    font-weight: 400;\r\n    color: #666665;\r\n    line-height: 1.3em;\r\n    margin: 0 0 .75em;\r\n    font-size: 1em;\r\n  }\r\n  .investment-signals input{\r\n    background-color: transparent;\r\n    border: hidden;\r\n    border-bottom: 2px solid #666665;\r\n    height: 30px;\r\n    margin-right: 6%;\r\n    margin-bottom: 6%;\r\n    color: #666665;\r\n  }\r\n  .investment-signal h3 {\r\n    font-size: 1em;\r\n    line-height: 1.5em;\r\n    margin: 0;\r\n    color: #79bde9;\r\n    font-weight: 400;\r\n  }\r\n  .investment-signal p {\r\n    font-size: 1em;\r\n    line-height: 1.5em;\r\n    font-weight: 400;\r\n    margin-top: .25em;\r\n    color: #666665;\r\n  }\r\n  .company-details strong{\r\n     color: #666665;\r\n  }\r\n  .investment-signals article {\r\n    margin-left: -15px;\r\n    margin-right: -15px;\r\n    margin-top: 1em;\r\n    margin-bottom: 1em;\r\n  }\r\n  .company-details .pr-button {\r\n    background: #0072ad;\r\n    color: #fff;\r\n    display: inline-block;\r\n    font-weight: 400;\r\n    padding: .125em .5em;\r\n    margin-top: 3em;\r\n  }\r\n  .space-line{\r\n    display: block;\r\n    margin-top: 0.5em;\r\n    margin-bottom: 0.5em;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    border-style: inset;\r\n    border-width: 1px;\r\n  }</style>");
$templateCache.put("app/components/modals/addToListModal.html","<div id=addToListModal aria-labelledby=addToListModalLabel><form><div class=modal-body><h2>Choose a list <a href=\"\" ng-click=atlmController.close()><i class=\"fa fa-close\"></i></a></h2><input type=text id=search placeholder=Search ng-model=searchName><h4>My Lists</h4><div class=all_lists><a href=\"\" ng-click=atlmController.editNewListName()><img class=add-to-list-image src=assets/img/icons/my_velociti@2x.png> <span ng-show=!atlmController.isEditing>{{atlmController.newListName ? atlmController.newListName : \'New List ...\'}}</span> <input id=addToNewList ng-show=atlmController.isEditing ng-disabled=!atlmController.isEditing ng-model=atlmController.newListName ng-keydown=atlmController.keyPressed($event) autofocus><div id=new-list-error class=small-error ng-if=\"atlmController.nameAlreadyExists() && atlmController.newListSubmitting\">List name already exists</div></a><a ng-repeat=\"list in atlmController.myLists | filter:searchName\" href=\"\" ng-click=atlmController.addCompanyToList(list)><div class=add-to-do-list ng-if=!list.isDeleted><div class=add-to-list-image><img ng-src={{list.imageUrl}}></div><span>{{list.name}}</span> <i ng-if=atlmController.isInList(list) class=\"fa fa-check\" aria-hidden=true></i></div></a></div></div></form></div>");
$templateCache.put("app/components/modals/modalAlert.html","<div id=alertModal aria-labelledby=alertModalLabel><div id=alertModalBody class=modal-body>{{modalAlertController.message()}}</div><div class=modal-footer><button type=button class=\"btn colr btn-dark-blue custom-btn\" ng-click=modalAlertController.ok()>OK</button> <button type=button class=\"btn btn brdr custom-btn\" ng-click=modalAlertController.cancel()>Cancel</button></div></div>");
$templateCache.put("app/components/modals/newListModal.html","<div id=addListModal aria-labelledby=alertModalLabel><div id=alertModalBody class=modal-body><input ng-model=nlmController.title ng-change=nlmController.onTitleChange() type=text name=list_name placeholder=\"New list title...\"></div><div class=modal-footer><button type=button class=\"btn btn brdr\" ng-click=nlmController.cancel()>Cancel</button> <button type=button class=\"btn btn-dark-blue\" ng-disabled=!nlmController.hasListTitle ng-click=nlmController.ok()>Add List</button></div></div>");
$templateCache.put("app/components/modals/okModal.html","<div id=alertModal aria-labelledby=alertModalLabel><div id=alertModalBody class=modal-body>{{okModalController.message()}}</div><div class=modal-footer><button type=button class=\"btn colr primary\" ng-click=okModalController.ok()>OK</button></div></div>");
$templateCache.put("app/components/resultsScale/resultsScale.html","<!--\r\n<div class=\"header__results-block\">\r\n  <div class=\"results__scale\">\r\n    <div class=\"results__scale-bar\">\r\n      <div class=\"sme tooltip\" ng-style=\"{width: resultsScaleController.scaleSME}\" title=\"SME\"></div>&lt;!&ndash;\r\n								&ndash;&gt;<div class=\"midcap tooltip\" ng-style=\"{width: resultsScaleController.scaleMid}\" title=\"MID-CAP\"></div>&lt;!&ndash;\r\n								&ndash;&gt;<div class=\"corporate tooltip\" ng-style=\"{width: resultsScaleController.scaleLarge}\" title=\"Large Corporate\"></div>\r\n    </div>\r\n    <div class=\"results__scale-label\">\r\n      Scale\r\n    </div>\r\n  </div>\r\n  <div class=\"results__matched\">\r\n    <div class=\"results__matched-bar tooltip\" title=\"120 companies matched\">\r\n      <div class=\"matches\" ng-style=\"{width: resultsScaleController.matchingPercent}\"></div>\r\n    </div>\r\n    <div class=\"results__matched-label\">\r\n      Matched\r\n    </div>\r\n  </div>\r\n</div>\r\n-->");
$templateCache.put("app/components/sidebar/sidebar.html","<aside id=sidebar class=custom-scroll><nav><div class=expand-op><svg class=\"expand-icon bi bi-sliders\" xmlns=http://www.w3.org/2000/svg width=16 height=16 fill=currentColor viewBox=\"0 0 16 16\"><path fill-rule=evenodd d=\"M11.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM9.05 3a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0V3h9.05zM4.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM2.05 8a2.5 2.5 0 0 1 4.9 0H16v1H6.95a2.5 2.5 0 0 1-4.9 0H0V8h2.05zm9.45 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-2.45 1a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0v-1h9.05z\"/></svg></div><ul><!--<li id=\"my-velociti-tab\">\r\n        <a ui-sref=\"myVelociti\" ng-class=\"controller.isActive(\'myVelociti\')\">\r\n          <img src=\"./assets/img/icons/tiny_icons/my_velociti.png\"> My Velociti</a>\r\n      </li>--><li id=userPreferencesTab ng-class=\"controller.isSelect(\'userPreferences\')\"><a ui-sref=userPreferences ng-class=\"controller.isActive(\'userPreferences\')\"><img src=./assets/img/icons/tiny_icons/user_preferences.png> <span>User Preferences</span></a></li><li id=companyTab ng-class=\"controller.isSelect(\'companies\')\"><a ui-sref=companies ng-class=\"controller.isActive(\'companies\')\"><img src=./assets/img/icons/tiny_icons/company_search.png> <span>Company Search</span></a></li><li id=myListsTab ng-class=\"controller.isSelect(\'myLists\')\"><a ui-sref=myLists ng-class=\"controller.isActive(\'myLists\')\"><img src=./assets/img/icons/tiny_icons/my_lists.png> <span>My Velociti Lists</span></a></li><li id=topTargetListsTab ng-class=\"controller.isSelect(\'topTargetLists\')\"><a ui-sref=topTargetLists ng-class=\"controller.isActive(\'topTargetLists\')\"><img src=./assets/img/icons/tiny_icons/my_lists.png> <span>Top Target Lists</span></a></li><li id=requestRatingTab ng-class=\"controller.isSelect(\'requestRating\')\"><a ui-sref=requestRating ng-class=\"controller.isActive(\'requestRating\')\"><img src=./assets/img/icons/tiny_icons/request_rating.png> <span>Request Rating</span></a></li><li id=requestedProfiles ng-class=\"controller.isSelect(\'requestedProfiles\')\"><a ui-sref=requestedProfiles ng-class=\"controller.isActive(\'requestedProfiles\')\"><img src=./assets/img/icons/tiny_icons/profiles.png> <span>View Profiles</span></a></li><li id=exhibitorTab ng-class=\"controller.isSelect(\'exhibitorAnalysis\')\"><a ui-sref=exhibitorAnalysis ng-class=\"controller.isActive(\'exhibitorAnalysis\')\"><img src=./assets/img/icons/tiny_icons/exhibitor_analysis.png> <span>Exhibitor Analysis</span></a></li><li id=investmentSignalsTab ng-class=\"controller.isSelect(\'investmentSignals\')\"><a ui-sref=investmentSignals ng-class=\"controller.isActive(\'investmentSignals\')\"><img src=./assets/img/icons/tiny_icons/investment_signals.png> <span>Investment Signals</span></a></li><!-- <li id=\"demoVideoTab\" ng-class=\"controller.isSelect(\'demoVideo\')\">\r\n                                <a ui-sref=\"demoVideo\" ng-class=\"controller.isActive(\'demoVideo\')\">\r\n          <img src=\"./assets/img/icons/tiny_icons/demo_video.png\"> <span>Demo Video</span></a>\r\n      </li>--></ul><div class=nav-block><div class=nav-block-title>OCO Connect Services</div><ul><li id=dataAndInsights ng-class=\"controller.isSelect(\'dataAndInsights\')\"><a href=https://ococonnect.com/ target=_blank ng-class=\"controller.isActive(\'dataAndInsights\')\"><img src=./assets/img/icons/tiny_icons/Insights.png> <span>Data & Insights</span></a></li><li id=myCommunities ng-class=\"controller.isSelect(\'myCommunities\')\"><a href=https://ococonnect.com/ target=_blank ng-class=\"controller.isActive(\'myCommunities\')\"><img src=./assets/img/icons/tiny_icons/Communities.png> <span>My Communities</span></a></li></ul></div></nav></aside><script>jQuery(document).ready(function ($) {\r\n    $(\"aside#sidebar nav ul li a>span\").hide();\r\n<!--     $(\"main.with_sidebar\").removeClass(\"sidebar-expand\");-->\r\n\r\n<!--        if($(\"main.with_sidebar\").hasClass(\"sidebar-expand\")){-->\r\n<!--        $(\"aside#sidebar\").addClass(\"nav-expand\");-->\r\n<!--        $(\"aside#sidebar nav ul li a>span\").show();-->\r\n<!--        }else{-->\r\n<!--         $(\"aside#sidebar\").removeClass(\"nav-expand\");-->\r\n<!--         $(\"aside#sidebar nav ul li a>span\").hide();-->\r\n<!--        }-->\r\n\r\n            $(\"main.with_sidebar\").removeClass(\"sidebar-expand\");\r\n            $(\"aside#sidebar\").removeClass(\"nav-expand\");\r\n           $(\"aside#sidebar nav ul li a>span\").hide()\r\n            $(\"aside#sidebar nav .nav-block-title\").hide();\r\n\r\n<!--    $(\".expand-icon\").on(\'click\', function () {-->\r\n    $(\"aside#sidebar\").hover(function(){\r\n        $(\"aside#sidebar nav ul li a>span\").toggle();\r\n        $(\"aside#sidebar nav .nav-block-title\").toggle();\r\n        $(\"aside#sidebar\").toggleClass(\"nav-expand\");\r\n         $(\"main.with_sidebar\").toggleClass(\"sidebar-expand\");\r\n    });\r\n\r\n});</script>");
$templateCache.put("app/components/singleMessageSummary/singleMessageSummary.html","<div id=alertMessage ng-show=smController.isDisplayingErrorMessage class=\"message {{smController.alert.type}}\" bind-html-compile=smController.alert.message></div>");
$templateCache.put("app/components/tradeDestination/tradeDestination.html","<section class=trade_destination><!-- add / remove the class name selected to this to toggle the hiding / showing of the title text below--><div ng-show=!tdController.isTradeDestinationDefined class=trade_destination-title>Please specify your <strong>Trade Destination</strong> as companies are scored based on attractiveness of destination country to origin country. If this field is left blank, your search results will not appear.</div><div class=trade_destination-select><label>Trade Destination</label><input name=country id=trade_destination class=filter-trade_destination type=text ng-keydown=tdController.keyPressed($event) ng-model=tdController.selectedTradeDestinationName typeahead-on-select=tdController.changeSelectedTradeDestination($label) uib-typeahead=\"country as country for country in tdController.countries | filter: $viewValue | limitTo:12 | nonSelectedCountry\" placeholder=\"Please select country...\" autocomplete=off></div></section>");
$templateCache.put("app/components/velocitiListEditCompanyButton/velocitiListEditCompanyButton.html","<div class=toggle_pill><button type=button ng-click=vlecbController.toggleCompanyInList() ng-class=\"{\'active\' : vlecbController.isInList, \'inactive\' : !vlecbController.isInList}\"></button></div>");
$templateCache.put("app/components/velocitiListTitle/velocitiListTitle.html","<div id=alertBox class=alert ng-show=vltController.alertHide><div class=alert-msg><i class=\"fa fa-times-circle\" ng-click=vltController.closeAlert() aria-hidden=true></i> <span>{{vltController.responseMessage}}</span></div></div><header class=\"upper-block upper_block2\"><h1>My List : <span>{{vltController.listName}}</span></h1><div class=header__btn-block><button ng-disabled=vltController.isDownloading class=\"btn brdr primary\" ng-click=vltController.downloadListAsReportMail()>Mail Download</button></div><div class=header__btn-block><button ng-disabled=vltController.isDownloading class=\"btn brdr primary\" ng-click=vltController.downloadListAsReport()>Download</button></div><div class=clearfix></div><ul class=\"tabs velocitilisttab\"><li ng-class=\"{active: vltController.isOnList}\"><a href=\"\" ng-click=vltController.goToVelocitiListTab(true) aria-controls=list role=tab data-toggle=tab>View List</a></li><li ng-class=\"{active: !vltController.isOnList}\"><a href=\"\" ng-click=vltController.goToVelocitiListTab(false) aria-controls=add role=tab data-toggle=tab>Add companies to this list</a></li></ul><div class=clearfix></div></header>");}]);